// src/entities/account/new-account-schema.ts
import { oz as oz69 } from "@vy/utils";

// src/primitives/address-schema.ts
import { oz as oz2 } from "@vy/utils";

// src/primitives/sanitizedStringSchema.ts
import { oz } from "@vy/utils";
var SanitizedStringSchema = oz.string().trim();

// src/primitives/address-schema.ts
var AddressSchema = oz2.object({
  country: SanitizedStringSchema.nullish(),
  city: SanitizedStringSchema.nullish(),
  addressText: SanitizedStringSchema.nullish(),
  state: SanitizedStringSchema.nullish(),
  postalCode: SanitizedStringSchema.nullish()
}).openapi("Address");

// src/primitives/api-date-schema.ts
import { oz as oz3 } from "@vy/utils";
var documentationCodegen = typeof process !== "undefined" && !!process.env["API_TO_GENERATE"];
var AdvancedApiDateSchema = oz3.union([oz3.string().pipe(oz3.coerce.date()), oz3.date().openapi({ format: "date-time" })]).openapi("ApiDate", { format: "date-time" });
var BasicDateSchema = oz3.date().openapi({ format: "date-time" });
var ApiDateSchema = documentationCodegen ? BasicDateSchema : AdvancedApiDateSchema;

// src/primitives/base-64-schema.ts
import { Base64 } from "js-base64";
import { oz as oz4 } from "@vy/utils";
var Base64Schema = oz4.string().refine(Base64.isValid);

// src/primitives/billing-interval-schema.ts
import { oz as oz5 } from "@vy/utils";
var BILLING_INTERVALS = Object.freeze({
  Monthly: "Monthly",
  BiMonthly: "BiMonthly",
  Quarterly: "Quarterly",
  SixMonths: "SixMonths",
  Yearly: "Yearly"
});
var BillingIntervalSchema = oz5.nativeEnum(BILLING_INTERVALS).openapi("BillingInterval");

// src/primitives/commitment-tier-usage-data/commitment-tier-usage-data-schema.ts
import { oz as oz10 } from "@vy/utils";

// src/primitives/tier-usage-data/tier-discount-configuration.ts
import { oz as oz7 } from "@vy/utils";

// src/primitives/discount-type-schema.ts
import { oz as oz6 } from "@vy/utils";
var DISCOUNT_TYPES = Object.freeze({
  Fixed: "Fixed",
  Percentage: "Percentage"
});
var DiscountTypeSchema = oz6.nativeEnum(DISCOUNT_TYPES).openapi("DiscountType");

// src/primitives/tier-usage-data/tier-discount-configuration.ts
var TierDiscountConfigurationSchema = oz7.object({
  amount: oz7.number().nonnegative(),
  type: DiscountTypeSchema
}).openapi("TierDiscountConfiguration");

// src/primitives/tier-usage-data/tier-usage-data-input-schema.ts
import { oz as oz9 } from "@vy/utils";

// src/primitives/tier-usage-data/tier-usage-data-schema.ts
import { oz as oz8 } from "@vy/utils";
var TierUsageDataSchema = oz8.object({
  tierIndex: oz8.number().nonnegative(),
  periodUnits: oz8.number(),
  price: oz8.number(),
  discountAmount: oz8.number().optional(),
  discountConfiguration: TierDiscountConfigurationSchema.nullable(),
  chunkSize: oz8.number().nonnegative()
}).openapi("TierUsageData");

// src/primitives/tier-usage-data/tier-usage-data-input-schema.ts
var TierUsageDataInputSchema = oz9.object(TierUsageDataSchema.shape).partial().required({
  tierIndex: true,
  discountConfiguration: true
}).openapi("TierUsageDataInput");

// src/primitives/commitment-tier-usage-data/commitment-tier-usage-data-schema.ts
var CommitmentTierUsageDataSchema = TierUsageDataSchema.extend({
  billableUnits: oz10.number().nonnegative(),
  ytdUnits: oz10.number().nonnegative()
}).openapi("CommitmentTierUsageData");

// src/primitives/confirmation-code-schema.ts
import { oz as oz11 } from "@vy/utils";
var ConfirmationCodeSchema = oz11.string().length(6).openapi("ConfirmationCode");

// src/primitives/contact-schema/contact-schema.ts
import { oz as oz12 } from "@vy/utils";

// src/primitives/contact-schema/contact-schema-consts.ts
var CONTACT_EMAIL_REGEX = /^(?!\.)[A-Za-z0-9_!#$%&'*+/=?^`{|}~-]+(?:\.[A-Za-z0-9_!#$%&'*+/=?^`{|}~-]+)*@([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])?\.)+[A-Za-z]{2,}$/;
var CONTACT_EMAIL_VALIDATION_ERROR_MESSAGE = "Invalid email address";
var PHONE_REGEX = /^\+?[1-9]\d{4,15}$/;
var PHONE_VALIDATION_ERROR_MESSAGE = "Phone number must be greater than 5";

// src/primitives/contact-schema/contact-schema.ts
var ContactSchema = oz12.object({
  name: SanitizedStringSchema.optional(),
  email: oz12.string().regex(CONTACT_EMAIL_REGEX, CONTACT_EMAIL_VALIDATION_ERROR_MESSAGE).optional(),
  title: oz12.string().optional(),
  phone: oz12.string().regex(PHONE_REGEX, PHONE_VALIDATION_ERROR_MESSAGE).optional(),
  receiveInvoiceEmail: oz12.boolean().optional()
}).openapi("Contact");

// src/primitives/contact-schema/contact-refiner.ts
import { isNotNullOrUndefined, isNullOrUndefined } from "@vy/utils";
var contactRefiner = {
  refine: (contact) => {
    const hasNonEmailField = isNotNullOrUndefined(contact.name) || isNotNullOrUndefined(contact.title) || isNotNullOrUndefined(contact.phone);
    if (hasNonEmailField && isNullOrUndefined(contact.email)) {
      return false;
    }
    return true;
  },
  options: {
    message: "Required",
    path: ["email"]
  }
};

// src/primitives/contact-schema/refined-contact-schema.ts
var RefinedContactSchema = ContactSchema.refine(contactRefiner.refine, contactRefiner.options);

// src/primitives/currency-schema/currency-schema.ts
import { oz as oz13 } from "@vy/utils";
var CURRENCIES = Object.freeze({
  Usd: "USD",
  Eur: "EUR",
  Gbp: "GBP",
  Ils: "ILS",
  Cad: "CAD",
  Aud: "AUD",
  Cop: "COP",
  Brl: "BRL",
  Ars: "ARS",
  Inr: "INR",
  Mxn: "MXN"
});
var CurrencySchema = oz13.nativeEnum(CURRENCIES).openapi("Currency");

// src/primitives/currency-schema/currency-schema-consts.ts
var DEFAULT_CURRENCY = CURRENCIES.Usd;

// src/primitives/deposit-to-provider-schema.ts
import { oz as oz14 } from "@vy/utils";
var DEPOSIT_TO_PROVIDERS = Object.freeze({
  UndepositedFunds: "Undeposited Funds",
  BankAccounts: "Bank Accounts",
  Other: "Other"
});
var DepositToProviderSchema = oz14.nativeEnum(DEPOSIT_TO_PROVIDERS).openapi("DepositToProvider");

// src/primitives/customer-filters-schema.ts
import { oz as oz15, parseJson } from "@vy/utils";
var CUSTOMER_FILTERS = Object.freeze({
  PARENT: "parent",
  CHILD: "child"
});
var CustomerFilterSchema = oz15.nativeEnum(CUSTOMER_FILTERS);
var CustomerFiltersSchema = oz15.string().transform((s) => parseJson(s)).pipe(CustomerFilterSchema.array()).optional();

// src/primitives/customer-source-schema.ts
import { oz as oz16 } from "@vy/utils";
var CUSTOMER_SOURCES = Object.freeze({
  Stripe: "Stripe",
  VayuEventsApi: "VayuEventsApi",
  Api: "Api",
  Salesforce: "Salesforce",
  HubSpot: "HubSpot"
});
var CustomerSourcesSchema = oz16.nativeEnum(CUSTOMER_SOURCES).openapi("CustomerSource");

// src/primitives/customer-type-schema.ts
import { oz as oz17 } from "@vy/utils";
var CUSTOMER_TYPES = Object.freeze({
  Direct: "Direct",
  Reseller: "Reseller"
});
var CustomerTypeSchema = oz17.nativeEnum(CUSTOMER_TYPES).openapi("CustomerType");

// src/primitives/full-day-period-schema.ts
import { isValidFullDayPeriod } from "@vy/utils";

// src/primitives/period-schema.ts
import { oz as oz18 } from "@vy/utils";
var PeriodSchema = oz18.object({
  startTime: ApiDateSchema,
  endTime: ApiDateSchema
}).refine((data) => data.endTime.valueOf() >= data.startTime.valueOf(), {
  message: "Start date must be before or equals to end date",
  path: ["startTime"]
}).openapi("Period");

// src/primitives/full-day-period-schema.ts
var FullDayPeriodSchema = PeriodSchema.refine(isValidFullDayPeriod, {
  message: "Start time must be at 00:00:00 UTC and end time must be at 23:59:59 UTC",
  path: ["startTime", "endTime"]
}).openapi("FullDayPeriod");

// src/primitives/invoice-billing-status-schema.ts
import { parseJson as parseJson2, oz as oz19 } from "@vy/utils";
var INVOICE_BILLING_STATUSES = Object.freeze({
  None: "None",
  Paid: "Paid",
  Rejected: "Rejected",
  PendingPayment: "PendingPayment",
  Overdue: "Overdue"
});
var InvoiceBillingStatusSchema = oz19.nativeEnum(INVOICE_BILLING_STATUSES).openapi("InvoiceBillingStatus");
var InvoiceBillingStatusesSchema = oz19.string().transform((s) => parseJson2(s)).pipe(InvoiceBillingStatusSchema.array().optional()).optional();

// src/primitives/invoice-calculation-status-schema.ts
import { oz as oz20 } from "@vy/utils";
var INVOICE_CALCULATION_STATUSES = Object.freeze({
  Calculating: "Calculating",
  Calculated: "Calculated"
});
var InvoiceCalculationStatusSchema = oz20.nativeEnum(INVOICE_CALCULATION_STATUSES).openapi("InvoiceCalculationStatus");

// src/primitives/invoice-date-schema.ts
import { oz as oz21 } from "@vy/utils";
var InvoiceDateSchema = oz21.object({
  month: oz21.string(),
  year: oz21.number()
});

// src/primitives/invoice-pdf-type.ts
import { oz as oz22 } from "@vy/utils";
var INVOICE_PDF_TYPES = {
  Light: "Light",
  Statement: "Statement"
};
var InvoicePdfTypeSchema = oz22.nativeEnum(INVOICE_PDF_TYPES).openapi("InvoicePdfType");

// src/primitives/invoice-review-status-schema.ts
import { parseJson as parseJson3, oz as oz23 } from "@vy/utils";
var INVOICE_REVIEW_STATUSES = Object.freeze({
  Draft: "Draft",
  Approved: "Approved",
  InReview: "InReview",
  Future: "Future"
});
var InvoiceReviewStatusSchema = oz23.nativeEnum(INVOICE_REVIEW_STATUSES).openapi("InvoiceReviewStatus");
var InvoiceReviewStatusesSchema = oz23.string().transform((s) => parseJson3(s)).pipe(InvoiceReviewStatusSchema.array()).optional();

// src/primitives/invoices-overviews-additional-filters.ts
import { oz as oz24, parseJson as parseJson4 } from "@vy/utils";
var INVOICES_OVERVIEWS_ADDITIONAL_FILTERS = Object.freeze({
  Overage: "overage",
  YearlyCommitment: "yearlyCommitment",
  manualReview: "manualReview",
  meteredInvoice: "meteredInvoice"
});
var InvoicesOverviewsAdditionalFilterSchema = oz24.nativeEnum(INVOICES_OVERVIEWS_ADDITIONAL_FILTERS);
var InvoicesOverviewsAdditionalFiltersSchema = oz24.string().transform((s) => parseJson4(s)).pipe(InvoicesOverviewsAdditionalFilterSchema.array()).optional();

// src/primitives/json-schema.ts
import { oz as oz25 } from "@vy/utils";
var JsonSchema = oz25.record(oz25.string(), oz25.any()).refine(
  (data) => {
    try {
      JSON.parse(JSON.stringify(data));
      return true;
    } catch {
      return false;
    }
  },
  {
    message: "Invalid JSON schema"
  }
);

// src/primitives/jwt-schema/index.ts
import { oz as oz26 } from "@vy/utils";

// src/primitives/jwt-schema/jwt-schema-consts.ts
var NUM_OF_JWT_PARTS = 3;
var JWT_PATTERN = /^[A-Za-z0-9_-]+$/;

// src/primitives/jwt-schema/index.ts
function validateJWtSchema(token) {
  const parts = token.split(".");
  return parts.length === NUM_OF_JWT_PARTS && parts.every((part) => JWT_PATTERN.test(part));
}
var JwtSchema = oz26.string().refine(validateJWtSchema, "Must be a valid JWT").openapi("Jwt");

// src/primitives/mongo-filters-schema/mongo-filter-operator.ts
var MONGO_FILTER_OPERATORS = Object.freeze({
  EQUALS: "eq",
  GREATER_THAN: "gt",
  GREATER_THAN_OR_EQUAL: "gte",
  LESS_THAN: "lt",
  LESS_THAN_OR_EQUAL: "lte",
  REGEX: "regex",
  IN: "in",
  NOT_IN: "nin",
  IS_NOT_NULL: "ne",
  HAS_SOME: "hasSome",
  HAS_NONE: "hasNone"
});

// src/primitives/mongo-filters-schema/mongo-filter-input-schemas/date-filter-input-schema.ts
import { oz as oz27 } from "@vy/utils";
var DateFilterOperatorSchema = oz27.union([
  oz27.literal(MONGO_FILTER_OPERATORS.EQUALS),
  oz27.literal(MONGO_FILTER_OPERATORS.LESS_THAN),
  oz27.literal(MONGO_FILTER_OPERATORS.GREATER_THAN),
  oz27.literal(MONGO_FILTER_OPERATORS.LESS_THAN_OR_EQUAL),
  oz27.literal(MONGO_FILTER_OPERATORS.GREATER_THAN_OR_EQUAL)
]);
var DateFilterInputSchema = oz27.object({
  field: oz27.string(),
  operator: DateFilterOperatorSchema,
  value: oz27.union([oz27.string().datetime(), oz27.array(oz27.string().datetime())])
}).openapi("DateFilterInput");

// src/primitives/mongo-filters-schema/mongo-filter-input-schemas/enum-filter-input-schema.ts
import { oz as oz28 } from "@vy/utils";
var EnumFilterOperatorSchema = oz28.union([
  oz28.literal(MONGO_FILTER_OPERATORS.EQUALS),
  oz28.literal(MONGO_FILTER_OPERATORS.IN),
  oz28.literal(MONGO_FILTER_OPERATORS.NOT_IN)
]);
var EnumFilterInputSchema = oz28.object({
  field: oz28.string(),
  operator: EnumFilterOperatorSchema,
  value: oz28.union([oz28.string(), oz28.array(oz28.string())])
}).openapi("EnumFilterInput");

// src/primitives/mongo-filters-schema/mongo-filter-input-schemas/number-filter-input-schema.ts
import { oz as oz29 } from "@vy/utils";
var NumberFilterOperatorSchema = oz29.union([
  oz29.literal(MONGO_FILTER_OPERATORS.EQUALS),
  oz29.literal(MONGO_FILTER_OPERATORS.GREATER_THAN),
  oz29.literal(MONGO_FILTER_OPERATORS.GREATER_THAN_OR_EQUAL),
  oz29.literal(MONGO_FILTER_OPERATORS.LESS_THAN),
  oz29.literal(MONGO_FILTER_OPERATORS.LESS_THAN_OR_EQUAL)
]);
var NumberFilterInputSchema = oz29.object({
  field: oz29.string(),
  operator: NumberFilterOperatorSchema,
  value: oz29.union([oz29.number(), oz29.array(oz29.number())])
}).openapi("NumberFilterInput");

// src/primitives/mongo-filters-schema/mongo-filter-input-schemas/string-filter-input-schema.ts
import { oz as oz30 } from "@vy/utils";
var StringFilterOperatorSchema = oz30.union([
  oz30.literal(MONGO_FILTER_OPERATORS.EQUALS),
  oz30.literal(MONGO_FILTER_OPERATORS.IN),
  oz30.literal(MONGO_FILTER_OPERATORS.NOT_IN),
  oz30.literal(MONGO_FILTER_OPERATORS.REGEX)
]);
var StringFilterInputSchema = oz30.object({
  field: oz30.string(),
  operator: StringFilterOperatorSchema,
  value: oz30.string()
}).openapi("StringFilterInput");

// src/primitives/mongo-filters-schema/mongo-filter-input-schemas/boolean-filter-input-schema.ts
import { oz as oz31 } from "@vy/utils";
var BooleanFilterOperatorSchema = oz31.union([
  oz31.literal(MONGO_FILTER_OPERATORS.EQUALS),
  oz31.literal(MONGO_FILTER_OPERATORS.IN)
]);
var BooleanFilterInputSchema = oz31.object({
  field: oz31.string(),
  operator: BooleanFilterOperatorSchema,
  value: oz31.union([oz31.boolean(), oz31.array(oz31.boolean())])
}).openapi("BooleanFilterInput");

// src/primitives/months-schema.ts
import { oz as oz32 } from "@vy/utils";
var MONTHS_ENUM = Object.freeze({
  January: "January",
  February: "February",
  March: "March",
  April: "April",
  May: "May",
  June: "June",
  July: "July",
  August: "August",
  September: "September",
  October: "October",
  November: "November",
  December: "December"
});
var MONTHS = Object.freeze([
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
]);
var MonthsSchema = oz32.enum(MONTHS);

// src/primitives/object-id-schema/index.ts
import { oz as oz33 } from "@vy/utils";

// src/primitives/object-id-schema/object-id-schema-consts.ts
var ID_PATTERN = /^[0-9a-fA-F]{24}$/;

// src/primitives/object-id-schema/index.ts
var ObjectIdSchema = oz33.string().regex(ID_PATTERN, "Invalid ObjectId");

// src/primitives/overage-settings-schema.ts
import { oz as oz34 } from "@vy/utils";
var OVERAGE_SETTINGS = Object.freeze({
  NoCharge: "NoCharge",
  ChargeTier: "ChargeTier",
  ChargeExtras: "ChargeExtras"
});
var OverageSettingsSchema = oz34.nativeEnum(OVERAGE_SETTINGS).openapi("OverageSettings");

// src/primitives/pagination-schema/page-number-schema.ts
import { oz as oz38 } from "@vy/utils";

// src/utils/created-entity.ts
import { oz as oz35 } from "@vy/utils";
var CreatedEntitySchema = oz35.object({
  id: oz35.string(),
  createdAt: ApiDateSchema,
  updatedAt: ApiDateSchema
});

// src/utils/created.ts
function created(entity) {
  return entity.merge(CreatedEntitySchema);
}

// src/utils/created-entities.ts
function createdEntities(entity) {
  return created(entity).array();
}

// src/utils/deleted-entity.ts
import { oz as oz36 } from "@vy/utils";
var DeletedEntitySchema = oz36.object({
  deletedAt: oz36.date()
});

// src/utils/deleted.ts
function deleted(entity) {
  return created(entity).merge(DeletedEntitySchema);
}

// src/utils/literal-transforms.ts
import { oz as oz37 } from "@vy/utils";
var nullToUndefined = oz37.literal(null).transform(() => void 0);
function withNullAsOptional(schema) {
  return schema.optional().or(nullToUndefined);
}

// src/utils/mask-token.ts
function maskToken(value) {
  return value.length > 5 ? value.slice(0, 5) + "*".repeat(value.length - 5) : value;
}

// src/utils/pagination-consts.ts
var DEFAULT_PAGE_NUMBER = 0;
var DEFAULT_PAGE_SIZE = 10;
var MAX_PAGE_SIZE = 1e3;
var ALL_ITEMS_PAGE_SIZE_CODE = -1;

// src/utils/segregated.ts
function segregated(entity) {
  return created(entity).extend({
    accountId: ObjectIdSchema
  });
}

// src/primitives/pagination-schema/page-number-schema.ts
var PageNumberSchema = oz38.coerce.number().default(DEFAULT_PAGE_NUMBER);

// src/primitives/pagination-schema/pagination-schema.ts
import { oz as oz40 } from "@vy/utils";

// src/primitives/pagination-schema/page-size-schema.ts
import { oz as oz39 } from "@vy/utils";
var PageSizeSchema = oz39.coerce.number().optional().default(DEFAULT_PAGE_SIZE);

// src/primitives/pagination-schema/pagination-schema.ts
var PaginationSchema = oz40.object({
  page: PageNumberSchema,
  pageSize: PageSizeSchema
});

// src/primitives/password-confirmation-schema.ts
import { oz as oz41 } from "@vy/utils";
var passwordConfirmationSchema = oz41.string().min(1, "Confirmation password is required").openapi("PasswordConfirmationSchema");

// src/primitives/password-schema/index.ts
import { oz as oz42 } from "@vy/utils";
var PasswordSchema = oz42.string().min(8, "Must be at least 8 characters long").regex(/[A-Z]/, "Must contain an uppercase letter").regex(/[a-z]/, "Must contain a lowercase letter").regex(/[0-9]/, "Must contain a number").regex(/[^A-Za-z0-9]/, "Must contain a special character").openapi("Password");

// src/primitives/payment-info-schema.ts
import { oz as oz43 } from "@vy/utils";
var PaymentInfoSchema = oz43.object({
  transactionId: oz43.string().optional(),
  date: ApiDateSchema.optional(),
  paymentMethod: oz43.string().optional(),
  paymentMethodId: oz43.string().optional(),
  amount: oz43.number().positive({ message: "Amount must be greater than 0" }).optional(),
  currency: CurrencySchema.optional(),
  status: oz43.string().optional(),
  note: oz43.string().optional(),
  customerId: oz43.string().optional(),
  depositTo: oz43.object({
    id: oz43.string().optional(),
    name: oz43.string()
  }).optional()
}).openapi("PaymentInfo");

// src/primitives/payment-provider-schema.ts
import { oz as oz44 } from "@vy/utils";
var PAYMENT_PROVIDERS = Object.freeze({
  PayPal: "PayPal",
  Stripe: "Stripe",
  Wire: "Wire",
  ACH: "ACH",
  Vayu: "Vayu",
  Wallet: "Wallet",
  NetSuite: "NetSuite",
  QuickBooks: "QuickBooks",
  Xero: "Xero"
});
var PaymentProviderSchema = oz44.nativeEnum(PAYMENT_PROVIDERS).openapi("PaymentProvider");
function toPaymentProvider(value) {
  const result = PaymentProviderSchema.safeParse(value);
  return result.success ? result.data : void 0;
}

// src/primitives/payment-status-schema.ts
import { oz as oz45 } from "@vy/utils";
var PAYMENT_STATUSES = Object.freeze({
  Success: "Success"
});
var PaymentStatusSchema = oz45.nativeEnum(PAYMENT_STATUSES).openapi("PaymentStatus");

// src/primitives/payment-term-schema.ts
import { oz as oz46 } from "@vy/utils";
var PAYMENT_TERMS = Object.freeze({
  Prepayment: "Prepayment",
  Postpayment: "Postpayment"
});
var PaymentTermSchema = oz46.nativeEnum(PAYMENT_TERMS).openapi("PaymentTerm");

// src/primitives/reset-password-schema.ts
import { oz as oz47 } from "@vy/utils";
var ResetPasswordSchema = oz47.object({
  password: PasswordSchema,
  confirmPassword: PasswordSchema
}).refine((data) => data.password === data.confirmPassword, {
  message: "Passwords don't match",
  path: ["confirmPassword"]
});

// src/primitives/sale-tax-schema.ts
import { oz as oz48 } from "@vy/utils";
var SaleTaxSchema = oz48.object({
  finalSaleTax: oz48.number().nullish(),
  modifiedSaleTax: oz48.number().nullish(),
  autoSaleTax: oz48.number().nullish(),
  autoSaleTaxProvider: oz48.string().nullish()
}).openapi("SaleTax");

// src/primitives/sanity-check-report-schema.ts
import { oz as oz50 } from "@vy/utils";

// src/primitives/sanity-check-status-schema.ts
import { oz as oz49 } from "@vy/utils";
var SANITY_CHECK_STATUSES = Object.freeze({
  Error: "Error",
  Success: "Success"
});
var SanityCheckStatusSchema = oz49.nativeEnum(SANITY_CHECK_STATUSES);

// src/primitives/sanity-check-report-schema.ts
var SanityCheckReportSchema = oz50.array(
  oz50.object({
    test: oz50.string(),
    id: oz50.string(),
    status: SanityCheckStatusSchema,
    description: oz50.string().optional()
  })
);

// src/primitives/sanity-check-tests-schema.ts
import { oz as oz51 } from "@vy/utils";
var SANITY_CHECK_TESTS = Object.freeze({
  ContractContinuity: "contract continuity",
  CustomerRevenue: "customer revenue",
  InvoiceLineItem: "invoice total line items",
  InvoiceContinuity: "invoice continuity",
  UniqueMeasurements: "unique measurements",
  UniqueEvents: "unique events",
  MeasurementEventMatch: "measurement event match"
});
var SanityCheckTestSchema = oz51.nativeEnum(SANITY_CHECK_TESTS);

// src/primitives/scalar-value-schema.ts
import { oz as oz52 } from "@vy/utils";
var ScalarValueSchema = oz52.union([oz52.string(), oz52.number(), oz52.null()]).openapi("ScalarValue");

// src/primitives/sorting-item-schema.ts
import { oz as oz53 } from "@vy/utils";
var SORTING_OPTIONS = {
  ASC: "asc",
  DESC: "desc"
};
var SortingItemSchema = oz53.object({
  field: oz53.string().optional(),
  sort: oz53.enum([SORTING_OPTIONS.ASC, SORTING_OPTIONS.DESC]).optional()
}).openapi("SortingItem");

// src/primitives/sql-safe-string-schema.ts
import { oz as oz54 } from "@vy/utils";
import * as SqlString from "sqlstring";
var SqlSafeStringSchema = oz54.string().transform((value) => SqlString.escape(value).slice(1, -1));

// src/primitives/marketplace-sync-filter-statuses.ts
import { oz as oz55 } from "@vy/utils";
var MARKETPLACE_SYNC_FILTER_STATUSES = Object.freeze({
  Synced: "Synced",
  Failed: "Failed",
  Processing: "Processing",
  None: "None"
});
var MarketplaceSyncFilterStatusSchema = oz55.nativeEnum(MARKETPLACE_SYNC_FILTER_STATUSES);

// src/primitives/sync-status-schema.ts
import { parseJson as parseJson5, oz as oz56 } from "@vy/utils";
var SYNC_STATUSES = Object.freeze({
  None: "None",
  Synced: "Synced",
  Failed: "Failed"
});
var SyncStatusSchema = oz56.nativeEnum(SYNC_STATUSES).openapi("SyncStatus");
var SyncStatusesSchema = oz56.string().transform((s) => parseJson5(s)).pipe(SyncStatusSchema.array().optional()).optional();

// src/primitives/tax-rate-schema.ts
import { oz as oz57 } from "@vy/utils";
var TaxRateSchema = oz57.number().min(0).max(100).nullable();

// src/primitives/time-slot-schema.ts
import { oz as oz58 } from "@vy/utils";
var TimeSlotSchema = oz58.object({
  year: oz58.number().int().min(0),
  month: oz58.number().int().min(0).max(12),
  day: oz58.number().int().min(1).max(31)
});

// src/primitives/time-units-schema.ts
import { oz as oz59 } from "@vy/utils";
var TIME_UNITS = Object.freeze({
  MONTH: "month",
  YEAR: "year",
  DAY: "day",
  WEEK: "week"
});
var TimeUnitsSchema = oz59.nativeEnum(TIME_UNITS).openapi("TimeUnits");

// src/primitives/unlimited-duration-schema.ts
import { oz as oz60 } from "@vy/utils";
var UNLIMITED_DURATION = -1;
var MAX_DURATION = 12 * 5;
var UnlimitedDurationSchema = oz60.literal(UNLIMITED_DURATION).openapi("UnlimitedDuration");

// src/primitives/user-input-billing-interval-schema.ts
import { oz as oz61 } from "@vy/utils";
var UserInputBillingIntervalSchema = oz61.nativeEnum(BILLING_INTERVALS, {
  errorMap: (issue, ctx) => {
    if (issue.code === "invalid_enum_value") {
      return { message: "Billing interval is required." };
    }
    return { message: ctx.defaultError };
  }
}).openapi("UserInputBillingInterval");

// src/primitives/username-schema.ts
import { oz as oz62 } from "@vy/utils";
var UsernameSchema = oz62.string().email().openapi("Username");

// src/primitives/vy-error.ts
var VyError = class extends Error {
  constructor(message, statusCode) {
    super(message);
    this.statusCode = statusCode;
  }
};

// src/entities/account-settings/new-account-settings-schema.ts
import { oz as oz68 } from "@vy/utils";

// src/entities/bank-details/new-bank-details-schema.ts
import { oz as oz63 } from "@vy/utils";
var NewBankDetailsSchema = oz63.object({
  bankName: withNullAsOptional(oz63.string()),
  routingNumber: withNullAsOptional(oz63.string()),
  companyName: withNullAsOptional(oz63.string()),
  accountNumber: withNullAsOptional(oz63.string()),
  address: withNullAsOptional(AddressSchema),
  swiftCode: withNullAsOptional(oz63.string()),
  abaNumber: withNullAsOptional(oz63.string()),
  sortCode: withNullAsOptional(oz63.string())
}).openapi("NewBankDetails");

// src/entities/billing-settings/new-billing-settings-schema.ts
import { oz as oz64 } from "@vy/utils";
var NewBillingSettingsSchema = oz64.object({
  billingCycle: PeriodSchema.optional(),
  decimalPrecision: oz64.number().min(0).max(10).optional()
}).openapi("NewBillingSettings");

// src/entities/invoicing-settings/invoicing-settings-schema.ts
import { oz as oz65 } from "@vy/utils";
var BaseInvoicingSettingsSchema = oz65.object({
  hideZeroAmountLineItems: oz65.boolean().default(false),
  showConsumptionBreakdown: oz65.boolean().default(false),
  forceCommitmentBreakdown: oz65.boolean().default(false),
  hidePriceBreakdownInInvoicePdf: oz65.boolean().default(false).optional(),
  showPaymentWalletInfo: oz65.boolean().default(false),
  issueOnApproval: oz65.boolean().default(false),
  excludeUsdtWallet: oz65.boolean().default(false).optional(),
  sendInvoiceOnApproval: oz65.boolean().default(false),
  defaultPaymentDueDays: oz65.number().optional(),
  issueOnEndOfMonth: oz65.boolean().default(false),
  deductCredits: oz65.boolean().default(false).optional(),
  showCustomerPortalLink: oz65.boolean().optional(),
  showProductVariantOnInvoice: oz65.boolean().default(false).optional(),
  creditOnPrepaidRevision: oz65.boolean().default(false).optional(),
  restrictPaymentsToCreditPoolBalance: oz65.boolean().default(false).optional()
});
var InvoicingSettingsSchema = BaseInvoicingSettingsSchema;

// src/feature-flags/feature-flag.ts
var FEATURE_FLAG = Object.freeze({
  WORKFLOWS: "workflows"
});

// src/entities/account-settings/email-settings/email-settings-schema.ts
import { oz as oz66 } from "@vy/utils";
var EmailSettingsSchema = oz66.object({
  senderAddressOverride: oz66.string().email().optional(),
  bccEmails: oz66.array(oz66.string().email()).optional(),
  billingEmail: oz66.string().email().or(oz66.literal("")).optional()
}).openapi("EmailSettings");

// src/entities/account-settings/security-settings-schema.ts
import { oz as oz67 } from "@vy/utils";
var AccountSecuritySettingsSchema = oz67.object({
  apiToken: oz67.string().optional(),
  apiThrottlingKey: oz67.string().optional()
}).openapi("AccountSecuritySettings");

// src/entities/account-settings/new-account-settings-schema.ts
var NewAccountSettingsSchema = oz68.object({
  address: withNullAsOptional(AddressSchema),
  billingSettings: withNullAsOptional(NewBillingSettingsSchema),
  bankDetails: withNullAsOptional(NewBankDetailsSchema),
  invoicingSettings: withNullAsOptional(InvoicingSettingsSchema),
  emailSettings: withNullAsOptional(EmailSettingsSchema),
  securitySettings: withNullAsOptional(AccountSecuritySettingsSchema),
  taxId: oz68.string().optional(),
  enabledFeatures: oz68.nativeEnum(FEATURE_FLAG).array().optional(),
  inboundEmailLocalPart: oz68.string().optional(),
  inboundEmailAllowedSenders: oz68.string().array().optional()
}).openapi("NewAccountSettings");

// src/entities/account/new-account-schema.ts
var NewAccountSchema = oz69.object({
  name: oz69.string().nonempty(),
  logoUrl: oz69.string().optional(),
  settings: NewAccountSettingsSchema,
  contact: withNullAsOptional(ContactSchema)
}).openapi("NewAccount");

// src/entities/account-settings/account-settings-schema.ts
import { oz as oz72 } from "@vy/utils";

// src/entities/workflows/workflow-action-id.ts
import { values } from "@vy/utils";
var WORKFLOW_ACTION_ID = Object.freeze({
  HANDLE_TIER_CROSS: "handle-tier-cross"
});
function isWorkflowActionId(value) {
  return values(WORKFLOW_ACTION_ID).includes(value);
}

// src/entities/workflows/workflow-template-id.ts
import { values as values2 } from "@vy/utils";
var WORKFLOW_TEMPLATE_ID = Object.freeze({
  AUTO_APPROVE_INVOICES: "auto-approve-invoices",
  CUSTOM_ACTIONS: "custom-actions"
});
function isWorkflowTemplateId(value) {
  return values2(WORKFLOW_TEMPLATE_ID).includes(value);
}

// src/entities/bank-details/bank-details-schema.ts
var BankDetailsSchema = NewBankDetailsSchema.openapi("BankDetails");

// src/entities/billing-settings/billing-settings-schema.ts
var BillingSettingsSchema = NewBillingSettingsSchema.openapi("BillingSettings");

// src/entities/account-settings/metering-settings/metering-settings-schema.ts
import { oz as oz70 } from "@vy/utils";
var MeteringSettingsSchema = oz70.object({
  manualMetering: oz70.boolean()
});

// src/entities/account-settings/product-settings/product-settings-schema.ts
import { oz as oz71 } from "@vy/utils";
var TieredSubscriptionSettingsSchema = oz71.object({
  payInAdvanceOnTierCross: oz71.boolean().optional()
});
var AccountProductSettingsSchema = oz71.object({
  tieredSubscription: TieredSubscriptionSettingsSchema.optional(),
  treatLastAsDaily: oz71.boolean().optional()
});

// src/entities/account-settings/account-settings-schema.ts
var AccountSettingsSchema = NewAccountSettingsSchema.extend({
  billingSettings: BillingSettingsSchema.optional(),
  invoicingSettings: InvoicingSettingsSchema.optional(),
  bankDetails: withNullAsOptional(BankDetailsSchema),
  emailSettings: withNullAsOptional(EmailSettingsSchema),
  meteringSettings: withNullAsOptional(MeteringSettingsSchema),
  productSettings: withNullAsOptional(AccountProductSettingsSchema),
  securitySettings: withNullAsOptional(AccountSecuritySettingsSchema),
  enabledWorkflowTemplates: oz72.nativeEnum(WORKFLOW_TEMPLATE_ID).array().optional(),
  enabledWorkflowActions: oz72.nativeEnum(WORKFLOW_ACTION_ID).array().optional()
}).openapi("AccountSettings");

// src/entities/account/account-schema.ts
var AccountSchema = created(NewAccountSchema).extend({
  settings: AccountSettingsSchema
}).openapi("Account");

// src/primitives/contact-input-schema.ts
import { oz as oz73 } from "@vy/utils";
var ContactInputSchema = ContactSchema.extend({
  email: oz73.string().regex(CONTACT_EMAIL_REGEX, CONTACT_EMAIL_VALIDATION_ERROR_MESSAGE).optional()
});

// src/entities/account-settings/account-settings-input-schema.ts
var AccountSettingsInputSchema = NewAccountSettingsSchema.partial().openapi("AccountSettingsInput");

// src/entities/account/account-input-schema.ts
var AccountInputSchema = NewAccountSchema.extend({
  settings: AccountSettingsInputSchema,
  contact: ContactInputSchema
}).partial().openapi("AccountInput");

// src/entities/billing-cycle/billing-cycle-schema.ts
import { oz as oz181 } from "@vy/utils";

// src/entities/customer/new-customer-schema.ts
import { oz as oz173 } from "@vy/utils";

// src/entities/integration-entity/customer-integration-entity/customer-integration-entity.ts
import { oz as oz164 } from "@vy/utils";

// src/entities/integration-entity/customer-integration-entity/customer-integration-entities/customer-hubspot-entity.ts
import { oz as oz157 } from "@vy/utils";

// src/entities/integrations/aws/aws-auth-data-schema.ts
import { oz as oz74 } from "@vy/utils";

// src/entities/integrations/aws/aws-types.ts
var AWS_REGIONS = [
  "us-east-1",
  // US East (N. Virginia)
  "us-east-2",
  // US East (Ohio)
  "us-west-1",
  // US West (N. California)
  "us-west-2",
  // US West (Oregon)
  "af-south-1",
  // Africa (Cape Town)
  "ap-east-1",
  // Asia Pacific (Hong Kong)
  "ap-south-1",
  // Asia Pacific (Mumbai)
  "ap-south-2",
  // Asia Pacific (Hyderabad)
  "ap-southeast-1",
  // Asia Pacific (Singapore)
  "ap-southeast-2",
  // Asia Pacific (Sydney)
  "ap-southeast-3",
  // Asia Pacific (Jakarta)
  "ap-southeast-4",
  // Asia Pacific (Melbourne)
  "ap-northeast-1",
  // Asia Pacific (Tokyo)
  "ap-northeast-2",
  // Asia Pacific (Seoul)
  "ap-northeast-3",
  // Asia Pacific (Osaka)
  "ca-central-1",
  // Canada (Central)
  "ca-west-1",
  // Canada West (Calgary)
  "eu-central-1",
  // Europe (Frankfurt)
  "eu-central-2",
  // Europe (Zurich)
  "eu-west-1",
  // Europe (Ireland)
  "eu-west-2",
  // Europe (London)
  "eu-west-3",
  // Europe (Paris)
  "eu-north-1",
  // Europe (Stockholm)
  "eu-south-1",
  // Europe (Milan)
  "eu-south-2",
  // Europe (Spain)
  "il-central-1",
  // Israel (Tel Aviv)
  "me-central-1",
  // Middle East (UAE)
  "me-south-1",
  // Middle East (Bahrain)
  "sa-east-1"
  // South America (São Paulo)
];
var AWS_REGIONS_MAP = Object.fromEntries(AWS_REGIONS.map((region) => [region, region]));

// src/entities/integrations/aws/aws-auth-data-schema.ts
var AWSAuthDataSchema = oz74.object({
  accountId: oz74.string(),
  region: oz74.nativeEnum(AWS_REGIONS_MAP, {
    errorMap: (issue, ctx) => {
      if (issue.code === "invalid_enum_value") {
        return { message: "Region is required." };
      }
      return { message: ctx.defaultError };
    }
  })
}).openapi("AWSAuthData");

// src/entities/integrations/aws/s3/s3-auth-data-schema.ts
import { oz as oz75 } from "@vy/utils";
var S3AuthDataSchema = AWSAuthDataSchema.extend({
  bucketName: oz75.string()
}).omit({ accountId: true }).openapi("S3AuthData");

// src/entities/integrations/bearer/bearer-token-schema.ts
import { oz as oz76 } from "@vy/utils";
var BearerTokenSchema = oz76.string().transform(maskToken);

// src/entities/integrations/configuration/base-configuration-schema.ts
import { oz as oz77 } from "@vy/utils";
var BaseIntegrationConfigurationSchema = oz77.object({}).openapi("BaseIntegrationConfiguration");

// src/entities/integrations/configuration/advanced-filter/advanced-filter-schema.ts
import { oz as oz79 } from "@vy/utils";

// src/entities/integrations/configuration/advanced-filter/filter-operator-schema.ts
import { oz as oz78 } from "@vy/utils";
var FILTER_OPERATORS = Object.freeze({
  equals: "equals",
  notEquals: "notEquals",
  contains: "contains",
  notContains: "notContains",
  startsWith: "startsWith",
  endsWith: "endsWith",
  greaterThan: "greaterThan",
  greaterThanOrEquals: "greaterThanOrEquals",
  lessThan: "lessThan",
  lessThanOrEquals: "lessThanOrEquals",
  isNull: "isNull",
  isNotNull: "isNotNull"
});
var FilterOperatorsSchema = oz78.nativeEnum(FILTER_OPERATORS);

// src/entities/integrations/configuration/advanced-filter/advanced-filter-schema.ts
var AdvancedFilterSchema = oz79.object({
  filterOperator: FilterOperatorsSchema,
  field: oz79.string(),
  value: oz79.string().optional()
}).openapi("AdvancedFilter");

// src/entities/integrations/connected-integrations-schema.ts
import { oz as oz81 } from "@vy/utils";

// src/entities/integrations/integration-providers-schema.ts
import { oz as oz80 } from "@vy/utils";
var INTEGRATION_PROVIDERS = Object.freeze({
  hubspot: "Hubspot",
  stripe: "Stripe",
  netSuite: "NetSuite",
  salesforce: "Salesforce",
  quickBooks: "QuickBooks",
  slack: "Slack",
  S3: "S3",
  vayu: "Vayu",
  morning: "Morning",
  anrok: "Anrok",
  snowflake: "Snowflake",
  connact: "Connact",
  xero: "Xero",
  paddle: "Paddle"
});
var IntegrationProvidersSchema = oz80.nativeEnum(INTEGRATION_PROVIDERS).openapi("IntegrationProviders");

// src/entities/integrations/connected-integrations-schema.ts
var ConnectedIntegrationsSchema = oz81.array(IntegrationProvidersSchema).openapi("ConnectedIntegrations");

// src/entities/integrations/custom-field/custom-field-schema.ts
import { oz as oz82 } from "@vy/utils";
var CustomFieldSchema = oz82.object({
  internalKey: oz82.string(),
  externalKey: oz82.string().optional(),
  value: ScalarValueSchema.nullable()
}).openapi("CustomField");

// src/entities/integrations/entity-mapping/entity-mapping-schema.ts
import { oz as oz84 } from "@vy/utils";

// src/entities/integrations/entity-mapping/field-mapping-schema.ts
import { oz as oz83 } from "@vy/utils";
var FieldMappingSchema = oz83.object({
  accessor: oz83.string().array().min(1),
  name: oz83.string()
}).openapi("FieldMapping");

// src/entities/integrations/entity-mapping/entity-mapping-schema.ts
var EntityMappingSchema = oz84.object({
  entity: oz84.string(),
  fields: FieldMappingSchema.array()
}).openapi("EntityMapping");

// src/entities/integrations/hubspot/hubspot-create-token-actions.ts
import { oz as oz85 } from "@vy/utils";
var HUBSPOT_CREATE_TOKEN_ACTIONS = Object.freeze({
  refreshToken: "refresh_token",
  authCode: "authorization_code"
});
var hubspotCreateTokenActionsSchema = oz85.nativeEnum(HUBSPOT_CREATE_TOKEN_ACTIONS);

// src/entities/integrations/hubspot/hubspot-company-schemas/hubspot-company-properties-schema.ts
import { oz as oz86 } from "@vy/utils";
var HubspotCompanyPropertiesSchema = oz86.object({
  name: oz86.string().nullish(),
  createdate: oz86.string().nullish(),
  city: oz86.string().nullish(),
  country: oz86.string().nullish(),
  address: oz86.string().nullish(),
  zip: oz86.string().nullish(),
  hubspot_owner_id: oz86.string().nullish(),
  phone: oz86.string().nullish(),
  recent_deal_close_date: oz86.string().nullish(),
  contactsIds: oz86.array(oz86.string()).optional(),
  state: oz86.string().nullish(),
  nickname: oz86.string().nullish(),
  client_id: oz86.string().nullish()
}).openapi("HubspotCompanyProperties");

// src/entities/integrations/hubspot/hubspot-company-schemas/hubspot-company-schema.ts
import { oz as oz89 } from "@vy/utils";

// src/entities/integrations/hubspot/hubspot-contact-schemas/hubspot-contact-schema.ts
import { oz as oz88 } from "@vy/utils";

// src/entities/integrations/hubspot/hubspot-contact-schemas/hubspot-contact-properties-schema.ts
import { oz as oz87 } from "@vy/utils";
var HubspotContactPropertiesSchema = oz87.object({
  firstname: oz87.string().optional(),
  lastname: oz87.string().optional(),
  email: oz87.string().optional(),
  phone: oz87.string().optional()
}).openapi("HubspotContactProperties");

// src/entities/integrations/hubspot/hubspot-contact-schemas/hubspot-contact-schema.ts
var HubspotContactSchema = oz88.object({
  id: oz88.string(),
  properties: HubspotContactPropertiesSchema
}).openapi("HubspotContact");

// src/entities/integrations/hubspot/hubspot-company-schemas/hubspot-company-schema.ts
var HubspotCompanySchema = oz89.object({
  id: oz89.string(),
  properties: HubspotCompanyPropertiesSchema,
  currency: CurrencySchema.nullish(),
  contacts: oz89.array(HubspotContactSchema).optional()
}).openapi("HubspotCompany");

// src/entities/integrations/hubspot/hubspot-integration-schemas/hubspot-integration-configuration.ts
import { oz as oz91 } from "@vy/utils";

// src/entities/integrations/oauth/oauth2-data-schema.ts
import { oz as oz90 } from "@vy/utils";
var OAuth2DataSchema = oz90.object({
  state: oz90.string().optional(),
  redirectUrl: oz90.string().optional(),
  accessToken: oz90.string().optional(),
  refreshToken: oz90.string().optional(),
  expiresAt: ApiDateSchema.optional(),
  portalId: oz90.string().optional()
});

// src/entities/integrations/hubspot/hubspot-integration-schemas/hubspot-integration-configuration.ts
var HubspotIntegrationConfigurationSchema = BaseIntegrationConfigurationSchema.extend({
  authData: OAuth2DataSchema,
  customFieldMapping: EntityMappingSchema.array().optional(),
  autoImportCustomers: oz91.boolean().optional().default(false),
  autoImportContracts: oz91.boolean().optional().default(false)
}).openapi("HubspotIntegrationConfiguration");
var PartialHubspotIntegrationConfigurationSchema = HubspotIntegrationConfigurationSchema.partial().strict();

// src/entities/integrations/hubspot/hubspot-integration-schemas/hubspot-integration-settings.ts
import { oz as oz92 } from "@vy/utils";
var HubspotIntegrationSettingsSchema = oz92.object({
  integrationProvider: oz92.literal(INTEGRATION_PROVIDERS.hubspot),
  integrationConfiguration: HubspotIntegrationConfigurationSchema
}).openapi("HubspotIntegrationSettings");

// src/entities/integrations/hubspot/hubspot-product-schemas/hubspot-product-properties-schema.ts
import { oz as oz93 } from "@vy/utils";
var HubspotProductPropertiesSchema = oz93.object({
  createdate: oz93.string().nullish(),
  description: oz93.string().nullish(),
  hs_lastmodifieddate: oz93.string().nullish(),
  hs_object_id: oz93.string().nullish(),
  name: oz93.string(),
  price: oz93.string().nullish(),
  hs_sku: oz93.string().nullish(),
  hs_recurring_billing_period: oz93.string().nullish(),
  hs_cost_of_goods_sold: oz93.string().nullish(),
  hs_product_type: oz93.string().nullish(),
  hs_recurring_billing_frequency: oz93.string().nullish(),
  hs_folder_id: oz93.string().nullish()
}).openapi("HubspotProductProperties");

// src/entities/integrations/hubspot/hubspot-product-schemas/hubspot-product-schema.ts
import { oz as oz94 } from "@vy/utils";
var HubspotProductSchema = oz94.object({
  id: oz94.string(),
  properties: HubspotProductPropertiesSchema,
  createdAt: oz94.string().optional(),
  updatedAt: oz94.string().optional(),
  archived: oz94.boolean(),
  archivedAt: oz94.string().optional()
}).openapi("HubspotProduct");

// src/entities/integrations/hubspot/hubspot-deal-schemas/hubspot-deal-properties-schema.ts
import { oz as oz95 } from "@vy/utils";
var HubspotDealPropertiesSchema = oz95.object({
  amount: oz95.number(),
  closedate: oz95.string().optional(),
  createdate: oz95.string().optional(),
  dealname: oz95.string(),
  dealstage: oz95.string().optional(),
  hs_lastmodifieddate: oz95.string().optional(),
  hs_object_id: oz95.string().optional(),
  pipeline: oz95.string().optional(),
  dealtype: oz95.string().optional(),
  primary_company: oz95.string().optional(),
  hubspot_owner_id: oz95.string().optional(),
  deal_currency_code: oz95.string().optional(),
  rawSyncedData: oz95.record(oz95.string(), oz95.string()).optional()
}).openapi("HubspotDealProperties");

// src/entities/integrations/hubspot/hubspot-deal-schemas/hubspot-deal-associations-schema.ts
import { oz as oz97 } from "@vy/utils";

// src/entities/integrations/hubspot/hubspot-deal-schemas/hubspot-deal-association-result-schema.ts
import { oz as oz96 } from "@vy/utils";
var resultSchema = oz96.object({
  id: oz96.string(),
  type: oz96.string()
});

// src/entities/integrations/hubspot/hubspot-deal-schemas/hubspot-deal-associations-schema.ts
var HubspotDealAssociationsSchema = oz97.object({
  companies: oz97.array(resultSchema).nullish(),
  lineItems: oz97.array(resultSchema).nullish()
}).openapi("HubspotDealAssociations");

// src/entities/integrations/hubspot/hubspot-deal-schemas/hubspot-deal-schema.ts
import { oz as oz98 } from "@vy/utils";
var HubspotDealSchema = oz98.object({
  id: oz98.string(),
  associations: HubspotDealAssociationsSchema,
  properties: HubspotDealPropertiesSchema,
  createdAt: oz98.string(),
  updatedAt: oz98.string(),
  archived: oz98.boolean(),
  startDate: oz98.string(),
  endDate: oz98.string(),
  signatureDate: oz98.string(),
  terminatedDate: oz98.string().optional(),
  autoRenewal: oz98.boolean().optional()
}).openapi("HubspotDeal");

// src/entities/integrations/hubspot/hubspot-deal-schemas/hubspot-owner-schema.ts
import { oz as oz99 } from "@vy/utils";
var HubspotOwnerSchema = oz99.object({
  id: oz99.string(),
  name: oz99.string()
}).openapi("HubspotOwner");

// src/entities/integrations/integration-export-schema.ts
import { oz as oz100 } from "@vy/utils";
import { SYNC_JOB_STATUSES, INTEGRATION_TYPES } from "@vy/integrations-types";
var IntegrationExportSchema = oz100.object({
  status: oz100.nativeEnum(SYNC_JOB_STATUSES),
  integration: oz100.nativeEnum(INTEGRATION_TYPES),
  date: ApiDateSchema,
  entityId: oz100.string().optional()
});

// src/entities/integrations/new-integration-schema.ts
import { oz as oz146 } from "@vy/utils";

// src/entities/integrations/integration-settings-schema.ts
import { oz as oz145 } from "@vy/utils";

// src/entities/integrations/net-suite/net-suite-invoice-schema.ts
import { oz as oz105 } from "@vy/utils";

// src/entities/integrations/net-suite/net-suite-billing-status-schema.ts
import { oz as oz101 } from "@vy/utils";
var NET_SUITE_BILLING_STATUSES = Object.freeze({
  Open: "Open",
  PendingApproval: "Pending Approval",
  PaidInFull: "Paid In Full",
  Rejected: "Rejected",
  Voided: "Voided"
});
var NetSuiteBillingStatusSchema = oz101.nativeEnum(NET_SUITE_BILLING_STATUSES).openapi("NetSuiteBillingStatus");

// src/entities/integrations/net-suite/net-suite-invoice-item-schema.ts
import { oz as oz104 } from "@vy/utils";

// src/entities/integrations/net-suite/netsuite-invoice-internal-item-schema.ts
import { oz as oz102 } from "@vy/utils";
var NetsuiteInvoiceInternalItemSchema = oz102.object({
  id: oz102.string()
});

// src/entities/integrations/net-suite/net-suite-invoice-item-class-schema.ts
import { oz as oz103 } from "@vy/utils";
var NetSuiteInvoiceItemClassSchema = oz103.object({
  id: oz103.string()
});

// src/entities/integrations/net-suite/net-suite-invoice-item-schema.ts
var NetSuiteInvoiceItemSchema = oz104.object({
  item: NetsuiteInvoiceInternalItemSchema,
  class: NetSuiteInvoiceItemClassSchema.optional(),
  quantity: oz104.number(),
  amount: oz104.number().optional(),
  description: oz104.string().optional(),
  memo: oz104.string().optional(),
  rate: oz104.number().optional(),
  discountRate: oz104.number().optional(),
  discountAmount: oz104.number().optional()
});

// src/entities/integrations/net-suite/net-suite-invoice-schema.ts
var NetsuiteInvoiceStatusSchema = oz105.object({
  id: NetSuiteBillingStatusSchema,
  refName: NetSuiteBillingStatusSchema
});
var NetsuiteItemEntitySchema = oz105.object({
  id: oz105.string()
});
var NetsuiteInvoiceAccountSchema = oz105.object({
  id: oz105.string()
});
var NetSuiteInvoiceSchema = oz105.object({
  id: oz105.string().optional(),
  tranId: oz105.string().optional(),
  startDate: ApiDateSchema,
  endDate: ApiDateSchema,
  tranDate: ApiDateSchema,
  dueDate: ApiDateSchema.nullish(),
  memo: oz105.string(),
  externalId: ObjectIdSchema,
  entity: NetsuiteItemEntitySchema,
  account: NetsuiteInvoiceAccountSchema.optional(),
  item: oz105.object({
    items: oz105.array(NetSuiteInvoiceItemSchema)
  }),
  discountItem: NetsuiteItemEntitySchema.optional(),
  discountRate: oz105.number().optional(),
  status: NetsuiteInvoiceStatusSchema.optional(),
  custbody_vayu_invoice_number: oz105.string().optional(),
  custbody_po_number: oz105.string().optional(),
  custbody_notes: oz105.string().optional(),
  toBeEmailed: oz105.boolean().optional()
});

// src/entities/integrations/net-suite/net-suite-integration-types-schema.ts
import { oz as oz106 } from "@vy/utils";
var NET_SUITE_INTEGRATION_TYPES = Object.freeze({
  UpsertInvoice: "upsertInvoice"
});
var NetSuiteIntegrationTypesSchema = oz106.nativeEnum(NET_SUITE_INTEGRATION_TYPES).openapi("NetSuiteIntegrationTypes");

// src/entities/integrations/net-suite/net-suite-sync-invoice-payload-schema.ts
import { oz as oz107 } from "@vy/utils";
var NetSuiteSyncInvoicePayloadSchema = oz107.object({
  integrationType: oz107.literal(NET_SUITE_INTEGRATION_TYPES.UpsertInvoice),
  uid: oz107.string(),
  data: NetSuiteInvoiceSchema
});

// src/entities/integrations/net-suite/net-suite-sync-invoice-response-schema.ts
import { oz as oz108 } from "@vy/utils";
var NetSuiteSyncInvoiceResponseSchema = oz108.object({
  recordId: oz108.string().or(oz108.number()),
  tranId: oz108.string()
});

// src/entities/integrations/net-suite/net-suite-invoice-response-schema.ts
import { oz as oz109 } from "@vy/utils";
var NetSuiteInvoiceResponseSchema = oz109.object({
  status: oz109.object({
    id: oz109.string(),
    refName: oz109.string()
  }),
  id: oz109.string(),
  amountRemaining: oz109.number(),
  externalId: oz109.string()
});

// src/entities/integrations/net-suite/net-suite-product-schema.ts
import { oz as oz110 } from "@vy/utils";
var NetSuiteProductSchema = oz110.object({
  id: oz110.string(),
  name: oz110.string(),
  subsidiary: oz110.string().optional()
});

// src/entities/integrations/net-suite/net-suite-class-schema.ts
import { oz as oz111 } from "@vy/utils";
var NetSuiteClassSchema = oz111.object({
  id: oz111.string(),
  name: oz111.string()
});

// src/entities/integrations/net-suite/net-suite-integration-settings.ts
import { oz as oz121 } from "@vy/utils";

// src/entities/integrations/net-suite/net-suite-integration-configuration.ts
import { oz as oz120 } from "@vy/utils";

// src/entities/system-intermediate-metadata-schemas/erp-metadata-schema.ts
import { oz as oz117 } from "@vy/utils";

// src/entities/integration-entity/system-provider-integration-entity/erp-provider-integration-entity.ts
import { oz as oz116 } from "@vy/utils";

// src/entities/integration-entity/base-integration-entity.ts
import { oz as oz112 } from "@vy/utils";
var BaseIntegrationEntitySchema = oz112.object({
  updatedAt: ApiDateSchema,
  integrationProvider: IntegrationProvidersSchema,
  integrationExternalId: oz112.string(),
  syncStatus: SyncStatusSchema,
  metadata: JsonSchema.nullish(),
  rawSyncedData: JsonSchema.nullish()
}).openapi("IntegrationEntity");

// src/entities/integration-entity/system-provider-integration-entity/system-integration-entity-metadata/erp-integration-entity-metadata.ts
import { oz as oz113 } from "@vy/utils";
var ERPIntegrationEntityMetadataSchema = oz113.object({
  name: oz113.string(),
  displayId: oz113.string().nullish()
});

// src/entities/integration-entity/system-provider-integration-entity/system-integration-entity-metadata/crm-integration-entity-metadata.ts
import { oz as oz114 } from "@vy/utils";
var CRMIntegrationEntityMetadataSchema = oz114.object({});

// src/entities/integration-entity/system-provider-integration-entity/system-integration-entity-metadata/payment-integration-entity-metadata.ts
import { oz as oz115 } from "@vy/utils";
var PaymentIntegrationEntityMetadataSchema = oz115.object({
  status: oz115.string(),
  link: oz115.string().nullish(),
  transactionId: oz115.string().nullish()
});

// src/entities/integration-entity/system-provider-integration-entity/erp-provider-integration-entity.ts
var ERP_INTEGRATION_PROVIDERS = Object.freeze({
  netSuite: INTEGRATION_PROVIDERS.netSuite,
  quickBooks: INTEGRATION_PROVIDERS.quickBooks,
  morning: INTEGRATION_PROVIDERS.morning,
  xero: INTEGRATION_PROVIDERS.xero
});
var ErpIntegrationProvidersSchema = oz116.nativeEnum(ERP_INTEGRATION_PROVIDERS);
var ErpProviderIntegrationEntitySchema = BaseIntegrationEntitySchema.extend({
  integrationProvider: ErpIntegrationProvidersSchema,
  metadata: ERPIntegrationEntityMetadataSchema
});

// src/entities/system-intermediate-metadata-schemas/erp-metadata-schema.ts
var ErpIntermediateMetadataSchema = oz117.object({
  erpId: SanitizedStringSchema,
  erpName: SanitizedStringSchema,
  displayId: SanitizedStringSchema.nullable().optional(),
  integrationSource: ErpIntegrationProvidersSchema.optional(),
  code: SanitizedStringSchema.optional()
}).openapi("ErpMetadata");

// src/entities/integrations/net-suite/net-suite-auth-schema.ts
import { oz as oz119 } from "@vy/utils";

// src/entities/integrations/net-suite/net-suite-auth-data-schema.ts
import { oz as oz118 } from "@vy/utils";
var NetSuiteRestAuthDataSchema = oz118.object({
  accountRealm: oz118.string(),
  certificateId: oz118.string(),
  clientId: oz118.string(),
  clientSecret: oz118.string().optional(),
  tokenId: oz118.string().optional(),
  tokenSecret: oz118.string().optional()
}).openapi("NetSuiteRestAuthData");
var NetSuiteSoapAuthDataSchema = oz118.object({
  accountRealm: oz118.string(),
  certificateId: oz118.string(),
  clientId: oz118.string(),
  clientSecret: oz118.string().optional(),
  tokenId: oz118.string().optional(),
  tokenSecret: oz118.string().optional()
}).openapi("NetSuiteSoapAuthData");

// src/entities/integrations/net-suite/net-suite-auth-schema.ts
var NetSuiteAuthDataSchema = NetSuiteRestAuthDataSchema.extend({
  integrationProvider: oz119.literal(INTEGRATION_PROVIDERS.netSuite).default(INTEGRATION_PROVIDERS.netSuite)
}).openapi("NetSuiteAuthData");

// src/entities/integrations/net-suite/net-suite-integration-configuration.ts
import {
  INVOICE_NUMBER_SYNC_STRATEGY,
  INVOICE_PAYMENT_STATUS_SYNC_STRATEGY,
  InvoiceNumberSyncStrategySchema,
  InvoicePaymentStatusSyncStrategySchema,
  TAX_EXPORT_STRATEGY,
  TaxExportStrategySchema
} from "@vy/integrations-types";
var NetSuiteIntegrationConfigurationSchema = BaseIntegrationConfigurationSchema.extend({
  defaultReceivableAccount: oz120.string().optional(),
  defaultSubsidiaryId: oz120.string().optional(),
  defaultProduct: ErpIntermediateMetadataSchema.omit({
    integrationSource: true
  }).optional(),
  customersAdditionalFilters: oz120.array(AdvancedFilterSchema).optional(),
  authData: NetSuiteAuthDataSchema,
  autoExportInvoices: oz120.boolean().default(false),
  customFieldMapping: EntityMappingSchema.array().optional(),
  autoExportCreditMemos: oz120.boolean().default(false),
  autoExportCustomers: oz120.boolean().default(false),
  summarizeLineItemsByProductId: oz120.boolean().default(false),
  overrideLineItemQuantity: oz120.boolean().default(false),
  taxExportStrategy: TaxExportStrategySchema.default(TAX_EXPORT_STRATEGY.INCLUDE_IN_AMOUNT),
  accountTaxItem: ErpIntermediateMetadataSchema.omit({ integrationSource: true }).optional(),
  taxItemBySubsidiaryId: oz120.record(
    oz120.string(),
    ErpIntermediateMetadataSchema.omit({ integrationSource: true })
  ).optional(),
  invoiceNumberSyncStrategy: InvoiceNumberSyncStrategySchema.default(
    INVOICE_NUMBER_SYNC_STRATEGY.KEEP_SEPARATE
  ),
  invoicePaymentStatusSyncStrategy: InvoicePaymentStatusSyncStrategySchema.default(
    INVOICE_PAYMENT_STATUS_SYNC_STRATEGY.KEEP_SEPARATE
  ),
  defaultStripeDepositToAccountId: oz120.string().optional(),
  attachmentsConfig: oz120.object({
    folderId: oz120.string(),
    exportUsageEventsReport: oz120.boolean().default(false)
  }).optional(),
  linkInvoiceToSalesOrder: oz120.boolean().default(false)
}).openapi("NetSuiteIntegrationConfiguration");
var PartialNetSuiteIntegrationConfigurationSchema = NetSuiteIntegrationConfigurationSchema.partial().strict();

// src/entities/integrations/net-suite/net-suite-integration-settings.ts
var NetSuiteIntegrationSettingsSchema = oz121.object({
  integrationProvider: oz121.literal(INTEGRATION_PROVIDERS.netSuite),
  integrationConfiguration: NetSuiteIntegrationConfigurationSchema
}).openapi("NetSuiteIntegrationSettings");

// src/entities/integrations/net-suite/net-suite-customer-schema.ts
import { oz as oz122 } from "@vy/utils";
var NetSuiteCustomerSchema = oz122.object({
  id: oz122.string(),
  entityId: oz122.string(),
  companyName: oz122.string(),
  aliasName: oz122.string(),
  custentity_vayu_entity_id: oz122.string().optional()
});

// src/entities/integrations/net-suite/net-suite-sales-order-schema.ts
import { oz as oz124 } from "@vy/utils";

// src/entities/integrations/net-suite/net-suite-sales-order-item-schema.ts
import { oz as oz123 } from "@vy/utils";
var NetSuiteSalesOrderItemSchema = oz123.object({
  item: oz123.object({
    id: oz123.string()
  }),
  quantity: oz123.number(),
  amount: oz123.number(),
  rate: oz123.number(),
  description: oz123.string().optional(),
  custcol_mp_term_s_date: oz123.string().optional(),
  custcol_mp_term_e_date: oz123.string().optional()
});

// src/entities/integrations/net-suite/net-suite-sales-order-schema.ts
var NetSuiteSalesOrderSchema = NetSuiteInvoiceSchema.extend({
  subsidiary: oz124.object({
    id: oz124.string()
  }),
  item: oz124.object({
    items: oz124.array(NetSuiteSalesOrderItemSchema)
  })
}).openapi("NetSuiteSalesOrder");

// src/entities/integrations/net-suite/net-suite-subsidiaries-schema.ts
import { oz as oz125 } from "@vy/utils";
var NetSuiteSubsidiarySchema = oz125.object({
  id: oz125.string(),
  name: oz125.string(),
  parent: oz125.string().optional()
});

// src/entities/integrations/net-suite/net-suite-credit-memo-schema.ts
import { oz as oz127 } from "@vy/utils";

// src/entities/integrations/net-suite/net-suite-credit-memo-item-schema.ts
import { oz as oz126 } from "@vy/utils";
var NetSuiteCreditMemoItemSchema = oz126.object({
  item: oz126.object({
    id: oz126.string()
  }),
  amount: oz126.number(),
  description: oz126.string().optional()
});

// src/entities/integrations/net-suite/net-suite-credit-memo-schema.ts
var NetSuiteCreditMemoSchema = oz127.object({
  externalId: oz127.string(),
  entity: oz127.object({
    id: oz127.string()
  }),
  tranDate: ApiDateSchema,
  memo: oz127.string(),
  item: oz127.object({
    items: oz127.array(NetSuiteCreditMemoItemSchema)
  })
}).openapi("NetSuiteCreditMemo");

// src/entities/integrations/salesforce/salesforce-account-schema.ts
import { oz as oz129 } from "@vy/utils";

// src/entities/integrations/salesforce/salesforce-contact-schema.ts
import { oz as oz128 } from "@vy/utils";
var SalesforceContactSchema = oz128.object({
  Id: oz128.string(),
  Name: oz128.string(),
  Email: oz128.string().nullable(),
  AccountId: oz128.string()
}).openapi("SalesforceContact");

// src/entities/integrations/salesforce/salesforce-account-schema.ts
var SalesforceAccountSchema = oz129.object({
  Id: oz129.string(),
  Name: oz129.string(),
  BillingAddress: oz129.object({
    street: oz129.string().nullable(),
    city: oz129.string().nullable(),
    postalCode: oz129.string().nullable(),
    country: oz129.string().nullable()
  }).nullable(),
  Contacts: oz129.array(SalesforceContactSchema).optional()
}).openapi("SalesforceAccount");

// src/entities/integrations/salesforce/salesforce-auth-data-schema.ts
import { oz as oz130 } from "@vy/utils";
var SalesforceAuthDataSchema = oz130.object({
  accountUrl: oz130.string(),
  clientId: oz130.string(),
  clientSecret: oz130.string()
}).openapi("SalesforceAuthData");

// src/entities/integrations/salesforce/salesforce-mesh-contract-schema.ts
import { oz as oz131 } from "@vy/utils";
import { CustomFieldValueSchema } from "@vy/custom-fields-types";
var SalesforceMeshContractSchema = oz131.object({
  Id: oz131.string(),
  Amount__c: oz131.number().nullable(),
  Invoice_Due_Date_Terms__c: oz131.string().nullish(),
  Package__c: oz131.string(),
  Signature_Date__c: oz131.string().nullable(),
  Payment_Terms__c: oz131.string().nullable(),
  Org_Account__r: oz131.object({
    Id: oz131.string(),
    Name: oz131.string(),
    NumberOfEmployees: oz131.number().nullable()
  }),
  rawSyncData: JsonSchema
}).openapi("SalesforceMeshContract");
var SalesforceMeshContractWithCustomerSchema = SalesforceMeshContractSchema.extend({
  vayuCustomerId: ObjectIdSchema,
  customFieldValues: CustomFieldValueSchema.array().optional()
}).openapi("SalesforceMeshContractWithCustomer");

// src/entities/integrations/salesforce/salesforce-integration-settings-schema.ts
import { oz as oz132 } from "@vy/utils";

// src/entities/integrations/salesforce/salesforce-integration-configuration-schema.ts
var SalesforceIntegrationConfigurationSchema = BaseIntegrationConfigurationSchema.extend({
  authData: SalesforceAuthDataSchema,
  customFieldMapping: EntityMappingSchema.array().optional()
}).openapi("SalesforceIntegrationConfiguration");
var PartialSalesforceIntegrationConfigurationSchema = SalesforceIntegrationConfigurationSchema.partial().strict();

// src/entities/integrations/salesforce/salesforce-integration-settings-schema.ts
var SalesforceIntegrationSettingsSchema = oz132.object({
  integrationProvider: oz132.literal(INTEGRATION_PROVIDERS.salesforce),
  integrationConfiguration: SalesforceIntegrationConfigurationSchema
}).openapi("SalesforceIntegrationSettings");

// src/entities/integrations/slack/slack-user-schema.ts
import { oz as oz133 } from "@vy/utils";
var SlackUserSchema = oz133.object({
  id: oz133.string(),
  teamId: oz133.string(),
  realName: oz133.string()
});

// src/entities/integrations/slack/slack-block-schema.ts
import { oz as oz135 } from "@vy/utils";

// src/entities/integrations/slack/slack-text-block.ts
import { oz as oz134 } from "@vy/utils";
var SlackTextBlockSchema = oz134.object({
  type: oz134.string(),
  text: oz134.string()
});

// src/entities/integrations/slack/slack-block-schema.ts
var SlackBlockSchema = oz135.object({
  type: oz135.string(),
  text: SlackTextBlockSchema.optional(),
  elements: oz135.array(
    oz135.object({
      type: oz135.string(),
      text: SlackTextBlockSchema.optional(),
      action_id: oz135.string().optional()
    })
  ).optional()
});

// src/entities/integrations/slack/slack-user-payload-schema.ts
import { oz as oz136 } from "@vy/utils";
var SlackUserPayloadSchema = oz136.object({
  id: oz136.string(),
  username: oz136.string(),
  name: oz136.string().optional(),
  team_id: oz136.string().optional()
}).openapi("SlackUser");

// src/entities/integrations/slack/slack-invoice-data.ts
import { oz as oz137 } from "@vy/utils";
var SlackInvoiceDataSchema = oz137.object({
  customerName: oz137.string(),
  invoiceDate: oz137.string().nullable(),
  amountDue: oz137.number(),
  dueDate: oz137.string().nullable().optional(),
  invoiceId: oz137.string(),
  currency: CurrencySchema
});

// src/entities/integrations/slack/slack-integration-settings-schema.ts
import { oz as oz139 } from "@vy/utils";

// src/entities/integrations/slack/slack-integration-configuration-schema.ts
import { oz as oz138 } from "@vy/utils";
var SlackIntegrationConfigurationSchema = BaseIntegrationConfigurationSchema.extend({
  authData: OAuth2DataSchema,
  channelId: oz138.string().optional()
}).openapi("SlackIntegrationConfiguration");
var PartialSlackIntegrationConfigurationSchema = SlackIntegrationConfigurationSchema.partial().strict();

// src/entities/integrations/slack/slack-integration-settings-schema.ts
var SlackIntegrationSettingsSchema = oz139.object({
  integrationProvider: oz139.literal(INTEGRATION_PROVIDERS.slack),
  integrationConfiguration: SlackIntegrationConfigurationSchema
}).openapi("SlackIntegrationSettings");

// src/entities/integrations/slack/slack-channel-schema.ts
import { oz as oz140 } from "@vy/utils";
var SlackChannelOptionSchema = oz140.object({
  id: oz140.string(),
  name: oz140.string()
}).openapi("SlackChannelOption");

// src/entities/integrations/stripe/stripe-integration-settings-schema.ts
import { oz as oz143 } from "@vy/utils";

// src/entities/integrations/stripe/stripe-integration-configuration-schema.ts
import { oz as oz142 } from "@vy/utils";

// src/entities/integrations/stripe/stripe-auth-data-schema.ts
import { oz as oz141 } from "@vy/utils";
var StripeAuthDataSchema = oz141.object({
  bearerToken: oz141.string(),
  apiId: oz141.string()
}).openapi("StripeAuthData");

// src/entities/integrations/stripe/stripe-integration-configuration-schema.ts
var StripeIntegrationConfigurationSchema = BaseIntegrationConfigurationSchema.extend({
  autoImportCustomers: oz142.boolean().default(false),
  autoExportCreatedCustomers: oz142.boolean().default(false),
  autoExportInvoices: oz142.boolean().default(false),
  syncPaymentRefIdToErp: oz142.boolean().default(false),
  authData: StripeAuthDataSchema
}).openapi("StripeIntegrationConfiguration");
var PartialStripeIntegrationConfigurationSchema = StripeIntegrationConfigurationSchema.partial().strict();

// src/entities/integrations/stripe/stripe-integration-settings-schema.ts
var StripeIntegrationSettingsSchema = oz143.object({
  integrationProvider: oz143.literal(INTEGRATION_PROVIDERS.stripe),
  integrationConfiguration: StripeIntegrationConfigurationSchema
}).openapi("StripeIntegrationSettings");

// src/entities/integrations/stripe/stripe-invoice-status-schema.ts
import { oz as oz144 } from "@vy/utils";
var STRIPE_INVOICE_STATUSES = Object.freeze({
  DRAFT: "draft",
  OPEN: "open",
  PAID: "paid",
  UNCOLLECTIBLE: "uncollectible",
  VOID: "void"
});
var StripeInvoiceStatusSchema = oz144.nativeEnum(STRIPE_INVOICE_STATUSES).openapi("StripeInvoiceStatus");

// src/entities/integrations/integration-settings-schema.ts
var IntegrationSettingsSchema = oz145.discriminatedUnion("integrationProvider", [
  NetSuiteIntegrationSettingsSchema,
  HubspotIntegrationSettingsSchema,
  StripeIntegrationSettingsSchema,
  SlackIntegrationSettingsSchema,
  SalesforceIntegrationSettingsSchema
]).openapi("IntegrationSettings");

// src/entities/integrations/new-integration-schema.ts
var NewIntegrationSchema = oz146.object({
  integrationSettings: IntegrationSettingsSchema
}).openapi("NewIntegration");

// src/entities/integrations/integration-schema.ts
var IntegrationSchema = created(NewIntegrationSchema).openapi("Integration");

// src/entities/integrations/integration-settings-union-schema.ts
import { IntegrationsSettingsSchema } from "@vy/integrations-types";
import { oz as oz148 } from "@vy/utils";

// src/entities/integrations/integrations-version.ts
import { oz as oz147 } from "@vy/utils";
var IntegrationVersionSchema = Object.freeze({
  "v2": "2",
  "v3": "3"
});
var IntegrationVersion = oz147.nativeEnum(IntegrationVersionSchema).openapi("IntegrationVersion");

// src/entities/integrations/integration-settings-union-schema.ts
var V2IntegrationSettingsSchema = oz148.object({
  version: oz148.literal(IntegrationVersionSchema.v2),
  settings: IntegrationSettingsSchema
}).openapi("V2IntegrationSettingsSchema");
var V3IntegrationSettingsSchema = oz148.object({
  version: oz148.literal(IntegrationVersionSchema.v3),
  settings: IntegrationsSettingsSchema
}).openapi("V3IntegrationSettingsSchema");
var VersionedIntegrationSettingsSchema = oz148.discriminatedUnion("version", [V2IntegrationSettingsSchema, V3IntegrationSettingsSchema]).openapi("VersionedIntegrationSettingsSchema");

// src/entities/integrations/morning/morning-auth-data-schema.ts
import { oz as oz149 } from "@vy/utils";
var MorningAuthDataSchema = oz149.object({
  apiKey: oz149.string(),
  secretId: oz149.string()
}).openapi("MorningAuthData");

// src/entities/integrations/oauth2-integration-schema.ts
var OAuth2IntegrationSchema = IntegrationSchema.extend({
  authData: OAuth2DataSchema
}).openapi("OAuth2Integration");

// src/entities/integrations/quickbooks/quickbooks-customer-schema.ts
import { oz as oz150 } from "@vy/utils";
var QuickBooksCustomerSchema = oz150.object({
  id: oz150.string(),
  name: oz150.string(),
  companyName: oz150.string().optional(),
  displayName: oz150.string().optional(),
  isActive: oz150.boolean().optional()
});

// src/entities/integrations/quickbooks/quickbooks-product-schema.ts
import { oz as oz151 } from "@vy/utils";
var QuickBooksProductSchema = oz151.object({
  id: oz151.string(),
  name: oz151.string()
});

// src/entities/integrations/xero/xero-product-schema.ts
import { oz as oz152 } from "@vy/utils";
var XeroProductSchema = oz152.object({
  id: oz152.string(),
  name: oz152.string()
});

// src/entities/integrations/sync-job-attempt-schema.ts
import { SYNC_JOB_ATTEMPT_STATUSES } from "@vy/integrations-types";
import { oz as oz153 } from "@vy/utils";
var SyncJobAttemptSchema = oz153.object({
  id: oz153.string(),
  syncJobId: oz153.string(),
  status: oz153.nativeEnum(SYNC_JOB_ATTEMPT_STATUSES),
  startedAt: ApiDateSchema,
  completedAt: ApiDateSchema,
  error: oz153.string().nullable(),
  errorData: oz153.unknown().nullable()
});

// src/entities/integrations/update-integration-settings-schema.ts
import { oz as oz154 } from "@vy/utils";
var UpdateIntegrationSettingsSchema = oz154.object({
  integrationProvider: oz154.string(),
  integrationConfiguration: oz154.any()
}).openapi("UpdateIntegrationSettings");

// src/entities/integration-entity/system-provider-integration-entity/payment-provider-integration-entity.ts
import { oz as oz155 } from "@vy/utils";
var PAYMENT_INTEGRATION_PROVIDERS = Object.freeze({
  stripe: INTEGRATION_PROVIDERS.stripe,
  paddle: INTEGRATION_PROVIDERS.paddle
});
var PaymentIntegrationProvidersSchema = oz155.nativeEnum(PAYMENT_INTEGRATION_PROVIDERS);
var PaymentProviderIntegrationEntitySchema = BaseIntegrationEntitySchema.extend({
  integrationProvider: PaymentIntegrationProvidersSchema,
  metadata: PaymentIntegrationEntityMetadataSchema
});

// src/entities/integration-entity/system-provider-integration-entity/crm-provider-integration-entity.ts
import { oz as oz156 } from "@vy/utils";
var CRM_INTEGRATION_PROVIDERS = Object.freeze({
  hubspot: INTEGRATION_PROVIDERS.hubspot,
  salesforce: INTEGRATION_PROVIDERS.salesforce
});
var CrmIntegrationProvidersSchema = oz156.nativeEnum(CRM_INTEGRATION_PROVIDERS);
var CrmProviderIntegrationEntitySchema = BaseIntegrationEntitySchema.extend({
  integrationProvider: CrmIntegrationProvidersSchema,
  metadata: CRMIntegrationEntityMetadataSchema
});

// src/entities/integration-entity/customer-integration-entity/customer-integration-entities/customer-hubspot-entity.ts
var HubspotCustomerEntitySchema = BaseIntegrationEntitySchema.extend({
  integrationProvider: oz157.literal(INTEGRATION_PROVIDERS.hubspot),
  metadata: CRMIntegrationEntityMetadataSchema.optional()
}).openapi("HubspotCustomerEntity");

// src/entities/integration-entity/customer-integration-entity/customer-integration-entities/customer-morning-entity.ts
import { oz as oz158 } from "@vy/utils";
var MorningMetadataSchema = oz158.object({
  name: oz158.string()
}).nullish();
var MorningCustomerEntitySchema = BaseIntegrationEntitySchema.extend({
  integrationProvider: oz158.literal(INTEGRATION_PROVIDERS.morning),
  metadata: MorningMetadataSchema
}).openapi("MorningCustomerEntity");

// src/entities/integration-entity/customer-integration-entity/customer-integration-entities/customer-netsuite-entity.ts
import { oz as oz159 } from "@vy/utils";
var NetSuiteCustomerEntitySchema = BaseIntegrationEntitySchema.extend({
  integrationProvider: oz159.literal(INTEGRATION_PROVIDERS.netSuite),
  metadata: ERPIntegrationEntityMetadataSchema
}).openapi("NetSuiteCustomerEntity");

// src/entities/integration-entity/customer-integration-entity/customer-integration-entities/customer-quickbooks-entity.ts
import { oz as oz160 } from "@vy/utils";
var QuickBooksCustomerEntitySchema = BaseIntegrationEntitySchema.extend({
  integrationProvider: oz160.literal(INTEGRATION_PROVIDERS.quickBooks),
  metadata: ERPIntegrationEntityMetadataSchema
}).openapi("QuickBooksCustomerEntity");

// src/entities/integration-entity/customer-integration-entity/customer-integration-entities/customer-salesforce-entity.ts
import { oz as oz161 } from "@vy/utils";
var SalesforceCustomerEntitySchema = BaseIntegrationEntitySchema.extend({
  integrationProvider: oz161.literal(INTEGRATION_PROVIDERS.salesforce),
  metadata: CRMIntegrationEntityMetadataSchema.nullish()
}).openapi("SalesforceCustomerEntity");

// src/entities/integration-entity/customer-integration-entity/customer-integration-entities/customer-stripe-entity.ts
import { oz as oz162 } from "@vy/utils";
var StripeMetadataSchema = oz162.object({
  name: oz162.string().nullish(),
  email: oz162.string().nullish()
}).nullish();
var StripeCustomerEntitySchema = BaseIntegrationEntitySchema.extend({
  integrationProvider: oz162.literal(INTEGRATION_PROVIDERS.stripe),
  metadata: StripeMetadataSchema
}).openapi("StripeCustomerEntity");

// src/entities/integration-entity/customer-integration-entity/customer-integration-entities/customer-xero-entity.ts
import { oz as oz163 } from "@vy/utils";
var XeroCustomerEntitySchema = BaseIntegrationEntitySchema.extend({
  integrationProvider: oz163.literal(INTEGRATION_PROVIDERS.xero),
  metadata: ERPIntegrationEntityMetadataSchema
}).openapi("XeroCustomerEntity");

// src/entities/integration-entity/customer-integration-entity/customer-integration-entity.ts
var CustomerIntegrationEntitySchema = oz164.discriminatedUnion("integrationProvider", [
  HubspotCustomerEntitySchema,
  MorningCustomerEntitySchema,
  NetSuiteCustomerEntitySchema,
  QuickBooksCustomerEntitySchema,
  SalesforceCustomerEntitySchema,
  StripeCustomerEntitySchema,
  XeroCustomerEntitySchema
]).openapi("CustomerIntegrationEntity");

// src/entities/revenue-breakdown/revenue-breakdown-schema.ts
import { oz as oz165 } from "@vy/utils";
var RevenueBreakdownSchema = oz165.object({
  total: oz165.number(),
  subtotal: oz165.number(),
  overage: oz165.number(),
  discount: oz165.number(),
  creditsUsed: oz165.number(),
  tax: oz165.number()
});

// src/entities/system-intermediate-metadata-schemas/crm-metadata-schema.ts
import { oz as oz166 } from "@vy/utils";
var CrmIntermediateMetadataSchema = oz166.object({
  crmId: SanitizedStringSchema,
  integrationSource: CrmIntegrationProvidersSchema.optional()
}).openapi("CrmMetadata");

// src/entities/system-intermediate-metadata-schemas/stripe-metadata-schema.ts
import { oz as oz167 } from "@vy/utils";
var StripeIntermediateMetadataSchema = oz167.object({
  stripeId: SanitizedStringSchema,
  stripeName: SanitizedStringSchema,
  stripeEmail: SanitizedStringSchema.nullish(),
  integrationSource: oz167.literal(INTEGRATION_PROVIDERS.stripe)
}).openapi("StripeMetadata");

// src/entities/customer/customer-contracts-schema.ts
import { oz as oz168 } from "@vy/utils";
var CustomerContractsSchema = oz168.array(RefinedContactSchema);

// src/entities/customer/customer-settings-schema.ts
import { oz as oz170 } from "@vy/utils";

// src/entities/customer/customer-cloud-provider-settings-schema.ts
import { oz as oz169 } from "@vy/oz";
import { CloudProviderSchema } from "@vy/connact";
import { isNotEmptyString } from "@vy/utils";
var CustomerCloudProviderSettingsSchema = oz169.object({
  cloudProvider: CloudProviderSchema.optional(),
  cloudProviderMarketplaceId: oz169.string().optional(),
  customerIdentifier: oz169.string().optional()
}).superRefine((cloudProviderSettings, ctx) => {
  const hasCloudProvider = isNotEmptyString(cloudProviderSettings.cloudProvider);
  const hasMarketplaceId = isNotEmptyString(cloudProviderSettings.cloudProviderMarketplaceId);
  if (hasCloudProvider && !hasMarketplaceId) {
    ctx.addIssue({
      code: oz169.ZodIssueCode.custom,
      path: ["cloudProviderMarketplaceId"],
      message: "Marketplace ID is required"
    });
  }
  if (!hasCloudProvider && hasMarketplaceId) {
    ctx.addIssue({
      code: oz169.ZodIssueCode.custom,
      path: ["cloudProvider"],
      message: "Cloud provider is required"
    });
  }
  const hasCustomerIdentifier = isNotEmptyString(cloudProviderSettings.customerIdentifier);
  if (hasCustomerIdentifier && !hasCloudProvider) {
    ctx.addIssue({
      code: oz169.ZodIssueCode.custom,
      path: ["cloudProvider"],
      message: "Cloud provider is required"
    });
  }
  if (hasCustomerIdentifier && !hasMarketplaceId) {
    ctx.addIssue({
      code: oz169.ZodIssueCode.custom,
      path: ["cloudProviderMarketplaceId"],
      message: "Marketplace ID is required"
    });
  }
}).openapi("CustomerCloudProviderSettings");

// src/entities/customer/customer-settings-schema.ts
var CustomerSettingsSchema = oz170.object({
  currency: oz170.nativeEnum(CURRENCIES).optional(),
  taxRate: oz170.number().optional().nullable(),
  paymentProvider: oz170.nativeEnum(PAYMENT_PROVIDERS).optional(),
  paymentProviderMetadata: oz170.object({
    providerExternalId: oz170.string().optional()
  }).optional(),
  secondaryPaymentProvider: oz170.nativeEnum(PAYMENT_PROVIDERS).optional(),
  paymentDueDays: oz170.number().optional(),
  payments: oz170.object({
    autoCollectInvoice: oz170.boolean().optional()
  }).optional(),
  overage: OverageSettingsSchema.optional(),
  customerType: oz170.nativeEnum(CUSTOMER_TYPES).optional(),
  threshold: oz170.number().optional(),
  wallet: oz170.string().optional(),
  manualReview: oz170.boolean().optional(),
  cloudProviderSettings: CustomerCloudProviderSettingsSchema.nullish()
}).openapi("CustomerSettings");

// src/entities/customer/customer-status-schema.ts
import { oz as oz171 } from "@vy/utils";
var CUSTOMER_STATUSES = Object.freeze({
  Active: "Active",
  Inactive: "Inactive",
  Suspended: "Suspended",
  Trial: "Trial"
});
var CustomerStatusSchema = oz171.nativeEnum(CUSTOMER_STATUSES).openapi("CustomerStatus");

// src/entities/customer/external-customer-integration-schema.ts
import { IntegrationTypesV3Schema } from "@vy/integrations-types";
import { oz as oz172 } from "@vy/utils";
var ExternalCustomerIntegrationSchema = oz172.object({
  type: IntegrationTypesV3Schema,
  id: oz172.string(),
  name: oz172.string()
});

// src/entities/customer/new-customer-schema.ts
import { CustomFieldValueSchema as CustomFieldValueSchema2 } from "@vy/custom-fields-types";
var NewCustomerSchema = oz173.object({
  name: SanitizedStringSchema,
  legalName: oz173.string().nullish(),
  externalId: SanitizedStringSchema.nullish(),
  aliases: oz173.array(SanitizedStringSchema).default([]).nullish(),
  taxIds: oz173.array(SanitizedStringSchema).default([]).nullish(),
  crmId: SanitizedStringSchema.nullish(),
  crmMetadata: withNullAsOptional(CrmIntermediateMetadataSchema).nullable(),
  erpMetadata: withNullAsOptional(ErpIntermediateMetadataSchema).nullable(),
  address: withNullAsOptional(AddressSchema).nullable(),
  contacts: CustomerContractsSchema.nullish(),
  settings: CustomerSettingsSchema.nullish(),
  revenueBreakdown: RevenueBreakdownSchema,
  status: CustomerStatusSchema.optional(),
  source: CustomerSourcesSchema.nullish(),
  subsidiaryId: ObjectIdSchema.nullish(),
  integrationEntities: oz173.array(CustomerIntegrationEntitySchema).nullish(),
  externalIntegration: oz173.array(ExternalCustomerIntegrationSchema).nullish(),
  accountOwnerId: SanitizedStringSchema.nullish(),
  customFieldValues: oz173.array(CustomFieldValueSchema2).default([]).optional()
}).openapi("NewCustomer");

// src/entities/customer/customer-schema.ts
var CustomerSchema = segregated(NewCustomerSchema).openapi("Customer");

// src/entities/customer/customer-input-schema.ts
import { oz as oz174 } from "@vy/utils";
var CustomerInputSchema = oz174.object(NewCustomerSchema.shape).partial().openapi("CustomerInput");

// src/entities/customer/update-customer-schema.ts
import { oz as oz176 } from "@vy/utils";

// src/entities/customer/customer-relation-type-schema.ts
import { oz as oz175 } from "@vy/utils";
var CUSTOMER_RELATION_TYPES = Object.freeze({
  accumulateUsage: "accumulateUsage",
  accumulateCharges: "accumulateCharges",
  erpInvoiceSyncOnBehalfParent: "erpInvoiceSyncOnBehalfParent"
});
var CustomerRelationTypeSchema = oz175.nativeEnum(CUSTOMER_RELATION_TYPES).openapi("CustomerRelationType");

// src/entities/customer/update-customer-schema.ts
var CustomerChildrenRelationsSchema = oz176.array(
  oz176.object({
    id: ObjectIdSchema,
    relationType: CustomerRelationTypeSchema
  })
).optional().openapi("CustomerChildrenRelations");
var UpdateCustomerSchema = NewCustomerSchema.extend({
  childrenRelations: CustomerChildrenRelationsSchema,
  revenueBreakdown: RevenueBreakdownSchema.optional()
});

// src/entities/customer/child-customer-overview-schema.ts
var ChildCustomerOverviewSchema = CustomerSchema.pick({
  id: true,
  externalId: true,
  name: true
});

// src/entities/customer/minimal-customer-schema.ts
import { oz as oz177 } from "@vy/utils";
var MinimalCustomerSchema = CustomerSchema.pick({
  id: true,
  accountId: true,
  externalId: true
});
var MinimalCustomerReaderSchema = oz177.array(MinimalCustomerSchema);

// src/entities/customer/customer-payment-due-days/customer-payment-due-days-options.ts
var INVOICE_DUE_DATE_VALUES = {
  EOM: -1,
  "0": 0,
  "15": 15,
  "30": 30,
  "45": 45,
  "60": 60,
  "90": 90,
  "120": 120
};

// src/entities/customer/customer-payment-due-days/customer-payment-due-days.ts
import { isNullOrUndefined as isNullOrUndefined2, validateNotNullOrUndefined, vyDate } from "@vy/utils";
var DEFAULT_PAYMENT_DUE_DAYS = 30;
function getPaymentDueDays(paymentDueDays, accountSettings, issuedAt) {
  if (isNullOrUndefined2(paymentDueDays)) {
    const defaultAccountPaymentDueDays = accountSettings.invoicingSettings?.defaultPaymentDueDays;
    return defaultAccountPaymentDueDays ?? DEFAULT_PAYMENT_DUE_DAYS;
  }
  validateNotNullOrUndefined(issuedAt, "issuedAt");
  if (paymentDueDays === INVOICE_DUE_DATE_VALUES.EOM) {
    const endOfMonth = vyDate(issuedAt).endOf("month");
    return endOfMonth.diff(vyDate(issuedAt), "days");
  }
  return paymentDueDays;
}

// src/entities/customer/customer-relation-schema.ts
import { oz as oz178 } from "@vy/utils";
var NewCustomerRelationSchema = oz178.object({
  parentId: ObjectIdSchema,
  childId: ObjectIdSchema,
  relationType: CustomerRelationTypeSchema
}).openapi("NewCustomerRelation");
var CustomerRelationSchema = created(NewCustomerRelationSchema).openapi("CustomerRelation");

// src/entities/billing-cycle/new-billing-cycle-schema.ts
import { oz as oz180 } from "@vy/utils";

// src/entities/billing-cycle/billing-cycle-status-schema.ts
import { oz as oz179 } from "@vy/utils";
var BILLING_CYCLE_STATUSES = Object.freeze({
  Default: "Default",
  Active: "Active",
  Inactive: "Inactive"
});
var BillingCycleStatusSchema = oz179.nativeEnum(BILLING_CYCLE_STATUSES).openapi("BillingCycleStatus");

// src/entities/billing-cycle/new-billing-cycle-schema.ts
var NewBillingCycleSchema = oz180.object({
  name: oz180.string().nonempty(),
  billingDay: oz180.number().min(1).max(25),
  status: BillingCycleStatusSchema,
  customersIds: oz180.array(ObjectIdSchema).optional()
}).openapi("NewBillingCycle");

// src/entities/billing-cycle/billing-cycle-schema.ts
var BillingCycleSchema = created(
  NewBillingCycleSchema.omit({ customersIds: true }).extend({
    customers: oz181.array(CustomerSchema.pick({ id: true, name: true }))
  })
).openapi("BillingCycle");

// src/entities/billing-cycle/billing-cycle-input-schema.ts
import { oz as oz182 } from "@vy/utils";
var BillingCycleInputSchema = oz182.object(NewBillingCycleSchema.shape).partial().openapi("BillingCycleInput");

// src/entities/catalog-products/new-catalog-products-schema.ts
import { oz as oz300 } from "@vy/utils";

// src/entities/integration-entity/contract-integration-entity/contract-integration-entity.ts
import { oz as oz186 } from "@vy/utils";

// src/entities/integration-entity/contract-integration-entity/contract-integration-entities/contract-salesforce-entity.ts
import { oz as oz183 } from "@vy/utils";
var SalesforceContractEntitySchema = BaseIntegrationEntitySchema.extend({
  integrationProvider: oz183.literal(INTEGRATION_PROVIDERS.salesforce),
  metadata: CRMIntegrationEntityMetadataSchema.optional(),
  rawSyncedData: JsonSchema.nullish()
}).openapi("ContractSalesforceEntity");

// src/entities/integration-entity/contract-integration-entity/contract-integration-entities/contract-net-suite-entity.ts
import { oz as oz184 } from "@vy/utils";
var NetSuiteContractEntitySchema = BaseIntegrationEntitySchema.extend({
  integrationProvider: oz184.literal(INTEGRATION_PROVIDERS.netSuite)
}).openapi("ContractNetSuiteEntity");

// src/entities/integration-entity/contract-integration-entity/contract-integration-entities/contract-hubspot-entity.ts
import { oz as oz185 } from "@vy/utils";
var HubspotContractEntitySchema = BaseIntegrationEntitySchema.extend({
  integrationProvider: oz185.literal(INTEGRATION_PROVIDERS.hubspot),
  metadata: CRMIntegrationEntityMetadataSchema.optional(),
  rawSyncedData: JsonSchema.nullish()
}).openapi("ContractHubspotEntity");

// src/entities/integration-entity/contract-integration-entity/contract-integration-entity.ts
var ContractIntegrationEntitySchema = oz186.discriminatedUnion("integrationProvider", [
  SalesforceContractEntitySchema,
  NetSuiteContractEntitySchema,
  HubspotContractEntitySchema
]);

// src/entities/integration-entity/invoice-integration-entity/invoice-integration-entity.ts
import { oz as oz189 } from "@vy/utils";

// src/entities/integration-entity/invoice-integration-entity/invoice-integration-entities/invoice-netsuite-entity.ts
import { oz as oz187 } from "@vy/utils";
var NetSuiteInvoiceEntitySchema = BaseIntegrationEntitySchema.extend({
  integrationProvider: oz187.literal(INTEGRATION_PROVIDERS.netSuite),
  metadata: ERPIntegrationEntityMetadataSchema.nullish()
}).openapi("InvoiceNetsuiteEntity");

// src/entities/integration-entity/invoice-integration-entity/invoice-integration-entities/invoice-stripe-entity.ts
import { oz as oz188 } from "@vy/utils";
var StripeInvoiceEntitySchema = BaseIntegrationEntitySchema.extend({
  integrationProvider: oz188.literal(INTEGRATION_PROVIDERS.stripe),
  metadata: PaymentIntegrationEntityMetadataSchema
}).openapi("InvoiceStripeEntity");

// src/entities/integration-entity/invoice-integration-entity/invoice-integration-entity.ts
var InvoiceIntegrationEntitySchema = oz189.discriminatedUnion("integrationProvider", [
  StripeInvoiceEntitySchema,
  NetSuiteInvoiceEntitySchema
]);

// src/entities/integration-entity/payment-integration-entity/payment-integration-entity.ts
import { oz as oz192 } from "@vy/utils";

// src/entities/integration-entity/payment-integration-entity/payment-integration-entities/payment-stripe-entity.ts
import { oz as oz190 } from "@vy/utils";
var StripePaymentEntitySchema = BaseIntegrationEntitySchema.extend({
  integrationProvider: oz190.literal(INTEGRATION_PROVIDERS.stripe),
  metadata: PaymentIntegrationEntityMetadataSchema
}).openapi("StripePaymentEntity");

// src/entities/integration-entity/payment-integration-entity/payment-integration-entities/payment-paddle-entity.ts
import { oz as oz191 } from "@vy/utils";
var PaddlePaymentEntitySchema = BaseIntegrationEntitySchema.extend({
  integrationProvider: oz191.literal(INTEGRATION_PROVIDERS.paddle),
  metadata: PaymentIntegrationEntityMetadataSchema
}).openapi("PaddlePaymentEntity");

// src/entities/integration-entity/payment-integration-entity/payment-integration-entity.ts
var PaymentIntegrationEntitySchema = oz192.discriminatedUnion("integrationProvider", [
  StripePaymentEntitySchema,
  PaddlePaymentEntitySchema
]);

// src/entities/integration-entity/product-integration-entity/product-integration-entity.ts
import { oz as oz199 } from "@vy/utils";

// src/entities/integration-entity/product-integration-entity/product-integration-entities/product-netsuite-entity.ts
import { oz as oz193 } from "@vy/utils";
var NetSuiteProductEntitySchema = BaseIntegrationEntitySchema.extend({
  integrationProvider: oz193.literal(INTEGRATION_PROVIDERS.netSuite),
  metadata: ERPIntegrationEntityMetadataSchema.extend({
    classMetadata: NetSuiteClassSchema.nullish()
  })
}).openapi("ProductNetSuiteEntity");

// src/entities/integration-entity/product-integration-entity/product-integration-entities/product-hubspot-entity.ts
import { oz as oz194 } from "@vy/utils";
var ProductHubspotEntitySchema = BaseIntegrationEntitySchema.extend({
  integrationProvider: oz194.literal(INTEGRATION_PROVIDERS.hubspot),
  metadata: HubspotProductSchema
}).openapi("ProductHubspotEntity");

// src/entities/integration-entity/product-integration-entity/product-integration-entities/product-paddle-entity.ts
import { oz as oz195 } from "@vy/utils";
var PaddleProductEntitySchema = BaseIntegrationEntitySchema.extend({
  integrationProvider: oz195.literal(INTEGRATION_PROVIDERS.paddle),
  metadata: ERPIntegrationEntityMetadataSchema
}).openapi("ProductPaddleEntity");

// src/entities/integration-entity/product-integration-entity/product-integration-entities/product-quickbooks-entity.ts
import { oz as oz196 } from "@vy/utils";
var QuickBooksProductEntitySchema = BaseIntegrationEntitySchema.extend({
  integrationProvider: oz196.literal(INTEGRATION_PROVIDERS.quickBooks),
  metadata: ERPIntegrationEntityMetadataSchema
}).openapi("ProductQuickBooksEntity");

// src/entities/integration-entity/product-integration-entity/product-integration-entities/product-xero-entity.ts
import { oz as oz197 } from "@vy/utils";
var XeroProductEntitySchema = BaseIntegrationEntitySchema.extend({
  integrationProvider: oz197.literal(INTEGRATION_PROVIDERS.xero),
  metadata: ERPIntegrationEntityMetadataSchema
}).openapi("ProductXeroEntity");

// src/entities/integration-entity/product-integration-entity/product-integration-entities/product-anrok-entity.ts
import { oz as oz198 } from "@vy/utils";
import { INTEGRATION_TYPES as INTEGRATION_TYPES2 } from "@vy/integrations-types";
var AnrokProductEntitySchema = BaseIntegrationEntitySchema.extend({
  integrationProvider: oz198.literal(INTEGRATION_TYPES2.ANROK),
  metadata: oz198.object({
    productId: oz198.string()
  }).nullish()
}).openapi("ProductAnrokEntity");

// src/entities/integration-entity/product-integration-entity/product-integration-entity.ts
var ProductIntegrationEntitySchema = oz199.discriminatedUnion("integrationProvider", [
  NetSuiteProductEntitySchema,
  PaddleProductEntitySchema,
  ProductHubspotEntitySchema,
  QuickBooksProductEntitySchema,
  XeroProductEntitySchema,
  AnrokProductEntitySchema
]).openapi("ProductIntegrationEntity");

// src/entities/product/new-product-schema.ts
import { oz as oz287 } from "@vy/utils";

// src/entities/commitment/commitment-schema.ts
import { oz as oz201 } from "@vy/utils";

// src/entities/commitment/commitment-type-schema.ts
import { oz as oz200 } from "@vy/utils";
var COMMITMENT_TYPES = Object.freeze({
  Price: "Price",
  Units: "Units"
});
var CommitmentTypeSchema = oz200.nativeEnum(COMMITMENT_TYPES).openapi("CommitmentType");

// src/entities/commitment/commitment-schema.ts
var CommitmentSchema = oz201.object({
  amount: oz201.number().nonnegative(),
  type: CommitmentTypeSchema,
  consumption: oz201.number().nonnegative(),
  replenishmentInterval: withNullAsOptional(oz201.number())
});

// src/entities/commitment/commitment-input-schema.ts
import { oz as oz202 } from "@vy/utils";
var CommitmentInputSchema = CommitmentSchema.extend({
  autoRefillEnabled: oz202.boolean().default(false)
});

// src/entities/contract/credit-kind-schema.ts
import { oz as oz203 } from "@vy/utils";
var CREDIT_KINDS = Object.freeze({
  MONETARY: "Monetary",
  UNIT: "Unit"
});
var CreditKindSchema = oz203.nativeEnum(CREDIT_KINDS);

// src/entities/contract/credit-purchase-config-schema.ts
import { oz as oz206 } from "@vy/utils";

// src/entities/contract/credit-schedule-schema.ts
import { oz as oz204 } from "@vy/utils";
var CREDIT_SCHEDULES = Object.freeze({
  ONE_TIME: "OneTime",
  RECURRING_MONTHLY: "RecurringMonthly",
  RECURRING_QUARTERLY: "RecurringQuarterly",
  RECURRING_YEARLY: "RecurringYearly"
});
var CreditScheduleSchema = oz204.nativeEnum(CREDIT_SCHEDULES);

// src/entities/contract/credit-expiration-policy-schema.ts
import { oz as oz205 } from "@vy/utils";
var CREDIT_EXPIRATION_POLICIES = Object.freeze({
  AT_NEXT_GRANT: "AtNextGrant",
  NEVER: "Never",
  END_OF_INVOICE: "EndOfInvoice",
  END_OF_RENEWAL_PERIOD: "EndOfRenewalPeriod",
  END_OF_CONTRACT: "EndOfContract"
});
var CreditExpirationPolicySchema = oz205.nativeEnum(CREDIT_EXPIRATION_POLICIES);

// src/entities/contract/credit-purchase-config-schema.ts
var CreditPurchaseConfigSchema = oz206.object({
  creditTypeId: ObjectIdSchema,
  name: oz206.string(),
  creditKind: CreditKindSchema,
  amount: oz206.number().positive(),
  schedule: CreditScheduleSchema,
  price: oz206.number().optional().nullable(),
  expiryDate: ApiDateSchema.optional().nullable(),
  expirationPolicy: CreditExpirationPolicySchema.optional()
}).openapi("CreditPurchaseConfig");

// src/entities/product-config/product-config-schema.ts
import { oz as oz280 } from "@vy/utils";

// src/entities/product-config/product-config-status-schema.ts
import { oz as oz207 } from "@vy/utils";
var PRODUCT_CONFIG_STATUSES = Object.freeze({
  ACTIVE: "ACTIVE",
  DELETED: "DELETED"
});
var productConfigStatusSchema = oz207.nativeEnum(PRODUCT_CONFIG_STATUSES);

// src/entities/product-variant/fixed-product-variants/commercial-terms/commercial-terms-pricing-configuration-schema.ts
import { oz as oz212 } from "@vy/utils";

// src/entities/discount/discount-configuration-schema.ts
import { isNumber, oz as oz209 } from "@vy/utils";

// src/entities/discount/discount-models-schema.ts
import { oz as oz208 } from "@vy/utils";
var DISCOUNT_MODELS = Object.freeze({
  FIXED: "Fixed",
  PERCENTAGE: "Percentage"
});
var DiscountModelSchema = oz208.nativeEnum(DISCOUNT_MODELS).openapi("DiscountModel");

// src/entities/discount/discount-configuration-schema.ts
var DiscountConfigurationSchema = oz209.object({
  name: oz209.string().min(1, "Discount name is required"),
  type: oz209.union([oz209.literal(DISCOUNT_MODELS.FIXED), oz209.literal(DISCOUNT_MODELS.PERCENTAGE)]),
  amountToDeduct: oz209.number().positive({
    message: "Discount amount must be greater than 0"
  }).superRefine((value, ctx) => {
    if (!isNumber(value)) {
      ctx.addIssue({
        code: oz209.ZodIssueCode.custom,
        message: "Discount amount is required"
      });
    }
  }).transform((value) => Math.abs(value)),
  recurring: oz209.number().min(1, "Recurring times must be at least 1").optional()
});

// src/entities/product-variant/fixed-product-variants/commercial-terms/scheduled-installment/new-scheduled-installment-schema.ts
import { oz as oz210 } from "@vy/utils";
var NewScheduledInstallmentSchema = oz210.object({
  scheduledDateStr: oz210.string(),
  amount: oz210.number().nonnegative()
}).openapi("NewScheduledInstallment");

// src/entities/product-variant/fixed-product-variants/commercial-terms/scheduled-installment/scheduled-installment-configuration-schema.ts
import { oz as oz211 } from "@vy/utils";
var ScheduledInstallmentConfigurationSchema = oz211.object({
  totalAmount: oz211.number().nonnegative(),
  installments: oz211.array(NewScheduledInstallmentSchema)
}).openapi("ScheduledInstallmentConfiguration");

// src/entities/product-variant/fixed-product-variants/commercial-terms/commercial-terms-pricing-configuration-schema.ts
var CommercialTermsPricingConfigurationSchema = oz212.object({
  price: oz212.number({ invalid_type_error: "Commercial terms amount is required" }).nonnegative(),
  shouldCreateSeparateInvoice: oz212.boolean().default(false),
  shouldSplitAmount: oz212.boolean().default(false),
  discountConfiguration: DiscountConfigurationSchema.optional(),
  installments: oz212.number().nonnegative().step(1).optional(),
  scheduledInstallments: ScheduledInstallmentConfigurationSchema.nullish()
}).openapi("CommercialTermsPricingConfiguration");

// src/entities/product-variant/fixed-product-variants/commercial-terms/commercial-terms-pricing-schema.ts
import { oz as oz214 } from "@vy/utils";

// src/entities/pricing/pricing-model-schema.ts
import { oz as oz213 } from "@vy/utils";
var USAGE_PRICING_MODELS = Object.freeze({
  Tiers: "Tiers",
  TieredSubscription: "TieredSubscription",
  PerUnit: "PerUnit"
});
var PROMOTION_PRICING_MODELS = Object.freeze({
  FixedDeduction: "FixedDeduction",
  PercentageDeduction: "PercentageDeduction"
});
var FIXED_PRICING_MODELS = Object.freeze({
  ...PROMOTION_PRICING_MODELS,
  Subscription: "Subscription",
  FixedOneTime: "FixedOneTime",
  Commission: "Commission",
  CommercialTerms: "CommercialTerms",
  Refund: "Refund"
});
var PRICING_MODELS = Object.freeze({
  ...USAGE_PRICING_MODELS,
  ...FIXED_PRICING_MODELS
});
var UsagePricingModelsSchema = oz213.nativeEnum(USAGE_PRICING_MODELS).openapi("UsagePricingModels");
var FixedPricingModelsSchema = oz213.nativeEnum(FIXED_PRICING_MODELS).openapi("FixedPricingModels");
var PricingModelSchema = oz213.nativeEnum(PRICING_MODELS).openapi("PricingModel");

// src/entities/product-variant/fixed-product-variants/commercial-terms/commercial-terms-pricing-schema.ts
var CommercialTermsPricingSchema = oz214.object({
  pricingModel: oz214.literal(PRICING_MODELS.CommercialTerms),
  priceConfiguration: CommercialTermsPricingConfigurationSchema
}).openapi("CommercialTermsPricing");

// src/entities/product-variant/fixed-product-variants/commercial-terms/commercial-terms-pricing-input-schema.ts
var CommercialTermsPricingInputSchema = CommercialTermsPricingSchema.deepPartial().required({ pricingModel: true }).openapi("CommercialTermsPricingInput");

// src/entities/pricing/pricing-input-schema.ts
import { oz as oz235 } from "@vy/utils";

// src/entities/product-variant/fixed-product-variants/fixed-commission/commission-pricing-schema.ts
import { oz as oz216 } from "@vy/utils";

// src/entities/product-variant/fixed-product-variants/fixed-commission/commission-pricing-configuration-schema.ts
import { oz as oz215 } from "@vy/utils";
var CommissionPricingConfigurationSchema = oz215.object({
  percentage: oz215.number({ invalid_type_error: "Commission amount is required" }).nonnegative().min(0.01)
}).openapi("CommissionPricingConfiguration");

// src/entities/product-variant/fixed-product-variants/fixed-commission/commission-pricing-schema.ts
var CommissionPricingSchema = oz216.object({
  pricingModel: oz216.literal(PRICING_MODELS.Commission),
  priceConfiguration: CommissionPricingConfigurationSchema
}).openapi("CommissionPricing");

// src/entities/product-variant/fixed-product-variants/fixed-commission/commission-pricing-input-schema.ts
var CommissionPricingInputSchema = CommissionPricingSchema.deepPartial().required({ pricingModel: true }).openapi("CommissionPricingInput");

// src/entities/product-variant/fixed-product-variants/fixed-deduction/fixed-deduction-pricing-schema.ts
import { oz as oz218 } from "@vy/utils";

// src/entities/product-variant/fixed-product-variants/fixed-deduction/fixed-deduction-pricing-configuration-schema.ts
import { oz as oz217 } from "@vy/utils";
var FixedDeductionPricingConfigurationSchema = oz217.object({
  amountToDeduct: oz217.number().min(0),
  installments: oz217.number({ invalid_type_error: "Installments are required" }).nonnegative().step(1).optional()
}).openapi("FixedDeductionPricingConfiguration");

// src/entities/product-variant/fixed-product-variants/fixed-deduction/fixed-deduction-pricing-schema.ts
var FixedDeductionPricingSchema = oz218.object({
  pricingModel: oz218.literal(PRICING_MODELS.FixedDeduction),
  priceConfiguration: FixedDeductionPricingConfigurationSchema
}).openapi("FixedDeductionPricing");

// src/entities/product-variant/fixed-product-variants/fixed-deduction/fixed-deduction-pricing-input-schema.ts
var FixedDeductionPricingInputSchema = FixedDeductionPricingSchema.deepPartial().required({ pricingModel: true }).openapi("FixedDeductionPricingInput");

// src/entities/product-variant/fixed-product-variants/fixed-one-time/one-time-pricing-schema.ts
import { oz as oz220 } from "@vy/utils";

// src/entities/product-variant/fixed-product-variants/fixed-one-time/one-time-pricing-configuration-schema.ts
import { oz as oz219 } from "@vy/utils";
var OneTimePricingConfigurationSchema = oz219.object({
  price: oz219.number({ invalid_type_error: "Fixed amount is required" }),
  shouldCreateSeparateInvoice: oz219.boolean().default(false),
  discountConfiguration: DiscountConfigurationSchema.optional()
}).openapi("OneTimePricingConfiguration");

// src/entities/product-variant/fixed-product-variants/fixed-one-time/one-time-pricing-schema.ts
var OneTimePricingSchema = oz220.object({
  pricingModel: oz220.literal(PRICING_MODELS.FixedOneTime),
  priceConfiguration: OneTimePricingConfigurationSchema
}).openapi("OneTimePricing");

// src/entities/product-variant/fixed-product-variants/fixed-one-time/one-time-pricing-input-schema.ts
var OneTimePricingInputSchema = OneTimePricingSchema.deepPartial().required({ pricingModel: true }).openapi("OneTimePricingInput");

// src/entities/product-variant/fixed-product-variants/percentage-deduction/percentage-deduction-pricing-schema.ts
import { oz as oz222 } from "@vy/utils";

// src/entities/product-variant/fixed-product-variants/percentage-deduction/percentage-deduction-pricing-configuration-schema.ts
import { oz as oz221 } from "@vy/utils";
var PercentageDeductionPricingConfigurationSchema = oz221.object({
  percentageToDeduct: oz221.number().min(1),
  installments: oz221.number({ invalid_type_error: "Installments are required" }).nonnegative().step(1).optional()
}).openapi("PercentageDeductionPricingConfiguration");

// src/entities/product-variant/fixed-product-variants/percentage-deduction/percentage-deduction-pricing-schema.ts
var PercentageDeductionPricingSchema = oz222.object({
  pricingModel: oz222.literal(PRICING_MODELS.PercentageDeduction),
  priceConfiguration: PercentageDeductionPricingConfigurationSchema
}).openapi("PercentageDeductionPricing");

// src/entities/product-variant/fixed-product-variants/percentage-deduction/percentage-deduction-pricing-input-schema.ts
var PercentageDeductionPricingInputSchema = PercentageDeductionPricingSchema.deepPartial().required({ pricingModel: true }).openapi("PercentageDeductionPricingInput");

// src/entities/product-variant/fixed-product-variants/refund/refund-pricing-schema.ts
import { oz as oz224 } from "@vy/utils";

// src/entities/product-variant/fixed-product-variants/refund/refund-pricing-configuration-schema.ts
import { oz as oz223 } from "@vy/utils";
var RefundPricingConfigurationSchema = oz223.object({
  price: oz223.number({ invalid_type_error: "Fixed amount is required" }).transform((val) => -Math.abs(val)),
  shouldCreateSeparateInvoice: oz223.boolean().default(false)
}).openapi("RefundPricingConfiguration");

// src/entities/product-variant/fixed-product-variants/refund/refund-pricing-schema.ts
var RefundPricingSchema = oz224.object({
  pricingModel: oz224.literal(PRICING_MODELS.Refund),
  priceConfiguration: RefundPricingConfigurationSchema
}).openapi("RefundPricing");

// src/entities/product-variant/fixed-product-variants/refund/refund-pricing-input-schema.ts
var RefundPricingInputSchema = RefundPricingSchema.deepPartial().required({ pricingModel: true }).openapi("RefundPricingInput");

// src/entities/product-variant/fixed-product-variants/subscription/subscription-pricing-schema.ts
import { oz as oz226 } from "@vy/utils";

// src/entities/product-variant/fixed-product-variants/subscription/subscription-pricing-configuration-schema.ts
import { oz as oz225 } from "@vy/utils";
var SubscriptionPricingConfigurationSchema = oz225.object({
  price: oz225.number({ invalid_type_error: "Recurring amount is required" }).nonnegative(),
  upfrontPay: oz225.boolean().default(false),
  shouldCreateSeparateInvoice: oz225.boolean().default(false),
  installments: oz225.number({ invalid_type_error: "Installments are required" }).nonnegative().step(1).optional(),
  seats: oz225.number({ invalid_type_error: "Seats are required" }).nonnegative().step(1).optional(),
  discountConfiguration: DiscountConfigurationSchema.optional()
}).openapi("RecurringPricingConfiguration");

// src/entities/product-variant/fixed-product-variants/subscription/subscription-pricing-schema.ts
var SubscriptionPricingSchema = oz226.object({
  pricingModel: oz226.literal(PRICING_MODELS.Subscription),
  priceConfiguration: SubscriptionPricingConfigurationSchema
}).openapi("RecurringPricing");

// src/entities/product-variant/fixed-product-variants/subscription/subscription-pricing-input-schema.ts
var SubscriptionPricingInputSchema = SubscriptionPricingSchema.deepPartial().required({ pricingModel: true }).openapi("RecurringPricingInput");

// src/entities/product-variant/usage-product-variants/per-unit/per-unit-pricing-schema.ts
import { oz as oz228 } from "@vy/utils";

// src/entities/product-variant/usage-product-variants/per-unit/per-unit-pricing-configuration-schema.ts
import { oz as oz227 } from "@vy/utils";
var PerUnitPricingConfigurationSchema = oz227.object({
  price: oz227.number({ invalid_type_error: "amount is required" }),
  chunkSize: oz227.number({ invalid_type_error: "Bulk size is required" }).positive().optional(),
  isMeteredCredit: oz227.boolean().optional().default(false)
}).openapi("PerUnitPricingConfiguration");

// src/entities/product-variant/usage-product-variants/per-unit/per-unit-pricing-schema.ts
var PerUnitPricingSchema = oz228.object({
  pricingModel: oz228.literal(PRICING_MODELS.PerUnit),
  priceConfiguration: PerUnitPricingConfigurationSchema
}).openapi("PerUnitPricing");

// src/entities/product-variant/usage-product-variants/per-unit/per-unit-pricing-input-schema.ts
var PerUnitPricingInputSchema = PerUnitPricingSchema.deepPartial().required({ pricingModel: true }).openapi("PerUnitPricingInput");

// src/entities/product-variant/usage-product-variants/tiered-subscription/tiered-subscription-pricing-input-schema.ts
import { oz as oz231 } from "@vy/utils";

// src/entities/product-variant/usage-product-variants/tiered-subscription/tiered-subscription-pricing-configuration-input-schema.ts
import { oz as oz230 } from "@vy/utils";

// src/entities/price-tier/price-tier-schema/price-tier-schema.ts
import { oz as oz229 } from "@vy/utils";
var PriceTierSchema = oz229.object({
  from: oz229.number({ invalid_type_error: "Tier from amount is required" }).nonnegative(),
  to: oz229.number({ invalid_type_error: "Tier to amount is required" }).nonnegative(),
  price: oz229.number({
    invalid_type_error: "Tier price is required",
    required_error: "Tier price is required"
  }).nonnegative(),
  flatRate: oz229.number().optional(),
  chunkSize: oz229.number().optional()
}).openapi("PriceTier");

// src/entities/product-variant/usage-product-variants/tiered-subscription/tiered-subscription-pricing-configuration-input-schema.ts
var TieredSubscriptionPricingConfigurationInputSchema = oz230.object({
  tiers: oz230.array(PriceTierSchema.partial()),
  maxUnits: oz230.number().optional(),
  tierLock: oz230.boolean().default(false).optional(),
  discountConfiguration: DiscountConfigurationSchema.partial().optional()
}).openapi("TieredSubscriptionPricingConfigurationInput");

// src/entities/product-variant/usage-product-variants/tiered-subscription/tiered-subscription-pricing-input-schema.ts
var TieredSubscriptionPricingInputSchema = oz231.object({
  pricingModel: oz231.literal(PRICING_MODELS.TieredSubscription),
  priceConfiguration: TieredSubscriptionPricingConfigurationInputSchema.optional()
}).openapi("TieredSubscriptionPricingInput");

// src/entities/product-variant/usage-product-variants/tiers/tiers-pricing-input-schema.ts
import { oz as oz234 } from "@vy/utils";

// src/entities/product-variant/usage-product-variants/tiers/tiers-pricing-configuration-input-schema.ts
import { oz as oz233 } from "@vy/utils";

// src/entities/price-tier/price-tier-schema/price-tier-schema-consts.ts
var MAX_TO = 999999999999999;

// src/entities/price-tier/price-tiers-list-schema.ts
import { oz as oz232 } from "@vy/utils";
function validateTiersRanges(tiers) {
  return tiers.every(({ from, to }) => from < to);
}
function fromBiggerOrEqualToPreviousTo(tiers) {
  return tiers.every(({ from }, tierIndex) => tierIndex === 0 || from >= tiers[tierIndex - 1].to);
}
var PriceTiersListSchema = oz232.array(PriceTierSchema).min(1).refine(validateTiersRanges, "tier must have normal units boundaries").refine(fromBiggerOrEqualToPreviousTo, "tiers must be ascending order").openapi("PriceTiersList");

// src/entities/product-variant/usage-product-variants/tiers/tiers-pricing-configuration-input-schema.ts
var TiersPricingConfigurationInputSchema = oz233.object({
  tiers: oz233.array(PriceTierSchema.partial()),
  isVolume: oz233.boolean().default(false).optional(),
  isFlatRate: oz233.boolean().default(false).optional(),
  isChunked: oz233.boolean().default(false).optional(),
  isRevShare: oz233.boolean().default(false).optional(),
  useInfinity: oz233.boolean().default(false).optional(),
  tierLock: oz233.boolean().default(false).optional()
}).openapi("TiersPricingConfigurationInput");

// src/entities/product-variant/usage-product-variants/tiers/tiers-pricing-input-schema.ts
var TiersPricingInputSchema = oz234.object({
  pricingModel: oz234.literal(PRICING_MODELS.Tiers),
  priceConfiguration: TiersPricingConfigurationInputSchema.optional()
}).openapi("TiersPricingInput");

// src/entities/pricing/pricing-input-schema.ts
var PricingInputSchema = oz235.discriminatedUnion("pricingModel", [
  PerUnitPricingInputSchema,
  TiersPricingInputSchema,
  TieredSubscriptionPricingInputSchema,
  SubscriptionPricingInputSchema,
  OneTimePricingInputSchema,
  CommercialTermsPricingInputSchema,
  CommissionPricingInputSchema,
  RefundPricingInputSchema,
  FixedDeductionPricingInputSchema,
  PercentageDeductionPricingInputSchema
]).openapi("PricingInput");

// src/entities/product-variant/new-product-variant-schema.ts
import { oz as oz248 } from "@vy/utils";

// src/entities/pricing/pricing-schema.ts
import { oz as oz240 } from "@vy/utils";

// src/entities/product-variant/usage-product-variants/tiered-subscription/tiered-subscription-pricing-schema.ts
import { oz as oz237 } from "@vy/utils";

// src/entities/product-variant/usage-product-variants/tiered-subscription/tiered-subscription-pricing-configuration-schema.ts
import { oz as oz236 } from "@vy/utils";
var TieredSubscriptionPricingConfigurationSchema = oz236.object({
  tiers: PriceTiersListSchema,
  isVolume: oz236.boolean().default(true),
  maxUnits: oz236.number().optional(),
  useInfinity: oz236.boolean().default(false).optional(),
  tierLock: oz236.boolean().default(false).optional(),
  discountConfiguration: DiscountConfigurationSchema.optional()
}).openapi("TieredSubscriptionPricingConfiguration");

// src/entities/product-variant/usage-product-variants/tiered-subscription/tiered-subscription-pricing-schema.ts
var TieredSubscriptionPricingSchema = oz237.object({
  pricingModel: oz237.literal(PRICING_MODELS.TieredSubscription),
  priceConfiguration: TieredSubscriptionPricingConfigurationSchema
}).openapi("TieredSubscriptionPricing");

// src/entities/product-variant/usage-product-variants/tiers/tiers-pricing-schema.ts
import { oz as oz239 } from "@vy/utils";

// src/entities/product-variant/usage-product-variants/tiers/tiers-pricing-configuration-schema.ts
import { oz as oz238 } from "@vy/utils";
var TiersPricingConfigurationSchema = oz238.object({
  tiers: PriceTiersListSchema,
  isVolume: oz238.boolean().optional().default(false),
  isFlatRate: oz238.boolean().optional().default(false),
  isChunked: oz238.boolean().optional().default(false),
  isRevShare: oz238.boolean().optional().default(false),
  useInfinity: oz238.boolean().optional().default(false),
  tierLock: oz238.boolean().optional().default(false)
}).openapi("TiersPricingConfiguration");

// src/entities/product-variant/usage-product-variants/tiers/tiers-pricing-schema.ts
var TiersPricingSchema = oz239.object({
  pricingModel: oz239.literal(PRICING_MODELS.Tiers),
  priceConfiguration: TiersPricingConfigurationSchema
}).openapi("TiersPricing");

// src/entities/pricing/pricing-schema.ts
var PricingSchema = oz240.discriminatedUnion("pricingModel", [
  PerUnitPricingSchema,
  TiersPricingSchema,
  TieredSubscriptionPricingSchema,
  OneTimePricingSchema,
  SubscriptionPricingSchema,
  CommercialTermsPricingSchema,
  CommissionPricingSchema,
  RefundPricingSchema,
  FixedDeductionPricingSchema,
  PercentageDeductionPricingSchema
]).openapi("Pricing");

// src/entities/product-variant/fixed-product-variants/product-settings-schemas/credit/credit-product-configuration.ts
import { oz as oz241 } from "@vy/utils";
var CreditProductConfigurationSchema = oz241.object({
  shouldCreateSeparateInvoice: oz241.boolean().default(false)
}).openapi("CreditProductConfiguration");

// src/entities/product-variant/fixed-product-variants/product-settings-schemas/credit/credit-product-settings.ts
import { oz as oz243 } from "@vy/utils";

// src/entities/product-variant/fixed-product-variants/fixed-product-type-schema.ts
import { oz as oz242 } from "@vy/utils";
var FIXED_PRODUCT_TYPES = Object.freeze({
  Service: "Service",
  CommercialTerms: "CommercialTerms",
  Credit: "Credit"
});
var FixedProductTypeSchema = oz242.nativeEnum(FIXED_PRODUCT_TYPES).openapi("FixedProductType");

// src/entities/product-variant/fixed-product-variants/product-settings-schemas/credit/credit-product-settings.ts
var CreditProductSettingsSchema = oz243.object({
  productType: oz243.literal(FIXED_PRODUCT_TYPES.Credit),
  productConfiguration: CreditProductConfigurationSchema
}).openapi("CreditProductSettings");

// src/entities/product-variant/fixed-product-variants/product-settings-schemas/service/service-product-configuration.ts
import { oz as oz244 } from "@vy/utils";
var ServiceProductConfigurationSchema = oz244.object({}).openapi("ServiceProductConfiguration");

// src/entities/product-variant/fixed-product-variants/product-settings-schemas/service/service-product-settings.ts
import { oz as oz245 } from "@vy/utils";
var ServiceProductSettingsSchema = oz245.object({
  productType: oz245.literal(FIXED_PRODUCT_TYPES.Service),
  productConfiguration: ServiceProductConfigurationSchema
}).openapi("ServiceProductSettings");

// src/entities/product-variant/fixed-product-variants/product-settings-schemas/product-settings-schema.ts
import { oz as oz246 } from "@vy/utils";
var ProductSettingsSchema = oz246.discriminatedUnion("productType", [CreditProductSettingsSchema, ServiceProductSettingsSchema]).openapi("ProductSettings");

// src/entities/product-variant/fixed-product-variants/product-settings-schemas/product-configuration-schema.ts
import { oz as oz247 } from "@vy/utils";
var ProductConfigurationSchema = oz247.union([CreditProductConfigurationSchema, ServiceProductConfigurationSchema]).openapi("ProductConfiguration");

// src/entities/product-variant/new-product-variant-schema.ts
var NewProductVariantSchema = oz248.object({
  id: withNullAsOptional(ObjectIdSchema),
  meterId: withNullAsOptional(ObjectIdSchema),
  pricing: PricingSchema,
  settings: withNullAsOptional(ProductSettingsSchema),
  description: withNullAsOptional(oz248.string().nonempty()),
  name: oz248.string().nonempty("Product variant name is required")
}).openapi("NewProductVariant");

// src/entities/product-variant/product-variant-input-schema.ts
var ProductVariantInputSchema = NewProductVariantSchema.partial().extend({
  id: ObjectIdSchema,
  pricing: PricingInputSchema
}).openapi("ProductVariantInput");

// src/entities/product-variant/fixed-product-variants/commercial-terms/commercial-terms-product-variant-input-schema.ts
var CommercialTermsProductVariantInputSchema = ProductVariantInputSchema.extend({
  pricing: CommercialTermsPricingInputSchema
}).openapi("CommercialTermsProductVariantInput");

// src/entities/product-variant/product-variant-schema.ts
import { oz as oz271 } from "@vy/utils";

// src/entities/meter/condition-schema.ts
import { oz as oz251 } from "@vy/utils";

// src/entities/meter/criterion-schema.ts
import { oz as oz250 } from "@vy/utils";

// src/entities/meter/criterion-operator-schema.ts
import { oz as oz249 } from "@vy/utils";
var CRITERION_OPERATORS = Object.freeze({
  Equals: "Equals",
  DoesntEqual: "DoesntEqual",
  Has: "Has",
  In: "In",
  Contains: "Contains",
  DoesntContain: "DoesntContain",
  LargerThan: "LargerThan",
  LowerThan: "LowerThan",
  LowerEqualTo: "LowerEqualTo",
  LargerEqualTo: "LargerEqualTo",
  Exists: "Exists",
  DoesntExists: "DoesntExists"
});
var CriterionOperatorSchema = oz249.nativeEnum(CRITERION_OPERATORS).openapi("CriterionOperator");

// src/entities/meter/criterion-schema.ts
var CriterionSchema = oz250.object({
  field: oz250.string().nonempty(),
  operator: CriterionOperatorSchema,
  value: oz250.string().nonempty()
}).openapi("Criterion");

// src/entities/meter/condition-schema.ts
var ConditionSchema = oz251.object({
  criterions: oz251.array(CriterionSchema).nonempty()
}).openapi("Condition");

// src/entities/meter/filter-schema.ts
import { oz as oz252 } from "@vy/utils";
var FilterSchema = oz252.object({
  conditions: oz252.array(ConditionSchema).nonempty()
}).openapi("Filter");

// src/entities/meter/new-meter-schema.ts
import { oz as oz265 } from "@vy/utils";

// src/entities/meter/aggregation-method/aggregation-method-schema.ts
import { oz as oz264 } from "@vy/utils";

// src/entities/meter/aggregation-method/aggregation-method-with-field-schemas/average.ts
import { oz as oz256 } from "@vy/utils";

// src/entities/meter/aggregation-method/aggregation-operator-schema.ts
import { oz as oz253, values as values3 } from "@vy/utils";
var AGGREGATION_WITH_FIELD_OPERATORS = Object.freeze({
  Sum: "Sum",
  Distinct: "Distinct",
  Max: "Max",
  Min: "Min",
  Average: "Average",
  First: "First",
  Last: "Last"
});
var AGGREGATION_WITHOUT_FIELD_OPERATORS = Object.freeze({
  Count: "Count"
});
var AGGREGATION_OPERATORS = Object.freeze({
  ...AGGREGATION_WITHOUT_FIELD_OPERATORS,
  ...AGGREGATION_WITH_FIELD_OPERATORS
});
var AGGREGATION_METHOD_VALUES = values3(AGGREGATION_OPERATORS);
var AggregationOperatorSchema = oz253.nativeEnum(AGGREGATION_OPERATORS).openapi("AggregationOperator");
var AggregationWithFieldOperatorSchema = oz253.nativeEnum(AGGREGATION_WITH_FIELD_OPERATORS).openapi("AggregationWithFieldOperator");
var AggregationWithoutFieldOperatorSchema = oz253.nativeEnum(AGGREGATION_WITHOUT_FIELD_OPERATORS).openapi("AggregationWithoutFieldOperator");

// src/entities/meter/aggregation-method/base-aggregation-method-schema.ts
import { oz as oz255 } from "@vy/utils";

// src/entities/meter/meter-sql-config-schema.ts
import { oz as oz254 } from "@vy/utils";
var MeterSqlConfigSchema = oz254.object({
  selectExpression: oz254.string(),
  whereExpression: oz254.string().nullish()
});

// src/entities/meter/aggregation-method/base-aggregation-method-schema.ts
var BaseAggregationMethodSchema = oz255.object({
  instanceKey: oz255.string().optional(),
  sql: withNullAsOptional(MeterSqlConfigSchema)
});

// src/entities/meter/aggregation-method/aggregation-method-with-field-schemas/average.ts
var AggregationAverageMethodSchema = BaseAggregationMethodSchema.extend({
  field: oz256.string().nonempty(),
  operator: oz256.literal(AGGREGATION_WITH_FIELD_OPERATORS.Average)
}).openapi("AggregationAverageMethod");

// src/entities/meter/aggregation-method/aggregation-method-with-field-schemas/distinct.ts
import { oz as oz257 } from "@vy/utils";
var AggregationDistinctMethodSchema = BaseAggregationMethodSchema.extend({
  field: oz257.string().nonempty(),
  operator: oz257.literal(AGGREGATION_WITH_FIELD_OPERATORS.Distinct)
}).openapi("AggregationDistinctMethod");

// src/entities/meter/aggregation-method/aggregation-method-with-field-schemas/first.ts
import { oz as oz258 } from "@vy/utils";
var AggregationFirstMethodSchema = BaseAggregationMethodSchema.extend({
  field: oz258.string().nonempty(),
  operator: oz258.literal(AGGREGATION_WITH_FIELD_OPERATORS.First)
}).openapi("AggregationFirstMethod");

// src/entities/meter/aggregation-method/aggregation-method-with-field-schemas/last.ts
import { oz as oz259 } from "@vy/utils";
var AggregationLastMethodSchema = BaseAggregationMethodSchema.extend({
  field: oz259.string().nonempty(),
  operator: oz259.literal(AGGREGATION_WITH_FIELD_OPERATORS.Last)
}).openapi("AggregationLastMethod");

// src/entities/meter/aggregation-method/aggregation-method-with-field-schemas/max.ts
import { oz as oz260 } from "@vy/utils";
var AggregationMaxMethodSchema = BaseAggregationMethodSchema.extend({
  field: oz260.string().nonempty(),
  operator: oz260.literal(AGGREGATION_WITH_FIELD_OPERATORS.Max)
}).openapi("AggregationMaxMethod");

// src/entities/meter/aggregation-method/aggregation-method-with-field-schemas/min.ts
import { oz as oz261 } from "@vy/utils";
var AggregationMinMethodSchema = BaseAggregationMethodSchema.extend({
  field: oz261.string().nonempty(),
  operator: oz261.literal(AGGREGATION_WITH_FIELD_OPERATORS.Min)
}).openapi("AggregationMinMethod");

// src/entities/meter/aggregation-method/aggregation-method-with-field-schemas/sum.ts
import { oz as oz262 } from "@vy/utils";
var AggregationSumMethodSchema = BaseAggregationMethodSchema.extend({
  field: oz262.string().nonempty(),
  operator: oz262.literal(AGGREGATION_WITH_FIELD_OPERATORS.Sum)
}).openapi("AggregationSumMethod");

// src/entities/meter/aggregation-method/aggregation-method-without-field-schema.ts
import { oz as oz263 } from "@vy/utils";
var AggregationWithoutFieldMethodSchema = BaseAggregationMethodSchema.extend({
  operator: oz263.literal(AGGREGATION_WITHOUT_FIELD_OPERATORS.Count)
}).openapi("AggregationWithoutFieldMethod");

// src/entities/meter/aggregation-method/aggregation-method-schema.ts
var AggregationMethodSchema = oz264.discriminatedUnion("operator", [
  AggregationWithoutFieldMethodSchema,
  AggregationSumMethodSchema,
  AggregationAverageMethodSchema,
  AggregationDistinctMethodSchema,
  AggregationFirstMethodSchema,
  AggregationLastMethodSchema,
  AggregationMaxMethodSchema,
  AggregationMinMethodSchema
]).openapi("AggregationMethod");

// src/entities/meter/new-meter-schema.ts
var NewMeterSchema = oz265.object({
  eventName: oz265.string().nonempty(),
  name: oz265.string().min(1, "Name is required"),
  description: oz265.string().optional(),
  unitsType: oz265.string().optional(),
  filter: withNullAsOptional(FilterSchema),
  aggregationMethod: AggregationMethodSchema,
  integrationEntities: ProductIntegrationEntitySchema.array().optional(),
  creditTypeIds: withNullAsOptional(ObjectIdSchema.array()),
  isTaxable: oz265.boolean().optional()
});

// src/entities/meter/meter-schema.ts
var MeterSchema = segregated(NewMeterSchema).openapi("Meter");

// src/entities/meter/filter-input-schema.ts
import { oz as oz267 } from "@vy/utils";

// src/entities/meter/condition-input-schema.ts
import { oz as oz266 } from "@vy/utils";
var ConditionInputSchema = oz266.object({
  criterions: oz266.array(CriterionSchema)
});

// src/entities/meter/filter-input-schema.ts
var FilterInputSchema = oz267.object({
  conditions: oz267.array(ConditionInputSchema)
});

// src/entities/meter/meter-input-schema.ts
var MeterInputSchema = NewMeterSchema.deepPartial().extend({
  filter: FilterInputSchema.optional()
});

// src/entities/meter/aggregation-method/parameterized-aggregation-method-schema.ts
import { oz as oz268 } from "@vy/utils";
var ParameterizedAggregationMethodSchema = oz268.union([
  AggregationSumMethodSchema,
  AggregationAverageMethodSchema,
  AggregationDistinctMethodSchema,
  AggregationFirstMethodSchema,
  AggregationLastMethodSchema,
  AggregationMaxMethodSchema,
  AggregationMinMethodSchema
]);

// src/entities/meter/ingested-meter-schema.ts
import { oz as oz269 } from "@vy/utils";
var IngestedMeterSchema = oz269.object({
  meterId: ObjectIdSchema
});

// src/entities/meter/meter-product-schema.ts
import { oz as oz270 } from "@vy/utils";
var MeterProductSchema = MeterSchema.extend({
  contractsCount: oz270.number(),
  planNames: oz270.string().array()
});

// src/entities/product-variant/product-variant-schema.ts
var ProductVariantSchema = created(
  NewProductVariantSchema.extend({
    productId: oz271.string(),
    meter: MeterSchema.nullable()
  })
).openapi("ProductVariant");

// src/entities/product-variant/fixed-product-variants/commercial-terms/commercial-terms-product-variant-schema.ts
var CommercialTermsProductVariantSchema = ProductVariantSchema.extend({
  pricing: CommercialTermsPricingSchema
}).openapi("CommercialTermsProductVariant");

// src/entities/product-variant/fixed-product-variants/commercial-terms/new-commercial-terms-variant-schema.ts
var NewCommercialTermsVariantSchema = NewProductVariantSchema.extend({
  pricing: CommercialTermsPricingSchema
}).openapi("NewCommercialTermsVariant");

// src/entities/product-variant/fixed-product-variants/fixed-one-time/new-one-time-product-variant-schema.ts
var NewOneTimeProductVariantSchema = NewProductVariantSchema.extend({
  pricing: OneTimePricingSchema
}).openapi("NewOneTimeProductVariant");

// src/entities/product-variant/fixed-product-variants/fixed-one-time/one-time-product-variant-input-schema.ts
var OneTimeProductVariantInputSchema = ProductVariantInputSchema.partial().extend({
  pricing: OneTimePricingInputSchema
}).openapi("OneTimeProductVariantInput");

// src/entities/product-variant/fixed-product-variants/fixed-one-time/one-time-product-variant-schema.ts
var OneTimeProductVariantSchema = ProductVariantSchema.extend({
  pricing: OneTimePricingSchema
}).openapi("OneTimeProductVariant");

// src/entities/product-variant/fixed-product-variants/subscription/new-subscription-product-variant-schema.ts
var NewSubscriptionProductVariantSchema = NewProductVariantSchema.extend({
  pricing: SubscriptionPricingSchema
}).openapi("NewRecurringProductVariant");

// src/entities/product-variant/fixed-product-variants/subscription/subscription-product-variant-input-schema.ts
var SubscriptionProductVariantInputSchema = ProductVariantInputSchema.partial().extend({
  pricing: SubscriptionPricingInputSchema
}).openapi("RecurringProductVariantInput");

// src/entities/product-variant/fixed-product-variants/subscription/subscription-product-variant-schema.ts
var SubscriptionProductVariantSchema = ProductVariantSchema.extend({
  pricing: SubscriptionPricingSchema
}).openapi("RecurringProductVariant");

// src/entities/product-variant/fixed-product-variants/fixed-commission/commission-product-variant-input-schema.ts
var CommissionProductVariantInputSchema = ProductVariantInputSchema.partial().extend({
  pricing: CommissionPricingInputSchema
}).openapi("CommissionProductVariantInput");

// src/entities/product-variant/fixed-product-variants/fixed-commission/new-commission-product-variant-schema.ts
var CommissionProductVariantSchema = NewProductVariantSchema.extend({
  pricing: CommissionPricingSchema
}).openapi("CommissionProductVariant");

// src/entities/product-variant/fixed-product-variants/fixed-deduction/fixed-deduction-product-variant-schema.ts
var FixedDeductionProductVariantSchema = ProductVariantSchema.extend({
  pricing: FixedDeductionPricingSchema
}).openapi("FixedDeductionProductVariant");

// src/entities/product-variant/fixed-product-variants/refund/refund-product-varaint-schema.ts
var RefundProductVariantSchema = ProductVariantSchema.extend({
  pricing: RefundPricingSchema
}).openapi("RefundProductVariant");

// src/entities/product-variant/fixed-product-variants/fixed-pricing-configuration-schema.ts
import { oz as oz272 } from "@vy/utils";
var FixedPricingConfigurationSchema = oz272.union([
  OneTimePricingConfigurationSchema,
  SubscriptionPricingConfigurationSchema,
  CommercialTermsPricingConfigurationSchema,
  CommissionPricingConfigurationSchema,
  RefundPricingConfigurationSchema,
  FixedDeductionPricingConfigurationSchema,
  PercentageDeductionPricingConfigurationSchema
]).openapi("FixedPricingConfiguration");

// src/entities/product-variant/fixed-product-variants/fixed-pricing-input-schema.ts
import { oz as oz273 } from "@vy/utils";
var FixedPricingInputSchema = oz273.discriminatedUnion("pricingModel", [
  SubscriptionPricingInputSchema,
  OneTimePricingInputSchema,
  CommercialTermsPricingInputSchema,
  CommissionPricingInputSchema,
  RefundPricingInputSchema,
  FixedDeductionPricingInputSchema,
  PercentageDeductionPricingInputSchema
]).openapi("FixedPricingInput");

// src/entities/product-variant/fixed-product-variants/fixed-pricing-schema.ts
import { oz as oz274 } from "@vy/oz";
var FixedPricingSchema = oz274.discriminatedUnion("pricingModel", [
  SubscriptionPricingSchema,
  OneTimePricingSchema,
  CommercialTermsPricingSchema,
  CommissionPricingSchema,
  RefundPricingSchema,
  FixedDeductionPricingSchema,
  PercentageDeductionPricingSchema
]).openapi("FixedPricing");

// src/entities/product-variant/fixed-product-variants/fixed-product-variant-input-schema.ts
var FixedProductVariantInputSchema = ProductVariantInputSchema.extend({
  pricing: FixedPricingInputSchema
}).openapi("FixedProductVariantInput");

// src/entities/product-variant/fixed-product-variants/fixed-product-variant-schema.ts
var FixedProductVariantSchema = ProductVariantSchema.extend({
  pricing: FixedPricingSchema
}).openapi("FixedProductVariant");

// src/entities/product-variant/fixed-product-variants/new-fixed-product-variant-schema.ts
var NewFixedProductVariantSchema = NewProductVariantSchema.extend({
  pricing: FixedPricingSchema
}).openapi("NewFixedProductVariant");

// src/entities/product-variant/fixed-product-variants/percentage-deduction/percentage-deduction-product-variant-schema.ts
var PercentageDeductionProductVariantSchema = ProductVariantSchema.extend({
  pricing: PercentageDeductionPricingSchema
}).openapi("PercentageDeductionProductVariant");

// src/entities/product-variant/usage-product-variants/per-unit/new-per-unit-product-variant-schema.ts
var NewPerUnitProductVariantSchema = NewProductVariantSchema.extend({
  pricing: PerUnitPricingSchema
}).openapi("NewPerUnitProductVariant");

// src/entities/product-variant/usage-product-variants/per-unit/per-unit-product-variant-input-schema.ts
var PerUnitProductVariantInputSchema = ProductVariantInputSchema.partial().extend({
  pricing: PerUnitPricingInputSchema
}).openapi("PerUnitProductVariantInput");

// src/entities/product-variant/usage-product-variants/usage-pricing-schema.ts
import { oz as oz275 } from "@vy/utils";
var UsagePricingSchema = oz275.discriminatedUnion("pricingModel", [
  PerUnitPricingSchema,
  TiersPricingSchema,
  TieredSubscriptionPricingSchema
]).openapi("UsagePricing");

// src/entities/product-variant/usage-product-variants/usage-product-variant-schema.ts
var UsageProductVariantSchema = ProductVariantSchema.extend({
  pricing: UsagePricingSchema
}).required({
  meterId: true
}).openapi("UsageProductVariant");

// src/entities/product-variant/usage-product-variants/per-unit/per-unit-product-variant-schema.ts
var PerUnitProductVariantSchema = UsageProductVariantSchema.extend({
  pricing: PerUnitPricingSchema
}).openapi("PerUnitProductVariant");

// src/entities/product-variant/usage-product-variants/tiers/new-tiers-product-variant-schema.ts
var NewTiersProductVariantSchema = NewProductVariantSchema.extend({
  pricing: TiersPricingSchema
}).openapi("NewTiersProductVariant");

// src/entities/product-variant/usage-product-variants/tiers/tiers-product-variant-input-schema.ts
var TiersProductVariantInputSchema = ProductVariantInputSchema.partial().extend({
  pricing: TiersPricingInputSchema
}).openapi("TiersProductVariantInput");

// src/entities/product-variant/usage-product-variants/tiers/tiers-product-variant-schema.ts
var TiersProductVariantSchema = UsageProductVariantSchema.extend({
  pricing: TiersPricingSchema
}).openapi("TiersProductVariant");

// src/entities/product-variant/usage-product-variants/new-usage-product-variant-refinements.ts
import { isNotNullOrUndefined as isNotNullOrUndefined2 } from "@vy/utils";
function withUsageProductMeterIdValidation(schema) {
  return schema.refine(
    (variant) => {
      const { success: isUsageVariant } = UsagePricingSchema.safeParse(variant.pricing);
      return !isUsageVariant || isNotNullOrUndefined2(variant.meterId);
    },
    {
      message: "Meter ID is required for usage products"
    }
  );
}

// src/entities/product-variant/usage-product-variants/new-usage-product-variant-schema.ts
import { oz as oz276 } from "@vy/utils";
var NewUsageProductVariantSchema = NewProductVariantSchema.extend({
  meterId: oz276.string({
    required_error: "Meter ID is required"
  }).refine((value) => ObjectIdSchema.safeParse(value).success, {
    message: "Invalid ObjectId"
  }),
  pricing: UsagePricingSchema
}).openapi("NewUsageProductVariant");

// src/entities/product-variant/usage-product-variants/usage-pricing-configuration-schema.ts
import { oz as oz277 } from "@vy/utils";
var UsagePricingConfigurationSchema = oz277.union([
  PerUnitPricingConfigurationSchema,
  TiersPricingConfigurationSchema,
  TieredSubscriptionPricingConfigurationSchema
]).openapi("UsagePricingConfiguration");

// src/entities/product-variant/usage-product-variants/usage-pricing-input-schema.ts
import { oz as oz278 } from "@vy/utils";
var UsagePricingInputSchema = oz278.discriminatedUnion("pricingModel", [
  TiersPricingInputSchema,
  PerUnitPricingInputSchema,
  TieredSubscriptionPricingInputSchema
]).openapi("UsagePricingInput");

// src/entities/product-variant/usage-product-variants/usage-product-variant-input-schema.ts
var UsageProductVariantInputSchema = ProductVariantInputSchema.extend({
  pricing: UsagePricingInputSchema
}).openapi("UsageProductVariantInput");

// src/entities/product-variant/usage-product-variants/tiered-subscription/new-tiered-subscription-product-variant-schema.ts
var NewTieredSubscriptionProductVariantSchema = NewProductVariantSchema.extend({
  pricing: TieredSubscriptionPricingSchema
}).openapi("NewTieredSubscriptionProductVariant");

// src/entities/product-variant/usage-product-variants/tiered-subscription/tiered-subscription-product-variant-input-schema.ts
var TieredSubscriptionProductVariantInputSchema = ProductVariantInputSchema.partial().extend({
  pricing: TieredSubscriptionPricingInputSchema
}).openapi("TieredSubscriptionVariantInput");

// src/entities/product-variant/usage-product-variants/tiered-subscription/tiered-subscription-product-variant-schema.ts
var TieredSubscriptionProductVariantSchema = UsageProductVariantSchema.extend({
  pricing: TieredSubscriptionPricingSchema
}).openapi("TieredSubscriptionVariant");

// src/entities/product/product-cloud-provider-settings-schema.ts
import { oz as oz279 } from "@vy/oz";
import { CloudProviderSchema as CloudProviderSchema2 } from "@vy/connact";
import { isNotEmptyString as isNotEmptyString2 } from "@vy/utils";
var ProductCloudProviderSettingsSchema = oz279.object({
  cloudProvider: CloudProviderSchema2.optional(),
  cloudProviderMarketplaceId: oz279.string().optional(),
  dimension: oz279.string().optional()
}).superRefine((cloudProviderSettings, ctx) => {
  const hasCloudProvider = isNotEmptyString2(cloudProviderSettings.cloudProvider);
  const hasMarketplaceId = isNotEmptyString2(cloudProviderSettings.cloudProviderMarketplaceId);
  const hasDimension = isNotEmptyString2(cloudProviderSettings.dimension);
  const allDefined = hasCloudProvider && hasDimension && hasMarketplaceId;
  const allUndefined = !hasCloudProvider && !hasDimension && !hasMarketplaceId;
  if (allDefined || allUndefined) {
    return;
  }
  if (!hasCloudProvider) {
    ctx.addIssue({
      code: oz279.ZodIssueCode.custom,
      path: ["cloudProvider"],
      message: "Cloud provider is required"
    });
  }
  if (!hasMarketplaceId) {
    ctx.addIssue({
      code: oz279.ZodIssueCode.custom,
      path: ["cloudProviderMarketplaceId"],
      message: "Marketplace ID is required"
    });
  }
  if (!hasDimension) {
    ctx.addIssue({
      code: oz279.ZodIssueCode.custom,
      path: ["dimension"],
      message: "Dimension is required"
    });
  }
}).openapi("ProductCloudProviderSettings");

// src/entities/product-config/product-config-schema.ts
var ProductConfigSchema = created(
  oz280.object({
    productId: oz280.string(),
    name: withNullAsOptional(oz280.string()),
    status: productConfigStatusSchema,
    basePrice: withNullAsOptional(oz280.number().nonnegative()),
    additionalCharge: withNullAsOptional(oz280.number().nonnegative()),
    proRata: withNullAsOptional(oz280.boolean()),
    paymentTerm: PaymentTermSchema,
    billingInterval: BillingIntervalSchema,
    chargingCadence: withNullAsOptional(oz280.number()),
    accumulationInterval: withNullAsOptional(oz280.number()),
    rateMultiplier: withNullAsOptional(oz280.number()),
    currencyCommitment: withNullAsOptional(oz280.number()),
    variantPricingOverrides: withNullAsOptional(oz280.record(oz280.string(), NewProductVariantSchema)),
    period: PeriodSchema,
    commitment: withNullAsOptional(CommitmentSchema),
    revisionId: withNullAsOptional(oz280.string()),
    cloudProviderSettings: ProductCloudProviderSettingsSchema.nullish()
  })
).openapi("ProductConfig");

// src/entities/product/advance-payment/advance-payment-schema.ts
import { oz as oz284 } from "@vy/utils";

// src/entities/product/advance-payment/advance-payment-configs/base-advance-payment-config-schema.ts
import { oz as oz281 } from "@vy/utils";
var BaseAdvancePaymentConfigSchema = oz281.object({
  separateLineItems: oz281.boolean(),
  payInAdvanceOnTierCross: oz281.boolean().optional()
}).openapi("BaseAdvancePaymentConfig");

// src/entities/product/advance-payment/advance-payment-configs/tiers-advance-payment/tiers-advance-payment-config-schema.ts
var TiersAdvancePaymentConfigSchema = BaseAdvancePaymentConfigSchema.openapi("TiersAdvancePaymentConfig");

// src/entities/product/advance-payment/advance-payment-configs/tiers-advance-payment/tiers-advance-payment-schema.ts
import { oz as oz283 } from "@vy/utils";

// src/entities/product/advance-payment/advance-payment-types.ts
import { oz as oz282 } from "@vy/utils";
var ADVANCE_PAYMENT_TYPES = Object.freeze({
  Tiers: "Tiers"
});
var AdvancePaymentTypesSchema = oz282.nativeEnum(ADVANCE_PAYMENT_TYPES).openapi("AdvancePaymentTypes");

// src/entities/product/advance-payment/advance-payment-configs/tiers-advance-payment/tiers-advance-payment-schema.ts
var TiersAdvancePaymentSchema = oz283.object({
  advancePaymentType: oz283.literal(ADVANCE_PAYMENT_TYPES.Tiers),
  advancePaymentConfig: TiersAdvancePaymentConfigSchema
}).openapi("TiersAdvancePayment");

// src/entities/product/advance-payment/advance-payment-schema.ts
var AdvancePaymentSchema = oz284.discriminatedUnion("advancePaymentType", [TiersAdvancePaymentSchema]).openapi("AdvancePayment");

// src/entities/product/external-product-integration.ts
import { oz as oz285 } from "@vy/utils";
var ExternalProductIntegrationSchema = oz285.object({
  type: IntegrationProvidersSchema,
  id: oz285.string(),
  code: oz285.string().nullish()
});

// src/entities/product/uplift-configuration-schema.ts
import { oz as oz286 } from "@vy/utils";
var UpliftConfigurationSchema = oz286.object({
  inflationaryUpliftEnabled: oz286.boolean().default(false),
  seatUpliftEnabled: oz286.boolean().default(false),
  commitmentUpliftEnabled: oz286.boolean().default(false)
});

// src/entities/product/new-product-schema.ts
var NewProductSchema = oz287.object({
  id: withNullAsOptional(ObjectIdSchema),
  name: withNullAsOptional(oz287.string().nonempty()),
  description: withNullAsOptional(oz287.string()),
  variants: oz287.array(NewProductVariantSchema).min(1),
  basePrice: withNullAsOptional(oz287.number().nonnegative()),
  additionalCharge: withNullAsOptional(oz287.number().nonnegative()),
  commitment: withNullAsOptional(CommitmentSchema),
  advancePayment: withNullAsOptional(AdvancePaymentSchema),
  chargingCadence: oz287.number().optional(),
  currencyCommitment: withNullAsOptional(oz287.number()),
  paymentTerm: PaymentTermSchema,
  billingInterval: BillingIntervalSchema,
  accumulationInterval: withNullAsOptional(oz287.number()),
  proRata: withNullAsOptional(oz287.boolean()),
  erpMetadata: withNullAsOptional(ErpIntermediateMetadataSchema).openapi({
    description: "DEPRECATED: Use integrationEntities instead. Will be removed in a future version.",
    deprecated: true
  }),
  rateMultiplier: withNullAsOptional(oz287.number()),
  isPeriodicVariants: oz287.boolean().optional().default(false),
  integrationEntities: withNullAsOptional(oz287.array(ProductIntegrationEntitySchema)),
  startDate: withNullAsOptional(ApiDateSchema),
  endDate: withNullAsOptional(ApiDateSchema),
  catalogProductId: withNullAsOptional(ObjectIdSchema),
  productConfigs: withNullAsOptional(oz287.array(ProductConfigSchema)),
  externalIntegration: ExternalProductIntegrationSchema.nullish(),
  revisionId: withNullAsOptional(ObjectIdSchema),
  cloudProviderSettings: ProductCloudProviderSettingsSchema.nullish(),
  isCalendarAligned: oz287.boolean(),
  upliftConfiguration: UpliftConfigurationSchema.optional(),
  creditTypeIds: withNullAsOptional(ObjectIdSchema.array()),
  creditPurchaseConfig: CreditPurchaseConfigSchema.optional()
}).openapi("NewProduct");

// src/entities/product/new-product-refinements.ts
import { isNotNullOrUndefined as isNotNullOrUndefined3 } from "@vy/utils";
var ADVANCE_PAYMENT_SUPPORTED_PRICING_MODELS = /* @__PURE__ */ new Set([PRICING_MODELS.TieredSubscription]);
var BASE_PRICE_UNSUPPORTED_PRICING_MODELS = /* @__PURE__ */ new Set([PRICING_MODELS.TieredSubscription]);
function withAdvancePaymentPricingValidation(schema) {
  return schema.refine(
    (product) => {
      if (!isNotNullOrUndefined3(product.advancePayment)) {
        return true;
      }
      const allVariantsSupportAdvancePayment = product.variants.every(
        (variant) => supportsAdvancePayment(variant.pricing.pricingModel)
      );
      return allVariantsSupportAdvancePayment;
    },
    {
      message: "advancePayment is only supported for products with Tiers or TieredSubscription pricing model",
      path: ["advancePayment"]
    }
  );
}
function withBasePriceValidation(schema) {
  return schema.refine(
    (product) => {
      if (!isNotNullOrUndefined3(product.basePrice)) {
        return true;
      }
      return product.variants.every(
        (variant) => supportsBasePrice(variant.pricing.pricingModel)
      );
    },
    {
      message: "basePrice is not supported for products with TieredSubscription pricing model",
      path: ["basePrice"]
    }
  );
}
function supportsBasePrice(pricingModel) {
  return !BASE_PRICE_UNSUPPORTED_PRICING_MODELS.has(pricingModel);
}
function withMeterResetCommitmentRefillValidation(schema) {
  return schema.refine(
    (product) => {
      const isPerUnit = product.variants.every(
        (variant) => isPerUnitVariant(variant)
      );
      if (!isPerUnit) {
        return true;
      }
      if (!hasMeterReset(product.accumulationInterval)) {
        return true;
      }
      if (!isNotNullOrUndefined3(product.commitment)) {
        return true;
      }
      return isNotNullOrUndefined3(product.commitment.replenishmentInterval);
    },
    {
      message: "Per-unit products with meter reset must have commitment refill (replenishmentInterval) enabled",
      path: ["commitment", "replenishmentInterval"]
    }
  );
}
function withOneTimeProrationValidation(schema) {
  return schema.refine(
    (product) => {
      const isFixedOneTime = product.variants.every(
        (variant) => variant.pricing.pricingModel === PRICING_MODELS.FixedOneTime
      );
      if (!isFixedOneTime) {
        return true;
      }
      return product.proRata !== true && product.isCalendarAligned !== true;
    },
    {
      message: "One-time fees cannot be prorated or calendar-aligned",
      path: []
    }
  );
}
function supportsAdvancePayment(pricingModel) {
  return ADVANCE_PAYMENT_SUPPORTED_PRICING_MODELS.has(pricingModel);
}
function isPerUnitVariant(variant) {
  return variant.pricing.pricingModel === PRICING_MODELS.PerUnit;
}
function hasMeterReset(accumulationInterval) {
  return isNotNullOrUndefined3(accumulationInterval) && accumulationInterval > 0;
}

// src/entities/product/new-product-schemas/new-fixed-product.ts
import { oz as oz288 } from "@vy/utils";
var NewFixedProductSchema = NewProductSchema.extend({
  variants: oz288.array(NewFixedProductVariantSchema).min(1)
});

// src/entities/product/new-product-schemas/new-usage-product.ts
import { oz as oz289 } from "@vy/utils";
var NewUsageProductSchema = NewProductSchema.extend({
  variants: oz289.array(NewUsageProductVariantSchema).min(1)
});

// src/entities/product/product-schema.ts
import { oz as oz291 } from "@vy/utils";

// src/entities/timeline/timeline-schema.ts
import { oz as oz290 } from "@vy/utils";
var TimelineSchema = oz290.object({
  period: PeriodSchema,
  productId: oz290.string()
});

// src/entities/product/product-schema.ts
var ProductSchema = created(NewProductSchema).extend({
  timeline: TimelineSchema.nullish(),
  variants: oz291.array(ProductVariantSchema).min(1),
  commitment: CommitmentSchema.nullish(),
  proRata: oz291.boolean(),
  isCalendarAligned: oz291.boolean()
}).openapi("Product");

// src/entities/product/product-schemas/fixed-product.ts
import { oz as oz292 } from "@vy/utils";
var FixedProductSchema = ProductSchema.extend({
  variants: oz292.array(FixedProductVariantSchema).min(1)
});

// src/entities/product/product-schemas/usage-product.ts
import { oz as oz293 } from "@vy/utils";
var UsageProductSchema = ProductSchema.extend({
  variants: oz293.array(UsageProductVariantSchema).min(1)
});

// src/entities/product/product-input-schema.ts
import { oz as oz294 } from "@vy/utils";
var ProductInputSchema = NewProductSchema.partial().extend({
  variants: oz294.array(ProductVariantInputSchema),
  id: withNullAsOptional(ObjectIdSchema),
  isCalendarAligned: oz294.boolean()
}).openapi("ProductInput");

// src/entities/product/product-input-schemas/fixed-product-input.ts
import { oz as oz295 } from "@vy/utils";
var FixedProductInputSchema = ProductInputSchema.extend({
  variants: oz295.array(FixedProductVariantInputSchema).min(1)
});

// src/entities/product/product-input-schemas/usage-product-input.ts
import { oz as oz296 } from "@vy/utils";
var UsageProductInputSchema = ProductInputSchema.extend({
  isRevShare: oz296.boolean().optional(),
  variants: oz296.array(UsageProductVariantInputSchema).min(1)
});

// src/entities/product/plan-input-form-usage-product.ts
import { oz as oz297 } from "@vy/utils";
var PlanInputFormUsageProductSchema = UsageProductInputSchema.extend({
  billingInterval: UserInputBillingIntervalSchema,
  commitment: withNullAsOptional(CommitmentInputSchema),
  _originalCommitmentAmount: oz297.number().optional(),
  isCalendarAlignedOverridden: oz297.boolean().optional()
});

// src/entities/product/plan-input-form-fixed-product.ts
import { oz as oz298 } from "@vy/utils";
var PlanInputFormFixedProductSchema = FixedProductInputSchema.extend({
  billingInterval: UserInputBillingIntervalSchema,
  isCalendarAlignedOverridden: oz298.boolean().optional()
});

// src/entities/product/product-consumption-schema.ts
import { oz as oz299 } from "@vy/utils";
var ProductConsumptionSchema = oz299.object({
  productId: ObjectIdSchema,
  productName: oz299.string().nonempty(),
  provisionedAmount: oz299.number().nonnegative(),
  consumedAmount: oz299.number().nonnegative(),
  usagePercentage: oz299.number().nonnegative(),
  hasAccess: oz299.boolean(),
  remainingAmount: oz299.number().optional(),
  exceededAmount: oz299.number().optional()
}).openapi("ProductConsumption");

// src/entities/catalog-products/new-catalog-products-schema.ts
var NewCatalogProductSchema = oz300.object({
  accountId: oz300.string(),
  name: oz300.string().min(1, "Name is required"),
  description: oz300.string().optional(),
  isTaxable: oz300.boolean().optional(),
  products: ProductSchema.array().optional(),
  integrationEntities: ProductIntegrationEntitySchema.array().optional(),
  externalIntegration: ExternalProductIntegrationSchema.nullish(),
  creditTypeIds: withNullAsOptional(ObjectIdSchema.array())
});

// src/entities/catalog-products/catalog-products-schema.ts
var CatalogProductsSchema = segregated(NewCatalogProductSchema).openapi("CatalogProducts");

// src/entities/child-consumption-data-schema.ts
import { oz as oz301 } from "@vy/utils";
var ChildConsumptionDataSchema = oz301.object({
  childId: oz301.string(),
  childName: oz301.string(),
  variantData: oz301.array(
    oz301.object({
      variantId: oz301.string(),
      variantName: oz301.string(),
      units: oz301.number()
    })
  )
});

// src/entities/client-notification/client-notification-schema.ts
import { oz as oz360 } from "@vy/utils";

// src/entities/notification/notification-schema.ts
import { oz as oz357 } from "@vy/utils";

// src/entities/notification/notification-schemas/overage-notification-schema.ts
import { oz as oz328 } from "@vy/utils";

// src/entities/notification-subscription/notification-event-type-schema.ts
import { oz as oz302 } from "@vy/utils";
var NOTIFICATION_EVENT_TYPES = Object.freeze({
  AnonymousCustomer: "AnonymousCustomer",
  Overage: "Overage",
  UpcomingRenewal: "UpcomingRenewal",
  ContractExpired: "ContractExpired",
  InvoiceApproved: "InvoiceApproved",
  CustomerPortalLinkSent: "CustomerPortalLinkSent",
  NewCustomerWithoutContract: "NewCustomerWithoutContract",
  MonthEndReport: "MonthEndReport",
  UnchargedEvents: "UnchargedEvents",
  TierCrossed: "TierCrossed",
  CommitmentCrossed: "CommitmentCrossed",
  CommitmentUsageCrossed: "CommitmentUsageCrossed",
  CurrencyCommitmentUsageCrossed: "CurrencyCommitmentUsageCrossed",
  FinalTierExceeded: "FinalTierExceeded",
  InvoicePaymentStatusChanged: "InvoicePaymentStatusChanged",
  InvoiceSendFailed: "InvoiceSendFailed",
  CreditPoolDepleted: "CreditPoolDepleted",
  CreditPoolThresholdCrossed: "CreditPoolThresholdCrossed",
  CreditPoolIncreased: "CreditPoolIncreased",
  PaymentFailed: "PaymentFailed",
  CustomerCreated: "CustomerCreated",
  ContractCreated: "ContractCreated",
  PingTest: "PingTest"
});
var NotificationEventTypeSchema = oz302.nativeEnum(NOTIFICATION_EVENT_TYPES).openapi("NotificationEventType");

// src/entities/notification/base-notification-schema.ts
import { oz as oz305 } from "@vy/utils";

// src/entities/notification/notification-entity-schema.ts
import { oz as oz304 } from "@vy/utils";

// src/entities/notification/notification-entity-type-schema.ts
import { oz as oz303 } from "@vy/utils";
var NOTIFICATION_ENTITY_TYPES = Object.freeze({
  Customer: "Customer",
  Contract: "Contract",
  Invoice: "Invoice",
  Account: "Account",
  Product: "Product"
});
var NotificationEntityTypeSchema = oz303.nativeEnum(NOTIFICATION_ENTITY_TYPES).openapi("NotificationEntity");

// src/entities/notification/notification-entity-schema.ts
var NotificationEntitySchema = oz304.object({
  entityId: oz304.string(),
  type: NotificationEntityTypeSchema
}).openapi("NotificationEntity");

// src/entities/notification/base-notification-schema.ts
var BaseNotificationSchema = oz305.object({
  message: oz305.string().optional(),
  duplicationId: oz305.string().optional(),
  entity: NotificationEntitySchema
});

// src/entities/notification/notification-metadata-schemas/overage-notification-metadata-schema.ts
import { oz as oz306 } from "@vy/utils";
var OverageNotificationMetadataSchema = oz306.object({
  date: ApiDateSchema,
  overageAmount: oz306.number(),
  invoiceId: oz306.string(),
  customerId: oz306.string(),
  customerName: oz306.string(),
  currency: CurrencySchema
}).openapi("OverageNotificationMetadata");

// src/entities/notification/notification-metadata-schemas/anonymous-customer-metadata-schema.ts
import { oz as oz307 } from "@vy/utils";
var AnonymousNotificationMetadataSchema = oz307.object({
  customerName: oz307.string(),
  date: ApiDateSchema
}).openapi("AnonymousNotificationMetadata");

// src/entities/notification/notification-metadata-schemas/upcoming-renewal-metadata-schema.ts
import { oz as oz308 } from "@vy/utils";
var UpcomingRenewalNotificationMetadataSchema = oz308.object({
  date: ApiDateSchema,
  contractEndDate: ApiDateSchema,
  contractName: oz308.string(),
  contractId: oz308.string(),
  customerName: oz308.string().optional(),
  isTrial: oz308.boolean().optional()
}).openapi("UpcomingRenewalNotificationMetadata");

// src/entities/notification/notification-metadata-schemas/contract-expired-metadata-schema.ts
import { oz as oz309 } from "@vy/utils";
var ContractExpiredNotificationMetadataSchema = oz309.object({
  date: ApiDateSchema,
  contractEndDate: ApiDateSchema,
  contractName: oz309.string(),
  contractId: oz309.string(),
  customerName: oz309.string().optional(),
  isTrial: oz309.boolean().optional()
}).openapi("ContractExpiredNotificationMetadata");

// src/entities/notification/notification-metadata-schemas/invoice-approved-notification-metadata-schema.ts
import { oz as oz310 } from "@vy/utils";
var InvoiceApprovedNotificationMetadataSchema = oz310.object({
  date: ApiDateSchema,
  invoiceId: ObjectIdSchema
}).openapi("InvoiceApprovedNotificationMetadata");

// src/entities/notification/notification-metadata-schemas/customer-portal-link-sent-schema.ts
import { oz as oz311 } from "@vy/utils";
var CustomerPortalLinkSentNotificationMetadataSchema = oz311.object({
  customerId: oz311.string(),
  isSuccessful: oz311.boolean(),
  email: oz311.string().email(),
  errorMessage: oz311.string().optional(),
  date: ApiDateSchema
}).openapi("CustomerPortalLinkSentNotificationMetadata");

// src/entities/notification/notification-metadata-schemas/new-customer-without-contract-metadata-schema.ts
import { oz as oz312 } from "@vy/utils";
var NewCustomerWithoutContractNotificationMetadataSchema = oz312.object({
  date: ApiDateSchema,
  customerId: oz312.string(),
  customerName: oz312.string()
}).openapi("NewCustomerWithoutContractNotificationMetadata");

// src/entities/notification/notification-metadata-schemas/month-end-report-metadata-schema.ts
import { oz as oz313 } from "@vy/utils";
var MonthEndReportNotificationMetadataSchema = oz313.object({
  date: ApiDateSchema,
  reportId: ObjectIdSchema
}).openapi("MonthEndReportNotificationMetadata");

// src/entities/notification/notification-metadata-schemas/uncharged-events-metadata-schema.ts
import { oz as oz314 } from "@vy/utils";
var UnchargedEventsNotificationMetadataSchema = oz314.object({
  date: ApiDateSchema,
  reportId: oz314.string()
}).openapi("UnchargedEventsNotificationMetadata");

// src/entities/notification/notification-metadata-schemas/tier-crossed-metadata-schema.ts
import { oz as oz315 } from "@vy/utils";
var TierCrossedNotificationMetadataSchema = oz315.object({
  date: ApiDateSchema,
  customerId: oz315.string(),
  contractId: oz315.string(),
  customerName: oz315.string(),
  contractName: oz315.string(),
  variantId: oz315.string().optional()
}).openapi("TierCrossedNotificationMetadata");

// src/entities/notification/notification-metadata-schemas/commitment-crossed-metadata-schema.ts
import { oz as oz316 } from "@vy/utils";
var CommitmentCrossedNotificationMetadataSchema = oz316.object({
  date: ApiDateSchema,
  productConsumption: ProductConsumptionSchema,
  customerId: ObjectIdSchema
}).openapi("CommitmentCrossedNotificationMetadata");

// src/entities/notification/notification-metadata-schemas/commitment-usage-crossed-metadata-schema.ts
import { oz as oz317 } from "@vy/utils";
var CommitmentUsageCrossedNotificationMetadataSchema = oz317.object({
  date: ApiDateSchema,
  productConsumption: ProductConsumptionSchema,
  customerId: ObjectIdSchema,
  threshold: oz317.number().gt(0),
  pctUsage: oz317.number().nonnegative()
}).openapi("CommitmentUsageCrossedNotificationMetadata");

// src/entities/notification/notification-metadata-schemas/currency-commitment-usage-crossed-metadata-schema.ts
import { oz as oz318 } from "@vy/utils";
var CurrencyCommitmentUsageCrossedNotificationMetadataSchema = oz318.object({
  date: ApiDateSchema,
  productId: ObjectIdSchema,
  productName: oz318.string().nonempty(),
  customerId: ObjectIdSchema,
  threshold: oz318.number().gt(0),
  pctUsage: oz318.number().nonnegative(),
  currency: CurrencySchema,
  committedAmount: oz318.number().nonnegative(),
  consumedAmount: oz318.number().nonnegative(),
  cycleStart: ApiDateSchema
}).openapi("CurrencyCommitmentUsageCrossedNotificationMetadata");

// src/entities/notification/notification-metadata-schemas/final-tier-exceeded-metadata-schema.ts
import { oz as oz319 } from "@vy/utils";
var FinalTierExceededNotificationMetadataSchema = oz319.object({
  date: ApiDateSchema,
  customerId: oz319.string(),
  contractId: oz319.string(),
  customerName: oz319.string(),
  contractName: oz319.string(),
  productId: oz319.string(),
  productName: oz319.string(),
  accumulatedUnitsValue: oz319.number()
}).openapi("FinalTierExceededNotificationMetadata");

// src/entities/notification/notification-metadata-schemas/invoice-payment-status-changed-metadata-schema.ts
import { oz as oz320 } from "@vy/utils";
var InvoicePaymentStatusChangedMetadataSchema = oz320.object({
  invoiceId: ObjectIdSchema,
  billingStatus: InvoiceBillingStatusSchema,
  amountDue: oz320.number(),
  amountPaid: oz320.number(),
  total: oz320.number(),
  dueDate: ApiDateSchema.optional(),
  paidAt: ApiDateSchema.optional(),
  invoicePdfUrl: oz320.string().optional()
}).openapi("InvoicePaymentStatusChangedMetadata");

// src/entities/notification/notification-metadata-schemas/invoice-send-failed-notification-metadata-schema.ts
import { oz as oz321 } from "@vy/utils";
var InvoiceSendFailedNotificationMetadataSchema = oz321.object({
  invoiceId: ObjectIdSchema,
  invoiceNumber: oz321.string(),
  date: ApiDateSchema
}).openapi("InvoiceSendFailedNotificationMetadata");

// src/entities/notification/notification-metadata-schemas/credit-pool-depleted-metadata-schema.ts
import { oz as oz322 } from "@vy/utils";
var CreditPoolDepletedNotificationMetadataSchema = oz322.object({
  date: ApiDateSchema,
  customerId: ObjectIdSchema,
  creditPoolId: ObjectIdSchema,
  creditTypeId: ObjectIdSchema,
  creditKind: CreditKindSchema,
  balance: oz322.number()
}).openapi("CreditPoolDepletedNotificationMetadata");

// src/entities/notification/notification-metadata-schemas/credit-pool-threshold-crossed-metadata-schema.ts
import { oz as oz323 } from "@vy/utils";
var CreditPoolThresholdCrossedNotificationMetadataSchema = oz323.object({
  date: ApiDateSchema,
  customerId: ObjectIdSchema,
  creditPoolId: ObjectIdSchema,
  creditTypeId: ObjectIdSchema,
  creditKind: CreditKindSchema,
  threshold: oz323.number(),
  pctUsage: oz323.number().nonnegative(),
  balance: oz323.number()
}).openapi("CreditPoolThresholdCrossedNotificationMetadata");

// src/entities/notification/notification-metadata-schemas/credit-pool-increased-metadata-schema.ts
import { oz as oz324 } from "@vy/utils";
var CreditPoolIncreasedNotificationMetadataSchema = oz324.object({
  date: ApiDateSchema,
  customerId: ObjectIdSchema,
  creditPoolId: ObjectIdSchema,
  creditTypeId: ObjectIdSchema,
  creditKind: CreditKindSchema,
  grantedAmount: oz324.number().positive(),
  previousBalance: oz324.number(),
  balance: oz324.number()
}).openapi("CreditPoolIncreasedNotificationMetadata");

// src/entities/notification/notification-metadata-schemas/payment-failed-metadata-schema.ts
import { oz as oz325 } from "@vy/utils";
var PaymentFailedNotificationMetadataSchema = oz325.object({
  date: ApiDateSchema,
  customerId: ObjectIdSchema,
  invoiceId: ObjectIdSchema,
  // Which integration provider attempted (and failed) the payment, e.g. Paddle or Stripe.
  paymentProvider: IntegrationProvidersSchema,
  amount: oz325.number().nonnegative().optional(),
  currency: CurrencySchema.optional(),
  // Provider-reported reason for the failure, when available.
  failureReason: oz325.string().optional()
}).openapi("PaymentFailedNotificationMetadata");

// src/entities/notification/notification-metadata-schemas/customer-created-metadata-schema.ts
import { oz as oz326 } from "@vy/utils";
var CustomerCreatedIntegrationEntitySchema = oz326.object({
  integrationProvider: oz326.string(),
  integrationExternalId: oz326.string(),
  syncStatus: oz326.string()
}).openapi("CustomerCreatedIntegrationEntity");
var CustomerCreatedNotificationMetadataSchema = oz326.object({
  date: ApiDateSchema,
  customerId: ObjectIdSchema,
  name: oz326.string(),
  externalId: oz326.string().optional(),
  aliases: oz326.string().array(),
  integrationEntities: CustomerCreatedIntegrationEntitySchema.array()
}).openapi("CustomerCreatedNotificationMetadata");

// src/entities/notification/notification-metadata-schemas/contract-created-metadata-schema.ts
import { oz as oz327 } from "@vy/utils";
var ContractCreatedNotificationMetadataSchema = oz327.object({
  date: ApiDateSchema,
  contractId: ObjectIdSchema,
  customerId: ObjectIdSchema,
  contractName: oz327.string(),
  status: oz327.string(),
  startDate: ApiDateSchema,
  endDate: ApiDateSchema.optional(),
  // The full CustomerCreated body for the contract's customer, so subscribers get the
  // customer's details (aliases, integration links, …) without a follow-up lookup.
  customer: CustomerCreatedNotificationMetadataSchema
}).openapi("ContractCreatedNotificationMetadata");

// src/entities/notification/notification-schemas/overage-notification-schema.ts
var OverageNotificationSchema = BaseNotificationSchema.extend({
  eventType: oz328.literal(NOTIFICATION_EVENT_TYPES.Overage),
  metadata: OverageNotificationMetadataSchema
}).openapi("OverageNotification");

// src/entities/notification/notification-schemas/anonymous-customer-notification-schema.ts
import { oz as oz329 } from "@vy/utils";
var AnonymousCustomerNotificationSchema = BaseNotificationSchema.extend({
  eventType: oz329.literal(NOTIFICATION_EVENT_TYPES.AnonymousCustomer),
  metadata: AnonymousNotificationMetadataSchema
}).openapi("AnonymousCustomerNotification");

// src/entities/notification/notification-schemas/upcoming-renewal-notification-schema.ts
import { oz as oz330 } from "@vy/utils";
var UpcomingRenewalNotificationSchema = BaseNotificationSchema.extend({
  eventType: oz330.literal(NOTIFICATION_EVENT_TYPES.UpcomingRenewal),
  metadata: UpcomingRenewalNotificationMetadataSchema
}).openapi("UpcomingRenewalNotification");

// src/entities/notification/notification-schemas/contract-expired-notification-schema.ts
import { oz as oz331 } from "@vy/utils";
var ContractExpiredNotificationSchema = BaseNotificationSchema.extend({
  eventType: oz331.literal(NOTIFICATION_EVENT_TYPES.ContractExpired),
  metadata: ContractExpiredNotificationMetadataSchema
}).openapi("ContractExpiredNotification");

// src/entities/notification/notification-schemas/invoice-approved-notification-schema.ts
import { oz as oz332 } from "@vy/utils";
var InvoiceApprovedNotificationSchema = BaseNotificationSchema.extend({
  eventType: oz332.literal(NOTIFICATION_EVENT_TYPES.InvoiceApproved),
  metadata: InvoiceApprovedNotificationMetadataSchema
}).openapi("InvoiceApprovedNotification");

// src/entities/notification/notification-schemas/customer-portal-link-sent-notification-schema.ts
import { oz as oz340 } from "@vy/utils";

// src/entities/notification-subscription/new-notification-subscription-schema.ts
import { oz as oz339 } from "@vy/utils";

// src/entities/notification-subscription/notification-channels/notification-channel-schema.ts
import { oz as oz338 } from "@vy/utils";

// src/entities/notification-subscription/notification-channels/client-channel-schema.ts
import { oz as oz334 } from "@vy/utils";

// src/entities/notification-subscription/notification-channels/channel-type-schema.ts
import { oz as oz333 } from "@vy/utils";
var CHANNEL_TYPE = Object.freeze({
  Email: "Email",
  Slack: "Slack",
  Client: "Client",
  Webhook: "Webhook"
});
var ChannelTypeSchema = oz333.nativeEnum(CHANNEL_TYPE).openapi("ChannelType");

// src/entities/notification-subscription/notification-channels/client-channel-schema.ts
var ClientChannelSchema = oz334.object({
  type: oz334.literal(CHANNEL_TYPE.Client)
}).openapi("ClientChannel");

// src/entities/notification-subscription/notification-channels/email-channel-schema.ts
import { oz as oz335 } from "@vy/utils";
var EmailChannelSchema = oz335.object({
  type: oz335.literal(CHANNEL_TYPE.Email),
  configuration: oz335.object({
    recipient: oz335.string().email()
  })
}).openapi("EmailChannel");

// src/entities/notification-subscription/notification-channels/slack-channel-schema.ts
import { oz as oz336 } from "@vy/utils";
var SlackChannelSchema = oz336.object({
  type: oz336.literal(CHANNEL_TYPE.Slack)
}).openapi("SlackChannel");

// src/entities/notification-subscription/notification-channels/webhook-channel-schema.ts
import { oz as oz337 } from "@vy/utils";
var WebhookChannelSchema = oz337.object({
  type: oz337.literal(CHANNEL_TYPE.Webhook),
  configuration: oz337.object({
    callbackUrl: oz337.string()
  })
}).openapi("WebhookChannel");

// src/entities/notification-subscription/notification-channels/notification-channel-schema.ts
var NotificationChannelSchema = oz338.discriminatedUnion("type", [
  ClientChannelSchema,
  EmailChannelSchema,
  SlackChannelSchema,
  WebhookChannelSchema
]).openapi("NotificationChannel");

// src/entities/notification-subscription/new-notification-subscription-schema.ts
var NewNotificationSubscriptionSchema = oz339.object({
  channel: NotificationChannelSchema,
  eventType: NotificationEventTypeSchema
}).openapi("NewNotificationSubscription");

// src/entities/notification-subscription/notification-settings-schema.ts
var NotificationSubscriptionSchema = segregated(NewNotificationSubscriptionSchema).openapi(
  "Notification"
);

// src/entities/notification/notification-schemas/customer-portal-link-sent-notification-schema.ts
var CustomerPortalLinkSentNotificationSchema = BaseNotificationSchema.extend({
  eventType: oz340.literal(NOTIFICATION_EVENT_TYPES.CustomerPortalLinkSent),
  metadata: CustomerPortalLinkSentNotificationMetadataSchema
}).openapi("CustomerPortalLinkSentNotification");

// src/entities/notification/notification-schemas/new-customer-without-contract-notification-schema.ts
import { oz as oz341 } from "@vy/utils";
var NewCustomerWithoutContractNotificationSchema = BaseNotificationSchema.extend({
  eventType: oz341.literal(NOTIFICATION_EVENT_TYPES.NewCustomerWithoutContract),
  metadata: NewCustomerWithoutContractNotificationMetadataSchema
}).openapi("NewCustomerWithoutContractNotification");

// src/entities/notification/notification-schemas/month-end-report-notification-schema.ts
import { oz as oz342 } from "@vy/utils";
var MonthEndReportNotificationSchema = BaseNotificationSchema.extend({
  eventType: oz342.literal(NOTIFICATION_EVENT_TYPES.MonthEndReport),
  metadata: MonthEndReportNotificationMetadataSchema
}).openapi("MonthEndReportNotification");

// src/entities/notification/notification-schemas/uncharged-events-notification-schema.ts
import { oz as oz343 } from "@vy/utils";
var UnchargedEventsNotificationSchema = BaseNotificationSchema.extend({
  eventType: oz343.literal(NOTIFICATION_EVENT_TYPES.UnchargedEvents),
  metadata: UnchargedEventsNotificationMetadataSchema
}).openapi("UnchargedEventsNotification");

// src/entities/notification/notification-schemas/tier-crossed-notification-schema.ts
import { oz as oz344 } from "@vy/utils";
var TierCrossedNotificationSchema = BaseNotificationSchema.extend({
  eventType: oz344.literal(NOTIFICATION_EVENT_TYPES.TierCrossed),
  metadata: TierCrossedNotificationMetadataSchema
}).openapi("TierCrossedNotification");

// src/entities/notification/notification-schemas/commitment-crossed-notification-schema.ts
import { oz as oz345 } from "@vy/utils";
var CommitmentCrossedNotificationSchema = BaseNotificationSchema.extend({
  eventType: oz345.literal(NOTIFICATION_EVENT_TYPES.CommitmentCrossed),
  metadata: CommitmentCrossedNotificationMetadataSchema
}).openapi("CommitmentCrossedNotification");

// src/entities/notification/notification-schemas/commitment-usage-crossed-notification-schema.ts
import { oz as oz346 } from "@vy/utils";
var CommitmentUsageCrossedNotificationSchema = BaseNotificationSchema.extend({
  eventType: oz346.literal(NOTIFICATION_EVENT_TYPES.CommitmentUsageCrossed),
  metadata: CommitmentUsageCrossedNotificationMetadataSchema
}).openapi("CommitmentUsageCrossedNotification");

// src/entities/notification/notification-schemas/currency-commitment-usage-crossed-notification-schema.ts
import { oz as oz347 } from "@vy/utils";
var CurrencyCommitmentUsageCrossedNotificationSchema = BaseNotificationSchema.extend({
  eventType: oz347.literal(NOTIFICATION_EVENT_TYPES.CurrencyCommitmentUsageCrossed),
  metadata: CurrencyCommitmentUsageCrossedNotificationMetadataSchema
}).openapi("CurrencyCommitmentUsageCrossedNotification");

// src/entities/notification/notification-schemas/final-tier-exceeded-notification-schema.ts
import { oz as oz348 } from "@vy/utils";
var FinalTierExceededNotificationSchema = BaseNotificationSchema.extend({
  eventType: oz348.literal(NOTIFICATION_EVENT_TYPES.FinalTierExceeded),
  metadata: FinalTierExceededNotificationMetadataSchema
}).openapi("FinalTierExceededNotification");

// src/entities/notification/notification-schemas/invoice-payment-status-changed-notification-schema.ts
import { oz as oz349 } from "@vy/utils";
var InvoicePaymentStatusChangedNotificationSchema = BaseNotificationSchema.extend({
  eventType: oz349.literal(NOTIFICATION_EVENT_TYPES.InvoicePaymentStatusChanged),
  metadata: InvoicePaymentStatusChangedMetadataSchema
}).openapi("InvoicePaymentStatusChangedNotification");

// src/entities/notification/notification-schemas/invoice-send-failed-notification-schema.ts
import { oz as oz350 } from "@vy/utils";
var InvoiceSendFailedNotificationSchema = BaseNotificationSchema.extend({
  eventType: oz350.literal(NOTIFICATION_EVENT_TYPES.InvoiceSendFailed),
  metadata: InvoiceSendFailedNotificationMetadataSchema
}).openapi("InvoiceSendFailedNotification");

// src/entities/notification/notification-schemas/credit-pool-depleted-notification-schema.ts
import { oz as oz351 } from "@vy/utils";
var CreditPoolDepletedNotificationSchema = BaseNotificationSchema.extend({
  eventType: oz351.literal(NOTIFICATION_EVENT_TYPES.CreditPoolDepleted),
  metadata: CreditPoolDepletedNotificationMetadataSchema
}).openapi("CreditPoolDepletedNotification");

// src/entities/notification/notification-schemas/credit-pool-threshold-crossed-notification-schema.ts
import { oz as oz352 } from "@vy/utils";
var CreditPoolThresholdCrossedNotificationSchema = BaseNotificationSchema.extend({
  eventType: oz352.literal(NOTIFICATION_EVENT_TYPES.CreditPoolThresholdCrossed),
  metadata: CreditPoolThresholdCrossedNotificationMetadataSchema
}).openapi("CreditPoolThresholdCrossedNotification");

// src/entities/notification/notification-schemas/credit-pool-increased-notification-schema.ts
import { oz as oz353 } from "@vy/utils";
var CreditPoolIncreasedNotificationSchema = BaseNotificationSchema.extend({
  eventType: oz353.literal(NOTIFICATION_EVENT_TYPES.CreditPoolIncreased),
  metadata: CreditPoolIncreasedNotificationMetadataSchema
}).openapi("CreditPoolIncreasedNotification");

// src/entities/notification/notification-schemas/payment-failed-notification-schema.ts
import { oz as oz354 } from "@vy/utils";
var PaymentFailedNotificationSchema = BaseNotificationSchema.extend({
  eventType: oz354.literal(NOTIFICATION_EVENT_TYPES.PaymentFailed),
  metadata: PaymentFailedNotificationMetadataSchema
}).openapi("PaymentFailedNotification");

// src/entities/notification/notification-schemas/customer-created-notification-schema.ts
import { oz as oz355 } from "@vy/utils";
var CustomerCreatedNotificationSchema = BaseNotificationSchema.extend({
  eventType: oz355.literal(NOTIFICATION_EVENT_TYPES.CustomerCreated),
  metadata: CustomerCreatedNotificationMetadataSchema
}).openapi("CustomerCreatedNotification");

// src/entities/notification/notification-schemas/contract-created-notification-schema.ts
import { oz as oz356 } from "@vy/utils";
var ContractCreatedNotificationSchema = BaseNotificationSchema.extend({
  eventType: oz356.literal(NOTIFICATION_EVENT_TYPES.ContractCreated),
  metadata: ContractCreatedNotificationMetadataSchema
}).openapi("ContractCreatedNotification");

// src/entities/notification/notification-schema.ts
var NotificationSchema = oz357.discriminatedUnion("eventType", [
  OverageNotificationSchema,
  AnonymousCustomerNotificationSchema,
  UpcomingRenewalNotificationSchema,
  ContractExpiredNotificationSchema,
  InvoiceApprovedNotificationSchema,
  CustomerPortalLinkSentNotificationSchema,
  NewCustomerWithoutContractNotificationSchema,
  MonthEndReportNotificationSchema,
  UnchargedEventsNotificationSchema,
  TierCrossedNotificationSchema,
  CommitmentCrossedNotificationSchema,
  CommitmentUsageCrossedNotificationSchema,
  CurrencyCommitmentUsageCrossedNotificationSchema,
  CreditPoolThresholdCrossedNotificationSchema,
  CreditPoolDepletedNotificationSchema,
  CreditPoolIncreasedNotificationSchema,
  FinalTierExceededNotificationSchema,
  InvoicePaymentStatusChangedNotificationSchema,
  InvoiceSendFailedNotificationSchema,
  PaymentFailedNotificationSchema,
  CustomerCreatedNotificationSchema,
  ContractCreatedNotificationSchema
]).openapi("NewNotification");

// src/entities/notification-alert/notification-status-schema.ts
import { oz as oz358 } from "@vy/utils";
var NOTIFICATION_ALERT_STATUSES = Object.freeze({
  Read: "Read",
  Unread: "Unread",
  Dismissed: "Dismissed"
});
var NotificationAlertStatusSchema = oz358.nativeEnum(NOTIFICATION_ALERT_STATUSES).openapi("NotificationAlertStatus");

// src/entities/notification-alert/notification-alert-schema.ts
import { oz as oz359 } from "@vy/utils";
var NotificationAlertSchema = oz359.object({
  id: oz359.string(),
  status: NotificationAlertStatusSchema,
  channelType: ChannelTypeSchema
});

// src/entities/client-notification/client-notification-schema.ts
var ClientNotificationSchema = oz360.object({
  notification: NotificationSchema,
  notificationAlert: NotificationAlertSchema
});

// src/entities/consumption-period/new-consumption-period-schema.ts
import { oz as oz361 } from "@vy/utils";
var NewConsumptionPeriodSchema = oz361.object({
  productPeriodId: oz361.string(),
  productVariantId: oz361.string(),
  meterId: oz361.string(),
  productId: oz361.string(),
  contractId: oz361.string(),
  accountId: oz361.string(),
  periodValue: oz361.number(),
  cumulativeFromContractStartValue: oz361.number(),
  cumulativeFromResetValue: oz361.number().optional(),
  resetFromDate: ApiDateSchema.optional()
});

// src/entities/consumption-period/consumption-period-schema.ts
var ConsumptionPeriodSchema = created(NewConsumptionPeriodSchema);

// src/entities/consumption-period-monthly-bucket/new-consumption-period-monthly-bucket-schema.ts
import { oz as oz362 } from "@vy/utils";
var NewConsumptionPeriodMonthlyBucketSchema = oz362.object({
  consumptionPeriodId: oz362.string(),
  startTime: ApiDateSchema,
  endTime: ApiDateSchema,
  value: oz362.number(),
  cumulativeFromContractStartValue: oz362.number(),
  cumulativeFromResetValue: oz362.number().optional()
});

// src/entities/consumption-period-monthly-bucket/consumption-period-monthly-bucket-schema.ts
var ConsumptionPeriodMonthlyBucketSchema = created(NewConsumptionPeriodMonthlyBucketSchema);

// src/entities/contract/contract-schema.ts
import { oz as oz379 } from "@vy/utils";

// src/entities/label/label-entity-type-schema.ts
var LABEL_ENTITY_TYPES = Object.freeze({
  CUSTOMER: "Customer",
  CONTRACT: "Contract"
});

// src/entities/label/label-schema.ts
import { oz as oz363 } from "@vy/utils";
var LabelSchema = created(
  oz363.object({
    accountId: oz363.string(),
    name: oz363.string(),
    color: oz363.string(),
    backgroundColor: oz363.string()
  })
).openapi("Label");

// src/entities/label/label-summary-schema.ts
import { oz as oz364 } from "@vy/utils";
var LabelSummarySchema = oz364.object({
  id: oz364.string(),
  name: oz364.string(),
  color: oz364.string(),
  backgroundColor: oz364.string()
}).openapi("LabelSummary");

// src/entities/label/new-label-schema.ts
import { oz as oz365 } from "@vy/utils";
var NewLabelSchema = oz365.object({
  name: oz365.string(),
  color: oz365.string(),
  backgroundColor: oz365.string()
}).openapi("NewLabel");

// src/entities/label/update-label-schema.ts
import { oz as oz366 } from "@vy/utils";
var UpdateLabelSchema = oz366.object({
  name: oz366.string().optional(),
  color: oz366.string().optional(),
  backgroundColor: oz366.string().optional()
}).openapi("UpdateLabel");

// src/entities/plan/new-plan-schema.ts
import { oz as oz371 } from "@vy/utils";

// src/entities/plan/plan-billing-data-schema.ts
import { oz as oz368 } from "@vy/utils";

// src/entities/plan/plan-duration-schema.ts
import { getEnvVar, oz as oz367 } from "@vy/utils";
var RegularPlanDuration = oz367.number().positive();
var AdvancedPlanDuration = RegularPlanDuration.or(UnlimitedDurationSchema).openapi("PlanDuration");
var documentationCodegen2 = typeof process !== "undefined" && !!getEnvVar("DOCUMENTATION_CODEGEN");
var PlanDurationSchema = documentationCodegen2 ? RegularPlanDuration : AdvancedPlanDuration;

// src/entities/plan/plan-billing-data-schema.ts
var PlanBillingDataSchema = oz368.object({
  billingInterval: BillingIntervalSchema,
  duration: PlanDurationSchema,
  paymentTerm: PaymentTermSchema.default(PAYMENT_TERMS.Postpayment).describe(
    "flag to indicate if the payment is postpayment or prepayment"
  ),
  autoRenewal: oz368.boolean().default(false),
  proRated: oz368.boolean().nullish()
}).openapi("PlanBillingData");

// src/entities/plan/plan-status-schema.ts
import { parseJson as parseJson6, oz as oz369 } from "@vy/utils";
var PLAN_STATUSES = Object.freeze({
  Active: "Active",
  Inactive: "Inactive",
  Error: "Error"
});
var PlanStatusSchema = oz369.nativeEnum(PLAN_STATUSES).openapi("PlanStatus");
var PlanStatusesSchema = oz369.string().transform((value) => parseJson6(value)).pipe(PlanStatusSchema.array()).optional();

// src/entities/plan/trial-duration-schema.ts
import { oz as oz370 } from "@vy/utils";

// src/entities/plan/trial-duration-types.ts
var TRIAL_DURATION_TYPES = Object.freeze({
  Weeks: "Weeks",
  Months: "Months"
});

// src/entities/plan/trial-duration-schema.ts
var TrialDurationSchema = oz370.object({
  duration: oz370.number(),
  type: oz370.nativeEnum(TRIAL_DURATION_TYPES),
  free: oz370.boolean().default(false)
}).openapi("PlanTrial");

// src/entities/plan/new-plan-schema.ts
var RefinedNewProductSchema = withMeterResetCommitmentRefillValidation(
  withOneTimeProrationValidation(
    withAdvancePaymentPricingValidation(
      withBasePriceValidation(
        NewProductSchema.extend({
          variants: oz371.array(withUsageProductMeterIdValidation(NewProductVariantSchema)).min(1)
        })
      )
    )
  )
);
var NewPlanSchema = oz371.object({
  name: oz371.string().min(1, "Plan name is required"),
  description: withNullAsOptional(oz371.string().nonempty()),
  products: oz371.array(RefinedNewProductSchema).min(1, "At least one product is required"),
  billingData: PlanBillingDataSchema,
  status: PlanStatusSchema,
  basedFromPlanId: withNullAsOptional(oz371.string().nullable()),
  trial: TrialDurationSchema.nullable().optional(),
  purchaseOrder: oz371.string().max(20).optional(),
  rawSyncData: oz371.object({ integrationSource: IntegrationProvidersSchema }).optional(),
  integrationEntities: withNullAsOptional(oz371.array(BaseIntegrationEntitySchema))
}).openapi("NewPlan");

// src/entities/plan/plan-schema.ts
import { oz as oz372 } from "@vy/utils";
var PlanSchema = segregated(NewPlanSchema).extend({
  products: oz372.array(ProductSchema),
  revision: oz372.number()
}).openapi("Plan");

// src/entities/plan/plan-input-schema.ts
import { oz as oz373 } from "@vy/utils";
var PlanInputSchema = oz373.object(NewPlanSchema.shape).extend({
  products: oz373.array(ProductInputSchema),
  trial: TrialDurationSchema.nullable().optional()
}).partial().openapi("PlanInput");

// src/entities/plan/extracted-plan-schema.ts
import { oz as oz374 } from "@vy/utils";
var ExtractedProductSchema = NewProductSchema.extend({
  variants: oz374.array(NewProductVariantSchema.omit({ meterId: true })).min(1).max(1),
  paymentTerm: oz374.literal(PAYMENT_TERMS.Postpayment)
});
var ExtractedPlanSchema = NewPlanSchema.omit({ basedFromPlanId: true }).extend({
  products: oz374.array(ExtractedProductSchema).min(1),
  status: oz374.literal(PLAN_STATUSES.Active)
}).openapi("ExtractedPlan");

// src/entities/contract/new-contract-schema.ts
import { isValidEndTime, isValidStartTime, oz as oz378 } from "@vy/utils";
import { CustomFieldValueSchema as CustomFieldValueSchema3 } from "@vy/custom-fields-types";

// src/entities/contract/contract-status-schema.ts
import { parseJson as parseJson7, oz as oz375 } from "@vy/utils";
var CONTRACT_STATUSES = Object.freeze({
  InReview: "InReview",
  Active: "Active",
  Inactive: "Inactive",
  Expired: "Expired",
  Terminated: "Terminated",
  PendingTermination: "PendingTermination",
  Error: "Error"
});
var ContractStatusSchema = oz375.nativeEnum(CONTRACT_STATUSES).openapi("ContractStatus");
var ContractStatusesSchema = oz375.string().transform((value) => parseJson7(value)).pipe(ContractStatusSchema.array()).optional();

// src/entities/contract/contract-type-schema.ts
import { oz as oz376 } from "@vy/utils";
var CONTRACT_TYPES = Object.freeze({
  Standard: "Standard",
  ParentAgreement: "ParentAgreement"
});
var ContractTypeSchema = oz376.nativeEnum(CONTRACT_TYPES).openapi("ContractType");

// src/entities/contract/parent-agreement-settings-schema.ts
import { oz as oz377 } from "@vy/utils";
var ParentAgreementSettingsSchema = oz377.object({
  productName: oz377.string(),
  productDescription: oz377.string().optional(),
  integrationEntities: ProductIntegrationEntitySchema.array().optional()
}).openapi("ParentAgreementSettings");

// src/entities/contract/new-contract-schema.ts
var NewContractSchema = oz378.object({
  startDate: ApiDateSchema.refine(isValidStartTime, {
    message: "Start time must be at 00:00:00 UTC"
  }),
  endDate: ApiDateSchema.refine(isValidEndTime, {
    message: "End time must be at 23:59:59 UTC"
  }).optional(),
  planId: ObjectIdSchema,
  customerId: ObjectIdSchema,
  status: ContractStatusSchema,
  contractType: ContractTypeSchema.default(CONTRACT_TYPES.Standard),
  parentAgreementSettings: ParentAgreementSettingsSchema.optional(),
  trialEndDate: ApiDateSchema.optional(),
  cancelledAt: ApiDateSchema.optional(),
  terminatedAt: ApiDateSchema.optional(),
  revisedAt: ApiDateSchema.optional(),
  initialStartDate: ApiDateSchema.optional(),
  signatureDate: ApiDateSchema.optional(),
  integrationEntities: ContractIntegrationEntitySchema.array().optional(),
  currencyOverride: CurrencySchema.optional(),
  customFieldValues: CustomFieldValueSchema3.array().optional(),
  notes: oz378.string().max(500).optional(),
  credits: CreditPurchaseConfigSchema.array().optional(),
  isTrial: oz378.boolean().optional()
}).openapi("NewContract");

// src/entities/contract/contract-schema.ts
var ContractInvoiceSchema = oz379.object({
  revenueBreakdown: RevenueBreakdownSchema,
  reviewStatus: InvoiceReviewStatusSchema,
  billingStatus: InvoiceBillingStatusSchema
});
var ContractSchema = created(
  NewContractSchema.omit({ customerId: true, planId: true }).extend({
    accountId: ObjectIdSchema,
    customer: CustomerSchema,
    plan: PlanSchema,
    invoices: ContractInvoiceSchema.array().optional(),
    labels: LabelSchema.pick({ id: true, name: true, color: true, backgroundColor: true }).array().optional()
  })
).openapi("Contract");

// src/entities/contract/contract-input-schema.ts
var ContractInputSchema = NewContractSchema.partial().openapi("ContractInput");

// src/entities/contract/contract-creation-type-schema.ts
import { oz as oz380 } from "@vy/utils";
var CONTRACT_CREATION_TYPES = Object.freeze({
  CreateContractWithPlan: "CreateContractWithPlan",
  CreateContractWithoutPlan: "CreateContractWithoutPlan"
});
var ContractCreationTypeSchema = oz380.nativeEnum(CONTRACT_CREATION_TYPES).openapi("CreationType");

// src/entities/contract/new-contract-schema-with-plan.ts
import { oz as oz381 } from "@vy/utils";

// src/entities/contract/uplift-duration-rule.ts
var MINIMUM_MULTI_YEAR_DURATION_MONTHS = 13;
var UPLIFT_DURATION_ERROR_MESSAGE = "Uplift can only be enabled on multi-year contracts (duration > 12 months)";
var UPLIFT_FLAG_KEYS = [
  "inflationaryUpliftEnabled",
  "seatUpliftEnabled",
  "commitmentUpliftEnabled"
];
function hasUpliftEnabled(product) {
  return UPLIFT_FLAG_KEYS.some((flag) => Boolean(product.upliftConfiguration?.[flag]));
}
function isMultiYearDuration(duration) {
  return duration >= MINIMUM_MULTI_YEAR_DURATION_MONTHS;
}
function violatesUpliftDurationRule(plan) {
  return plan.products.some(hasUpliftEnabled) && !isMultiYearDuration(plan.billingData.duration);
}

// src/entities/contract/new-contract-schema-with-plan.ts
var NewContractSchemaWithPlanBase = oz381.object({
  creationType: oz381.literal(CONTRACT_CREATION_TYPES.CreateContractWithPlan),
  contracts: oz381.array(NewContractSchema.omit({ planId: true }).extend({ plan: NewPlanSchema }))
});
var NewContractSchemaWithPlan = NewContractSchemaWithPlanBase.superRefine((data, ctx) => {
  data.contracts.forEach((contract, contractIndex) => {
    if (violatesUpliftDurationRule(contract.plan)) {
      ctx.addIssue({
        code: oz381.ZodIssueCode.custom,
        message: UPLIFT_DURATION_ERROR_MESSAGE,
        path: ["contracts", contractIndex, "plan", "products"]
      });
    }
  });
}).openapi("NewContractWithPlan");

// src/entities/contract/new-contract-schema-without-plan.ts
import { oz as oz382 } from "@vy/utils";
var NewContractSchemaWithoutPlan = oz382.object({
  creationType: oz382.literal(CONTRACT_CREATION_TYPES.CreateContractWithoutPlan),
  contracts: oz382.array(NewContractSchema.omit({ endDate: true }))
}).openapi("NewContractWithoutPlan");

// src/entities/contract/contract-overview-schema.ts
import { oz as oz383 } from "@vy/utils";
var ContractOverviewProductVariantSchema = oz383.object({
  id: oz383.string(),
  meter: MeterSchema.nullish()
}).extend({
  pricing: ProductVariantSchema.shape.pricing.optional(),
  name: oz383.string().optional(),
  productId: oz383.string().optional(),
  createdAt: ApiDateSchema.optional(),
  updatedAt: ApiDateSchema.optional(),
  description: oz383.string().optional(),
  meterId: oz383.string().optional(),
  settings: ProductVariantSchema.shape.settings.optional()
}).openapi("ContractOverviewProductVariant");
var ContractOverviewProductSchema = oz383.object({
  id: oz383.string(),
  productConfigs: ProductSchema.shape.productConfigs.optional()
}).extend({
  variants: oz383.array(ContractOverviewProductVariantSchema),
  paymentTerm: ProductSchema.shape.paymentTerm.optional(),
  billingInterval: ProductSchema.shape.billingInterval.optional(),
  proRata: oz383.boolean().optional(),
  createdAt: ApiDateSchema.optional(),
  updatedAt: ApiDateSchema.optional(),
  name: oz383.string().optional(),
  description: oz383.string().optional(),
  basePrice: oz383.number().optional(),
  additionalCharge: oz383.number().optional(),
  commitment: ProductSchema.shape.commitment.optional(),
  timeline: ProductSchema.shape.timeline.optional(),
  chargingCadence: oz383.number().optional(),
  currencyCommitment: oz383.number().optional(),
  accumulationInterval: oz383.number().optional(),
  rateMultiplier: oz383.number().optional(),
  isPeriodicVariants: oz383.boolean().optional(),
  startDate: ApiDateSchema.optional(),
  endDate: ApiDateSchema.optional(),
  catalogProductId: oz383.string().optional(),
  integrationEntities: ProductSchema.shape.integrationEntities.optional(),
  externalIntegration: ProductSchema.shape.externalIntegration.optional(),
  revisionId: oz383.string().optional()
}).openapi("ContractOverviewProduct");
var ContractOverviewSchema = ContractSchema.pick({
  id: true,
  createdAt: true,
  updatedAt: true,
  status: true,
  startDate: true,
  initialStartDate: true,
  revisedAt: true,
  endDate: true,
  integrationEntities: true,
  signatureDate: true,
  customFieldValues: true,
  notes: true
}).extend({
  isEditable: oz383.boolean(),
  createdAt: ApiDateSchema,
  revenue: oz383.number(),
  customer: CustomerSchema.pick({
    id: true,
    name: true,
    settings: true
  }),
  plan: PlanSchema.pick({
    id: true,
    name: true,
    billingData: true
  }).extend({
    id: ObjectIdSchema,
    products: oz383.array(ContractOverviewProductSchema)
  }),
  labels: LabelSchema.pick({ id: true, name: true, color: true, backgroundColor: true }).array().optional()
});

// src/entities/contract/contract-additional-filter-schema.ts
import { parseJson as parseJson8, oz as oz384 } from "@vy/utils";
var CONTRACT_ADDITIONAL_FILTERS = Object.freeze({
  UPCOMING_RENEWALS: "UpcomingRenewals"
});
var ContractAdditionalFilterSchema = oz384.nativeEnum(CONTRACT_ADDITIONAL_FILTERS).openapi("ContractAdditionalFilters");
var ContractAdditionalFiltersSchema = oz384.string().transform((value) => parseJson8(value)).pipe(ContractAdditionalFilterSchema.array()).optional();

// src/entities/contract/contract-version-schema.ts
import { oz as oz385 } from "@vy/utils";
var ContractVersionSchema = oz385.object({
  name: oz385.string(),
  createdDate: ApiDateSchema,
  effectiveDate: ApiDateSchema,
  products: oz385.array(ProductSchema)
}).openapi("ContractVersion");

// src/entities/contract-renewal/contract-renewal-schema.ts
import { oz as oz386 } from "@vy/utils";
var ContractRenewalSchema = oz386.object({
  id: oz386.string(),
  contractId: oz386.string(),
  effectiveDate: ApiDateSchema,
  duration: PlanDurationSchema
}).openapi("ContractRenewal");

// src/entities/credit-ledger/credit-ledger-entry-type-schema.ts
import { oz as oz387 } from "@vy/utils";
var CREDIT_LEDGER_ENTRY_TYPE = Object.freeze({
  Grant: "Grant",
  Deduct: "Deduct"
});
var CreditLedgerEntryTypeSchema = oz387.nativeEnum(CREDIT_LEDGER_ENTRY_TYPE).openapi("BillingCycleStatus");

// src/entities/credit-ledger/credit-ledger-entry-overview-schema.ts
import { oz as oz388 } from "@vy/utils";
var CreditLedgerEntryOverviewSchema = oz388.object({
  id: oz388.string(),
  date: ApiDateSchema,
  invoiceId: oz388.string().optional(),
  invoiceNumber: oz388.string(),
  debitAmount: oz388.number().optional(),
  creditAmount: oz388.number().optional(),
  balance: oz388.number(),
  isInvoiceExportedToNetSuite: oz388.boolean().optional()
}).openapi("CreditLedgerEntryOverview");

// src/entities/credit-ledger/credit-ledger-entry-schema.ts
import { oz as oz389 } from "@vy/utils";
var CreditLedgerEntrySchema = oz389.object({
  id: ObjectIdSchema,
  createdAt: ApiDateSchema,
  type: CreditLedgerEntryTypeSchema,
  amount: oz389.number(),
  balanceAfterEntry: oz389.number(),
  invoiceId: oz389.string().optional(),
  erpId: oz389.string().optional(),
  contractId: oz389.string().optional(),
  integrationEntities: oz389.array(BaseIntegrationEntitySchema)
}).openapi("CreditLedgerEntry");

// src/entities/credit-ledger/credit-ledger-schema.ts
import { oz as oz390 } from "@vy/utils";
var CreditLedgerSchema = oz390.object({
  id: ObjectIdSchema,
  customerId: ObjectIdSchema,
  currentBalance: oz390.number()
}).openapi("CreditLedger");

// src/entities/currency-exchange-rates/currency-exchange-rates-schema.ts
import { oz as oz391 } from "@vy/utils";
var CurrencyExchangeRatesSchema = oz391.object({
  USD: oz391.number(),
  EUR: oz391.number(),
  GBP: oz391.number(),
  ILS: oz391.number(),
  CAD: oz391.number().nullish(),
  AUD: oz391.number().nullish(),
  COP: oz391.number().nullish(),
  BRL: oz391.number().nullish(),
  ARS: oz391.number().nullish(),
  INR: oz391.number().nullish(),
  MXN: oz391.number().nullish()
});

// src/entities/customer-note/customer-note-schema.ts
import { oz as oz392 } from "@vy/utils";
var CustomerNoteSchema = oz392.object({
  id: oz392.string(),
  createdAt: oz392.date(),
  updatedAt: oz392.date().nullish(),
  content: oz392.string().min(1).max(1e3),
  customerId: oz392.string(),
  accountId: oz392.string(),
  authorId: oz392.string()
}).openapi("CustomerNote");

// src/entities/customer-portal/customer-portal-customer-schema.ts
var CustomerPortalCustomerSchema = CustomerSchema.pick({
  legalName: true,
  name: true,
  address: true,
  contacts: true
});

// src/entities/customer-portal/customer-portal-invoice-schema.ts
import { oz as oz455 } from "@vy/utils";

// src/entities/invoice/ar-health-metrics-consts.ts
var OVERDUE_BUCKET_THRESHOLDS = Object.freeze({
  FIRST: 30,
  SECOND: 60,
  THIRD: 90
});
var MAX_DAYS_TO_APPROVE = 30;

// src/entities/invoice/invoice-balance.ts
import { oz as oz393 } from "@vy/utils";
var InvoiceBalanceSchema = oz393.object({
  chargedAmount: oz393.number(),
  promotionsAmount: oz393.number(),
  creditsUsed: oz393.number()
}).openapi("InvoiceBalance");

// src/entities/invoice/invoice-filters-schema/invoice-filter-schema.ts
import { oz as oz416 } from "@vy/utils";

// src/entities/invoice/invoice-filters-schema/invoice-filterable-fields.ts
var INVOICE_FILTERABLE_FIELDS = Object.freeze({
  INVOICE_AMOUNT_FIELD: "amount",
  INVOICE_BILLING_STATUS_FIELD: "billingStatus",
  INVOICE_REVIEW_STATUS_FIELD: "reviewStatus",
  INVOICE_OVERAGE_FIELD: "overage",
  INVOICE_PERIOD_FIELD: "billingCycle",
  INVOICE_DUE_DATE_FIELD: "dueDate",
  INVOICE_ISSUED_AT_FIELD: "issuedAt",
  INVOICE_CUSTOMER_ID_FIELD: "customerId",
  INVOICE_CURRENCY_FIELD: "currency",
  INVOICE_NAME_FIELD: "name",
  INVOICE_CONTRACT_PLAN_NAME_FIELD: "contractName",
  INVOICE_CONTRACT_STATUS_FIELD: "contractStatus",
  INVOICE_SYNC_INTEGRATION_FIELD: "syncIntegration",
  INVOICE_MANUAL_REVIEW_FIELD: "manualReview",
  INVOICE_YEARLY_COMMITMENT_FIELD: "yearlyCommitment",
  INVOICE_METERED_FIELD: "metered",
  INVOICE_LAST_SENT_FIELD: "lastSentAt",
  INVOICE_PURCHASE_ORDER_FIELD: "purchaseOrder",
  INVOICE_NOTES_FIELD: "notes",
  INVOICE_MARKETPLACE_SYNC_FIELD: "marketplaceSync",
  INVOICE_SUBSIDIARY_FIELD: "subsidiaryId"
});

// src/entities/invoice/invoice-filters-schema/invoice-filter-schemas/invoice-amount-filter-schema.ts
import { oz as oz394 } from "@vy/utils";
var InvoiceAmountFieldPathSchema = oz394.literal(INVOICE_FILTERABLE_FIELDS.INVOICE_AMOUNT_FIELD);
var InvoiceAmountFilterSchema = NumberFilterInputSchema.extend({
  field: InvoiceAmountFieldPathSchema
}).openapi("InvoiceAmountFilter");

// src/entities/invoice/invoice-filters-schema/invoice-filter-schemas/invoice-billing-status-filter-schema.ts
import { oz as oz395 } from "@vy/utils";
var InvoiceBillingStatusFieldPathSchema = oz395.literal(INVOICE_FILTERABLE_FIELDS.INVOICE_BILLING_STATUS_FIELD);
var InvoiceBillingStatusValueSchema = oz395.union([
  oz395.nativeEnum(INVOICE_BILLING_STATUSES),
  oz395.array(oz395.nativeEnum(INVOICE_BILLING_STATUSES))
]);
var InvoiceBillingStatusFilterSchema = EnumFilterInputSchema.extend({
  field: InvoiceBillingStatusFieldPathSchema,
  value: InvoiceBillingStatusValueSchema
}).openapi("InvoiceBillingStatusFilter");

// src/entities/invoice/invoice-filters-schema/invoice-filter-schemas/invoice-contract-plan-name-filter-schema.ts
import { oz as oz396 } from "@vy/utils";
var InvoiceContractPlanNameFieldPathSchema = oz396.literal(INVOICE_FILTERABLE_FIELDS.INVOICE_CONTRACT_PLAN_NAME_FIELD);
var InvoiceContractPlanNameFilterSchema = StringFilterInputSchema.extend({
  field: InvoiceContractPlanNameFieldPathSchema
}).openapi("InvoiceContractPlanNameFilter");

// src/entities/invoice/invoice-filters-schema/invoice-filter-schemas/invoice-contract-status-filter-schema.ts
import { oz as oz397 } from "@vy/utils";
var InvoiceContractStatusFieldPathSchema = oz397.literal(INVOICE_FILTERABLE_FIELDS.INVOICE_CONTRACT_STATUS_FIELD);
var InvoiceContractStatusValueSchema = oz397.union([
  oz397.nativeEnum(CONTRACT_STATUSES),
  oz397.array(oz397.nativeEnum(CONTRACT_STATUSES))
]);
var InvoiceContractStatusFilterSchema = EnumFilterInputSchema.extend({
  field: InvoiceContractStatusFieldPathSchema,
  value: InvoiceContractStatusValueSchema
}).openapi("InvoiceContractStatusFilter");

// src/entities/invoice/invoice-filters-schema/invoice-filter-schemas/invoice-currency-filter-schema.ts
import { oz as oz398 } from "@vy/utils";
var InvoiceCurrencyFieldPathSchema = oz398.literal(INVOICE_FILTERABLE_FIELDS.INVOICE_CURRENCY_FIELD);
var InvoiceCurrencyValueSchema = oz398.union([
  oz398.nativeEnum(CURRENCIES),
  oz398.array(oz398.nativeEnum(CURRENCIES))
]);
var InvoiceCurrencyFilterSchema = EnumFilterInputSchema.extend({
  field: InvoiceCurrencyFieldPathSchema,
  value: InvoiceCurrencyValueSchema
}).openapi("InvoiceCurrencyFilter");

// src/entities/invoice/invoice-filters-schema/invoice-filter-schemas/invoice-customer-id-filter-schema.ts
import { oz as oz399 } from "@vy/utils";
var InvoiceCustomerIdFieldPathSchema = oz399.literal(INVOICE_FILTERABLE_FIELDS.INVOICE_CUSTOMER_ID_FIELD);
var InvoiceCustomerIdFilterSchema = StringFilterInputSchema.extend({
  field: InvoiceCustomerIdFieldPathSchema
}).openapi("InvoiceCustomerIdFilter");

// src/entities/invoice/invoice-filters-schema/invoice-filter-schemas/invoice-due-date-filter-schema.ts
import { oz as oz400 } from "@vy/utils";
var InvoiceDueDateFieldPathSchema = oz400.literal(INVOICE_FILTERABLE_FIELDS.INVOICE_DUE_DATE_FIELD);
var InvoiceDueDateFilterSchema = DateFilterInputSchema.extend({
  field: InvoiceDueDateFieldPathSchema
}).openapi("InvoiceDueDateFilter");

// src/entities/invoice/invoice-filters-schema/invoice-filter-schemas/invoice-issued-at-filter-schema.ts
import { oz as oz401 } from "@vy/utils";
var InvoiceIssuedAtFieldPathSchema = oz401.literal(INVOICE_FILTERABLE_FIELDS.INVOICE_ISSUED_AT_FIELD);
var InvoiceIssuedAtFilterSchema = DateFilterInputSchema.extend({
  field: InvoiceIssuedAtFieldPathSchema
}).openapi("InvoiceIssuedAtFilter");

// src/entities/invoice/invoice-filters-schema/invoice-filter-schemas/invoice-last-sent-filter-schema.ts
import { oz as oz402 } from "@vy/utils";
var InvoiceLastSentFieldPathSchema = oz402.literal(INVOICE_FILTERABLE_FIELDS.INVOICE_LAST_SENT_FIELD);
var InvoiceLastSentFilterSchema = DateFilterInputSchema.extend({
  field: InvoiceLastSentFieldPathSchema
});

// src/entities/invoice/invoice-filters-schema/invoice-filter-schemas/invoice-manual-review-filter-schema.ts
import { oz as oz403 } from "@vy/utils";
var InvoiceManualReviewFieldPathSchema = oz403.literal(INVOICE_FILTERABLE_FIELDS.INVOICE_MANUAL_REVIEW_FIELD);
var InvoiceManualReviewFilterSchema = BooleanFilterInputSchema.extend({
  field: InvoiceManualReviewFieldPathSchema
}).openapi("InvoiceManualReviewFilter");

// src/entities/invoice/invoice-filters-schema/invoice-filter-schemas/invoice-metered-filter-schema.ts
import { oz as oz404 } from "@vy/utils";
var InvoiceMeteredFieldPathSchema = oz404.literal(INVOICE_FILTERABLE_FIELDS.INVOICE_METERED_FIELD);
var InvoiceMeteredFilterSchema = BooleanFilterInputSchema.extend({
  field: InvoiceMeteredFieldPathSchema
}).openapi("InvoiceMeteredFilter");

// src/entities/invoice/invoice-filters-schema/invoice-filter-schemas/invoice-name-filter-schema.ts
import { oz as oz405 } from "@vy/utils";
var InvoiceNameFieldPathSchema = oz405.literal(INVOICE_FILTERABLE_FIELDS.INVOICE_NAME_FIELD);
var InvoiceNameFilterSchema = StringFilterInputSchema.extend({
  field: InvoiceNameFieldPathSchema
}).openapi("InvoiceNameFilter");

// src/entities/invoice/invoice-filters-schema/invoice-filter-schemas/invoice-overage-filter-schema.ts
import { oz as oz406 } from "@vy/utils";
var InvoiceOverageFieldPathSchema = oz406.literal(INVOICE_FILTERABLE_FIELDS.INVOICE_OVERAGE_FIELD);
var InvoiceOverageFilterSchema = BooleanFilterInputSchema.extend({
  field: InvoiceOverageFieldPathSchema
}).openapi("InvoiceOverageFilter");

// src/entities/invoice/invoice-filters-schema/invoice-filter-schemas/invoice-period-filter-schema.ts
import { oz as oz407 } from "@vy/utils";
var InvoicePeriodFieldPathSchema = oz407.literal(INVOICE_FILTERABLE_FIELDS.INVOICE_PERIOD_FIELD);
var InvoicePeriodFilterSchema = DateFilterInputSchema.extend({
  field: InvoicePeriodFieldPathSchema
}).openapi("InvoicePeriodFilter");

// src/entities/invoice/invoice-filters-schema/invoice-filter-schemas/invoice-review-status-filter-schema.ts
import { oz as oz408 } from "@vy/utils";
var InvoiceReviewStatusFieldPathSchema = oz408.literal(INVOICE_FILTERABLE_FIELDS.INVOICE_REVIEW_STATUS_FIELD);
var InvoiceReviewStatusValueSchema = oz408.union([
  oz408.nativeEnum(INVOICE_REVIEW_STATUSES),
  oz408.array(oz408.nativeEnum(INVOICE_REVIEW_STATUSES))
]);
var InvoiceReviewStatusFilterSchema = EnumFilterInputSchema.extend({
  field: InvoiceReviewStatusFieldPathSchema,
  value: InvoiceReviewStatusValueSchema
}).openapi("InvoiceReviewStatusFilter");

// src/entities/invoice/invoice-filters-schema/invoice-filter-schemas/invoice-marketplace-sync-filter-schema.ts
import { oz as oz409 } from "@vy/utils";
var InvoiceMarketplaceSyncFieldPathSchema = oz409.literal(
  INVOICE_FILTERABLE_FIELDS.INVOICE_MARKETPLACE_SYNC_FIELD
);
var InvoiceMarketplaceSyncValueSchema = oz409.union([
  MarketplaceSyncFilterStatusSchema,
  oz409.array(MarketplaceSyncFilterStatusSchema)
]);
var InvoiceMarketplaceSyncFilterSchema = EnumFilterInputSchema.extend({
  field: InvoiceMarketplaceSyncFieldPathSchema,
  value: InvoiceMarketplaceSyncValueSchema
}).openapi("InvoiceMarketplaceSyncFilter");

// src/entities/invoice/invoice-filters-schema/invoice-filter-schemas/invoice-sync-integration-filter-schema.ts
import { oz as oz410 } from "@vy/utils";
var InvoiceSyncIntegrationFieldPathSchema = oz410.literal(INVOICE_FILTERABLE_FIELDS.INVOICE_SYNC_INTEGRATION_FIELD);
var InvoiceSyncIntegrationValueSchema = oz410.union([
  oz410.nativeEnum(SYNC_STATUSES),
  oz410.array(oz410.nativeEnum(SYNC_STATUSES))
]);
var InvoiceSyncIntegrationFilterSchema = EnumFilterInputSchema.extend({
  field: InvoiceSyncIntegrationFieldPathSchema,
  value: InvoiceSyncIntegrationValueSchema
}).openapi("InvoiceSyncIntegrationFilter");

// src/entities/invoice/invoice-filters-schema/invoice-filter-schemas/invoice-yearly-commitment-filter-schema.ts
import { oz as oz411 } from "@vy/utils";
var InvoiceYearlyCommitmentFieldPathSchema = oz411.literal(INVOICE_FILTERABLE_FIELDS.INVOICE_YEARLY_COMMITMENT_FIELD);
var InvoiceYearlyCommitmentFilterSchema = BooleanFilterInputSchema.extend({
  field: InvoiceYearlyCommitmentFieldPathSchema
}).openapi("InvoiceYearlyCommitmentFilter");

// src/entities/invoice/invoice-filters-schema/invoice-filter-schemas/invoice-purchase-order-filter-schema.ts
import { oz as oz412 } from "@vy/utils";
var InvoicePurchaseOrderFieldPathSchema = oz412.literal(INVOICE_FILTERABLE_FIELDS.INVOICE_PURCHASE_ORDER_FIELD);
var InvoicePurchaseOrderFilterSchema = StringFilterInputSchema.extend({
  field: InvoicePurchaseOrderFieldPathSchema
}).openapi("InvoicePurchaseOrderFilter");

// src/entities/invoice/invoice-filters-schema/invoice-filter-schemas/invoice-notes-filter-schema.ts
import { oz as oz413 } from "@vy/utils";
var InvoiceNotesFieldPathSchema = oz413.literal(INVOICE_FILTERABLE_FIELDS.INVOICE_NOTES_FIELD);
var InvoiceNotesFilterSchema = StringFilterInputSchema.extend({
  field: InvoiceNotesFieldPathSchema
}).openapi("InvoiceNotesFilter");

// src/entities/invoice/invoice-filters-schema/invoice-filter-schemas/invoice-subsidiary-filter-schema.ts
import { oz as oz414 } from "@vy/utils";
var InvoiceSubsidiaryFieldPathSchema = oz414.literal(INVOICE_FILTERABLE_FIELDS.INVOICE_SUBSIDIARY_FIELD);
var InvoiceSubsidiaryFilterSchema = EnumFilterInputSchema.extend({
  field: InvoiceSubsidiaryFieldPathSchema
}).openapi("InvoiceSubsidiaryFilter");

// src/entities/invoice/invoice-filters-schema/invoice-filter-schemas/invoice-custom-field-filter-schema.ts
import { oz as oz415 } from "@vy/utils";
var INVOICE_CUSTOM_FIELD_PREFIX = "customFieldValues.";
var InvoiceCustomFieldFieldPathSchema = oz415.string().startsWith(INVOICE_CUSTOM_FIELD_PREFIX).openapi("InvoiceCustomFieldFieldPath");
var InvoiceCustomFieldEnumFilterSchema = EnumFilterInputSchema.extend({
  field: InvoiceCustomFieldFieldPathSchema,
  value: oz415.string().array()
});
var InvoiceCustomFieldStringFilterSchema = StringFilterInputSchema.extend({
  field: InvoiceCustomFieldFieldPathSchema
});
var InvoiceCustomFieldNumberFilterSchema = NumberFilterInputSchema.extend({
  field: InvoiceCustomFieldFieldPathSchema,
  value: oz415.union([oz415.number(), oz415.array(oz415.number())])
});
var InvoiceCustomFieldBooleanFilterSchema = BooleanFilterInputSchema.extend({
  field: InvoiceCustomFieldFieldPathSchema,
  value: oz415.union([oz415.boolean(), oz415.array(oz415.boolean())])
});
var InvoiceCustomFieldFilterSchema = oz415.union([
  InvoiceCustomFieldEnumFilterSchema,
  InvoiceCustomFieldStringFilterSchema,
  InvoiceCustomFieldNumberFilterSchema,
  InvoiceCustomFieldBooleanFilterSchema
]).openapi("InvoiceCustomFieldFilter");

// src/entities/invoice/invoice-filters-schema/invoice-filter-schema.ts
var InvoiceFilterSchema = oz416.union([
  InvoiceAmountFilterSchema,
  InvoiceBillingStatusFilterSchema,
  InvoiceContractPlanNameFilterSchema,
  InvoiceCurrencyFilterSchema,
  InvoiceCustomerIdFilterSchema,
  InvoiceDueDateFilterSchema,
  InvoiceIssuedAtFilterSchema,
  InvoiceLastSentFilterSchema,
  InvoiceNameFilterSchema,
  InvoiceNotesFilterSchema,
  InvoicePeriodFilterSchema,
  InvoicePurchaseOrderFilterSchema,
  InvoiceReviewStatusFilterSchema,
  InvoiceSubsidiaryFilterSchema,
  InvoiceOverageFilterSchema,
  InvoiceContractStatusFilterSchema,
  InvoiceSyncIntegrationFilterSchema,
  InvoiceManualReviewFilterSchema,
  InvoiceYearlyCommitmentFilterSchema,
  InvoiceMeteredFilterSchema,
  InvoiceMarketplaceSyncFilterSchema,
  InvoiceCustomFieldFilterSchema
]).openapi("InvoiceFilter");

// src/entities/invoice/invoice-schema.ts
import { oz as oz454 } from "@vy/utils";

// src/entities/line-item/line-item-schema.ts
import { oz as oz446 } from "@vy/utils";

// src/entities/line-item/line-item-schemas/fixed-line-item/new-fixed-line-item-schema.ts
import { oz as oz428 } from "@vy/utils";

// src/entities/line-item/line-item-type-schema.ts
import { oz as oz417 } from "@vy/utils";
var LINE_ITEM_TYPES = Object.freeze({
  Fixed: "Fixed",
  NonProductFixed: "NonProductFixed",
  Usage: "Usage",
  Commitment: "Commitment",
  Deduction: "Deduction"
});
var LineItemTypeSchema = oz417.nativeEnum(LINE_ITEM_TYPES).openapi("LineItemType");

// src/entities/line-item-product/line-item-product-schema.ts
import { oz as oz422 } from "@vy/utils";

// src/entities/line-item-product-commitment/new-line-item-product-commitment-schema.ts
import { oz as oz418 } from "@vy/utils";
var NewLineItemProductCommitmentSchema = oz418.object({
  consumption: oz418.number(),
  amount: oz418.number(),
  type: CommitmentTypeSchema,
  replenishmentInterval: withNullAsOptional(oz418.number())
}).openapi("NewLineItemProductCommitment");

// src/entities/line-item-product-commitment/line-item-product-commitment-schema.ts
var LineItemProductCommitmentSchema = NewLineItemProductCommitmentSchema.openapi("LineItemProductCommitment");

// src/entities/line-item-product-variant/new-line-item-product-variant-schema.ts
import { oz as oz420 } from "@vy/utils";

// src/entities/line-item-product-variant-meter/new-line-item-product-variant-meter-schema.ts
import { oz as oz419 } from "@vy/utils";
var NewLineItemProductVariantMeterSchema = oz419.object({
  meterId: ObjectIdSchema,
  name: oz419.string(),
  eventName: oz419.string(),
  filter: FilterSchema.optional(),
  aggregationMethod: AggregationMethodSchema,
  unitsType: oz419.string().optional()
}).openapi("NewLineItemProductVariantMeter");

// src/entities/line-item-product-variant/new-line-item-product-variant-schema.ts
var NewLineItemProductVariantSchema = oz420.object({
  productVariantId: withNullAsOptional(oz420.string()),
  name: oz420.string(),
  description: withNullAsOptional(oz420.string()),
  pricing: PricingSchema,
  periodLimit: PeriodSchema.optional(),
  settings: withNullAsOptional(ProductSettingsSchema),
  meter: withNullAsOptional(NewLineItemProductVariantMeterSchema)
}).openapi("NewLineItemProductVariant");

// src/entities/line-item-product-variant/line-item-product-variant-schema.ts
var LineItemProductVariantSchema = NewLineItemProductVariantSchema.openapi("LineItemProductVariant");

// src/entities/line-item-product/new-line-item-product-schema.ts
import { oz as oz421 } from "@vy/utils";
var NewLineItemProductSchema = oz421.object({
  productId: withNullAsOptional(ObjectIdSchema),
  name: withNullAsOptional(oz421.string()),
  basePrice: withNullAsOptional(oz421.number()),
  additionalCharge: withNullAsOptional(oz421.number()),
  proRata: oz421.boolean(),
  rateMultiplier: withNullAsOptional(oz421.number()),
  variants: oz421.array(NewLineItemProductVariantSchema),
  commitment: NewLineItemProductCommitmentSchema.optional(),
  paymentTerm: PaymentTermSchema,
  billingInterval: BillingIntervalSchema,
  accumulationInterval: withNullAsOptional(oz421.number()),
  currencyCommitment: oz421.number().optional(),
  integrationEntities: withNullAsOptional(oz421.array(ProductIntegrationEntitySchema)),
  externalIntegration: ExternalProductIntegrationSchema.nullish(),
  cloudProviderSettings: ProductCloudProviderSettingsSchema.optional(),
  creditTypeIds: withNullAsOptional(ObjectIdSchema.array()),
  creditPurchaseConfig: CreditPurchaseConfigSchema.optional()
}).openapi("NewLineItemProduct");

// src/entities/line-item-product/line-item-product-schema.ts
var LineItemProductSchema = NewLineItemProductSchema.extend({
  variants: oz422.array(LineItemProductVariantSchema),
  commitment: LineItemProductCommitmentSchema.nullable().optional()
}).openapi("LineItemProduct");

// src/entities/line-item/base-line-item-schema.ts
import { oz as oz424 } from "@vy/utils";

// src/entities/line-item/original-invoice-data-schema.ts
import { oz as oz423 } from "@vy/utils";
var OriginalInvoiceDataSchema = oz423.object({
  id: ObjectIdSchema,
  customerId: ObjectIdSchema
}).openapi("OriginalInvoiceData");

// src/entities/line-item/base-line-item-schema.ts
var BaseLineItemSchema = oz424.object({
  invoiceId: ObjectIdSchema,
  revenueBreakdown: RevenueBreakdownSchema.readonly(),
  isRevised: oz424.boolean(),
  disabled: oz424.boolean().default(false).optional(),
  modifiedName: oz424.string().nullable(),
  modifiedDescription: oz424.string().nullable(),
  modifiedPrice: oz424.number().optional(),
  percentage: oz424.number().nonnegative().nullish(),
  lineItemPeriod: PeriodSchema.optional(),
  originalInvoiceData: OriginalInvoiceDataSchema.optional(),
  saleTax: SaleTaxSchema.nullish().readonly()
}).openapi("BaseLineItem");

// src/entities/line-item/line-item-schemas/base-product-line-item.ts
var BaseProductLineItemSchema = BaseLineItemSchema.extend({
  lineItemProduct: LineItemProductSchema
}).openapi("BaseProductLineItem");

// src/entities/line-item/line-item-schemas/commitment-line-item/new-commitment-line-item-schema.ts
import { oz as oz426 } from "@vy/utils";

// src/entities/line-item/line-item-schemas/commitment-line-item/commitment-tiers-usage-map-schema.ts
import { oz as oz425 } from "@vy/utils";
var CommitmentTiersUsageMapSchema = oz425.record(oz425.string(), oz425.array(CommitmentTierUsageDataSchema).nonempty()).openapi("CommitmentTiersUsageMap");

// src/entities/line-item/line-item-schemas/commitment-line-item/new-commitment-line-item-schema.ts
var NewCommitmentLineItemSchema = BaseProductLineItemSchema.extend({
  type: oz426.literal(LINE_ITEM_TYPES.Commitment),
  invoiceId: ObjectIdSchema,
  units: oz426.number().nonnegative(),
  commitmentTiersUsageMap: CommitmentTiersUsageMapSchema,
  lineItemProduct: NewLineItemProductSchema.required({
    productId: true
  })
}).openapi("NewCommitmentLineItem");

// src/entities/line-item/line-item-schemas/commitment-line-item/commitment-line-item-schema.ts
var CommitmentLineItemSchema = created(NewCommitmentLineItemSchema).openapi("CommitmentLineItem");

// src/entities/line-item/line-item-schemas/commitment-line-item/commitment-line-item-input-schema.ts
import { oz as oz427 } from "@vy/utils";
var CommitmentLineItemInputSchema = oz427.object(NewCommitmentLineItemSchema.shape).partial().required({ type: true }).openapi("CommitmentLineItemInput");

// src/entities/line-item/line-item-schemas/fixed-line-item/new-fixed-line-item-schema.ts
var NewFixedLineItemSchema = BaseProductLineItemSchema.extend({
  type: oz428.literal(LINE_ITEM_TYPES.Fixed),
  tiersUsageMap: CommitmentTiersUsageMapSchema.nullish()
}).openapi("NewFixedLineItem");

// src/entities/line-item/line-item-schemas/fixed-line-item/fixed-line-item-schema.ts
var FixedLineItemSchema = created(NewFixedLineItemSchema).openapi("FixedLineItem");

// src/entities/line-item/line-item-schemas/fixed-line-item/fixed-line-item-input-schema.ts
import { oz as oz429 } from "@vy/utils";
var FixedLineItemInputSchema = oz429.object(NewFixedLineItemSchema.shape).partial().required({ type: true }).openapi("FixedLineItemInput");

// src/entities/line-item/line-item-schemas/usage-line-item/new-usage-line-item-schema.ts
import { oz as oz441 } from "@vy/utils";

// src/entities/line-item-product/line-item-product-input-schema.ts
import { oz as oz439 } from "@vy/utils";

// src/entities/line-item-product-commitment/line-item-product-commitment-input-schema.ts
import { oz as oz430 } from "@vy/utils";
var LineItemProductCommitmentInputSchema = oz430.object(NewLineItemProductCommitmentSchema.shape).partial().openapi("LineItemProductCommitmentInput");

// src/entities/line-item-product-variant/line-item-product-variant-input-schema.ts
import { oz as oz438 } from "@vy/utils";

// src/entities/pricing/is-fixed-pricing-model.ts
var fixedPricingModels = new Set(Object.values(FIXED_PRICING_MODELS));
function isFixedPricingModel(model) {
  return fixedPricingModels.has(model);
}

// src/entities/pricing/is-usage-pricing-model.ts
var usagePricingModels = new Set(Object.values(USAGE_PRICING_MODELS));
function isUsagePricingModel(model) {
  return usagePricingModels.has(model);
}

// src/entities/pricing/pricing-template/pricing-setting-types-schema.ts
import { oz as oz431 } from "@vy/utils";
var PRICING_TEMPLATE_TYPES = Object.freeze({
  BILLING_INTERVAL: "BillingInterval",
  PAYMENT_TERMS: "PaymentTerms",
  CADENCE: "Cadence",
  PRORATE: "Prorate",
  TIER_RESET: "TierReset"
});
var PricingTemplateTypeSchema = oz431.nativeEnum(PRICING_TEMPLATE_TYPES).openapi("PricingTemplateType");

// src/entities/pricing/pricing-template/pricing-template-schema.ts
import { isEmptyArray, oz as oz437 } from "@vy/utils";

// src/entities/pricing/pricing-template/pricing-template-schemas/boolean-pricing-template-schema.ts
import { oz as oz434 } from "@vy/utils";

// src/entities/primitive-types-schema.ts
import { oz as oz432 } from "@vy/utils";
var PRIMITIVE_TYPES = Object.freeze({
  BOOLEAN: "Boolean",
  NUMBER: "Number",
  ENUM: "Enum"
});
var PrimitiveTypeSchema = oz432.nativeEnum(PRIMITIVE_TYPES).openapi("PrimitiveType");

// src/entities/pricing/pricing-template/pricing-template-schemas/base-pricing-template-schema.ts
import { oz as oz433 } from "@vy/utils";
var BasePricingTemplateSchema = created(
  oz433.object({
    accountId: oz433.string().optional(),
    pricingModel: PricingModelSchema,
    templateType: PricingTemplateTypeSchema,
    primitiveType: PrimitiveTypeSchema,
    userConfigurable: oz433.boolean()
  })
);

// src/entities/pricing/pricing-template/pricing-template-schemas/boolean-pricing-template-schema.ts
var booleanValue = oz434.string().refine((value) => value === "true" || value === "false", {
  message: "Value must be a valid boolean"
});
var BooleanPricingTemplateSchema = BasePricingTemplateSchema.extend({
  primitiveType: oz434.literal(PRIMITIVE_TYPES.BOOLEAN),
  defaultValue: booleanValue.optional(),
  possibleValues: booleanValue.array().optional()
});

// src/entities/pricing/pricing-template/pricing-template-schemas/enum-pricing-template-schema.ts
import { oz as oz435 } from "@vy/utils";
var EnumPricingTemplateSchema = BasePricingTemplateSchema.extend({
  primitiveType: oz435.literal(PRIMITIVE_TYPES.ENUM),
  defaultValue: oz435.string().optional(),
  possibleValues: oz435.string().array().optional()
});

// src/entities/pricing/pricing-template/pricing-template-schemas/number-pricing-template-schema.ts
import { oz as oz436 } from "@vy/utils";
var numberValue = oz436.string().refine((value) => !isNaN(Number(value)), {
  message: "Value must be a valid number"
});
var NumberPricingTemplateSchema = BasePricingTemplateSchema.extend({
  primitiveType: oz436.literal(PRIMITIVE_TYPES.NUMBER),
  defaultValue: numberValue.optional(),
  possibleValues: numberValue.array().optional()
});

// src/entities/pricing/pricing-template/pricing-template-schema.ts
var BaseUnionSchema = oz437.discriminatedUnion("primitiveType", [
  BooleanPricingTemplateSchema,
  NumberPricingTemplateSchema,
  EnumPricingTemplateSchema
]);
var PricingTemplateSchema = BaseUnionSchema.refine(
  (data) => isEmptyArray(data.possibleValues) || data.possibleValues.includes(data.defaultValue),
  {
    message: "defaultValue must be one of the possibleValues when specified",
    path: ["defaultValue"]
  }
).openapi("PricingTemplate");

// src/entities/pricing/supports-proration.ts
var PRORATION_SUPPORTING_PRICING_MODELS = /* @__PURE__ */ new Set([
  PRICING_MODELS.Subscription,
  PRICING_MODELS.TieredSubscription
]);
function supportsProration(model) {
  return PRORATION_SUPPORTING_PRICING_MODELS.has(model);
}

// src/entities/line-item-product-variant/line-item-product-variant-input-schema.ts
var LineItemProductVariantInputSchema = oz438.object(NewLineItemProductVariantSchema.shape).partial().extend({
  pricing: PricingInputSchema
}).openapi("LineItemProductVariantInput");

// src/entities/line-item-product/line-item-product-input-schema.ts
var LineItemProductInputSchema = oz439.object(NewLineItemProductSchema.shape).extend({
  variants: oz439.array(LineItemProductVariantInputSchema),
  commitment: LineItemProductCommitmentInputSchema.optional()
}).partial().openapi("LineItemProductInput");

// src/entities/line-item/line-item-schemas/usage-line-item/tiers-usage-map/tiers-usage-map-schema.ts
import { oz as oz440 } from "@vy/utils";
var TiersUsageMapSchema = oz440.record(oz440.string(), oz440.array(TierUsageDataSchema).nonempty()).openapi("TiersUsageMap");

// src/entities/line-item/line-item-schemas/usage-line-item/new-usage-line-item-schema.ts
var NewUsageLineItemSchema = BaseProductLineItemSchema.extend({
  type: oz441.literal(LINE_ITEM_TYPES.Usage),
  invoiceId: ObjectIdSchema,
  units: oz441.number(),
  tiersUsageMap: CommitmentTiersUsageMapSchema,
  instanceUsageMap: TiersUsageMapSchema.optional(),
  lineItemProduct: LineItemProductSchema.required({ productId: true })
}).openapi("NewUsageLineItem");

// src/entities/line-item/line-item-schemas/usage-line-item/usage-line-item-schema.ts
var UsageLineItemSchema = created(NewUsageLineItemSchema).openapi("UsageLineItem");

// src/entities/line-item/line-item-schemas/usage-line-item/usage-line-item-input-schema.ts
import { oz as oz443 } from "@vy/utils";

// src/entities/line-item/line-item-schemas/usage-line-item/tiers-usage-map/tiers-usage-map-input-schema.ts
import { oz as oz442 } from "@vy/utils";
var TiersUsageMapInputSchema = oz442.record(ObjectIdSchema, oz442.array(TierUsageDataInputSchema).nonempty()).openapi("TiersUsageMapInput");

// src/entities/line-item/line-item-schemas/usage-line-item/usage-line-item-input-schema.ts
var UsageLineItemInputSchema = oz443.object(NewUsageLineItemSchema.shape).omit({ tiersUsageMap: true }).extend({
  tiersUsageMap: TiersUsageMapInputSchema
}).partial().required({ type: true }).openapi("UsageLineItemInput");

// src/entities/line-item/line-item-schemas/non-product-fixed-line-item/new-non-product-fixed-line-item-schema.ts
import { oz as oz444 } from "@vy/utils";
var NewNonProductFixedLineItemSchema = BaseLineItemSchema.extend({
  type: oz444.literal(LINE_ITEM_TYPES.NonProductFixed),
  lineItemProduct: LineItemProductSchema.omit({
    productId: true
  })
}).openapi("NewNonProductFixedLineItem");

// src/entities/line-item/line-item-schemas/non-product-fixed-line-item/non-product-fixed-line-item-schema.ts
var NonProductFixedLineItemSchema = created(NewNonProductFixedLineItemSchema).openapi(
  "NonProductFixedLineItem"
);

// src/entities/line-item/line-item-schemas/non-product-fixed-line-item/non-product-fixed-line-item-input-schema.ts
import { oz as oz445 } from "@vy/utils";
var NonProductFixedLineItemInputSchema = oz445.object(NonProductFixedLineItemSchema.shape).partial().required({ type: true }).openapi("NonProductFixedLineItemInput");

// src/entities/line-item/line-item-schema.ts
var LineItemSchema = oz446.discriminatedUnion("type", [
  FixedLineItemSchema,
  NonProductFixedLineItemSchema,
  UsageLineItemSchema,
  CommitmentLineItemSchema
]).openapi("LineItem");

// src/entities/line-item/new-line-item-schema.ts
import { oz as oz447 } from "@vy/utils";
var NewLineItemSchema = oz447.discriminatedUnion("type", [
  NewFixedLineItemSchema,
  NewUsageLineItemSchema,
  NewNonProductFixedLineItemSchema,
  NewCommitmentLineItemSchema
]).openapi("NewLineItem");

// src/entities/line-item/line-item-input-schema.ts
import { oz as oz448 } from "@vy/utils";
var LineItemInputSchema = oz448.discriminatedUnion("type", [
  FixedLineItemInputSchema.extend({ id: ObjectIdSchema }),
  NonProductFixedLineItemInputSchema.extend({ id: ObjectIdSchema }),
  UsageLineItemInputSchema.extend({ id: ObjectIdSchema }),
  CommitmentLineItemInputSchema.extend({ id: ObjectIdSchema })
]).openapi("LineItemInput");

// src/entities/line-item/line-item-with-no-product-type.ts
import { oz as oz449 } from "@vy/utils";
var LINE_ITEM_WITH_NO_PRODUCT_TYPES = Object.freeze({
  Fixed: "Fixed",
  FixedPromotion: "FixedPromotion",
  PercentagePromotion: "PercentagePromotion"
});
var LineItemWithNoProductTypeSchema = oz449.nativeEnum(LINE_ITEM_WITH_NO_PRODUCT_TYPES).openapi("LineItemWithNoProductType");

// src/entities/invoice/invoice-snapshot-schema.ts
import { oz as oz450 } from "@vy/utils";
var InvoiceSnapshotCustomerSchema = oz450.object({
  address: AddressSchema.optional()
}).openapi("InvoiceSnapshotCustomer");
var InvoiceSnapshotSchema = oz450.object({
  customer: InvoiceSnapshotCustomerSchema.optional()
}).openapi("InvoiceSnapshot");

// src/entities/invoice/new-invoices-schema.ts
import { oz as oz452 } from "@vy/utils";

// src/entities/invoice/invoice-type-schema.ts
import { oz as oz451 } from "@vy/utils";
var INVOICE_TYPES = Object.freeze({
  ...PAYMENT_TERMS,
  Hybrid: "Hybrid"
});
var InvoiceTypeSchema = oz451.nativeEnum(INVOICE_TYPES).openapi("InvoiceType");

// src/entities/invoice/new-invoices-schema.ts
var NewInvoiceSchema = oz452.object({
  id: ObjectIdSchema.optional(),
  name: oz452.string().nonempty(),
  reviewStatus: InvoiceReviewStatusSchema,
  billingStatus: InvoiceBillingStatusSchema,
  billingCycle: FullDayPeriodSchema,
  customerId: ObjectIdSchema,
  taxRate: TaxRateSchema,
  issuedAt: ApiDateSchema.nullable(),
  dueDate: ApiDateSchema.nullable(),
  lineItems: oz452.array(NewLineItemSchema),
  contractId: ObjectIdSchema.optional(),
  paymentTerm: PaymentTermSchema,
  revenueBreakdown: RevenueBreakdownSchema.readonly(),
  approvedAt: ApiDateSchema.optional(),
  paymentDueDays: oz452.number().nullable(),
  trial: withNullAsOptional(TrialDurationSchema),
  syncStatus: SyncStatusSchema.default(SYNC_STATUSES.None),
  syncStatusUpdatedAt: withNullAsOptional(ApiDateSchema),
  stripeSyncStatus: SyncStatusSchema.default(SYNC_STATUSES.None),
  stripeSyncStatusUpdatedAt: ApiDateSchema.nullish(),
  stripeIntegrationExternalId: oz452.string().optional(),
  paymentInfo: PaymentInfoSchema.optional(),
  lineItemsGroupingKey: oz452.string().optional(),
  invoicingDate: ApiDateSchema.optional(),
  invoiceType: InvoiceTypeSchema,
  parentLineItemId: ObjectIdSchema.optional(),
  currency: CurrencySchema,
  modifiedCurrency: CurrencySchema.nullable().optional(),
  baseCurrency: CurrencySchema.nullable().optional(),
  exchangeRateSnapshot: oz452.record(oz452.string(), oz452.number()).nullable().optional(),
  modifiedExchangeRate: oz452.number().nullable().optional(),
  invoiceNumber: oz452.string().optional(),
  ref: oz452.string().optional(),
  invoicingSettingsOverride: InvoicingSettingsSchema.nullish(),
  exchangeRateSnapshotTimestamp: ApiDateSchema.nullish()
}).openapi("NewInvoice");

// src/entities/invoice/payment-provider-information-schema.ts
import { oz as oz453 } from "@vy/utils";
var InvoicePaymentProviderInformationSchema = oz453.object({
  paymentProviderType: PaymentIntegrationProvidersSchema,
  externalInvoicePaymentLink: oz453.string().optional(),
  externalInvoiceId: oz453.string(),
  externalInvoiceStatus: oz453.string()
}).openapi("InvoicePaymentProviderInformation");

// src/entities/invoice/invoice-schema.ts
var InvoiceSchema = segregated(
  NewInvoiceSchema.extend({
    invoiceNumber: oz454.string(),
    ref: oz454.string(),
    purchaseOrder: oz454.string().max(500).optional(),
    notes: oz454.string().max(500).optional(),
    customer: CustomerSchema.nullable(),
    contract: ContractSchema.nullable(),
    lineItems: oz454.array(LineItemSchema),
    parentLineItem: LineItemSchema.optional(),
    paymentProviderInformation: InvoicePaymentProviderInformationSchema.optional(),
    erpId: oz454.string().optional(),
    refundsInvoiceId: oz454.string().optional(),
    snapshot: InvoiceSnapshotSchema.nullish()
  })
).openapi("Invoice");

// src/entities/customer-portal/customer-portal-invoice-schema.ts
var CustomerPortalInvoiceSchema = InvoiceSchema.pick({
  id: true,
  name: true,
  billingStatus: true,
  revenueBreakdown: true,
  issuedAt: true,
  dueDate: true,
  invoicingDate: true,
  invoiceNumber: true,
  ref: true
}).extend({
  customerName: oz455.string(),
  currency: CurrencySchema,
  productsConsumption: oz455.array(ProductConsumptionSchema),
  isTrial: oz455.boolean()
});

// src/entities/customer-portal/customer-portal-token-params.ts
import { oz as oz456 } from "@vy/utils";
var CustomerPortalTokenParamsSchema = oz456.object({
  customerId: oz456.string()
}).openapi("CustomerPortalTokenParams");

// src/entities/customer-portal/customer-portal-checkout-link-token-params.ts
import { oz as oz457 } from "@vy/utils";
var CustomerPortalCheckoutLinkTokenParamsSchema = oz457.object({
  invoiceId: oz457.string(),
  accountId: oz457.string()
}).openapi("CustomerPortalCheckoutLinkTokenParams");

// src/entities/email-message/email-type-schema.ts
import { oz as oz458 } from "@vy/utils";
var EMAIL_TYPES = Object.freeze({
  SharedCreditNote: "SharedCreditNote",
  SharedInvoice: "SharedInvoice",
  PaymentReminder: "PaymentReminder",
  Invitation: "Invitation",
  SupportRequest: "SupportRequest",
  Notification: "Notification"
});
var EmailTypeSchema = oz458.nativeEnum(EMAIL_TYPES).openapi("EmailType");

// src/entities/email-message/email-status-schema.ts
import { oz as oz459, parseJson as parseJson9 } from "@vy/utils";
var EMAIL_STATUSES = Object.freeze({
  Pending: "Pending",
  Processing: "Processing",
  Processed: "Processed",
  Failed: "Failed",
  Delivered: "Delivered"
});
var EmailStatusSchema = oz459.nativeEnum(EMAIL_STATUSES).openapi("EmailStatus");
var EmailStatusesSchema = oz459.string().transform((s) => parseJson9(s)).pipe(EmailStatusSchema.array()).optional();

// src/entities/email-message/email-message-schema.ts
import { oz as oz460 } from "@vy/utils";
var EmailMessageSchema = oz460.object({
  messageId: oz460.string(),
  invoiceId: ObjectIdSchema.optional(),
  accountId: ObjectIdSchema,
  type: EmailTypeSchema,
  status: EmailStatusSchema,
  isManual: oz460.boolean(),
  subject: oz460.string().optional(),
  content: oz460.string(),
  templateId: oz460.string(),
  recipient: oz460.string(),
  bcc: oz460.array(oz460.string()).optional(),
  date: ApiDateSchema
}).openapi("EmailMessage");

// src/entities/email-verification-message/email-verification-message-schema.ts
import { oz as oz463 } from "@vy/utils";

// src/entities/email-verification-message/email-verification-event-schema.ts
import { oz as oz461, parseJson as parseJson10 } from "@vy/utils";
var EMAIL_VERIFICATION_EVENTS = Object.freeze({
  Dropped: "Dropped",
  Bounced: "Bounced",
  Delivered: "Delivered"
});
var EmailVerificationEventSchema = oz461.nativeEnum(EMAIL_VERIFICATION_EVENTS).openapi("EmailVerificationEvent");
var EmailVerificationEventsSchema = oz461.string().transform((s) => parseJson10(s)).pipe(EmailVerificationEventSchema.array()).optional();

// src/entities/email-verification-message/email-verification-source-schema.ts
import { oz as oz462 } from "@vy/utils";
var EMAIL_VERIFICATION_SOURCE = Object.freeze({
  SendGrid: "SendGrid",
  Vayu: "Vayu"
});
var EmailVerificationSourceSchema = oz462.nativeEnum(EMAIL_VERIFICATION_SOURCE);

// src/entities/email-verification-message/email-verification-message-schema.ts
var EmailVerificationMessageSchema = oz463.object({
  messageId: oz463.string(),
  eventId: oz463.string(),
  reason: oz463.string().optional(),
  response: oz463.string().optional(),
  recipient: oz463.string(),
  timestamp: oz463.number(),
  source: EmailVerificationSourceSchema,
  event: EmailVerificationEventSchema
}).openapi("EmailVerificationMessage");

// src/entities/event/new-event-schema.ts
import { oz as oz467 } from "@vy/utils";

// src/entities/event/event-metering-status.ts
import { oz as oz464 } from "@vy/utils";
var EVENT_METERING_STATUSES = {
  Ingested: "Ingested",
  Matched: "Matched",
  Measured: "Measured"
};
var EventMeteringStatusSchema = oz464.nativeEnum(EVENT_METERING_STATUSES);

// src/entities/event/ingested-event-schema.ts
import { oz as oz466 } from "@vy/utils";

// src/entities/event/event-data-schema.ts
import { oz as oz465 } from "@vy/utils";
var EventDataSchema = oz465.record(oz465.string(), oz465.any());

// src/entities/event/ingested-event-schema.ts
var IngestedEventSchema = oz466.object({
  timestamp: ApiDateSchema,
  customerAlias: oz466.string().min(1),
  accountId: ObjectIdSchema,
  data: EventDataSchema.optional().nullable(),
  ref: oz466.string(),
  name: oz466.string()
});
var DBIngestedEventSchema = IngestedEventSchema.extend({
  day: oz466.number(),
  month: oz466.number(),
  year: oz466.number()
}).openapi("DBIngestedEvent");
var CreatedIngestedEventSchema = segregated(DBIngestedEventSchema);
var IngestedMatchedEventSchema = IngestedEventSchema.omit({
  accountId: true
}).extend({
  data: EventDataSchema.nullable().optional(),
  customerId: oz466.string().optional().nullable(),
  affectedMeters: oz466.number().optional()
}).openapi("IngestedMatchedEvent");
var IngestedEventSampleSchema = IngestedMatchedEventSchema.extend({
  customerName: oz466.string().optional(),
  matchedAt: ApiDateSchema.optional()
}).openapi("IngestedEventSample");
var S3IngestedEventSchema = IngestedEventSchema.omit({
  accountId: true
});

// src/entities/event/new-event-schema.ts
var NewEventSchema = IngestedEventSchema.extend({
  customerId: ObjectIdSchema.optional(),
  meteringStatus: EventMeteringStatusSchema.default(EVENT_METERING_STATUSES.Ingested)
});
var CreatedEventSchema = IngestedEventSchema.extend({
  id: oz467.string(),
  updatedAt: ApiDateSchema,
  createdAt: ApiDateSchema
});

// src/entities/event/event-schema.ts
var EventSchema = segregated(NewEventSchema);

// src/entities/event/events-payload-schema.ts
import { oz as oz468 } from "@vy/utils";
var MIN_EVENTS = 1;
var MAX_EVENTS = 1e3;
var EventsPayloadSchema = oz468.object({
  events: oz468.array(IngestedEventSchema).min(MIN_EVENTS).max(MAX_EVENTS)
});

// src/async-messages/events-processor/price-event-message-schema.ts
import { oz as oz469 } from "@vy/utils";
var PriceEventMessageSchema = oz469.object({
  meteredEventId: oz469.string(),
  accumulatedUnits: oz469.number().optional(),
  productVariantId: oz469.string(),
  invoiceId: oz469.string(),
  commitmentAccumulatedUnits: oz469.number().optional()
});

// src/async-messages/events-processor/accumulate-metered-event-message-schema.ts
import { oz as oz470 } from "@vy/utils";
var AccumulateMeteredEventMessageSchema = oz470.object({
  meteredEventId: oz470.string()
});

// src/async-messages/events-processor/accumulate-line-item-charge-message-schema.ts
import { oz as oz471 } from "@vy/utils";
var AccumulateLineItemChargeMessageSchema = oz471.object({
  pricedEventId: oz471.string()
});

// src/entities/event/metered-event-schema.ts
import { oz as oz472 } from "@vy/utils";
var MeteredEventSchema = oz472.object({
  customerEventId: oz472.string(),
  meterId: oz472.string(),
  value: oz472.number().nullable()
});
var CreateMeteredEventSchema = MeteredEventSchema.omit({
  customerEventId: true
});
var DbMeteredEventSchema = created(MeteredEventSchema).openapi("DbMeteredEvent");
var AffectedMeteredEventSampleSchema = oz472.object({
  name: oz472.string(),
  meterId: oz472.string(),
  value: oz472.number(),
  assignedAt: ApiDateSchema
});

// src/entities/event/customer-event-schema.ts
import { oz as oz473 } from "@vy/utils";
var CustomerEventSchema = oz473.object({
  eventId: oz473.string(),
  customerId: ObjectIdSchema
});
var DbCustomerEventSchema = created(CustomerEventSchema).openapi("DbCustomerEvent");

// src/entities/event/event-field-extractor-payload-schema.ts
import { oz as oz474 } from "@vy/utils";
var EventFieldExtractorPayloadSchema = oz474.union([IngestedMeterSchema, IngestedEventSchema]);

// src/entities/event-field/event-data-field-schema.ts
import { oz as oz480 } from "@vy/utils";

// src/entities/event-field/enum-event-field-schema.ts
import { oz as oz477 } from "@vy/utils";

// src/entities/event-field/event-field-schema.ts
import { oz as oz475 } from "@vy/utils";
var EventFieldSchema = oz475.object({
  name: oz475.string().nonempty(),
  eventName: oz475.string().nonempty(),
  accountId: oz475.string().nonempty(),
  type: oz475.string().nonempty()
}).openapi("DataField");

// src/entities/event-field/event-field-type-schema.ts
import { oz as oz476 } from "@vy/utils";
var EVENT_FIELD_TYPES = Object.freeze({
  String: "String",
  Number: "Number",
  Enum: "Enum"
});
var EventFieldTypeSchema = oz476.nativeEnum(EVENT_FIELD_TYPES).openapi("DataFieldType");

// src/entities/event-field/enum-event-field-schema.ts
var EnumEventFieldSchema = EventFieldSchema.extend({
  type: oz477.literal(EVENT_FIELD_TYPES.Enum),
  values: oz477.array(oz477.string()).default([])
}).openapi("EnumDataField");

// src/entities/event-field/number-event-field-schema.ts
import { oz as oz478 } from "@vy/utils";
var NumberEventFieldSchema = EventFieldSchema.extend({
  type: oz478.literal(EVENT_FIELD_TYPES.Number)
}).openapi("NumberEventField");

// src/entities/event-field/string-event-field-schema.ts
import { oz as oz479 } from "@vy/utils";
var StringEventFieldSchema = EventFieldSchema.extend({
  type: oz479.literal(EVENT_FIELD_TYPES.String)
}).openapi("StringDataField");

// src/entities/event-field/event-data-field-schema.ts
var EventFieldSchema2 = oz480.discriminatedUnion("type", [NumberEventFieldSchema, StringEventFieldSchema, EnumEventFieldSchema]).openapi("EventField");

// src/entities/event-field/event-name-schema.ts
import { oz as oz481 } from "@vy/utils";
var EventNameSchema = oz481.object({
  eventName: oz481.string()
});

// src/entities/fixed-variant-charge/new-fixed-variant-charge-schema.ts
import { oz as oz483 } from "@vy/utils";

// src/entities/fixed-variant-charge/advance-payment-charge-type-schema.ts
import { oz as oz482 } from "@vy/utils";
var ADVANCE_PAYMENT_CHARGE_TYPE = Object.freeze({
  PaidInAdvance: "PaidInAdvance",
  DeductedPayment: "DeductedPayment"
});
var AdvancePaymentChargeTypeSchema = oz482.nativeEnum(ADVANCE_PAYMENT_CHARGE_TYPE);

// src/entities/fixed-variant-charge/new-fixed-variant-charge-schema.ts
var NewFixedVariantChargeSchema = oz483.object({
  accountId: oz483.string(),
  customerId: oz483.string(),
  productVariantId: oz483.string(),
  invoiceId: oz483.string().nullish(),
  contractId: oz483.string(),
  period: PeriodSchema,
  timeSlot: TimeSlotSchema,
  advancePaymentChargeType: AdvancePaymentChargeTypeSchema.nullish(),
  price: oz483.number(),
  currency: CurrencySchema,
  tierIndex: oz483.number().nullish()
});

// src/entities/fixed-variant-charge/anonymous-fixed-variant-charge-schema.ts
var AnonymousFixedVariantChargeSchema = NewFixedVariantChargeSchema.omit({
  accountId: true,
  contractId: true
});

// src/entities/fixed-variant-charge/fixed-variant-charge-schema.ts
var FixedVariantChargeSchema = created(NewFixedVariantChargeSchema);

// src/entities/integration-events/sync-entity-schema.ts
import { oz as oz484 } from "@vy/utils";
var SYNC_ENTITIES = Object.freeze({
  customer: "Customer",
  invoice: "Invoice",
  product: "Product"
});
var SyncEntitySchema = oz484.nativeEnum(SYNC_ENTITIES);

// src/entities/invoicing-charge/commitment-tier-info-schema.ts
import { oz as oz485 } from "@vy/utils";
var CommitmentTierInfoSchema = oz485.object({
  chargeInfo: oz485.object({
    price: oz485.number(),
    discountAmount: oz485.number().optional(),
    periodUnits: oz485.number(),
    tierContext: oz485.object({
      tierIndex: oz485.number().nonnegative()
    }),
    discountConfiguration: TierDiscountConfigurationSchema.nullish(),
    instanceKey: oz485.string().optional()
  }),
  commitmentContext: oz485.object({
    billableUnits: oz485.number(),
    ytdUnits: oz485.number()
  })
});

// src/entities/invoicing-charge/invoicing-charge-calculation-breakdown-schema.ts
import { oz as oz486 } from "@vy/utils";
var InvoiceChargeCalculationBreakdownSchema = oz486.object({
  period: PeriodSchema,
  price: oz486.number(),
  billablePeriodUnits: oz486.number(),
  periodNonBillableUnits: oz486.number(),
  periodUnits: oz486.number(),
  variantTierBreakdown: oz486.array(
    oz486.object({
      variantId: oz486.string(),
      commitmentTiers: oz486.array(CommitmentTierInfoSchema)
    })
  ),
  commitmentUsed: oz486.number().nullish(),
  ytdCommitmentUsed: oz486.number().nullish(),
  accumulatedUnits: oz486.number().nullish(),
  currency: CurrencySchema
});

// src/entities/invoicing-charge/new-invoicing-charge-schema.ts
import { oz as oz487 } from "@vy/utils";
var NewInvoicingChargeSchema = oz487.object({
  productPeriodId: oz487.string(),
  advancePaymentChargeType: AdvancePaymentChargeTypeSchema.nullish(),
  calculationBreakdown: InvoiceChargeCalculationBreakdownSchema
});

// src/entities/invoicing-charge/invoicing-charge-schema.ts
var InvoicingChargeSchema = created(NewInvoicingChargeSchema);

// src/entities/line-item-product-variant-meter/line-item-product-variant-meter-input-schema.ts
import { oz as oz488 } from "@vy/utils";
var LineItemProductVariantMeterInputSchema = oz488.object(NewLineItemProductVariantMeterSchema.shape).partial().openapi("LineItemProductVariantMeterInput");

// src/entities/line-item-product-variant-meter/line-item-product-variant-meter-schema.ts
var LineItemProductVariantMeterSchema = NewLineItemProductVariantMeterSchema.openapi(
  "LineItemProductVariantMeter"
);

// src/entities/line-item-order/line-item-order-schema.ts
import { oz as oz489 } from "@vy/utils";
var LINE_ITEM_ORDER_KINDS = {
  CatalogProduct: "catalogProduct",
  Meter: "meter"
};
var LineItemOrderEntrySchema = oz489.object({
  kind: oz489.enum([LINE_ITEM_ORDER_KINDS.CatalogProduct, LINE_ITEM_ORDER_KINDS.Meter]),
  id: ObjectIdSchema
}).openapi("LineItemOrderEntry");
var LineItemOrderSchema = oz489.array(LineItemOrderEntrySchema);

// src/entities/line-item-promotion/line-item-promotion-input-schema.ts
import { oz as oz506 } from "@vy/utils";

// src/entities/promotion/promotion-model-input-schema.ts
import { oz as oz497 } from "@vy/utils";

// src/entities/promotion/promotion-model-input-schemas/credit-promotion-model-input-schema.ts
import { oz as oz494 } from "@vy/utils";

// src/entities/promotion/promotion-configuration-input-schemas/credit-promotion-configuration-input-schema.ts
import { oz as oz490 } from "@vy/utils";
var CreditPromotionConfigurationInputSchema = oz490.object({
  creditAmount: oz490.number().nonnegative().nullable(),
  recurringAmount: oz490.number({ invalid_type_error: "Recurring discount is required" }).step(1).optional()
}).openapi("CreditPromotionConfigurationInput");

// src/entities/promotion/promotion-configuration-input-schemas/free-trial-promotion-configuration-input-schema.ts
import { oz as oz491 } from "@vy/utils";
var FreeTrialPromotionConfigurationInputSchema = oz491.object({
  daysFree: oz491.number().nonnegative().nullable()
}).openapi("FreeTrialPromotionConfigurationInput");

// src/entities/promotion/promotion-configuration-input-schemas/percentage-configuration-input-schema.ts
import { oz as oz492 } from "@vy/utils";
var PercentagePromotionConfigurationInputSchema = oz492.object({
  percentage: oz492.number().nonnegative().max(100).min(1).nullable(),
  recurringAmount: oz492.number({ invalid_type_error: "Recurring discount is required" }).step(1).optional()
}).openapi("PercentagePromotionConfigurationInput");

// src/entities/promotion/promotion-type-schema.ts
import { oz as oz493 } from "@vy/utils";
var PROMOTION_TYPES = Object.freeze({
  FreeTrial: "FreeTrial",
  Credit: "Credit",
  Fixed: "Fixed",
  Percentage: "Percentage"
});
var PromotionTypeSchema = oz493.nativeEnum(PROMOTION_TYPES).openapi("PromotionType");

// src/entities/promotion/promotion-model-input-schemas/credit-promotion-model-input-schema.ts
var CreditPromotionModelInputSchema = oz494.object({
  promotionType: oz494.literal(PROMOTION_TYPES.Credit),
  promotionConfiguration: CreditPromotionConfigurationInputSchema
}).openapi("CreditPromotionModelInput");

// src/entities/promotion/promotion-model-input-schemas/free-trial-promotion-model-input-schema.ts
import { oz as oz495 } from "@vy/utils";
var FreeTrialPromotionModelInputSchema = oz495.object({
  promotionType: oz495.literal(PROMOTION_TYPES.FreeTrial),
  promotionConfiguration: FreeTrialPromotionConfigurationInputSchema
}).openapi("FreeTrialPromotionModelInput");

// src/entities/promotion/promotion-model-input-schemas/percentage-promotion-model-input-schema.ts
import { oz as oz496 } from "@vy/utils";
var PercentagePromotionModelInputSchema = oz496.object({
  promotionType: oz496.literal(PROMOTION_TYPES.Percentage),
  promotionConfiguration: PercentagePromotionConfigurationInputSchema
}).openapi("PercentagePromotionModelInput");

// src/entities/promotion/promotion-model-input-schema.ts
var PromotionModelInputSchema = oz497.discriminatedUnion("promotionType", [
  CreditPromotionModelInputSchema,
  FreeTrialPromotionModelInputSchema,
  PercentagePromotionModelInputSchema
]).openapi("PromotionModelInput");

// src/entities/line-item-promotion/new-line-item-promotion-schema.ts
import { oz as oz505 } from "@vy/utils";

// src/entities/promotion/promotion-model-schema.ts
import { oz as oz504 } from "@vy/utils";

// src/entities/promotion/promotion-model-schemas/credit-promotion-model-schema.ts
import { oz as oz501 } from "@vy/utils";

// src/entities/promotion/promotion-configuration-schemas/credit-promotion-configuration-schema.ts
import { oz as oz498 } from "@vy/utils";
var CreditPromotionConfigurationSchema = oz498.object({
  creditAmount: oz498.number({ invalid_type_error: "Credit amount is required" }).nonnegative(),
  recurringAmount: oz498.number({ invalid_type_error: "Recurring discount is required" }).step(1).optional()
}).openapi("CreditPromotionConfiguration");

// src/entities/promotion/promotion-configuration-schemas/free-trial-promotion-configuration-schema.ts
import { oz as oz499 } from "@vy/utils";
var FreeTrialPromotionConfigurationSchema = oz499.object({
  daysFree: oz499.number().nonnegative()
}).openapi("FreeTrialPromotionConfiguration");

// src/entities/promotion/promotion-configuration-schemas/percentage-promotion-configuration-schema.ts
import { oz as oz500 } from "@vy/utils";
var PercentagePromotionConfigurationSchema = oz500.object({
  percentage: oz500.number({ invalid_type_error: "Percentage amount is required" }).nonnegative().max(100).min(1),
  recurringAmount: oz500.number({ invalid_type_error: "Recurring discount is required" }).step(1).optional()
}).openapi("PercentagePromotionConfiguration");

// src/entities/promotion/promotion-model-schemas/credit-promotion-model-schema.ts
var CreditPromotionModelSchema = oz501.object({
  promotionType: oz501.literal(PROMOTION_TYPES.Credit),
  promotionConfiguration: CreditPromotionConfigurationSchema
}).openapi("CreditPromotionModel");

// src/entities/promotion/promotion-model-schemas/free-trial-promotion-model-schema.ts
import { oz as oz502 } from "@vy/utils";
var FreeTrialPromotionModelSchema = oz502.object({
  promotionType: oz502.literal(PROMOTION_TYPES.FreeTrial),
  promotionConfiguration: FreeTrialPromotionConfigurationSchema
}).openapi("FreeTrialPromotionModel");

// src/entities/promotion/promotion-model-schemas/percentage-promotion-model.ts
import { oz as oz503 } from "@vy/utils";
var PercentagePromotionModelSchema = oz503.object({
  promotionType: oz503.literal(PROMOTION_TYPES.Percentage),
  promotionConfiguration: PercentagePromotionConfigurationSchema
}).openapi("PercentagePromotionModel");

// src/entities/promotion/promotion-model-schema.ts
var PromotionModelSchema = oz504.discriminatedUnion("promotionType", [
  CreditPromotionModelSchema,
  FreeTrialPromotionModelSchema,
  PercentagePromotionModelSchema
]).openapi("PromotionModel");

// src/entities/line-item-promotion/new-line-item-promotion-schema.ts
var NewLineItemPromotionSchema = oz505.object({
  promotionId: ObjectIdSchema.optional(),
  name: oz505.string(),
  description: oz505.string().optional(),
  promotionModel: PromotionModelSchema,
  deductedAmount: oz505.number()
}).openapi("NewLineItemPromotion");

// src/entities/line-item-promotion/line-item-promotion-input-schema.ts
var LineItemPromotionInputSchema = oz506.object(NewLineItemPromotionSchema.shape).extend({
  promotionModel: PromotionModelInputSchema
}).partial().openapi("LineItemPromotionInput");

// src/entities/line-item-promotion/line-item-promotion-schema.ts
var LineItemPromotionSchema = NewLineItemPromotionSchema.openapi("LineItemPromotion");

// src/entities/measurement/new-measurement-schema.ts
import { oz as oz507 } from "@vy/utils";
var NewMeasurementSchema = oz507.object({
  accountId: ObjectIdSchema,
  period: FullDayPeriodSchema,
  meterId: ObjectIdSchema,
  customerId: ObjectIdSchema,
  value: oz507.number(),
  price: withNullAsOptional(oz507.number()),
  measurementPriceId: withNullAsOptional(ObjectIdSchema),
  instanceKey: oz507.string().optional(),
  measurementTimeSlot: TimeSlotSchema.optional()
});

// src/entities/measurement/measurement-schema.ts
var MeasurementSchema = created(NewMeasurementSchema).openapi("Measurement");

// src/entities/measurement/measurement-input-schema.ts
import { oz as oz508 } from "@vy/utils";
var measurementInputSchema = oz508.object({
  customerNames: oz508.array(oz508.string()),
  file: oz508.any()
}).openapi("MeasurementInput");

// src/entities/measurement/latest-metered-event-updated-at-result-schema.ts
import { oz as oz509 } from "@vy/utils";
var latestMeteredEventUpdatedAtResultSchema = oz509.object({
  latestMeteredEventUpdatedAt: ApiDateSchema
}).openapi("latestMeteredEventUpdatedAtResult");

// src/entities/measurement-price/measurement-price-schema.ts
import { oz as oz510 } from "@vy/utils";
var MeasurementPriceSchema = oz510.object({
  measurementId: ObjectIdSchema,
  price: oz510.number().nonnegative()
});

// src/entities/payments/payment/new-payment-schema.ts
import { oz as oz512 } from "@vy/utils";

// src/entities/payments/external-payment-schema.ts
import { oz as oz511 } from "@vy/utils";
var ExternalPaymentSchema = oz511.object({
  chargeTime: ApiDateSchema.optional(),
  receiptUrl: oz511.string().optional()
}).openapi("ExternalPayment");

// src/entities/payments/payment/new-payment-schema.ts
var NewPaymentSchema = oz512.object({
  accountId: ObjectIdSchema,
  externalId: ObjectIdSchema,
  amount: oz512.number(),
  currency: CurrencySchema,
  paymentMethod: oz512.string().optional(),
  externalPayment: withNullAsOptional(ExternalPaymentSchema),
  status: oz512.string(),
  invoiceId: withNullAsOptional(ObjectIdSchema),
  customerId: ObjectIdSchema
}).openapi("NewPayment");

// src/entities/payments/payment/payment-schema.ts
var PaymentSchema = segregated(NewPaymentSchema).openapi("Payment");

// src/entities/payments/payment/payment-input-schema.ts
import { oz as oz513 } from "@vy/utils";
var PaymentInputSchema = oz513.object(NewPaymentSchema.shape).partial().openapi("PaymentInput");

// src/entities/phase-label/phase-type-schema.ts
import { oz as oz514 } from "@vy/utils";
var PHASE_TYPES = Object.freeze({
  Standard: "Standard",
  RampUp: "RampUp",
  GracePeriod: "GracePeriod",
  FreeTrial: "FreeTrial",
  PriceUpdate: "PriceUpdate",
  Milestone: "Milestone",
  Renewal: "Renewal",
  Upsell: "Upsell",
  AnnualUplift: "AnnualUplift"
});
var PhaseTypeSchema = oz514.nativeEnum(PHASE_TYPES).openapi("PhaseType");

// src/entities/phase-label/phase-label-schema.ts
import { oz as oz515 } from "@vy/utils";
var PhaseLabelSchema = created(
  oz515.object({
    accountId: oz515.string().optional(),
    type: PhaseTypeSchema,
    textLabel: oz515.string(),
    color: oz515.string(),
    backgroundColor: oz515.string()
  })
).openapi("PhaseLabel");

// src/entities/phase-label/new-phase-label-schema.ts
import { oz as oz516 } from "@vy/utils";
var NewPhaseLabelSchema = oz516.object({
  type: PhaseTypeSchema,
  textLabel: oz516.string(),
  color: oz516.string().optional(),
  backgroundColor: oz516.string().optional()
}).openapi("NewPhaseLabel");

// src/entities/price.ts
import { oz as oz517 } from "@vy/utils";
var PriceSchema = oz517.object({
  amount: oz517.number(),
  currency: CurrencySchema
});

// src/entities/product-period/new-product-period-schema.ts
import { oz as oz518 } from "@vy/utils";
var NewProductPeriodSchema = oz518.object({
  accountingPeriod: PeriodSchema,
  pricingAggregationPeriod: PeriodSchema,
  productId: oz518.string(),
  invoicingDate: ApiDateSchema
});

// src/entities/product-period/product-period-schema.ts
var ProductPeriodSchema = created(NewProductPeriodSchema);

// src/entities/product-usage-breakdown/customer-usage-breakdown-schema.ts
import { oz as oz519 } from "@vy/utils";
var CustomerUsageBreakdownSchema = oz519.object({
  customerId: oz519.string(),
  customerName: oz519.string(),
  units: oz519.number(),
  price: oz519.number().optional()
});

// src/entities/product-usage-breakdown/product-usage-by-date-breakdown-schema.ts
import { oz as oz520 } from "@vy/utils";
var UsageByDateBreakdownSchema = oz520.object({
  date: ApiDateSchema,
  units: oz520.number(),
  price: oz520.number().optional(),
  customerUsage: CustomerUsageBreakdownSchema.array()
});

// src/entities/promotion/new-promotion-schema.ts
import { oz as oz521 } from "@vy/utils";
var NewPromotionSchema = oz521.object({
  name: oz521.string().nonempty("Name is required"),
  description: withNullAsOptional(oz521.string().nonempty()),
  promotionModel: PromotionModelSchema
}).openapi("NewPromotion");

// src/entities/promotion/promotion-schema.ts
var PromotionSchema = created(NewPromotionSchema).openapi("Promotion");

// src/entities/promotion/promotion-input-schema.ts
import { oz as oz522 } from "@vy/utils";
var PromotionInputSchema = oz522.object(NewPromotionSchema.shape).partial().extend({
  id: ObjectIdSchema,
  promotionModel: PromotionModelInputSchema
}).openapi("PromotionInput");

// src/entities/promotion/promotion-configuration-schema.ts
import { oz as oz523 } from "@vy/utils";
var PromotionConfigurationSchema = oz523.union([
  CreditPromotionConfigurationSchema,
  FreeTrialPromotionConfigurationSchema,
  PercentagePromotionConfigurationSchema
]);

// src/entities/promotion/promotion-configuration-input-schema.ts
import { oz as oz524 } from "@vy/utils";
var PromotionConfigurationInputSchema = oz524.union([
  CreditPromotionConfigurationInputSchema,
  FreeTrialPromotionConfigurationInputSchema,
  PercentagePromotionConfigurationInputSchema
]);

// src/entities/rbac/permissions/permission-schema.ts
import { oz as oz525 } from "@vy/utils";

// src/entities/rbac/permissions/entities-permissions/invoices-permissions.ts
var INVOICES_PERMISSIONS = Object.freeze({
  INVOICE_FULL_ACCESS: "INVOICE:FULL_ACCESS",
  INVOICE_CREATE: "INVOICE:CREATE",
  INVOICE_READ: "INVOICE:READ",
  INVOICE_UPDATE: "INVOICE:UPDATE",
  INVOICE_DELETE: "INVOICE:DELETE",
  INVOICE_APPROVE: "INVOICE:APPROVE"
});

// src/entities/rbac/permissions/entities-permissions/customers-permissions.ts
var CUSTOMERS_PERMISSIONS = Object.freeze({
  CUSTOMER_FULL_ACCESS: "CUSTOMER:FULL_ACCESS",
  CUSTOMER_CREATE: "CUSTOMER:CREATE",
  CUSTOMER_READ: "CUSTOMER:READ",
  CUSTOMER_UPDATE: "CUSTOMER:UPDATE",
  CUSTOMER_DELETE: "CUSTOMER:DELETE"
});

// src/entities/rbac/permissions/entities-permissions/plans-permissions.ts
var PLANS_PERMISSIONS = Object.freeze({
  PLAN_FULL_ACCESS: "PLAN:FULL_ACCESS",
  PLAN_CREATE: "PLAN:CREATE",
  PLAN_READ: "PLAN:READ",
  PLAN_UPDATE: "PLAN:UPDATE",
  PLAN_DELETE: "PLAN:DELETE"
});

// src/entities/rbac/permissions/entities-permissions/meters-permissions.ts
var METERS_PERMISSIONS = Object.freeze({
  METER_FULL_ACCESS: "METER:FULL_ACCESS",
  METER_CREATE: "METER:CREATE",
  METER_READ: "METER:READ",
  METER_UPDATE: "METER:UPDATE",
  METER_DELETE: "METER:DELETE"
});

// src/entities/rbac/permissions/entities-permissions/users-permissions.ts
var USERS_PERMISSIONS = Object.freeze({
  USER_FULL_ACCESS: "USER:FULL_ACCESS",
  USER_INVITE: "USER:INVITE",
  USER_READ: "USER:READ",
  USER_UPDATE: "USER:UPDATE",
  USER_DELETE: "USER:DELETE"
});

// src/entities/rbac/permissions/entities-permissions/accounts-permissions.ts
var ACCOUNTS_PERMISSIONS = Object.freeze({
  ACCOUNT_CONFIGURE: "ACCOUNT:CONFIGURE"
});

// src/entities/rbac/permissions/entities-permissions/events-permissions.ts
var EVENTS_PERMISSIONS = Object.freeze({
  EVENT_READ: "EVENT:READ"
});

// src/entities/rbac/permissions/entities-permissions/products-permissions.ts
var PRODUCTS_PERMISSIONS = Object.freeze({
  PRODUCT_FULL_ACCESS: "PRODUCT:FULL_ACCESS",
  PRODUCT_CREATE: "PRODUCT:CREATE",
  PRODUCT_READ: "PRODUCT:READ",
  PRODUCT_UPDATE: "PRODUCT:UPDATE",
  PRODUCT_DELETE: "PRODUCT:DELETE"
});

// src/entities/rbac/permissions/entities-permissions/integrations-permissions.ts
var INTEGRATIONS_PERMISSIONS = Object.freeze({
  INTEGRATION_FULL_ACCESS: "INTEGRATION:FULL_ACCESS",
  INTEGRATION_CREATE: "INTEGRATION:CREATE",
  INTEGRATION_READ: "INTEGRATION:READ",
  INTEGRATION_UPDATE: "INTEGRATION:UPDATE",
  INTEGRATION_DELETE: "INTEGRATION:DELETE"
});

// src/entities/rbac/permissions/entities-permissions/reports-permissions.ts
var REPORTS_PERMISSIONS = Object.freeze({
  REPORT_FULL_ACCESS: "REPORT:FULL_ACCESS",
  REPORT_CREATE: "REPORT:CREATE",
  REPORT_READ: "REPORT:READ",
  REPORT_UPDATE: "REPORT:UPDATE",
  REPORT_DELETE: "REPORT:DELETE"
});

// src/entities/rbac/permissions/entities-permissions/measurements-permissions.ts
var MEASUREMENTS_PERMISSIONS = Object.freeze({
  MEASUREMENTS_FULL_ACCESS: "MEASUREMENTS:FULL_ACCESS",
  MEASUREMENT_READ: "MEASUREMENT:READ",
  MEASUREMENT_CREATE: "MEASUREMENT:CREATE"
});

// src/entities/rbac/permissions/entities-permissions/labels-permissions.ts
var LABELS_PERMISSIONS = Object.freeze({
  LABELS_READ: "LABELS:READ",
  LABELS_WRITE: "LABELS:WRITE",
  LABELS_FULL_ACCESS: "LABELS:FULL_ACCESS"
});

// src/entities/rbac/permissions/entities-permissions/phase-labels-permissions.ts
var PHASE_LABELS_PERMISSIONS = Object.freeze({
  PHASE_LABELS_READ: "PHASE_LABELS:READ",
  PHASE_LABELS_WRITE: "PHASE_LABELS:WRITE",
  PHASE_LABELS_FULL_ACCESS: "PHASE_LABELS:FULL_ACCESS"
});

// src/entities/rbac/permissions/entities-permissions/revenue-permissions.ts
var REVENUE_PERMISSIONS = Object.freeze({
  REVENUE_FULL_ACCESS: "REVENUE:FULL_ACCESS",
  REVENUE_READ: "REVENUE:READ"
});

// src/entities/rbac/permissions/entities-permissions/credits-permissions.ts
var CREDIT_LEDGER_PERMISSIONS = Object.freeze({
  CREDIT_LEDGER_FULL_ACCESS: "CREDIT_LEDGER:FULL_ACCESS",
  CREDIT_LEDGER_CREATE: "CREDIT_LEDGER:CREATE",
  CREDIT_LEDGER_READ: "CREDIT_LEDGER:READ",
  CREDIT_LEDGER_UPDATE: "CREDIT_LEDGER:UPDATE",
  CREDIT_LEDGER_DELETE: "CREDIT_LEDGER:DELETE"
});

// src/entities/rbac/permissions/entities-permissions/pricing-permissions.ts
var PRICING_PERMISSIONS = Object.freeze({
  PRICING_READ: "PRICING:READ",
  PRICING_FULL_ACCESS: "PRICING:FULL_ACCESS"
});

// src/entities/rbac/permissions/entities-permissions/catalog-products-permissions.ts
var CATALOG_PRODUCTS_PERMISSIONS = Object.freeze({
  CATALOG_PRODUCTS_FULL_ACCESS: "CATALOG_PRODUCTS:FULL_ACCESS",
  CATALOG_PRODUCTS_READ: "CATALOG_PRODUCTS:READ",
  CATALOG_PRODUCTS_CREATE: "CATALOG_PRODUCTS:CREATE",
  CATALOG_PRODUCTS_UPDATE: "CATALOG_PRODUCTS:UPDATE",
  CATALOG_PRODUCTS_DELETE: "CATALOG_PRODUCTS:DELETE"
});

// src/entities/rbac/permissions/entities-permissions/jobs-permissions.ts
var JOBS_PERMISSIONS = Object.freeze({
  JOB_FULL_ACCESS: "JOB:FULL_ACCESS",
  JOB_READ: "JOB:READ"
});

// src/entities/rbac/permissions/entities-permissions/public-api-keys-permissions.ts
var PUBLIC_API_KEYS_PERMISSIONS = Object.freeze({
  PUBLIC_API_KEY_FULL_ACCESS: "PUBLIC_API_KEY:FULL_ACCESS",
  PUBLIC_API_KEY_CREATE: "PUBLIC_API_KEY:CREATE",
  PUBLIC_API_KEY_READ: "PUBLIC_API_KEY:READ",
  PUBLIC_API_KEY_DELETE: "PUBLIC_API_KEY:DELETE",
  PUBLIC_API_KEY_REVOKE: "PUBLIC_API_KEY:REVOKE"
});

// src/entities/rbac/permissions/entities-permissions/webhook-subscriptions-permissions.ts
var WEBHOOK_SUBSCRIPTIONS_PERMISSIONS = Object.freeze({
  WEBHOOK_SUBSCRIPTION_FULL_ACCESS: "WEBHOOK_SUBSCRIPTION:FULL_ACCESS",
  WEBHOOK_SUBSCRIPTION_CREATE: "WEBHOOK_SUBSCRIPTION:CREATE",
  WEBHOOK_SUBSCRIPTION_READ: "WEBHOOK_SUBSCRIPTION:READ",
  WEBHOOK_SUBSCRIPTION_DELETE: "WEBHOOK_SUBSCRIPTION:DELETE"
});

// src/entities/rbac/permissions/entities-permissions/workflows-permissions.ts
var WORKFLOWS_PERMISSIONS = Object.freeze({
  WORKFLOWS_READ: "WORKFLOWS:READ",
  WORKFLOWS_WRITE: "WORKFLOWS:WRITE",
  WORKFLOWS_FULL_ACCESS: "WORKFLOWS:FULL_ACCESS"
});

// src/entities/rbac/permissions/permission-schema.ts
var PERMISSIONS = Object.freeze({
  ...INVOICES_PERMISSIONS,
  ...LABELS_PERMISSIONS,
  ...CUSTOMERS_PERMISSIONS,
  ...PLANS_PERMISSIONS,
  ...METERS_PERMISSIONS,
  ...USERS_PERMISSIONS,
  ...ACCOUNTS_PERMISSIONS,
  ...EVENTS_PERMISSIONS,
  ...PRODUCTS_PERMISSIONS,
  ...INTEGRATIONS_PERMISSIONS,
  ...REPORTS_PERMISSIONS,
  ...MEASUREMENTS_PERMISSIONS,
  ...PHASE_LABELS_PERMISSIONS,
  ...REVENUE_PERMISSIONS,
  ...CREDIT_LEDGER_PERMISSIONS,
  ...PRICING_PERMISSIONS,
  ...CATALOG_PRODUCTS_PERMISSIONS,
  ...JOBS_PERMISSIONS,
  ...PUBLIC_API_KEYS_PERMISSIONS,
  ...WEBHOOK_SUBSCRIPTIONS_PERMISSIONS,
  ...WORKFLOWS_PERMISSIONS
});
var PermissionSchema = oz525.nativeEnum(PERMISSIONS).openapi("Permission");

// src/entities/rbac/permissions/permissions-groups.ts
var MASTER_PERMISSIONS = [
  PERMISSIONS.INVOICE_FULL_ACCESS,
  PERMISSIONS.CUSTOMER_FULL_ACCESS,
  PERMISSIONS.PLAN_FULL_ACCESS,
  PERMISSIONS.METER_FULL_ACCESS,
  PERMISSIONS.USER_FULL_ACCESS,
  PERMISSIONS.PRODUCT_FULL_ACCESS,
  PERMISSIONS.INTEGRATION_FULL_ACCESS,
  PERMISSIONS.REPORT_FULL_ACCESS,
  PERMISSIONS.MEASUREMENTS_FULL_ACCESS,
  PERMISSIONS.REVENUE_FULL_ACCESS,
  PERMISSIONS.CREDIT_LEDGER_FULL_ACCESS,
  PERMISSIONS.PHASE_LABELS_FULL_ACCESS,
  PERMISSIONS.LABELS_FULL_ACCESS,
  PERMISSIONS.PRICING_FULL_ACCESS,
  PERMISSIONS.CATALOG_PRODUCTS_FULL_ACCESS,
  PERMISSIONS.PUBLIC_API_KEY_FULL_ACCESS,
  PERMISSIONS.WEBHOOK_SUBSCRIPTION_FULL_ACCESS,
  PERMISSIONS.WORKFLOWS_FULL_ACCESS
];
var PERMISSIONS_GROUPS = {
  [PERMISSIONS.INVOICE_FULL_ACCESS]: [
    PERMISSIONS.INVOICE_CREATE,
    PERMISSIONS.INVOICE_READ,
    PERMISSIONS.INVOICE_UPDATE,
    PERMISSIONS.INVOICE_DELETE,
    PERMISSIONS.INVOICE_APPROVE
  ],
  [PERMISSIONS.CUSTOMER_FULL_ACCESS]: [
    PERMISSIONS.CUSTOMER_CREATE,
    PERMISSIONS.CUSTOMER_READ,
    PERMISSIONS.CUSTOMER_UPDATE,
    PERMISSIONS.CUSTOMER_DELETE
  ],
  [PERMISSIONS.PLAN_FULL_ACCESS]: [
    PERMISSIONS.PLAN_CREATE,
    PERMISSIONS.PLAN_READ,
    PERMISSIONS.PLAN_UPDATE,
    PERMISSIONS.PLAN_DELETE
  ],
  [PERMISSIONS.METER_FULL_ACCESS]: [
    PERMISSIONS.METER_CREATE,
    PERMISSIONS.METER_READ,
    PERMISSIONS.METER_UPDATE,
    PERMISSIONS.METER_DELETE
  ],
  [PERMISSIONS.USER_FULL_ACCESS]: [
    PERMISSIONS.USER_READ,
    PERMISSIONS.USER_UPDATE,
    PERMISSIONS.USER_DELETE,
    PERMISSIONS.USER_INVITE
  ],
  [PERMISSIONS.PRODUCT_FULL_ACCESS]: [
    PERMISSIONS.PRODUCT_CREATE,
    PERMISSIONS.PRODUCT_READ,
    PERMISSIONS.PRODUCT_UPDATE,
    PERMISSIONS.PRODUCT_DELETE
  ],
  [PERMISSIONS.INTEGRATION_FULL_ACCESS]: [
    PERMISSIONS.INTEGRATION_CREATE,
    PERMISSIONS.INTEGRATION_READ,
    PERMISSIONS.INTEGRATION_UPDATE,
    PERMISSIONS.INTEGRATION_DELETE
  ],
  [PERMISSIONS.REPORT_FULL_ACCESS]: [
    PERMISSIONS.REPORT_CREATE,
    PERMISSIONS.REPORT_READ,
    PERMISSIONS.REPORT_UPDATE,
    PERMISSIONS.REPORT_DELETE
  ],
  [PERMISSIONS.MEASUREMENTS_FULL_ACCESS]: [PERMISSIONS.MEASUREMENT_CREATE, PERMISSIONS.MEASUREMENT_READ],
  [PERMISSIONS.REVENUE_FULL_ACCESS]: [PERMISSIONS.REVENUE_READ],
  [PERMISSIONS.CREDIT_LEDGER_FULL_ACCESS]: [
    PERMISSIONS.CREDIT_LEDGER_CREATE,
    PERMISSIONS.CREDIT_LEDGER_READ,
    PERMISSIONS.CREDIT_LEDGER_UPDATE,
    PERMISSIONS.CREDIT_LEDGER_DELETE
  ],
  [PERMISSIONS.PHASE_LABELS_FULL_ACCESS]: [PERMISSIONS.PHASE_LABELS_READ, PERMISSIONS.PHASE_LABELS_WRITE],
  [PERMISSIONS.LABELS_FULL_ACCESS]: [PERMISSIONS.LABELS_READ, PERMISSIONS.LABELS_WRITE],
  [PERMISSIONS.PRICING_FULL_ACCESS]: [PERMISSIONS.PRICING_READ],
  [PERMISSIONS.CATALOG_PRODUCTS_FULL_ACCESS]: [
    PERMISSIONS.CATALOG_PRODUCTS_READ,
    PERMISSIONS.CATALOG_PRODUCTS_CREATE,
    PERMISSIONS.CATALOG_PRODUCTS_UPDATE,
    PERMISSIONS.CATALOG_PRODUCTS_DELETE
  ],
  [PERMISSIONS.PUBLIC_API_KEY_FULL_ACCESS]: [
    PERMISSIONS.PUBLIC_API_KEY_CREATE,
    PERMISSIONS.PUBLIC_API_KEY_READ,
    PERMISSIONS.PUBLIC_API_KEY_DELETE,
    PERMISSIONS.PUBLIC_API_KEY_REVOKE
  ],
  [PERMISSIONS.WEBHOOK_SUBSCRIPTION_FULL_ACCESS]: [
    PERMISSIONS.WEBHOOK_SUBSCRIPTION_CREATE,
    PERMISSIONS.WEBHOOK_SUBSCRIPTION_READ,
    PERMISSIONS.WEBHOOK_SUBSCRIPTION_DELETE
  ],
  [PERMISSIONS.WORKFLOWS_FULL_ACCESS]: [PERMISSIONS.WORKFLOWS_READ, PERMISSIONS.WORKFLOWS_WRITE]
};

// src/entities/rbac/roles/roles-schema.ts
import { oz as oz526 } from "@vy/utils";
var ROLES = Object.freeze({
  Admin: "Admin",
  Controller: "Controller",
  Developer: "Developer",
  Viewer: "Viewer"
});
var RolesSchema = oz526.nativeEnum(ROLES).openapi("Role");

// src/entities/rbac/roles/roles-permissions.ts
var ROLES_PERMISSIONS = Object.freeze({
  [ROLES.Admin]: [
    PERMISSIONS.INVOICE_FULL_ACCESS,
    PERMISSIONS.CUSTOMER_FULL_ACCESS,
    PERMISSIONS.METER_FULL_ACCESS,
    PERMISSIONS.PLAN_FULL_ACCESS,
    PERMISSIONS.PRODUCT_FULL_ACCESS,
    PERMISSIONS.REPORT_FULL_ACCESS,
    PERMISSIONS.INTEGRATION_FULL_ACCESS,
    PERMISSIONS.MEASUREMENTS_FULL_ACCESS,
    PERMISSIONS.USER_FULL_ACCESS,
    PERMISSIONS.ACCOUNT_CONFIGURE,
    PERMISSIONS.EVENT_READ,
    PERMISSIONS.REVENUE_FULL_ACCESS,
    PERMISSIONS.CREDIT_LEDGER_FULL_ACCESS,
    PERMISSIONS.PHASE_LABELS_FULL_ACCESS,
    PERMISSIONS.LABELS_FULL_ACCESS,
    PERMISSIONS.PRICING_FULL_ACCESS,
    PERMISSIONS.CATALOG_PRODUCTS_FULL_ACCESS,
    PERMISSIONS.JOB_FULL_ACCESS,
    PERMISSIONS.PUBLIC_API_KEY_FULL_ACCESS,
    PERMISSIONS.WEBHOOK_SUBSCRIPTION_FULL_ACCESS
  ],
  [ROLES.Controller]: [
    PERMISSIONS.INVOICE_FULL_ACCESS,
    PERMISSIONS.CUSTOMER_FULL_ACCESS,
    PERMISSIONS.METER_FULL_ACCESS,
    PERMISSIONS.PLAN_FULL_ACCESS,
    PERMISSIONS.PRODUCT_FULL_ACCESS,
    PERMISSIONS.REPORT_FULL_ACCESS,
    PERMISSIONS.INTEGRATION_CREATE,
    PERMISSIONS.MEASUREMENTS_FULL_ACCESS,
    PERMISSIONS.ACCOUNT_CONFIGURE,
    PERMISSIONS.EVENT_READ,
    PERMISSIONS.USER_READ,
    PERMISSIONS.REVENUE_FULL_ACCESS,
    PERMISSIONS.CREDIT_LEDGER_FULL_ACCESS,
    PERMISSIONS.PHASE_LABELS_FULL_ACCESS,
    PERMISSIONS.LABELS_FULL_ACCESS,
    PERMISSIONS.PRICING_FULL_ACCESS,
    PERMISSIONS.CATALOG_PRODUCTS_FULL_ACCESS,
    PERMISSIONS.JOB_FULL_ACCESS
  ],
  [ROLES.Developer]: [
    PERMISSIONS.EVENT_READ,
    PERMISSIONS.MEASUREMENTS_FULL_ACCESS,
    PERMISSIONS.METER_FULL_ACCESS,
    PERMISSIONS.PRODUCT_FULL_ACCESS,
    PERMISSIONS.INTEGRATION_READ,
    PERMISSIONS.PHASE_LABELS_READ,
    PERMISSIONS.LABELS_READ,
    PERMISSIONS.PRICING_READ,
    PERMISSIONS.JOB_FULL_ACCESS,
    PERMISSIONS.PUBLIC_API_KEY_FULL_ACCESS,
    PERMISSIONS.WEBHOOK_SUBSCRIPTION_FULL_ACCESS
  ],
  [ROLES.Viewer]: [
    PERMISSIONS.INVOICE_READ,
    PERMISSIONS.CUSTOMER_READ,
    PERMISSIONS.PLAN_READ,
    PERMISSIONS.PRODUCT_READ,
    PERMISSIONS.REPORT_READ,
    PERMISSIONS.MEASUREMENT_READ,
    PERMISSIONS.USER_READ,
    PERMISSIONS.EVENT_READ,
    PERMISSIONS.REVENUE_READ,
    PERMISSIONS.CREDIT_LEDGER_READ,
    PERMISSIONS.PHASE_LABELS_READ,
    PERMISSIONS.LABELS_READ,
    PERMISSIONS.PRICING_READ,
    PERMISSIONS.CATALOG_PRODUCTS_READ
  ]
});

// src/entities/report-job/report-job-statuses-schema.ts
import { oz as oz527 } from "@vy/utils";
var REPORT_JOB_STATUSES = Object.freeze({
  Pending: "Pending",
  Cancelled: "Cancelled",
  Completed: "Completed",
  Failed: "Failed"
});
var ReportJobStatusesSchema = oz527.nativeEnum(REPORT_JOB_STATUSES);

// src/entities/report-job/report-job-types-schema.ts
import { oz as oz528 } from "@vy/utils";
var REPORT_JOB_TYPES = Object.freeze({
  CommitmentUsage: "CommitmentUsage",
  UnchargedUsage: "UnchargedUsage",
  ProductsUsage: "ProductsUsage",
  CustomerRevenue: "CustomerRevenue",
  Contracts: "Contracts",
  AnonymousCustomers: "AnonymousCustomers",
  MonthlyClosure: "MonthlyClosure",
  Customers: "Customers",
  UpcomingInvoices: "UpcomingInvoices",
  UnapprovedInvoices: "UnapprovedInvoices",
  FailedInvoiceDeliveries: "FailedInvoiceDeliveries",
  Usage: "Usage",
  RecurringRevenue: "RecurringRevenue"
});
var ReportJobTypesSchema = oz528.nativeEnum(REPORT_JOB_TYPES);

// src/entities/report-job/report-job-invocation-types-schema.ts
import { oz as oz529 } from "@vy/utils";
var REPORT_JOB_INVOCATION_TYPES = Object.freeze({
  Scheduled: "Scheduled",
  Manual: "Manual"
});
var ReportJobInvocationTypesSchema = oz529.nativeEnum(REPORT_JOB_INVOCATION_TYPES);

// src/entities/reports/commitment-usage/commitment-usage-report-schema.ts
import { oz as oz531 } from "@vy/utils";

// src/entities/reports/commitment-usage/commitment-usage-report-item-schema.ts
import { oz as oz530 } from "@vy/utils";
var CommitmentUsageReportItemSchema = oz530.object({
  contractStatus: ContractStatusSchema,
  customerName: oz530.string(),
  startDate: ApiDateSchema,
  endDate: ApiDateSchema,
  contractName: oz530.string().optional(),
  contractStartDate: ApiDateSchema,
  contractEndDate: ApiDateSchema.optional(),
  daysToContractEnd: oz530.number().optional(),
  productVariantName: oz530.string(),
  commitmentConsumptionCurrencyAmount: oz530.number(),
  commitmentConsumptionUnitsAmount: oz530.number(),
  commitmentConsumptionPercentage: oz530.number(),
  totalCommitmentCurrencyAmount: oz530.number(),
  totalCommitmentUnitsAmount: oz530.number(),
  commercialTermsAmount: oz530.number().optional(),
  erpId: oz530.string().optional(),
  currency: CurrencySchema
}).openapi("GetCommitmentUsageReportItemResponseSchema");

// src/entities/reports/commitment-usage/commitment-usage-report-schema.ts
var CommitmentUsageReportSchema = oz531.array(CommitmentUsageReportItemSchema).openapi("GetCommitmentReportResponseSchema");

// src/entities/reports/report-data-schema.ts
import { oz as oz532 } from "@vy/utils";
var ReportDataSchema = oz532.object({
  id: ObjectIdSchema,
  status: ReportJobStatusesSchema,
  reportName: oz532.string().optional(),
  type: ReportJobTypesSchema,
  invocationType: ReportJobInvocationTypesSchema,
  createdAt: ApiDateSchema
});

// src/entities/reports/uncharged-usage/uncharged-usage-report-schema.ts
import { oz as oz533 } from "@vy/utils";
var UNCHARGED_USAGE_REASON = Object.freeze({
  NO_ACTIVE_CONTRACT: "No active contract",
  NO_CONTRACT: "No contract",
  NO_METER: "No meter"
});
var UnchargedUsageReportSchema = oz533.array(
  oz533.object({
    measurementId: oz533.string(),
    customerId: oz533.string(),
    meterId: oz533.string(),
    contractId: oz533.string().optional(),
    meterName: oz533.string(),
    customerName: oz533.string(),
    period: oz533.object({
      startTime: ApiDateSchema,
      endTime: ApiDateSchema
    }),
    value: oz533.number(),
    reason: oz533.nativeEnum(UNCHARGED_USAGE_REASON)
  })
).openapi("UnchargedUsageReportResponseSchema");

// src/entities/reports/ingestion-customer-schema.ts
import { oz as oz534 } from "@vy/utils";
var IngestionCustomerSchema = oz534.object({
  customerId: ObjectIdSchema,
  customerName: oz534.string().min(1),
  createdAt: ApiDateSchema
});

// src/entities/reports/product-usage/products-usage-report-schema.ts
import { oz as oz536 } from "@vy/utils";

// src/entities/reports/product-usage/product-usage-report-schema.ts
import { oz as oz535 } from "@vy/utils";
var ProductUsageReportSchema = CommitmentUsageReportItemSchema.extend({
  usageConsumptionCurrencyAmount: oz535.number().optional(),
  usageConsumptionUnitsAmount: oz535.number().optional(),
  commitmentConsumptionPercentage: oz535.number().optional(),
  totalCommitmentCurrencyAmount: oz535.number().optional(),
  totalCommitmentUnitsAmount: oz535.number().optional()
}).omit({
  commitmentConsumptionCurrencyAmount: true,
  commitmentConsumptionUnitsAmount: true
});

// src/entities/reports/product-usage/products-usage-report-schema.ts
var ProductsUsageReportSchema = oz536.array(ProductUsageReportSchema);

// src/entities/reports/customer-revenue/customer-revenue-report-item-schema.ts
import { oz as oz543 } from "@vy/utils";

// src/entities/revisioned-line-item/new-revision-line-item-schema.ts
import { oz as oz538 } from "@vy/utils";

// src/entities/revisioned-line-item/revisioned-line-item-type-schema.ts
import { oz as oz537 } from "@vy/utils";
var REVISIONED_LINE_ITEM_TYPES = Object.freeze({
  Fixed: "Fixed",
  Usage: "Usage",
  FixedPromotion: "FixedPromotion",
  PercentagePromotion: "PercentagePromotion"
});
var RevisionedLineItemTypeSchema = oz537.nativeEnum(REVISIONED_LINE_ITEM_TYPES).openapi("RevisionedLineItemType");

// src/entities/revisioned-line-item/new-revision-line-item-schema.ts
var NewRevisionedLineItemSchema = oz538.object({
  type: RevisionedLineItemTypeSchema,
  name: oz538.string(),
  description: oz538.string().nonempty().optional(),
  price: oz538.number().optional(),
  baseLineItemId: ObjectIdSchema.optional(),
  invoiceId: ObjectIdSchema,
  percentage: oz538.number().nonnegative().optional()
}).openapi("NewRevisionedLineItem");
var percentagePromotionLineItemSchema = NewRevisionedLineItemSchema.extend({
  type: oz538.literal(REVISIONED_LINE_ITEM_TYPES.PercentagePromotion),
  percentage: oz538.number().nonnegative()
}).openapi("NewPercentagePromotionRevisionedLineItem");
var fixedRevisionedLineItemSchema = NewRevisionedLineItemSchema.extend({
  type: oz538.union([
    oz538.literal(REVISIONED_LINE_ITEM_TYPES.Fixed),
    oz538.literal(REVISIONED_LINE_ITEM_TYPES.Usage),
    oz538.literal(REVISIONED_LINE_ITEM_TYPES.FixedPromotion)
  ]),
  price: oz538.number().nonnegative()
}).openapi("FixedNewRevisionLineItem");

// src/entities/revisioned-line-item/revisioned-line-item-schema.ts
import { oz as oz539 } from "@vy/utils";
var RevisionedLineItemSchema = created(NewRevisionedLineItemSchema).extend({
  price: oz539.number()
}).openapi("RevisionedLineItem");

// src/entities/reports/customer-revenue/revenue-recognition-type.ts
var REVENUE_RECOGNITION_TYPE = {
  PointInTime: "PointInTime",
  Milestones: "Milestones",
  StraightLine: "StraightLine",
  UsageBased: "UsageBased"
};

// src/entities/reports/customer-revenue/yearly-revenue-schema.ts
import { oz as oz542 } from "@vy/utils";

// src/entities/reports/customer-revenue/revenue-per-month-schema.ts
import { oz as oz541 } from "@vy/utils";

// src/entities/reports/customer-revenue/revenue-per-month-breakdown.ts
import { oz as oz540 } from "@vy/utils";
var RevenuePerMonthBreakdownSchema = oz540.object({
  scheduledCharge: oz540.number(),
  revenue: oz540.number(),
  deferredRevenue: oz540.number(),
  unbilledRevenue: oz540.number()
});

// src/entities/reports/customer-revenue/revenue-per-month-schema.ts
var RevenuePerMonthSchema = oz541.record(MonthsSchema, RevenuePerMonthBreakdownSchema.optional());

// src/entities/reports/customer-revenue/yearly-revenue-schema.ts
var YearlyRevenueSchema = oz542.record(oz542.string().or(oz542.number()), RevenuePerMonthSchema);

// src/entities/reports/customer-revenue/customer-revenue-report-item-schema.ts
var ReportLabelSchema = oz543.object({
  id: oz543.string(),
  name: oz543.string(),
  color: oz543.string(),
  backgroundColor: oz543.string()
});
var RevenueRecognitionRecordSchema = oz543.object({
  date: oz543.string(),
  value: oz543.number()
});
var CustomerRevenueReportItemSchema = oz543.object({
  productId: oz543.string().optional(),
  variantId: oz543.string().optional(),
  customer: oz543.object({
    id: oz543.string(),
    name: oz543.string(),
    currency: CurrencySchema,
    source: CustomerSourcesSchema.optional(),
    country: oz543.string().nullable().optional(),
    state: oz543.string().nullable().optional(),
    labels: oz543.array(ReportLabelSchema).optional()
  }),
  contract: ContractSchema.pick({
    id: true,
    startDate: true,
    endDate: true
  }).extend({
    status: ContractStatusSchema.optional(),
    renewedContractId: oz543.string().optional()
  }).partial({ startDate: true, endDate: true }).optional(),
  product: oz543.object({
    id: oz543.string(),
    name: oz543.string().nullable()
  }).optional(),
  variant: oz543.object({
    id: oz543.string(),
    name: oz543.string().nullable(),
    // TODO: tighten to PricingModelSchema / ProductTypeSchema once DB Prisma enums (e.g. CreditMetered) are reconciled with @vy/types.
    pricingModel: oz543.string().nullable().optional(),
    productType: oz543.string().nullable().optional()
  }).optional(),
  productVariant: oz543.object({
    id: oz543.string(),
    name: oz543.string(),
    pricing: PricingSchema
  }).optional(),
  revisionedLineItem: oz543.object({
    price: oz543.number(),
    type: RevisionedLineItemTypeSchema,
    name: oz543.string()
  }).optional(),
  invoices: oz543.array(
    oz543.object({
      id: oz543.string(),
      period: PeriodSchema,
      amount: oz543.number().optional(),
      currency: CurrencySchema.optional()
    })
  ).optional(),
  invoiceId: oz543.string().optional(),
  planName: oz543.string().optional(),
  catalogProducts: oz543.array(
    oz543.object({
      id: oz543.string(),
      name: oz543.string()
    })
  ).optional(),
  meterIds: oz543.array(oz543.string()).optional(),
  yearlyRevenue: YearlyRevenueSchema,
  billed: oz543.array(RevenueRecognitionRecordSchema).optional(),
  revenue: oz543.array(RevenueRecognitionRecordSchema).optional(),
  recognitionTypeOverride: oz543.enum([
    REVENUE_RECOGNITION_TYPE.PointInTime,
    REVENUE_RECOGNITION_TYPE.Milestones,
    REVENUE_RECOGNITION_TYPE.StraightLine
  ]).nullable().optional(),
  totalRevenue: oz543.number().optional(),
  totalBilled: oz543.number().optional(),
  totalDeferred: oz543.number().optional(),
  totalUnbilled: oz543.number().optional(),
  totalRecognized: oz543.number().optional(),
  totalRemaining: oz543.number().optional(),
  invoiceCount: oz543.number().optional(),
  contractDurationMonths: oz543.number().optional(),
  isOverridden: oz543.boolean().optional()
});

// src/entities/reports/customer-revenue/customer-revenue-report-schema.ts
import { oz as oz544 } from "@vy/utils";
var WaterfallTotalsBreakdownSchema = oz544.object({
  newDeferredRev: oz544.number(),
  recognizedRevenueDeferred: oz544.number(),
  endingDeferredBalance: oz544.number(),
  newUnbilledAR: oz544.number(),
  recognizedRevenueUnbilled: oz544.number(),
  endingUnbilledAR: oz544.number()
});
var CustomerRevenueReportTotalsSchema = oz544.record(
  oz544.string().or(oz544.number()),
  oz544.record(MonthsSchema, WaterfallTotalsBreakdownSchema.optional())
);
var CustomerRevenueReportSchema = oz544.object({
  accountId: oz544.string(),
  reportItems: CustomerRevenueReportItemSchema.array(),
  reportPeriod: PeriodSchema.optional(),
  totalRevenue: oz544.number().optional(),
  totalBilled: oz544.number().optional(),
  totalDeferred: oz544.number().optional(),
  totalUnbilled: oz544.number().optional(),
  customerCount: oz544.number().optional(),
  reportGeneratedAt: oz544.coerce.date().optional(),
  totals: CustomerRevenueReportTotalsSchema.optional()
});

// src/entities/reports/journal-entries/journal-entry-schema.ts
import { oz as oz545 } from "@vy/utils";
var JournalEntryAccountSchema = oz545.enum(["AR", "Revenue", "DeferredRevenue", "UnbilledRevenue"]);
var JournalEntryStatusSchema = oz545.enum(["draft", "posted", "synced"]);
var JournalEntryLineSchema = oz545.object({
  account: JournalEntryAccountSchema,
  customerId: oz545.string(),
  customerName: oz545.string(),
  productId: oz545.string(),
  productName: oz545.string(),
  invoiceId: oz545.string().nullable(),
  debit: oz545.number(),
  credit: oz545.number()
});
var JournalEntrySchema = oz545.object({
  accountId: oz545.string(),
  date: oz545.coerce.date(),
  status: JournalEntryStatusSchema,
  lines: JournalEntryLineSchema.array()
});

// src/entities/reports/journal-entries/journal-entries-report-schema.ts
import { oz as oz546 } from "@vy/utils";
var JournalEntriesReportSchema = oz546.object({
  accountId: oz546.string(),
  entries: JournalEntrySchema.array(),
  reportGeneratedAt: oz546.coerce.date()
});

// src/entities/reports/contracts/contracts-report-schema.ts
import { oz as oz547 } from "@vy/utils";
var ContractsReportSchema = oz547.array(
  oz547.object({
    contractName: oz547.string(),
    customerName: oz547.string(),
    status: ContractStatusSchema,
    startDate: ApiDateSchema,
    endDate: ApiDateSchema.optional(),
    currency: CurrencySchema,
    discountAmount: oz547.number(),
    daysToEnd: oz547.number().optional(),
    trialPeriod: oz547.string().optional(),
    overageAmount: oz547.number(),
    autoRenewal: oz547.boolean(),
    estimatedAmount: oz547.number(),
    syncStatusUpdatedAt: ApiDateSchema.optional(),
    contractId: oz547.string().optional()
  })
);

// src/entities/reports/anonymous-customers/anonymous-customers-report-schema.ts
import { oz as oz548 } from "@vy/utils";
var AnonymousCustomersReportSchema = oz548.object({
  customers: CustomerSchema.array(),
  count: oz548.number().nonnegative()
});

// src/entities/reports/report-dates/report-dates-schema.ts
import { oz as oz549 } from "@vy/utils";
var ReportDatesSchema = oz549.object({
  creationDate: ApiDateSchema,
  startDate: ApiDateSchema.optional(),
  endDate: ApiDateSchema.optional()
}).openapi("ReportDatesSchema");

// src/entities/reports/monthly-closure/monthly-closure-report-schema.ts
import { oz as oz550 } from "@vy/utils";
var MonthlyClosureReportSchema = oz550.array(
  InvoiceSchema.pick({
    id: true,
    name: true,
    revenueBreakdown: true,
    reviewStatus: true,
    billingStatus: true,
    billingCycle: true
  }).extend({
    invoiceNumber: oz550.string().nonempty(),
    customerName: oz550.string().nonempty(),
    erpDisplayId: oz550.string().optional(),
    overcharges: oz550.number().nonnegative(),
    currency: CurrencySchema,
    erpId: oz550.string().nullish(),
    customerExternalId: oz550.string().nonempty().optional(),
    paymentTerm: oz550.nativeEnum(PAYMENT_TERMS),
    contractName: oz550.string().optional()
  })
).openapi("MonthlyClosureReportResponseSchema");

// src/entities/reports/customers/customers-report-item-schema.ts
import { oz as oz551 } from "@vy/utils";
var CustomersReportItemSchema = oz551.object({
  customerId: oz551.string().optional(),
  customerName: oz551.string(),
  customerAlias: oz551.string().optional(),
  status: CustomerStatusSchema.optional(),
  crmId: oz551.string().optional(),
  nsErpId: oz551.string().optional(),
  qbErpId: oz551.string().optional(),
  stripeConnected: oz551.boolean(),
  wallet: oz551.string().optional(),
  createdAt: ApiDateSchema,
  dueDate: oz551.number().optional(),
  legalName: oz551.string().optional(),
  contacts: ContactSchema.array().optional(),
  parentCustomer: oz551.string().optional(),
  subsidiary: oz551.string().optional(),
  address: AddressSchema.optional()
});

// src/entities/reports/customers/customers-report-schema.ts
import { oz as oz552 } from "@vy/utils";
var CustomersReportSchema = oz552.array(CustomersReportItemSchema);

// src/entities/reports/customer-master/customer-master-contract-schema.ts
import { oz as oz553 } from "@vy/utils";
import { CustomFieldValueSchema as CustomFieldValueSchema4 } from "@vy/custom-fields-types";
var CustomerMasterContractSchema = oz553.object({
  contractId: oz553.string(),
  contractName: oz553.string(),
  status: ContractStatusSchema,
  startDate: ApiDateSchema,
  endDate: ApiDateSchema.optional(),
  daysToEnd: oz553.number().optional(),
  durationMonths: oz553.number().optional(),
  currency: CurrencySchema,
  estimatedAmount: oz553.number(),
  mrr: oz553.number().optional(),
  autoRenewal: oz553.boolean(),
  trialPeriod: oz553.string().optional(),
  purchaseOrder: oz553.string().optional(),
  accountManager: oz553.string().optional(),
  salesforceOpportunityId: oz553.string().optional(),
  netSuiteSalesOrderId: oz553.string().optional(),
  syncStatusUpdatedAt: ApiDateSchema.optional(),
  customFieldValues: CustomFieldValueSchema4.array().optional()
});

// src/entities/reports/customer-master/customer-master-customer-schema.ts
import { oz as oz554 } from "@vy/utils";
import { CustomFieldValueSchema as CustomFieldValueSchema5 } from "@vy/custom-fields-types";
var CustomerMasterCustomerSchema = oz554.object({
  customerId: oz554.string().optional(),
  customerName: oz554.string(),
  customerAlias: oz554.string().optional(),
  status: CustomerStatusSchema.optional(),
  customerType: CustomerTypeSchema.optional(),
  legalName: oz554.string().optional(),
  parentCustomer: oz554.string().optional(),
  crmId: oz554.string().optional(),
  nsErpId: oz554.string().optional(),
  qbErpId: oz554.string().optional(),
  xeroErpId: oz554.string().optional(),
  stripeId: oz554.string().optional(),
  subsidiary: oz554.string().optional(),
  taxId: oz554.string().optional(),
  customerCurrency: CurrencySchema.optional(),
  taxMethod: oz554.string().optional(),
  taxRate: oz554.number().optional(),
  manualReview: oz554.boolean().optional(),
  paymentProvider: PaymentProviderSchema.optional(),
  autoPay: oz554.boolean().optional(),
  customerNotes: oz554.string().optional(),
  wallet: oz554.string().optional(),
  createdAt: ApiDateSchema,
  dueDate: oz554.number().optional(),
  contacts: ContactSchema.array().optional(),
  address: AddressSchema.optional(),
  customFieldValues: CustomFieldValueSchema5.array().optional(),
  contracts: CustomerMasterContractSchema.array()
});

// src/entities/reports/customer-master/customer-master-report-schema.ts
import { oz as oz555 } from "@vy/utils";
var CustomerMasterReportSchema = oz555.array(CustomerMasterCustomerSchema);

// src/entities/reports/upcoming-invoices/upcoming-invoices-report-item-schema.ts
import { oz as oz557 } from "@vy/utils";

// src/entities/reports/shared-schemas/invoices-report-item-schema.ts
import { oz as oz556 } from "@vy/utils";
var invoicesReportItemSchema = oz556.object({
  id: oz556.string(),
  name: oz556.string(),
  reviewStatus: InvoiceReviewStatusSchema,
  billingStatus: InvoiceBillingStatusSchema,
  total: oz556.number(),
  issuedAt: ApiDateSchema.optional(),
  dueAt: ApiDateSchema.optional(),
  invoicingDate: ApiDateSchema,
  period: PeriodSchema
});

// src/entities/reports/upcoming-invoices/upcoming-invoices-report-item-schema.ts
var UpcomingInvoicesReportItemSchema = oz557.object({
  startDate: ApiDateSchema,
  invoices: invoicesReportItemSchema.array(),
  contract: oz557.object({
    id: oz557.string(),
    status: ContractStatusSchema
  }),
  revenue: oz557.object({
    total: oz557.number(),
    monthlyTotals: oz557.number().array(),
    currency: CurrencySchema
  }),
  customer: oz557.object({
    id: oz557.string(),
    name: oz557.string()
  })
});

// src/entities/reports/upcoming-invoices/upcoming-invoices-report-schema.ts
import { oz as oz558 } from "@vy/utils";
var UpcomingInvoicesReportSchema = oz558.object({
  accountId: oz558.string(),
  reportDate: ApiDateSchema,
  reportItems: UpcomingInvoicesReportItemSchema.array()
});

// src/entities/reports/unapproved-invoices/unapproved-invoices-report-item-schema.ts
import { oz as oz559 } from "@vy/utils";
var UnapprovedInvoicesReportItemSchema = oz559.object({
  startDate: ApiDateSchema,
  invoices: invoicesReportItemSchema.array(),
  contract: oz559.object({
    id: oz559.string(),
    status: ContractStatusSchema
  }),
  revenue: oz559.object({
    total: oz559.number(),
    revenueByDate: oz559.record(oz559.string(), oz559.number()),
    currency: CurrencySchema
  }),
  customer: oz559.object({
    id: oz559.string(),
    name: oz559.string()
  })
});

// src/entities/reports/unapproved-invoices/unapproved-invoices-report-schema.ts
import { oz as oz560 } from "@vy/utils";
var UnapprovedInvoicesReportSchema = oz560.object({
  accountId: oz560.string(),
  reportDate: ApiDateSchema,
  reportItems: UnapprovedInvoicesReportItemSchema.array()
});

// src/entities/reports/failed-invoice-deliveries/failed-invoice-deliveries-report-item-schema.ts
import { oz as oz561 } from "@vy/utils";
var FailedInvoiceDeliveriesReportItemSchema = oz561.object({
  date: ApiDateSchema,
  customer: oz561.object({
    id: oz561.string(),
    name: oz561.string(),
    currency: CurrencySchema.optional()
  }),
  invoice: InvoiceSchema.pick({
    id: true,
    contractId: true,
    parentLineItemId: true,
    invoicingDate: true,
    issuedAt: true,
    name: true,
    revenueBreakdown: true,
    invoiceNumber: true
  }),
  reason: oz561.string().optional(),
  response: oz561.string().optional(),
  recipient: oz561.string(),
  emailType: EmailTypeSchema,
  source: EmailVerificationSourceSchema,
  event: EmailVerificationEventSchema
});

// src/entities/reports/failed-invoice-deliveries/failed-invoice-deliveries-report-schema.ts
import { oz as oz562 } from "@vy/utils";
var FailedInvoiceDeliveriesReportSchema = oz562.object({
  accountId: oz562.string(),
  reportDate: ApiDateSchema,
  reportItems: FailedInvoiceDeliveriesReportItemSchema.array()
});

// src/entities/reports/usage-report/usage-report-contract-schema.ts
import { oz as oz563 } from "@vy/utils";
var UsageReportContractSchema = oz563.object({
  id: oz563.string(),
  startDate: oz563.date(),
  endDate: oz563.date().optional(),
  status: oz563.string()
});

// src/entities/reports/usage-report/usage-report-customer-schema.ts
import { oz as oz564 } from "@vy/utils";
var UsageReportCustomerSchema = oz564.object({
  id: oz564.string(),
  name: oz564.string(),
  externalId: oz564.string().nullish()
});

// src/entities/reports/usage-report/usage-report-variant-schema.ts
import { oz as oz565 } from "@vy/utils";
var UsageReportVariantSchema = oz565.object({
  name: oz565.string(),
  description: oz565.string().nullish(),
  pricing: PricingSchema
});

// src/entities/reports/usage-report/usage-report-child-customer-schema.ts
import { oz as oz566 } from "@vy/utils";
var UsageReportChildCustomerSchema = oz566.object({
  id: oz566.string(),
  name: oz566.string()
});

// src/entities/reports/usage-report/usage-report-data-item-schema.ts
import { oz as oz567 } from "@vy/utils";
var UsageReportDataItemSchema = oz567.object({
  tierIndex: oz567.number(),
  period: PeriodSchema,
  tierTotal: oz567.number(),
  commitmentAmount: oz567.number().optional(),
  billingInterval: BillingIntervalSchema,
  accumulationInterval: oz567.number().optional(),
  commitmentInterval: oz567.number().optional(),
  contract: UsageReportContractSchema,
  variant: UsageReportVariantSchema,
  usageCustomer: UsageReportCustomerSchema,
  childCustomer: UsageReportChildCustomerSchema.optional(),
  planName: oz567.string(),
  bulkAmount: oz567.number().optional(),
  tierFullSize: oz567.number().optional(),
  productId: oz567.string()
});

// src/entities/reports/usage-report/usage-report-row-schema.ts
import { oz as oz568 } from "@vy/utils";
var UsageReportRowSchema = oz568.object({
  customerNameParent: oz568.string(),
  customerIdParent: oz568.string(),
  externalIdParent: oz568.string().optional(),
  relatedEntityName: oz568.string().optional(),
  relatedEntityId: oz568.string().optional(),
  contractName: oz568.string(),
  contractId: oz568.string(),
  contractStartDate: oz568.string(),
  contractEndDate: oz568.string(),
  daysToEnd: oz568.number(),
  contractDuration: oz568.number(),
  contractStatus: oz568.string(),
  productName: oz568.string(),
  productDescription: oz568.string(),
  productId: oz568.string(),
  productGroupName: oz568.string(),
  pricingType: PricingModelSchema,
  periodCadence: oz568.number().optional(),
  billingInterval: BillingIntervalSchema,
  commitmentUnits: oz568.number(),
  commitmentReset: oz568.number(),
  tierNumber: oz568.number(),
  tiersQuantity: oz568.number().optional(),
  bulkAmountUnits: oz568.number().optional(),
  usagePeriod: oz568.string(),
  totalConsumed: oz568.number()
});

// src/entities/reports/usage-report/usage-report-data-schema.ts
import { oz as oz569 } from "@vy/utils";
var UsageReportDataSchema = oz569.object({
  accountId: oz569.string(),
  timestamp: oz569.date(),
  reportItems: oz569.array(UsageReportDataItemSchema)
}).openapi("UsageReportData");

// src/entities/reports/recurring-revenue/mrr-movement-type.ts
var MrrMovementType = {
  New: "New",
  Expansion: "Expansion",
  Contraction: "Contraction",
  Churn: "Churn",
  Reactivation: "Reactivation"
};

// src/entities/reports/recurring-revenue/recurring-revenue-report-schema.ts
import { oz as oz570 } from "@vy/utils";
var ReportLabelSchema2 = oz570.object({
  id: oz570.string(),
  name: oz570.string(),
  color: oz570.string(),
  backgroundColor: oz570.string()
});
var RecurringRevenueProductSummarySchema = oz570.object({
  productId: oz570.string(),
  productName: oz570.string().optional(),
  currentMrrUsd: oz570.number(),
  totalArrUsd: oz570.number()
});
var RecurringRevenueReportItemBaseSchema = oz570.object({
  contractId: oz570.string(),
  customerId: oz570.string().optional(),
  customerName: oz570.string(),
  subsidiaryName: oz570.string().nullable().optional(),
  parentName: oz570.string().nullable(),
  country: oz570.string().nullable().optional(),
  state: oz570.string().nullable().optional(),
  labels: oz570.array(ReportLabelSchema2).optional(),
  catalogProductIds: oz570.array(oz570.string()).optional(),
  meterIds: oz570.array(oz570.string()).optional(),
  contractName: oz570.string(),
  contractStartDate: oz570.string(),
  contractEndDate: oz570.string().nullable(),
  contractStatus: ContractStatusSchema,
  originalCurrency: oz570.string(),
  currentMrrInOriginalCurrency: oz570.number(),
  exchangeRate: oz570.number().nullable(),
  currentMrrUsd: oz570.number(),
  totalArrUsd: oz570.number(),
  productSummaries: oz570.array(RecurringRevenueProductSummarySchema).optional()
});
var RecurringRevenueReportItemSchema = RecurringRevenueReportItemBaseSchema.passthrough();
var RecurringRevenueReportSchema = oz570.array(RecurringRevenueReportItemSchema);

// src/entities/reports/usage-report-v2/usage-report-v2-report-item-schema.ts
import { oz as oz571 } from "@vy/utils";
var UsageReportV2CustomerSchema = oz571.object({
  id: oz571.string(),
  name: oz571.string(),
  externalId: oz571.string().nullable().optional()
});
var UsageReportV2ContractSchema = oz571.object({
  id: oz571.string(),
  name: oz571.string(),
  startDate: oz571.coerce.date(),
  endDate: oz571.coerce.date().nullable().optional(),
  status: oz571.string(),
  durationMonths: oz571.number().nullable().optional(),
  daysToEnd: oz571.number().nullable().optional()
});
var UsageReportV2ProductSchema = oz571.object({
  id: oz571.string(),
  name: oz571.string(),
  description: oz571.string().nullable().optional(),
  productGroupName: oz571.string().nullable().optional(),
  pricingModel: oz571.string(),
  chargingCadenceMonths: oz571.number().nullable().optional(),
  billingIntervalMonths: oz571.number().nullable().optional(),
  commitmentUnits: oz571.number().nullable().optional(),
  accumulationIntervalMonths: oz571.number().nullable().optional()
});
var UsageReportV2TierSchema = oz571.object({
  index: oz571.number(),
  from: oz571.number().nullable().optional(),
  to: oz571.number().nullable().optional(),
  isLast: oz571.boolean(),
  bulkAmount: oz571.number().nullable().optional()
});
var UsageReportV2PeriodSchema = oz571.object({
  startTime: oz571.coerce.date(),
  endTime: oz571.coerce.date()
});
var UsageReportV2ReportItemSchema = oz571.object({
  customer: UsageReportV2CustomerSchema,
  customerCustomFieldValues: oz571.record(oz571.string(), oz571.unknown()).optional(),
  contract: UsageReportV2ContractSchema,
  contractCustomFieldValues: oz571.record(oz571.string(), oz571.unknown()).optional(),
  product: UsageReportV2ProductSchema,
  tier: UsageReportV2TierSchema,
  period: UsageReportV2PeriodSchema,
  totalConsumed: oz571.number()
});

// src/entities/reports/usage-report-v2/usage-report-v2-schema.ts
import { oz as oz572 } from "@vy/utils";
var CustomFieldNameSchema = oz572.object({
  id: oz572.string(),
  name: oz572.string()
});
var UsageReportV2Schema = oz572.object({
  accountId: oz572.string(),
  reportItems: oz572.array(UsageReportV2ReportItemSchema),
  customerCustomFieldNames: oz572.array(CustomFieldNameSchema),
  contractCustomFieldNames: oz572.array(CustomFieldNameSchema),
  reportGeneratedAt: oz572.coerce.date()
});

// src/entities/reports/commitment-vs-usage/commitment-vs-usage-report-item-schema.ts
import { oz as oz573 } from "@vy/utils";
var CommitmentVsUsageCustomerSchema = oz573.object({
  id: oz573.string(),
  name: oz573.string(),
  externalId: oz573.string().nullable().optional()
});
var CommitmentVsUsageContractSchema = oz573.object({
  id: oz573.string(),
  name: oz573.string(),
  status: oz573.string(),
  startDate: oz573.coerce.date(),
  endDate: oz573.coerce.date().nullable().optional(),
  daysToEnd: oz573.number().nullable().optional()
});
var CommitmentVsUsageProductSchema = oz573.object({
  id: oz573.string(),
  name: oz573.string(),
  variantId: oz573.string(),
  variantName: oz573.string()
});
var CommitmentVsUsageCommitmentSchema = oz573.object({
  units: oz573.number().nullable().optional(),
  resetIntervalMonths: oz573.number().nullable().optional()
});
var CommitmentVsUsageCurrentCycleSchema = oz573.object({
  startDate: oz573.coerce.date().nullable().optional(),
  endDate: oz573.coerce.date().nullable().optional(),
  consumed: oz573.number().nullable().optional(),
  pctUsage: oz573.number().nullable().optional(),
  pacing: oz573.number().nullable().optional(),
  projectedEoP: oz573.number().nullable().optional(),
  shortfall: oz573.number().nullable().optional(),
  overage: oz573.number().nullable().optional()
});
var CommitmentVsUsageMonthlyEntrySchema = oz573.object({
  startTime: oz573.coerce.date(),
  qtyUsed: oz573.number().nullable().optional(),
  cumulativeQty: oz573.number().nullable().optional(),
  cumulativePct: oz573.number().nullable().optional(),
  isResetMonth: oz573.boolean().nullable().optional()
});
var CommitmentVsUsageReportItemSchema = oz573.object({
  customer: CommitmentVsUsageCustomerSchema,
  contract: CommitmentVsUsageContractSchema,
  product: CommitmentVsUsageProductSchema,
  commitment: CommitmentVsUsageCommitmentSchema,
  currentCycle: CommitmentVsUsageCurrentCycleSchema,
  monthlyEntries: oz573.array(CommitmentVsUsageMonthlyEntrySchema)
});

// src/entities/reports/commitment-vs-usage/commitment-vs-usage-schema.ts
import { oz as oz574 } from "@vy/utils";
var CommitmentVsUsageMonthSchema = oz574.object({
  startTime: oz574.coerce.date()
});
var CommitmentVsUsageSchema = oz574.object({
  accountId: oz574.string(),
  reportItems: oz574.array(CommitmentVsUsageReportItemSchema),
  months: oz574.array(CommitmentVsUsageMonthSchema),
  reportGeneratedAt: oz574.coerce.date()
});

// src/entities/reports/unmetered-events/disconnected-meter-breakpoint-schema.ts
import { oz as oz575 } from "@vy/utils";
var DisconnectedMeterBreakpointSchema = oz575.enum(["noVariant", "noPlan", "noContract"]);

// src/entities/reports/unmetered-events/disconnected-meter-schema.ts
import { oz as oz576 } from "@vy/utils";
var DisconnectedMeterSchema = oz576.object({
  meterName: oz576.string(),
  eventName: oz576.string(),
  breakpoint: DisconnectedMeterBreakpointSchema
});

// src/entities/reports/unmetered-events/unmetered-events-reason-schema.ts
import { oz as oz577 } from "@vy/utils";
var UnmeteredEventsReasonSchema = oz577.enum(["noMeter", "noContract", "noProductOnContract"]);

// src/entities/reports/unmetered-events/unmetered-events-report-item-schema.ts
import { oz as oz578 } from "@vy/utils";
var UnmeteredEventsReportItemSchema = oz578.object({
  customerAlias: oz578.string(),
  eventName: oz578.string(),
  eventCount: oz578.number(),
  filterFields: oz578.record(oz578.string(), oz578.string()),
  lastRawData: oz578.record(oz578.string(), oz578.unknown()),
  reason: UnmeteredEventsReasonSchema
});

// src/entities/reports/unmetered-events/unmetered-events-report-schema.ts
import { oz as oz579 } from "@vy/utils";
var UnmeteredEventsReportSchema = oz579.object({
  reportItems: oz579.array(UnmeteredEventsReportItemSchema),
  filterFieldNames: oz579.array(oz579.string()),
  disconnectedMeters: oz579.array(DisconnectedMeterSchema)
});

// src/entities/revision/revision-schema.ts
import { oz as oz580 } from "@vy/utils";
var BaseRevisionSchema = oz580.object({
  contractId: oz580.string(),
  payload: oz580.record(oz580.any()),
  userEmail: oz580.string(),
  effectiveDate: oz580.date(),
  label: PhaseTypeSchema,
  name: oz580.string().optional()
});
var RevisionSchema = created(BaseRevisionSchema).openapi("Revision");

// src/entities/sandbox/sandbox-environment.ts
import { oz as oz581 } from "@vy/utils";
var SANDBOX_ENVIRONMENTS = Object.freeze({
  AI_DATA: "AI & Data",
  FINTECH: "Fintech",
  CLOUD: "Cloud",
  SAAS: "SAAS",
  DEV_TOOLS: "Dev. Tools",
  SERVICES_OTHERS: "Services and Others"
});
var SandboxEnvironmentSchema = oz581.nativeEnum(SANDBOX_ENVIRONMENTS).openapi("SandboxEnvironment");

// src/entities/send-grid/send-grid-event-schema.ts
import { oz as oz583 } from "@vy/utils";

// src/entities/send-grid/send-grid-webhook-event-schema.ts
import { oz as oz582 } from "@vy/utils";
var SEND_GRID_WEBHOOK_EVENTS = Object.freeze({
  Dropped: "dropped",
  Delivered: "delivered",
  Bounce: "bounce",
  Open: "open"
});
var SendGridWebhookEventSchema = oz582.nativeEnum(SEND_GRID_WEBHOOK_EVENTS).openapi("SendGridWebhookEvent");

// src/entities/send-grid/send-grid-event-schema.ts
var SendGridEventSchema = oz583.object({
  email: oz583.string(),
  timestamp: oz583.number(),
  messageId: oz583.string(),
  event: SendGridWebhookEventSchema,
  sg_event_id: oz583.string(),
  reason: oz583.string().optional(),
  response: oz583.string().optional(),
  taskId: oz583.string().optional(),
  jobId: oz583.string().optional()
});

// src/entities/shareable-tokens/shareable-token-params-schema.ts
import { oz as oz584 } from "@vy/utils";
var ShareableTokenParamsSchema = oz584.union([CustomerPortalTokenParamsSchema, CustomerPortalCheckoutLinkTokenParamsSchema, oz584.object({})]);

// src/entities/subsidiary/new-subsidiary-schema.ts
import { oz as oz587 } from "@vy/utils";

// src/entities/subsidiary/erp-subsidiary-schema.ts
import { oz as oz586 } from "@vy/utils";

// src/entities/subsidiary/erp-subsidiary-settings-schema.ts
import { oz as oz585 } from "@vy/utils";
var NetSuiteSettingsSchema = oz585.object({
  integration: oz585.literal(ERP_INTEGRATION_PROVIDERS.netSuite),
  salesOrderDefaultFormId: oz585.string().optional()
});
var MorningSettingsSchema = oz585.object({
  integration: oz585.literal(ERP_INTEGRATION_PROVIDERS.morning)
});
var QuickBooksSettingsSchema = oz585.object({
  integration: oz585.literal(ERP_INTEGRATION_PROVIDERS.quickBooks)
});
var ErpSubsidiarySettingsSchema = oz585.discriminatedUnion("integration", [
  NetSuiteSettingsSchema,
  MorningSettingsSchema,
  QuickBooksSettingsSchema
]);

// src/entities/subsidiary/erp-subsidiary-schema.ts
var ErpSubsidiarySchema = oz586.object({
  integrationId: oz586.string(),
  integration: ErpIntegrationProvidersSchema,
  settings: ErpSubsidiarySettingsSchema.optional()
});

// src/entities/subsidiary/new-subsidiary-schema.ts
var NewSubsidiarySchema = oz587.object({
  name: oz587.string().min(1),
  isPrimary: oz587.boolean().optional(),
  taxId: oz587.string().min(1).optional(),
  erp: ErpSubsidiarySchema.optional(),
  settings: NewAccountSettingsSchema
}).openapi("NewSubsidiary");

// src/entities/subsidiary/subsidiary-input-schema.ts
var SubsidiaryInputSchema = NewSubsidiarySchema.extend({
  settings: AccountSettingsInputSchema
}).partial().openapi("SubsidiaryInput");

// src/entities/subsidiary/subsidiary-schema.ts
var SubsidiarySchema = created(NewSubsidiarySchema).extend({
  settings: AccountSettingsSchema
}).openapi("Subsidiary");

// src/entities/system-event/new-system-event-schema.ts
import { oz as oz590 } from "@vy/utils";

// src/entities/system-event/system-event-types-schema.ts
import { oz as oz588 } from "@vy/utils";
var SYSTEM_EVENT_TYPES = {
  INVOICE_CREATED: "INVOICE_CREATED",
  INVOICE_UPDATED: "INVOICE_UPDATED",
  INVOICE_APPROVED: "INVOICE_APPROVED",
  INVOICE_SYNCED: "INVOICE_SYNCED",
  INVOICE_SYNC_FAILED: "INVOICE_SYNC_FAILED",
  INVOICE_PAID: "INVOICE_PAID",
  INVOICE_CANCELLED: "INVOICE_CANCELLED",
  INVOICE_BILLING_STATUS_CHANGED: "INVOICE_BILLING_STATUS_CHANGED",
  INVOICE_EMAIL_OPENED: "INVOICE_EMAIL_OPENED"
};
var SystemEventTypesSchema = oz588.nativeEnum(SYSTEM_EVENT_TYPES).openapi("SystemEventType");

// src/entities/system-event/system-types-schema.ts
import { oz as oz589 } from "@vy/utils";
var SYSTEM_TYPES = {
  NetSuite: "NetSuite",
  Stripe: "Stripe"
};
var SystemTypesSchema = oz589.nativeEnum(SYSTEM_TYPES).openapi("SystemType");

// src/entities/system-event/new-system-event-schema.ts
var NewSystemEventSchema = oz590.object({
  type: SystemEventTypesSchema,
  objectTypeId: ObjectIdSchema,
  timestamp: ApiDateSchema.optional(),
  system: SystemTypesSchema.optional(),
  metadata: oz590.record(oz590.string(), oz590.array(ScalarValueSchema)).optional()
}).openapi("NewSystemEvent");

// src/entities/system-event/system-event-schema.ts
var SystemEventSchema = created(NewSystemEventSchema).openapi("SystemEvent");

// src/entities/text-template/text-template-schema.ts
import { oz as oz597 } from "@vy/utils";

// src/entities/text-template/text-template-schemas/invoice-email-template-schema.ts
import { oz as oz595 } from "@vy/utils";

// src/entities/text-template/base-text-template-schema.ts
import { oz as oz593 } from "@vy/utils";

// src/entities/text-template/text-template-entity-schema.ts
import { oz as oz592 } from "@vy/utils";

// src/entities/text-template/text-template-entity-type-schema.ts
import { oz as oz591 } from "@vy/utils";
var TEXT_TEMPLATE_ENTITY_TYPES = Object.freeze({
  Account: "Account",
  Customer: "Customer",
  Invoice: "Invoice"
});
var TextTemplateEntityTypeSchema = oz591.nativeEnum(TEXT_TEMPLATE_ENTITY_TYPES).openapi("TextTemplateEntityType");

// src/entities/text-template/text-template-entity-schema.ts
var TextTemplateEntitySchema = oz592.object({
  entityId: oz592.string(),
  entityType: TextTemplateEntityTypeSchema
});

// src/entities/text-template/base-text-template-schema.ts
var BaseTextTemplateSchema = oz593.object({
  id: oz593.string(),
  accountId: oz593.string(),
  name: oz593.string(),
  content: oz593.string(),
  entity: TextTemplateEntitySchema,
  fields: oz593.array(oz593.string())
});

// src/entities/text-template/text-template-type-schema.ts
import { oz as oz594 } from "@vy/utils";
var TEXT_TEMPLATE_TYPES = Object.freeze({
  InvoiceEmail: "InvoiceEmail",
  InvoicePdf: "InvoicePdf"
});
var TextTemplateTypeSchema = oz594.nativeEnum(TEXT_TEMPLATE_TYPES).openapi("TextTemplateType");

// src/entities/text-template/text-template-schemas/invoice-email-template-schema.ts
var InvoiceEmailTemplateSchema = BaseTextTemplateSchema.extend({
  type: oz595.literal(TEXT_TEMPLATE_TYPES.InvoiceEmail)
}).openapi("InvoiceEmailTemplate");

// src/entities/text-template/text-template-schemas/invoice-pdf-template-schema.ts
import { oz as oz596 } from "@vy/utils";
var InvoicePdfTemplateSchema = BaseTextTemplateSchema.extend({
  type: oz596.literal(TEXT_TEMPLATE_TYPES.InvoicePdf)
}).openapi("InvoicePdfTemplate");

// src/entities/text-template/text-template-schema.ts
var TextTemplateSchema = oz597.discriminatedUnion("type", [InvoiceEmailTemplateSchema, InvoicePdfTemplateSchema]).openapi("TextTemplate");

// src/entities/text-template/text-template-keys/invoice-pdf-template-keys.ts
import { oz as oz598 } from "@vy/utils";
var INVOICE_PDF_TEMPLATE_KEYS = Object.freeze({
  INVOICE_NUMBER: "invoiceNumber",
  INVOICE_NAME: "invoiceName"
});
var InvoicePdfTemplateKeySchema = oz598.nativeEnum(INVOICE_PDF_TEMPLATE_KEYS).openapi("InvoicePdfTemplateKey");

// src/entities/usage-variant-charge/new-usage-variant-charge-schema.ts
import { oz as oz601 } from "@vy/utils";

// src/entities/usage-variant-charge/measure-price-breakdown-schema.ts
import { oz as oz600 } from "@vy/utils";

// src/entities/usage-variant-charge/measured-price-schema.ts
import { oz as oz599 } from "@vy/utils";
var MeasuredPriceSchema = oz599.object({
  price: oz599.number(),
  discountAmount: oz599.number().nullish(),
  currency: CurrencySchema,
  units: oz599.number(),
  billableUnits: oz599.number(),
  nonBillableUnits: oz599.number()
});

// src/entities/usage-variant-charge/measure-price-breakdown-schema.ts
var MeasuredPriceBreakdownSchema = oz600.object({
  tierIndex: oz600.number(),
  measuredPrice: MeasuredPriceSchema
}).array();

// src/entities/usage-variant-charge/new-usage-variant-charge-schema.ts
var NewUsageVariantChargeSchema = oz601.object({
  accountId: oz601.string(),
  customerId: oz601.string(),
  contractId: oz601.string(),
  invoiceId: oz601.string().nullish(),
  childCustomerId: oz601.string().nullish(),
  measurementId: oz601.string(),
  productVariantId: oz601.string(),
  accumulatedUnits: oz601.number().nullish(),
  meterId: oz601.string(),
  period: PeriodSchema,
  timeSlot: TimeSlotSchema,
  measuredPrice: MeasuredPriceSchema,
  measuredPriceBreakdown: MeasuredPriceBreakdownSchema,
  isDailyCarryForward: oz601.boolean().optional()
});

// src/entities/usage-variant-charge/usage-variant-charge-schema.ts
var UsageVariantChargeSchema = created(NewUsageVariantChargeSchema);

// src/entities/user/new-user-schema.ts
import { oz as oz602 } from "@vy/utils";
var NewUserSchema = oz602.object({
  email: UsernameSchema,
  firstName: oz602.string().optional(),
  lastName: oz602.string().optional()
}).openapi("NewUser");

// src/entities/user/user-schema.ts
var BaseUserSchema = NewUserSchema.extend({
  role: RolesSchema,
  id: ObjectIdSchema
});
var UserSchema = segregated(BaseUserSchema).openapi("User");

// src/entities/user/invited-user-payload-schema.ts
import { oz as oz603 } from "@vy/utils";
var InvitedUserPayloadSchema = oz603.object({
  accountId: ObjectIdSchema,
  invitationId: ObjectIdSchema,
  username: UsernameSchema
}).openapi("InvitedUserPayload");

// src/entities/user-invitation/user-invitation-schema.ts
import { oz as oz605 } from "@vy/utils";

// src/entities/user-invitation/user-invitation-status-schema.ts
import { oz as oz604 } from "@vy/utils";
var USER_INVITATION_STATUSES = Object.freeze({
  Pending: "Pending",
  Accepted: "Accepted",
  Expired: "Expired",
  Cancelled: "Cancelled"
});
var UserInvitationStatusSchema = oz604.nativeEnum(USER_INVITATION_STATUSES).openapi("UserInvitationStatus");

// src/entities/user-invitation/user-invitation-schema.ts
var UserInvitationSchema = oz605.object({
  id: ObjectIdSchema,
  email: oz605.string().email(),
  role: RolesSchema,
  invitedBy: ObjectIdSchema,
  status: UserInvitationStatusSchema,
  firstName: oz605.string().optional(),
  lastName: oz605.string().optional()
}).openapi("UserInvitation");

// src/entities/variant-charge/new-variant-charge-schema.ts
import { oz as oz606 } from "@vy/utils";
var NewVariantChargeSchema = oz606.union([NewUsageVariantChargeSchema, NewFixedVariantChargeSchema]);

// src/async-messages/pricing/account-stats-caching-message.ts
import { oz as oz607 } from "@vy/utils";
var AccountCachingMessageSchema = oz607.object({
  type: oz607.literal("account"),
  accountId: oz607.string()
});
var CustomerCachingMessageSchema = oz607.object({
  type: oz607.literal("customer"),
  accountId: oz607.string(),
  customerId: oz607.string()
});
var ContractCachingMessageSchema = oz607.object({
  type: oz607.literal("contract"),
  accountId: oz607.string(),
  contractId: oz607.string()
});
var AccountStatsCachingWorkerMessageSchema = oz607.union([
  AccountCachingMessageSchema,
  CustomerCachingMessageSchema,
  ContractCachingMessageSchema
]);

// src/async-messages/pricing/approve-invoices-message-schema.ts
import { oz as oz608 } from "@vy/utils";
var ApproveInvoicesMessageSchema = oz608.object({
  accountId: ObjectIdSchema,
  invoiceIds: oz608.array(ObjectIdSchema)
});

// src/async-messages/pricing/backfill-anrok-transactions-message.ts
import { oz as oz609 } from "@vy/utils";
var BACKFILL_QUERY_SCOPE_OPTIONS = Object.freeze({
  ALL: "ALL",
  AUTOMATIC_TAX_ONLY: "AUTOMATIC_TAX_ONLY"
});
var MIGRATE_AUTO_SCOPE_OPTIONS = Object.freeze({
  ALL: "ALL",
  ZERO_TAX_RATE: "ZERO_TAX_RATE"
});
var BackfillAnrokTransactionsMessageSchema = oz609.object({
  invoiceId: oz609.string()
});

// src/async-messages/pricing/calculate-billable-items-message.ts
import { oz as oz610 } from "@vy/utils";
var CalculateBillableItemsMessageSchema = oz610.object({
  productId: oz610.string()
});

// src/async-messages/pricing/calculate-consumption-period-message.ts
import { oz as oz611 } from "@vy/utils";
var CalculateConsumptionPeriodMessageSchema = oz611.object({
  productId: oz611.string()
});

// src/async-messages/pricing/calculate-invoice-revenue-message.ts
import { oz as oz612 } from "@vy/utils";
var CalculateInvoiceRevenueSchema = oz612.object({
  invoiceId: oz612.string(),
  isOverageInvoice: oz612.boolean().optional()
});

// src/async-messages/pricing/calculate-invoices-by-customer-message.ts
import { oz as oz613 } from "@vy/utils";
var CalculateInvoicesByCustomerSchema = oz613.object({
  customerId: oz613.string()
});

// src/async-messages/pricing/calculate-invoices-message.ts
import { oz as oz614 } from "@vy/utils";
var InvoicesCalculatorSchema = oz614.object({
  contractId: oz614.string()
});

// src/async-messages/pricing/calculate-parent-agreement-invoices-message.ts
import { oz as oz615 } from "@vy/utils";
var CalculateParentAgreementInvoicesMessageSchema = oz615.object({
  parentAgreementId: oz615.string()
});

// src/async-messages/pricing/charge-invoices-associator-message.ts
import { oz as oz616 } from "@vy/utils";
var FixedChargesInvoicesAssociatorMessageSchema = oz616.object({
  invoiceId: oz616.string()
});

// src/async-messages/pricing/collect-invoice-message.ts
import { oz as oz617 } from "@vy/utils";
var CollectInvoiceMessageSchema = oz617.object({
  invoiceId: oz617.string()
});

// src/async-messages/pricing/contract-extension-message-schema.ts
import { oz as oz618 } from "@vy/utils";
var ContractExtensionMessageSchema = oz618.object({
  contractId: ObjectIdSchema
});

// src/async-messages/pricing/create-credit-ledger-message.ts
import { oz as oz619 } from "@vy/utils";
var CreateCreditLedgerMessageSchema = oz619.object({
  customerId: oz619.string()
});

// src/async-messages/pricing/create-invoice-pdf-message-schema.ts
import { oz as oz620 } from "@vy/utils";
var CreateInvoicePdfMessageSchema = oz620.object({
  accountId: ObjectIdSchema,
  invoiceId: ObjectIdSchema
});

// src/async-messages/pricing/customer-calculator-message.ts
import { oz as oz621 } from "@vy/utils";
var CustomerCalculatorMessageSchema = oz621.object({
  customerId: oz621.string()
});

// src/async-messages/pricing/deduct-credits-message.ts
import { oz as oz622 } from "@vy/utils";
var DeductCreditsMessageSchema = oz622.object({
  deductAmount: oz622.number(),
  customerId: oz622.string(),
  invoiceId: oz622.string()
});

// src/async-messages/pricing/deductible-line-item-calculator-message.ts
import { oz as oz623 } from "@vy/utils";
var DeductibleLineItemCalculatorMessageSchema = oz623.object({
  contractId: oz623.string(),
  timestamp: oz623.coerce.date()
});

// src/async-messages/pricing/fixed-variant-charges-calculator-message.ts
import { oz as oz624 } from "@vy/utils";
var FixedVariantChargeCalculatorMessageSchema = oz624.object({
  productId: oz624.string()
});

// src/async-messages/pricing/grant-credits-message.ts
import { oz as oz625 } from "@vy/utils";
var GrantCreditsMessageSchema = oz625.object({
  invoiceId: oz625.string()
});

// src/async-messages/pricing/inflationary-uplift-message-schema.ts
import { oz as oz626 } from "@vy/utils";
var InflationaryUpliftMessageSchema = oz626.object({
  contractId: ObjectIdSchema,
  accountId: ObjectIdSchema,
  effectiveDate: oz626.coerce.date().optional(),
  skipStatusValidation: oz626.boolean().optional(),
  // Retrospective uplifts: bypass live rate fetch and use these literal values.
  inflationRateOverride: oz626.number().optional(),
  inflationSourceOverride: oz626.string().optional(),
  // Retro batch runs: skip the post-commit fan-out (CONTRACT_UPDATED, INVOICE_DELETED, rev-rec)
  // so the caller can regenerate each contract exactly once after all revisions are created.
  suppressDownstreamEvents: oz626.boolean().optional()
});

// src/async-messages/pricing/invoice-billing-status-updated-message.ts
import { oz as oz627 } from "@vy/utils";
var InvoiceBillingStatusUpdatedMessageSchema = oz627.object({
  invoiceId: oz627.string()
});

// src/async-messages/pricing/invoice-calculator-controller-message-schema.ts
import { oz as oz628 } from "@vy/utils";
var InvoiceCalculatorControllerMessageSchema = oz628.object({
  invoiceId: ObjectIdSchema,
  timestamp: oz628.string().optional()
});
var ContractCalculatorControllerMessageSchema = oz628.object({
  contractId: ObjectIdSchema,
  timestamp: oz628.string().optional()
});
var CustomerCalculatorControllerMessageSchema = oz628.object({
  customerId: ObjectIdSchema,
  addressChanged: oz628.boolean().optional(),
  timestamp: oz628.string().optional()
});
var EntityOfInvoiceCalculatorControllerMessageSchema = oz628.union([
  InvoiceCalculatorControllerMessageSchema,
  ContractCalculatorControllerMessageSchema,
  CustomerCalculatorControllerMessageSchema
]);

// src/async-messages/pricing/invoice-calculator-schema.ts
import { oz as oz629 } from "@vy/utils";
var InvoiceCalculatorSchema = oz629.object({
  contractId: oz629.string()
});

// src/async-messages/pricing/invoice-charges-calculator-message.ts
import { oz as oz630 } from "@vy/utils";
var InvoicingChargesCalculatorMessageSchema = oz630.object({
  productId: oz630.string()
});

// src/async-messages/pricing/invoice-finalizer-message-schema.ts
import { oz as oz631 } from "@vy/utils";
var InvoiceFinalizerMessageSchema = oz631.object({
  invoiceId: ObjectIdSchema
});

// src/async-messages/pricing/invoice-review-status-updated-message.ts
import { oz as oz632 } from "@vy/utils";
var InvoiceReviewStatusUpdatedMessageSchema = oz632.object({
  accountId: oz632.string(),
  invoiceId: oz632.string(),
  eventType: SystemEventTypesSchema.optional()
});

// src/async-messages/pricing/invoices-life-cycle-manager-message.ts
import { oz as oz633 } from "@vy/utils";
var InvoicesLifeCycleManagerMessageSchema = oz633.object({
  targetDay: oz633.string().regex(/^\d{4}-\d{2}-\d{2}$/).optional()
});

// src/async-messages/pricing/line-items-calculator-dispatcher-payload.ts
import { oz as oz634 } from "@vy/utils";
var UsageVariantChargesCalculatorDispatcherPayloadSchema = oz634.object({
  customerId: ObjectIdSchema.optional()
});

// src/async-messages/pricing/line-items-calculator-message.ts
import { oz as oz635 } from "@vy/utils";
var LineItemsCalculatorMessageSchema = oz635.object({
  invoiceId: ObjectIdSchema
});

// src/async-messages/pricing/new-calculate-invoice-message.ts
import { oz as oz636 } from "@vy/utils";
var NewCalculateInvoiceSchema = oz636.object({
  contractId: oz636.string()
});

// src/async-messages/pricing/product-period-calculator-message.ts
import { oz as oz637 } from "@vy/utils";
var ProductPeriodCalculatorMessageSchema = oz637.object({
  contractId: oz637.string()
});

// src/async-messages/pricing/reconcile-revenue-recognition-message-schema.ts
import { oz as oz638 } from "@vy/utils";
var ReconcileRevenueRecognitionMessageSchema = oz638.object({
  accountId: oz638.string(),
  dryRun: oz638.boolean().optional(),
  verbose: oz638.boolean().optional(),
  force: oz638.boolean().optional()
});

// src/async-messages/pricing/recurring-revenue-contract-recalc-message-schema.ts
import { oz as oz639 } from "@vy/utils";
var RecurringRevenueContractRecalcTriggerReasonSchema = oz639.union([
  oz639.literal("contract-created"),
  oz639.literal("contract-updated"),
  oz639.literal("contract-extended"),
  oz639.literal("contract-terminated"),
  oz639.literal("contract-status-updated")
]);
var RecurringRevenueContractRecalcMessageSchema = oz639.object({
  accountId: ObjectIdSchema,
  contractId: ObjectIdSchema,
  triggerReason: RecurringRevenueContractRecalcTriggerReasonSchema
});

// src/async-messages/pricing/recurring-revenue-product-recalc-message-schema.ts
import { oz as oz640 } from "@vy/utils";
var RecurringRevenueProductRecalcTriggerReasonSchema = oz640.union([
  oz640.literal("phase-created"),
  oz640.literal("phase-deleted"),
  oz640.literal("reconcile-drift")
]);
var RecurringRevenueProductRecalcMessageSchema = oz640.object({
  accountId: ObjectIdSchema,
  productId: ObjectIdSchema,
  triggerReason: RecurringRevenueProductRecalcTriggerReasonSchema
});

// src/async-messages/pricing/timeline-calculator-message-schema.ts
import { oz as oz641 } from "@vy/utils";
var TimelineCalculatorMessageSchema = oz641.object({
  contractId: oz641.string()
});

// src/async-messages/pricing/update-customer-message.ts
import { oz as oz642 } from "@vy/utils";
var UpdateCustomerMessageSchema = oz642.object({
  customerId: oz642.string(),
  addressChanged: oz642.boolean()
});

// src/async-messages/pricing/update-invoice-exchange-rates-message-schema.ts
import { oz as oz643 } from "@vy/utils";
var UpdateInvoiceExchangeRatesMessageSchema = oz643.object({});

// src/async-messages/pricing/update-measurements-prices-message.ts
import { oz as oz644 } from "@vy/utils";
var UpdateMeasurementsPricesMessageSchema = oz644.array(MeasurementPriceSchema);

// src/async-messages/pricing/usage-line-item-calculator-message.ts
import { oz as oz645 } from "@vy/utils";
var LineItemCalculatorMessageSchema = oz645.object({
  invoiceChargeId: oz645.string()
});

// src/async-messages/pricing/usage-variant-charge-calculator-message.ts
import { oz as oz646 } from "@vy/utils";
var UsageVariantChargeCalculatorMessageSchema = oz646.object({
  lineItemId: oz646.string()
});

// src/async-messages/integrations/sync-net-suite-invoices-statuses-message.ts
import { oz as oz647 } from "@vy/utils";
var SyncNetSuiteInvoicesStatusesMessageSchema = oz647.object({
  accountId: oz647.string().nonempty()
});

// src/async-messages/integrations/import-stripe-customer-payments-message.ts
import { oz as oz648 } from "@vy/utils";
var ImportStripeCustomerPaymentsMessageSchema = oz648.object({
  accountId: oz648.string(),
  customerId: oz648.string(),
  stripeCustomerId: oz648.string()
});

// src/async-messages/integrations/integration-base-sync-message.ts
import { oz as oz649 } from "@vy/utils";
var IntegrationBaseSyncMessageSchema = oz649.object({
  accountId: oz649.string().nonempty()
});

// src/async-messages/integrations/import-stripe-customers-message.ts
import { oz as oz650 } from "@vy/utils";
var ImportStripeCustomersMessageSchema = oz650.object({
  accountId: oz650.string().nonempty()
});

// src/async-messages/integrations/import-salesforce-customers-message.ts
import { oz as oz651 } from "@vy/utils";
var ImportSalesforceCustomersMessageSchema = oz651.object({
  accountId: oz651.string().nonempty()
});

// src/async-messages/integrations/export-customer-message.ts
import { oz as oz652 } from "@vy/utils";
var ExportCustomerMessageSchema = oz652.object({
  customerId: ObjectIdSchema
});

// src/async-messages/integrations/sync-hubspot-contracts-message.ts
import { oz as oz653 } from "@vy/utils";
var SyncHubspotContractsMessageSchema = oz653.object({
  accountId: oz653.string().nonempty()
});

// src/async-messages/integrations/hubspot-deal-import-message.ts
import { oz as oz654 } from "@vy/utils";
var HubspotDealImportMessageSchema = oz654.object({
  accountId: oz654.string().nonempty(),
  dealId: oz654.string().nonempty()
});

// src/async-messages/integrations/hubspot-company-import-message.ts
import { oz as oz655 } from "@vy/utils";
var HubspotCompanyImportMessageSchema = oz655.object({
  accountId: oz655.string().nonempty(),
  companyId: oz655.string().nonempty()
});

// src/async-messages/integrations/sync-hubspot-customers-dispatcher-message.ts
import { oz as oz656 } from "@vy/utils";
var SyncHubspotCustomersDispatcherMessageSchema = oz656.object({
  overrideFilterAccountIds: oz656.array(oz656.string().min(1)).optional()
});

// src/async-messages/api/warm-up-flag-payload.ts
import { oz as oz657 } from "@vy/utils";
var WarmUpFlagPayloadSchema = oz657.object({
  isWarmUp: oz657.boolean()
});

// src/async-messages/reports/trigger-report-job-message-attributes.ts
var MESSAGE_ATTRIBUTE_NAME = "reportType";
var MESSAGE_ATTRIBUTE_DATA_TYPE = "String";
var TRIGGER_REPORT_JOB_MESSAGE_ATTRIBUTES = Object.freeze({
  commitmentUsage: getMessageAttribute(MESSAGE_ATTRIBUTE_NAME, REPORT_JOB_TYPES.CommitmentUsage),
  unchargedUsage: getMessageAttribute(MESSAGE_ATTRIBUTE_NAME, REPORT_JOB_TYPES.UnchargedUsage),
  productsUsage: getMessageAttribute(MESSAGE_ATTRIBUTE_NAME, REPORT_JOB_TYPES.ProductsUsage),
  customerRevenue: getMessageAttribute(MESSAGE_ATTRIBUTE_NAME, REPORT_JOB_TYPES.CustomerRevenue),
  contracts: getMessageAttribute(MESSAGE_ATTRIBUTE_NAME, REPORT_JOB_TYPES.Contracts),
  monthlyClosure: getMessageAttribute(MESSAGE_ATTRIBUTE_NAME, REPORT_JOB_TYPES.MonthlyClosure),
  customers: getMessageAttribute(MESSAGE_ATTRIBUTE_NAME, REPORT_JOB_TYPES.Customers),
  upcomingInvoices: getMessageAttribute(MESSAGE_ATTRIBUTE_NAME, REPORT_JOB_TYPES.UpcomingInvoices),
  unapprovedInvoices: getMessageAttribute(MESSAGE_ATTRIBUTE_NAME, REPORT_JOB_TYPES.UnapprovedInvoices),
  failedInvoiceDeliveries: getMessageAttribute(MESSAGE_ATTRIBUTE_NAME, REPORT_JOB_TYPES.FailedInvoiceDeliveries),
  recurringRevenue: getMessageAttribute(MESSAGE_ATTRIBUTE_NAME, REPORT_JOB_TYPES.RecurringRevenue)
});
function getMessageAttribute(name, value) {
  return {
    [name]: { DataType: MESSAGE_ATTRIBUTE_DATA_TYPE, StringValue: value }
  };
}

// src/async-messages/reports/report-job-request-message.ts
import { oz as oz658 } from "@vy/utils";
var ReportJobRequestMessageSchema = oz658.object({
  accountId: oz658.string().nonempty(),
  reportJobId: oz658.string().nonempty()
});

// src/async-messages/sns/invoice-created-event-payload.ts
import { oz as oz662 } from "@vy/utils";

// src/async-messages/sns/invoice-create-event-payload-types/invoice-created-from-api-event-payload.ts
import { oz as oz660 } from "@vy/utils";

// src/async-messages/sns/invoice-create-event-payload-types/invoice-created-event-payload-types.ts
import { oz as oz659 } from "@vy/utils";
var INVOICE_CREATED_EVENT_PAYLOAD_TYPES = Object.freeze({
  FROM_API: "FROM_API",
  FROM_PRICING: "FROM_PRICING"
});
var InvoiceCreatedEventPayloadTypesSchema = oz659.nativeEnum(INVOICE_CREATED_EVENT_PAYLOAD_TYPES).openapi("InvoiceCreatedEventPayloadType");

// src/async-messages/sns/invoice-create-event-payload-types/invoice-created-from-api-event-payload.ts
var InvoiceCreatedFromApiEventPayloadSchema = oz660.object({
  type: oz660.literal(INVOICE_CREATED_EVENT_PAYLOAD_TYPES.FROM_API),
  invoiceId: ObjectIdSchema,
  products: oz660.array(ProductSchema)
});

// src/async-messages/sns/invoice-create-event-payload-types/invoice-created-from-pricing-event-payload.ts
import { oz as oz661 } from "@vy/utils";
var InvoiceCreatedFromPricingEventPayloadSchema = oz661.object({
  type: oz661.literal(INVOICE_CREATED_EVENT_PAYLOAD_TYPES.FROM_PRICING),
  invoiceId: ObjectIdSchema,
  products: oz661.array(ProductSchema)
});

// src/async-messages/sns/invoice-created-event-payload.ts
var InvoiceCreatedEventPayloadSchema = oz662.discriminatedUnion("type", [
  InvoiceCreatedFromApiEventPayloadSchema,
  InvoiceCreatedFromPricingEventPayloadSchema
]);

// src/async-messages/notifications/notification-emitter-message.ts
import { oz as oz663 } from "@vy/utils";
var NotificationEmitterMessageSchema = oz663.object({
  notificationId: oz663.string()
});

// src/async-messages/system-events/system-event-message-schemas/overage-event-message.ts
import { oz as oz666 } from "@vy/utils";

// src/async-messages/system-events/base-system-event-message-schema.ts
import { oz as oz664 } from "@vy/utils";
var BaseSystemEventMessageSchema = oz664.object({
  date: ApiDateSchema,
  accountId: oz664.string(),
  duplicationId: oz664.string().optional()
});

// src/async-messages/system-events/system-event-message-types-schema.ts
import { oz as oz665 } from "@vy/utils";
var SYSTEM_EVENT_MESSAGE_TYPES = Object.freeze({
  Overage: "Overage",
  AnonymousCustomerIngested: "AnonymousCustomerIngested",
  UpcomingRenewal: "UpcomingRenewal",
  ContractExpired: "ContractExpired",
  InvoiceApproved: "InvoiceApproved",
  CustomerUpdated: "CustomerUpdated",
  MeasurementsCharged: "MeasurementsCharged",
  ProductCalculationLifecycle: "ProductCalculationLifecycle",
  CustomerPortalLinkSent: "CustomerPortalLinkSent",
  NewCustomerWithoutContract: "NewCustomerWithoutContract",
  MonthEndReport: "MonthEndReport",
  UnchargedEvents: "UnchargedEvents",
  TierCrossed: "TierCrossed",
  FinalTierExceeded: "FinalTierExceeded",
  CommitmentCrossed: "CommitmentCrossed",
  CommitmentUsageCrossed: "CommitmentUsageCrossed",
  CurrencyCommitmentUsageCrossed: "CurrencyCommitmentUsageCrossed",
  CreditPoolThresholdCrossed: "CreditPoolThresholdCrossed",
  CreditPoolDepleted: "CreditPoolDepleted",
  CreditPoolIncreased: "CreditPoolIncreased",
  PaymentCreated: "PaymentCreated",
  PaymentFailed: "PaymentFailed",
  InvoicePaymentStatusChanged: "InvoicePaymentStatusChanged",
  CustomerCreated: "CustomerCreated",
  ContractCreated: "ContractCreated"
});
var SystemEventMessageTypeSchema = oz665.nativeEnum(SYSTEM_EVENT_MESSAGE_TYPES);

// src/async-messages/system-events/system-event-message-schemas/overage-event-message.ts
var OverageSystemEventMessageSchema = BaseSystemEventMessageSchema.extend({
  eventType: oz666.literal(SYSTEM_EVENT_MESSAGE_TYPES.Overage),
  customerName: oz666.string(),
  customerId: oz666.string(),
  invoiceId: oz666.string(),
  currency: CurrencySchema,
  overage: oz666.number()
});

// src/async-messages/system-events/system-event-message-schemas/anonymous-customer-ingested-message.ts
import { oz as oz667 } from "@vy/utils";
var AnonymousCustomerIngestedSystemEventMessageSchema = oz667.object({
  eventType: oz667.literal(SYSTEM_EVENT_MESSAGE_TYPES.AnonymousCustomerIngested),
  name: oz667.string(),
  id: oz667.string(),
  accountId: oz667.string(),
  ingestionDate: ApiDateSchema
});

// src/async-messages/system-events/system-event-message-schemas/upcoming-renewal-message.ts
import { oz as oz668 } from "@vy/utils";
var UpcomingRenewalSystemEventMessageSchema = BaseSystemEventMessageSchema.extend({
  eventType: oz668.literal(SYSTEM_EVENT_MESSAGE_TYPES.UpcomingRenewal),
  contractName: oz668.string(),
  contractId: oz668.string(),
  contractEndDate: ApiDateSchema,
  accountId: oz668.string(),
  customerName: oz668.string().optional(),
  isTrial: oz668.boolean().optional()
});

// src/async-messages/system-events/system-event-message-schemas/contract-expired-event-message.ts
import { oz as oz669 } from "@vy/utils";
var ContractExpiredSystemEventMessageSchema = BaseSystemEventMessageSchema.extend({
  eventType: oz669.literal(SYSTEM_EVENT_MESSAGE_TYPES.ContractExpired),
  contractName: oz669.string(),
  contractId: oz669.string(),
  contractEndDate: ApiDateSchema,
  customerName: oz669.string().optional(),
  isTrial: oz669.boolean().optional()
});

// src/async-messages/system-events/system-event-message-schemas/invoice-approved-event-message.ts
import { oz as oz670 } from "@vy/utils";
var InvoiceApprovedSystemEventMessageSchema = BaseSystemEventMessageSchema.extend({
  eventType: oz670.literal(SYSTEM_EVENT_MESSAGE_TYPES.InvoiceApproved),
  invoiceId: ObjectIdSchema
});

// src/async-messages/system-events/system-event-message-schemas/customer-updated-message.ts
import { oz as oz671 } from "@vy/utils";
var CustomerUpdatedMessageSchema = BaseSystemEventMessageSchema.extend({
  eventType: oz671.literal(SYSTEM_EVENT_MESSAGE_TYPES.CustomerUpdated),
  childCustomersChanged: oz671.boolean(),
  customerId: ObjectIdSchema
});

// src/async-messages/system-events/system-event-message-schemas/measurements-changed-message.ts
import { oz as oz672 } from "@vy/utils";
var MeasurementsChargedSystemEventMessageSchema = BaseSystemEventMessageSchema.extend({
  eventType: oz672.literal(SYSTEM_EVENT_MESSAGE_TYPES.MeasurementsCharged),
  measurementsCreatedIds: oz672.array(ObjectIdSchema),
  measurementsUpdatedIds: oz672.array(ObjectIdSchema),
  measurementsDeletedIds: oz672.array(ObjectIdSchema),
  customerIds: oz672.array(ObjectIdSchema),
  accountId: ObjectIdSchema.optional()
});

// src/async-messages/system-events/system-event-message-schemas/products-calculation-lifecycle-message.ts
import { oz as oz673 } from "@vy/utils";
var ProductsCalculationLifecycleSystemEventMessageSchema = BaseSystemEventMessageSchema.extend({
  eventType: oz673.literal(SYSTEM_EVENT_MESSAGE_TYPES.ProductCalculationLifecycle),
  productsIds: oz673.array(ObjectIdSchema),
  accountId: oz673.string().optional()
});

// src/async-messages/system-events/system-event-message-schemas/customer-portal-link-sent-message.ts
import { oz as oz674 } from "@vy/utils";
var CustomerPortalLinkSentSystemEventMessageSchema = BaseSystemEventMessageSchema.extend({
  eventType: oz674.literal(SYSTEM_EVENT_MESSAGE_TYPES.CustomerPortalLinkSent),
  errorMessage: oz674.string().optional(),
  customerId: oz674.string(),
  isSuccessful: oz674.boolean(),
  email: oz674.string().email()
});

// src/async-messages/system-events/system-event-message-schemas/month-end-report-system-event-message-schema.ts
import { oz as oz675 } from "@vy/utils";
var MonthEndReportSystemEventMessageSchema = BaseSystemEventMessageSchema.extend({
  eventType: oz675.literal(SYSTEM_EVENT_MESSAGE_TYPES.MonthEndReport),
  reportId: oz675.string(),
  reportName: oz675.string(),
  date: ApiDateSchema
});

// src/async-messages/system-events/system-event-message-schemas/uncharged-events-system-event-message-schema.ts
import { oz as oz676 } from "@vy/utils";
var UnchargedEventsSystemEventMessageSchema = BaseSystemEventMessageSchema.extend({
  eventType: oz676.literal(SYSTEM_EVENT_MESSAGE_TYPES.UnchargedEvents),
  date: ApiDateSchema,
  reportId: oz676.string()
});

// src/async-messages/system-events/system-event-message-schemas/tier-crossed-system-event-message-schema.ts
import { oz as oz677 } from "@vy/utils";
var TierCrossedSystemEventMessageSchema = BaseSystemEventMessageSchema.extend({
  eventType: oz677.literal(SYSTEM_EVENT_MESSAGE_TYPES.TierCrossed),
  contractName: oz677.string(),
  contractId: oz677.string(),
  customerId: oz677.string(),
  customerName: oz677.string(),
  duplicationId: oz677.string(),
  variantId: oz677.string().optional(),
  isTrial: oz677.boolean().optional()
});

// src/async-messages/system-events/system-event-message-schemas/final-tier-exceeded-system-event-message-schema.ts
import { oz as oz678 } from "@vy/utils";
var FinalTierExceededSystemEventMessageSchema = BaseSystemEventMessageSchema.extend({
  eventType: oz678.literal(SYSTEM_EVENT_MESSAGE_TYPES.FinalTierExceeded),
  contractName: oz678.string(),
  contractId: oz678.string(),
  customerId: oz678.string(),
  customerName: oz678.string(),
  productId: oz678.string(),
  productName: oz678.string(),
  accumulatedUnitsValue: oz678.number(),
  duplicationId: oz678.string(),
  isTrial: oz678.boolean().optional()
});

// src/async-messages/system-events/system-event-message-schemas/new-customer-without-contract-system-event-message-schema.ts.ts
import { oz as oz679 } from "@vy/utils";
var NewCustomerWithoutContractSystemEventMessageSchema = BaseSystemEventMessageSchema.extend({
  eventType: oz679.literal(SYSTEM_EVENT_MESSAGE_TYPES.NewCustomerWithoutContract),
  customerName: oz679.string(),
  customerId: oz679.string()
});

// src/async-messages/system-events/system-event-message-schemas/commitment-crossed-event-message.ts
import { oz as oz680 } from "@vy/utils";
var CommitmentCrossedSystemEventMessageSchema = BaseSystemEventMessageSchema.extend({
  eventType: oz680.literal(SYSTEM_EVENT_MESSAGE_TYPES.CommitmentCrossed),
  productConsumption: ProductConsumptionSchema,
  customerId: ObjectIdSchema
});

// src/async-messages/system-events/system-event-message-schemas/commitment-usage-crossed-event-message.ts
import { oz as oz681 } from "@vy/utils";
var CommitmentUsageCrossedSystemEventMessageSchema = BaseSystemEventMessageSchema.extend({
  eventType: oz681.literal(SYSTEM_EVENT_MESSAGE_TYPES.CommitmentUsageCrossed),
  productConsumption: ProductConsumptionSchema,
  customerId: ObjectIdSchema,
  threshold: oz681.number().gt(0),
  pctUsage: oz681.number().nonnegative()
});

// src/async-messages/system-events/system-event-message-schemas/currency-commitment-usage-crossed-event-message.ts
import { oz as oz682 } from "@vy/utils";
var CurrencyCommitmentUsageCrossedSystemEventMessageSchema = BaseSystemEventMessageSchema.extend({
  eventType: oz682.literal(SYSTEM_EVENT_MESSAGE_TYPES.CurrencyCommitmentUsageCrossed),
  productId: ObjectIdSchema,
  productName: oz682.string().nonempty(),
  customerId: ObjectIdSchema,
  threshold: oz682.number().gt(0),
  pctUsage: oz682.number().nonnegative(),
  currency: CurrencySchema,
  committedAmount: oz682.number().nonnegative(),
  consumedAmount: oz682.number().nonnegative(),
  cycleStart: ApiDateSchema
});

// src/async-messages/system-events/system-event-message-schemas/credit-pool-threshold-crossed-event-message.ts
import { oz as oz683 } from "@vy/utils";
var CreditPoolThresholdCrossedSystemEventMessageSchema = BaseSystemEventMessageSchema.extend({
  eventType: oz683.literal(SYSTEM_EVENT_MESSAGE_TYPES.CreditPoolThresholdCrossed),
  customerId: ObjectIdSchema,
  creditPoolId: ObjectIdSchema,
  creditTypeId: ObjectIdSchema,
  creditKind: CreditKindSchema,
  threshold: oz683.number().gt(0),
  pctUsage: oz683.number().nonnegative(),
  balance: oz683.number()
});

// src/async-messages/system-events/system-event-message-schemas/credit-pool-depleted-event-message.ts
import { oz as oz684 } from "@vy/utils";
var CreditPoolDepletedSystemEventMessageSchema = BaseSystemEventMessageSchema.extend({
  eventType: oz684.literal(SYSTEM_EVENT_MESSAGE_TYPES.CreditPoolDepleted),
  customerId: ObjectIdSchema,
  creditPoolId: ObjectIdSchema,
  creditTypeId: ObjectIdSchema,
  creditKind: CreditKindSchema,
  balance: oz684.number()
});

// src/async-messages/system-events/system-event-message-schemas/credit-pool-increased-event-message.ts
import { oz as oz685 } from "@vy/utils";
var CreditPoolIncreasedSystemEventMessageSchema = BaseSystemEventMessageSchema.extend({
  eventType: oz685.literal(SYSTEM_EVENT_MESSAGE_TYPES.CreditPoolIncreased),
  customerId: ObjectIdSchema,
  creditPoolId: ObjectIdSchema,
  creditTypeId: ObjectIdSchema,
  creditKind: CreditKindSchema,
  grantedAmount: oz685.number().positive(),
  previousBalance: oz685.number(),
  balance: oz685.number()
});

// src/async-messages/system-events/system-event-message-schemas/payment-created-event-message.ts
import { oz as oz686 } from "@vy/utils";
var PaymentCreatedEventMessageSchema = BaseSystemEventMessageSchema.extend({
  eventType: oz686.literal(SYSTEM_EVENT_MESSAGE_TYPES.PaymentCreated),
  paymentId: oz686.string()
});

// src/async-messages/system-events/system-event-message-schemas/payment-failed-event-message.ts
import { oz as oz687 } from "@vy/utils";
var PaymentFailedSystemEventMessageSchema = BaseSystemEventMessageSchema.extend({
  eventType: oz687.literal(SYSTEM_EVENT_MESSAGE_TYPES.PaymentFailed),
  invoiceId: ObjectIdSchema,
  customerId: ObjectIdSchema,
  paymentProvider: IntegrationProvidersSchema,
  amount: oz687.number().nonnegative().optional(),
  currency: CurrencySchema.optional(),
  failureReason: oz687.string().optional()
});

// src/async-messages/system-events/system-event-message-schemas/invoice-payment-status-changed-event-message.ts
import { oz as oz688 } from "@vy/utils";
var InvoicePaymentStatusChangedSystemEventMessageSchema = BaseSystemEventMessageSchema.extend({
  eventType: oz688.literal(SYSTEM_EVENT_MESSAGE_TYPES.InvoicePaymentStatusChanged),
  invoiceId: ObjectIdSchema,
  billingStatus: InvoiceBillingStatusSchema,
  amountDue: oz688.number(),
  amountPaid: oz688.number(),
  total: oz688.number(),
  dueDate: ApiDateSchema.optional(),
  paidAt: ApiDateSchema.optional(),
  invoicePdfUrl: oz688.string().optional()
});

// src/async-messages/system-events/system-event-message-schemas/task-finalized-event-message.ts
import { oz as oz689 } from "@vy/oz";
var TaskFinalizedEventSchema = oz689.object({
  taskId: oz689.string(),
  jobId: oz689.string()
});

// src/async-messages/system-events/system-event-message-schemas/invoice-export-orchestrator-message.ts
import { oz as oz690 } from "@vy/oz";
var InvoiceExportOrchestratorSchema = oz690.union([
  InvoiceApprovedSystemEventMessageSchema,
  TaskFinalizedEventSchema
]);

// src/async-messages/system-events/system-event-message-schemas/customer-created-event-message.ts
import { oz as oz691 } from "@vy/utils";
var CustomerCreatedSystemEventMessageSchema = BaseSystemEventMessageSchema.extend({
  eventType: oz691.literal(SYSTEM_EVENT_MESSAGE_TYPES.CustomerCreated),
  customerId: oz691.string(),
  name: oz691.string(),
  externalId: oz691.string().optional(),
  aliases: oz691.string().array(),
  integrationEntities: CustomerCreatedIntegrationEntitySchema.array()
});

// src/async-messages/system-events/system-event-message-schemas/contract-created-event-message.ts
import { oz as oz692 } from "@vy/utils";
var ContractCreatedSystemEventMessageSchema = BaseSystemEventMessageSchema.extend({
  eventType: oz692.literal(SYSTEM_EVENT_MESSAGE_TYPES.ContractCreated),
  contractId: oz692.string(),
  customerId: oz692.string(),
  contractName: oz692.string(),
  status: oz692.string(),
  startDate: ApiDateSchema,
  endDate: ApiDateSchema.optional(),
  customer: CustomerCreatedNotificationMetadataSchema
});

// src/async-messages/system-events/system-event-message-schema.ts
import { oz as oz693 } from "@vy/utils";
var SystemEventMessageSchema = oz693.discriminatedUnion("eventType", [
  OverageSystemEventMessageSchema,
  AnonymousCustomerIngestedSystemEventMessageSchema,
  UpcomingRenewalSystemEventMessageSchema,
  ContractExpiredSystemEventMessageSchema,
  InvoiceApprovedSystemEventMessageSchema,
  CustomerUpdatedMessageSchema,
  MeasurementsChargedSystemEventMessageSchema,
  ProductsCalculationLifecycleSystemEventMessageSchema,
  CustomerPortalLinkSentSystemEventMessageSchema,
  NewCustomerWithoutContractSystemEventMessageSchema,
  MonthEndReportSystemEventMessageSchema,
  UnchargedEventsSystemEventMessageSchema,
  TierCrossedSystemEventMessageSchema,
  CommitmentCrossedSystemEventMessageSchema,
  CommitmentUsageCrossedSystemEventMessageSchema,
  CurrencyCommitmentUsageCrossedSystemEventMessageSchema,
  CreditPoolThresholdCrossedSystemEventMessageSchema,
  CreditPoolDepletedSystemEventMessageSchema,
  CreditPoolIncreasedSystemEventMessageSchema,
  PaymentCreatedEventMessageSchema,
  PaymentFailedSystemEventMessageSchema,
  FinalTierExceededSystemEventMessageSchema,
  InvoicePaymentStatusChangedSystemEventMessageSchema,
  CustomerCreatedSystemEventMessageSchema,
  ContractCreatedSystemEventMessageSchema
]);

// src/async-messages/communications/send-credit-note-email-message-schema.ts
import { oz as oz694 } from "@vy/utils";
var SendCreditNoteEmailMessageSchema = oz694.object({
  isManual: oz694.boolean().optional(),
  creditLedgerEntryId: oz694.string(),
  emailOverride: oz694.string().email().optional()
});

// src/async-messages/communications/send-email-message-schema.ts
import { oz as oz695 } from "@vy/utils";
var SendEmailMessageSchema = oz695.object({
  messageId: oz695.string()
});

// src/async-messages/communications/send-invoice-email-message-schema.ts
import { oz as oz696 } from "@vy/utils";
var SendInvoiceEmailMessageSchema = oz696.object({
  isManual: oz696.boolean().optional(),
  invoiceId: oz696.string(),
  emailOverride: oz696.string().email().optional()
});

// src/async-messages/communications/update-email-messages-schema.ts
import { oz as oz697 } from "@vy/utils";
var UpdateEmailMessagesSchema = oz697.object({
  messageIds: oz697.array(oz697.string())
});

// src/async-messages/communications/send-slack-message-schema.ts
import { oz as oz698 } from "@vy/utils";
var SendSlackMessageSchema = oz698.object({
  accountId: oz698.string(),
  text: oz698.string()
});

// src/async-messages/webhooks/webhook-invoker-message.ts
import { oz as oz699 } from "@vy/utils";
var WebhookInvokerMessageSchema = oz699.object({
  accountId: oz699.string(),
  eventType: SystemEventTypesSchema
});

// src/async-messages/events-processor/match-customer-message-schema.ts
import { oz as oz700 } from "@vy/utils";
var MatchCustomerMessageSchema = oz700.object({
  customerId: ObjectIdSchema
});

// src/async-messages/events-processor/match-meter-message-schema.ts
import { oz as oz701 } from "@vy/utils";
var MatchMeterMessageSchema = oz701.object({
  meterId: oz701.string()
});

// src/async-messages/events-processor/customer-matched-message-schema.ts
var CustomerMatchedMessageSchema = DbCustomerEventSchema.extend({
  accountId: ObjectIdSchema
});

// src/async-messages/events-processor/delete-customer-events-message-schema.ts
import { oz as oz702 } from "@vy/utils";
var DeleteCustomerEventsMessageSchema = oz702.object({
  customerId: ObjectIdSchema
});

// src/async-messages/events-processor/update-customer-events-message-schema.ts
import { oz as oz703 } from "@vy/utils";
var UpdateCustomerEventsMessageSchema = oz703.object({
  customerId: ObjectIdSchema
});

// src/async-messages/events-processor/delete-metered-events-message-schema.ts
import { oz as oz704 } from "@vy/utils";
var DeleteMeteredEventsMessageSchema = oz704.object({
  meterId: ObjectIdSchema
});

// src/async-messages/events-processor/update-meter-message-schema.ts
import { oz as oz705 } from "@vy/utils";
var UpdateMeterMessageSchema = oz705.object({
  meterId: oz705.string()
});

// src/async-messages/events-processor/calculate-measurement-message-schema.ts
import { oz as oz706 } from "@vy/utils";
var CalculateMeasurementMessageSchema = oz706.object({
  accountId: ObjectIdSchema,
  meterId: ObjectIdSchema,
  customerId: ObjectIdSchema,
  timeSlot: TimeSlotSchema
});

// src/async-messages/events-processor/measurements-upsert-dispatcher-message-schema.ts
var MeasurementsUpsertDispatcherMessageSchema = NewMeasurementSchema.array().openapi(
  "MeasurementsUpsertDispatcherMessage"
);

// src/async-messages/events-processor/db-write-event-message-schema.ts
import { oz as oz707 } from "@vy/utils";
var DbThrottlerEventMessageSchema = oz707.object({
  customerEvent: CustomerEventSchema,
  meters: oz707.array(CreateMeteredEventSchema),
  enrichedData: EventDataSchema.optional(),
  enrichedEvent: CreatedIngestedEventSchema.optional()
});

// src/async-messages/events-processor/create-measurements-payload-schema.ts
var CreateMeasurementsPayloadSchema = NewMeasurementSchema.pick({
  customerId: true,
  meterId: true,
  value: true,
  accountId: true,
  period: true
}).extend({
  measurementTimeSlot: TimeSlotSchema
});

// src/async-messages/events-processor/update-measurements-payload-schema.ts
var UpdateMeasurementsPayloadSchema = MeasurementSchema.pick({
  id: true,
  value: true
});

// src/async-messages/events-processor/upsert-measurements-payload-schema.ts
import { oz as oz708 } from "@vy/utils";
var UpsertMeasurementsPayloadSchema = oz708.union([
  UpdateMeasurementsPayloadSchema,
  CreateMeasurementsPayloadSchema
]);

// src/async-messages/events-processor/event-aggregation-message-schema.ts
import { oz as oz709 } from "@vy/utils";
var EventAggregationMessageSchema = oz709.object({
  accountId: ObjectIdSchema,
  customerAlias: oz709.string(),
  eventName: oz709.string(),
  days: oz709.array(oz709.string())
});

// src/async-messages/usage-charges/calculate-usage-charges-controller-message.ts
import { oz as oz710 } from "@vy/utils";
var CalculateUsageChargesControllerMessageSchema = oz710.discriminatedUnion("eventType", [
  CustomerUpdatedMessageSchema,
  MeasurementsChargedSystemEventMessageSchema,
  ProductsCalculationLifecycleSystemEventMessageSchema
]);

// src/secrets/oauth-integration-secrets-schema.ts
import { oz as oz711 } from "@vy/utils";
var OAuthIntegrationSecretsSchema = oz711.object({
  CLIENT_ID: oz711.string(),
  CLIENT_SECRET: oz711.string(),
  SCOPES: oz711.string()
});

// src/secrets/net-suite-cert-secrets-schema.ts
import { oz as oz712 } from "@vy/utils";
var NetSuiteCertSecretsSchema = oz712.object({
  PRIVATE_KEY: oz712.string(),
  SIGNATURE_ALGORITHM: oz712.string()
});

// src/secrets/postgres-secrets-schema.ts
import { oz as oz713 } from "@vy/utils";
var EventsDbCredentialsSecretsSchema = oz713.object({
  username: oz713.string(),
  password: oz713.string(),
  name: oz713.string()
});

// src/secrets/open-ai-secrets-schema.ts
import { oz as oz714 } from "@vy/utils";
var OpenAISecretsSchema = oz714.object({
  API_KEY: oz714.string()
});

// src/secrets/clickhouse-secrets-schema.ts
import { oz as oz715 } from "@vy/utils";
var ClickHouseCredentialsSecretsSchema = oz715.object({
  username: oz715.string(),
  password: oz715.string(),
  database: oz715.string(),
  hostname: oz715.string()
});

// src/parameters/environment-api-parameters-schema.ts
import { oz as oz716 } from "@vy/utils";
var EnvironmentApiParametersSchema = oz716.object({
  allowedOrigins: oz716.string().array(),
  apiUrl: oz716.string(),
  hubspotSecretsId: oz716.string(),
  netSuiteSecretsId: oz716.string(),
  slackSecretsId: oz716.string(),
  clientUrl: oz716.string(),
  openAiModel: oz716.string(),
  openAiOrganization: oz716.string(),
  openAiProject: oz716.string(),
  openAiApiKey: oz716.string()
});

// src/parameters/global-api-parameters-schema.ts
import { oz as oz717 } from "@vy/utils";
var GlobalApiParametersSchema = oz717.object({
  vayuEmailAddress: oz717.string(),
  emailSource: oz717.string(),
  inviteUserEmailTemplateId: oz717.string(),
  openAiSecretsId: oz717.string(),
  langchainOpenAIModel: oz717.string()
});

// src/table-names.ts
var TABLE_NAMES = Object.freeze({
  CUSTOMERS: "customers",
  CONTRACTS: "contracts",
  INVOICES: "invoices",
  PAYMENTS: "payments"
});
export {
  ADVANCE_PAYMENT_CHARGE_TYPE,
  ADVANCE_PAYMENT_TYPES,
  AGGREGATION_METHOD_VALUES,
  AGGREGATION_OPERATORS,
  AGGREGATION_WITHOUT_FIELD_OPERATORS,
  AGGREGATION_WITH_FIELD_OPERATORS,
  ALL_ITEMS_PAGE_SIZE_CODE,
  AWSAuthDataSchema,
  AWS_REGIONS,
  AWS_REGIONS_MAP,
  AccountInputSchema,
  AccountProductSettingsSchema,
  AccountSchema,
  AccountSecuritySettingsSchema,
  AccountSettingsInputSchema,
  AccountSettingsSchema,
  AccountStatsCachingWorkerMessageSchema,
  AccumulateLineItemChargeMessageSchema,
  AccumulateMeteredEventMessageSchema,
  AddressSchema,
  AdvancePaymentChargeTypeSchema,
  AdvancePaymentSchema,
  AdvancePaymentTypesSchema,
  AdvancedFilterSchema,
  AffectedMeteredEventSampleSchema,
  AggregationAverageMethodSchema,
  AggregationDistinctMethodSchema,
  AggregationFirstMethodSchema,
  AggregationLastMethodSchema,
  AggregationMaxMethodSchema,
  AggregationMethodSchema,
  AggregationMinMethodSchema,
  AggregationOperatorSchema,
  AggregationSumMethodSchema,
  AggregationWithFieldOperatorSchema,
  AggregationWithoutFieldMethodSchema,
  AggregationWithoutFieldOperatorSchema,
  AnonymousCustomerIngestedSystemEventMessageSchema,
  AnonymousCustomerNotificationSchema,
  AnonymousCustomersReportSchema,
  AnonymousFixedVariantChargeSchema,
  AnonymousNotificationMetadataSchema,
  AnrokProductEntitySchema,
  ApiDateSchema,
  ApproveInvoicesMessageSchema,
  BACKFILL_QUERY_SCOPE_OPTIONS,
  BILLING_CYCLE_STATUSES,
  BILLING_INTERVALS,
  BackfillAnrokTransactionsMessageSchema,
  BankDetailsSchema,
  Base64Schema,
  BaseAdvancePaymentConfigSchema,
  BaseIntegrationConfigurationSchema,
  BaseIntegrationEntitySchema,
  BaseLineItemSchema,
  BaseNotificationSchema,
  BaseProductLineItemSchema,
  BaseSystemEventMessageSchema,
  BaseTextTemplateSchema,
  BearerTokenSchema,
  BillingCycleInputSchema,
  BillingCycleSchema,
  BillingCycleStatusSchema,
  BillingIntervalSchema,
  BillingSettingsSchema,
  BooleanFilterInputSchema,
  BooleanFilterOperatorSchema,
  BooleanPricingTemplateSchema,
  CHANNEL_TYPE,
  COMMITMENT_TYPES,
  CONTACT_EMAIL_REGEX,
  CONTACT_EMAIL_VALIDATION_ERROR_MESSAGE,
  CONTRACT_ADDITIONAL_FILTERS,
  CONTRACT_CREATION_TYPES,
  CONTRACT_STATUSES,
  CONTRACT_TYPES,
  CREDIT_EXPIRATION_POLICIES,
  CREDIT_KINDS,
  CREDIT_LEDGER_ENTRY_TYPE,
  CREDIT_SCHEDULES,
  CRITERION_OPERATORS,
  CRMIntegrationEntityMetadataSchema,
  CRM_INTEGRATION_PROVIDERS,
  CURRENCIES,
  CUSTOMER_FILTERS,
  CUSTOMER_RELATION_TYPES,
  CUSTOMER_SOURCES,
  CUSTOMER_STATUSES,
  CUSTOMER_TYPES,
  CalculateBillableItemsMessageSchema,
  CalculateConsumptionPeriodMessageSchema,
  CalculateInvoiceRevenueSchema,
  CalculateInvoicesByCustomerSchema,
  CalculateMeasurementMessageSchema,
  CalculateParentAgreementInvoicesMessageSchema,
  CalculateUsageChargesControllerMessageSchema,
  CatalogProductsSchema,
  ChannelTypeSchema,
  ChildConsumptionDataSchema,
  ChildCustomerOverviewSchema,
  ClickHouseCredentialsSecretsSchema,
  ClientChannelSchema,
  ClientNotificationSchema,
  CollectInvoiceMessageSchema,
  CommercialTermsPricingConfigurationSchema,
  CommercialTermsPricingInputSchema,
  CommercialTermsPricingSchema,
  CommercialTermsProductVariantInputSchema,
  CommercialTermsProductVariantSchema,
  CommissionPricingConfigurationSchema,
  CommissionPricingInputSchema,
  CommissionPricingSchema,
  CommissionProductVariantInputSchema,
  CommissionProductVariantSchema,
  CommitmentCrossedNotificationMetadataSchema,
  CommitmentCrossedNotificationSchema,
  CommitmentCrossedSystemEventMessageSchema,
  CommitmentInputSchema,
  CommitmentLineItemInputSchema,
  CommitmentLineItemSchema,
  CommitmentSchema,
  CommitmentTierInfoSchema,
  CommitmentTierUsageDataSchema,
  CommitmentTiersUsageMapSchema,
  CommitmentTypeSchema,
  CommitmentUsageCrossedNotificationMetadataSchema,
  CommitmentUsageCrossedNotificationSchema,
  CommitmentUsageCrossedSystemEventMessageSchema,
  CommitmentUsageReportItemSchema,
  CommitmentUsageReportSchema,
  CommitmentVsUsageReportItemSchema,
  CommitmentVsUsageSchema,
  ConditionInputSchema,
  ConditionSchema,
  ConfirmationCodeSchema,
  ConnectedIntegrationsSchema,
  ConsumptionPeriodMonthlyBucketSchema,
  ConsumptionPeriodSchema,
  ContactSchema,
  ContractAdditionalFilterSchema,
  ContractAdditionalFiltersSchema,
  ContractCalculatorControllerMessageSchema,
  ContractCreatedNotificationMetadataSchema,
  ContractCreatedNotificationSchema,
  ContractCreatedSystemEventMessageSchema,
  ContractCreationTypeSchema,
  ContractExpiredNotificationMetadataSchema,
  ContractExpiredNotificationSchema,
  ContractExpiredSystemEventMessageSchema,
  ContractExtensionMessageSchema,
  ContractInputSchema,
  ContractIntegrationEntitySchema,
  ContractOverviewSchema,
  ContractRenewalSchema,
  ContractSchema,
  ContractStatusSchema,
  ContractStatusesSchema,
  ContractTypeSchema,
  ContractVersionSchema,
  ContractsReportSchema,
  CreateCreditLedgerMessageSchema,
  CreateInvoicePdfMessageSchema,
  CreateMeasurementsPayloadSchema,
  CreateMeteredEventSchema,
  CreatedEntitySchema,
  CreatedEventSchema,
  CreatedIngestedEventSchema,
  CreditExpirationPolicySchema,
  CreditKindSchema,
  CreditLedgerEntryOverviewSchema,
  CreditLedgerEntrySchema,
  CreditLedgerEntryTypeSchema,
  CreditLedgerSchema,
  CreditPoolDepletedNotificationMetadataSchema,
  CreditPoolDepletedNotificationSchema,
  CreditPoolDepletedSystemEventMessageSchema,
  CreditPoolIncreasedNotificationMetadataSchema,
  CreditPoolIncreasedNotificationSchema,
  CreditPoolIncreasedSystemEventMessageSchema,
  CreditPoolThresholdCrossedNotificationMetadataSchema,
  CreditPoolThresholdCrossedNotificationSchema,
  CreditPoolThresholdCrossedSystemEventMessageSchema,
  CreditProductConfigurationSchema,
  CreditProductSettingsSchema,
  CreditPromotionConfigurationInputSchema,
  CreditPromotionConfigurationSchema,
  CreditPromotionModelSchema,
  CreditPurchaseConfigSchema,
  CreditScheduleSchema,
  CriterionOperatorSchema,
  CriterionSchema,
  CrmIntegrationProvidersSchema,
  CrmIntermediateMetadataSchema,
  CrmProviderIntegrationEntitySchema,
  CurrencyCommitmentUsageCrossedNotificationMetadataSchema,
  CurrencyCommitmentUsageCrossedNotificationSchema,
  CurrencyCommitmentUsageCrossedSystemEventMessageSchema,
  CurrencyExchangeRatesSchema,
  CurrencySchema,
  CustomFieldSchema,
  CustomerCalculatorControllerMessageSchema,
  CustomerCalculatorMessageSchema,
  CustomerChildrenRelationsSchema,
  CustomerCloudProviderSettingsSchema,
  CustomerCreatedIntegrationEntitySchema,
  CustomerCreatedNotificationMetadataSchema,
  CustomerCreatedNotificationSchema,
  CustomerCreatedSystemEventMessageSchema,
  CustomerEventSchema,
  CustomerFilterSchema,
  CustomerFiltersSchema,
  CustomerInputSchema,
  CustomerIntegrationEntitySchema,
  CustomerMasterContractSchema,
  CustomerMasterCustomerSchema,
  CustomerMasterReportSchema,
  CustomerMatchedMessageSchema,
  CustomerNoteSchema,
  CustomerPortalCheckoutLinkTokenParamsSchema,
  CustomerPortalCustomerSchema,
  CustomerPortalInvoiceSchema,
  CustomerPortalLinkSentNotificationMetadataSchema,
  CustomerPortalLinkSentNotificationSchema,
  CustomerPortalLinkSentSystemEventMessageSchema,
  CustomerPortalTokenParamsSchema,
  CustomerRelationSchema,
  CustomerRelationTypeSchema,
  CustomerRevenueReportItemSchema,
  CustomerRevenueReportSchema,
  CustomerSchema,
  CustomerSettingsSchema,
  CustomerSourcesSchema,
  CustomerStatusSchema,
  CustomerTypeSchema,
  CustomerUpdatedMessageSchema,
  CustomerUsageBreakdownSchema,
  CustomersReportItemSchema,
  CustomersReportSchema,
  DBIngestedEventSchema,
  DEFAULT_CURRENCY,
  DEFAULT_PAGE_NUMBER,
  DEFAULT_PAGE_SIZE,
  DEFAULT_PAYMENT_DUE_DAYS,
  DEPOSIT_TO_PROVIDERS,
  DISCOUNT_MODELS,
  DISCOUNT_TYPES,
  DateFilterInputSchema,
  DateFilterOperatorSchema,
  DbCustomerEventSchema,
  DbMeteredEventSchema,
  DbThrottlerEventMessageSchema,
  DeductCreditsMessageSchema,
  DeductibleLineItemCalculatorMessageSchema,
  DeleteCustomerEventsMessageSchema,
  DeleteMeteredEventsMessageSchema,
  DeletedEntitySchema,
  DepositToProviderSchema,
  DisconnectedMeterBreakpointSchema,
  DisconnectedMeterSchema,
  DiscountConfigurationSchema,
  DiscountModelSchema,
  DiscountTypeSchema,
  EMAIL_STATUSES,
  EMAIL_TYPES,
  EMAIL_VERIFICATION_EVENTS,
  EMAIL_VERIFICATION_SOURCE,
  ERPIntegrationEntityMetadataSchema,
  ERP_INTEGRATION_PROVIDERS,
  EVENT_FIELD_TYPES,
  EVENT_METERING_STATUSES,
  EmailChannelSchema,
  EmailMessageSchema,
  EmailSettingsSchema,
  EmailStatusSchema,
  EmailStatusesSchema,
  EmailTypeSchema,
  EmailVerificationEventSchema,
  EmailVerificationEventsSchema,
  EmailVerificationMessageSchema,
  EmailVerificationSourceSchema,
  EntityMappingSchema,
  EntityOfInvoiceCalculatorControllerMessageSchema,
  EnumFilterInputSchema,
  EnumFilterOperatorSchema,
  EnumPricingTemplateSchema,
  EnvironmentApiParametersSchema,
  ErpIntegrationProvidersSchema,
  ErpIntermediateMetadataSchema,
  ErpProviderIntegrationEntitySchema,
  ErpSubsidiarySchema,
  ErpSubsidiarySettingsSchema,
  EventAggregationMessageSchema,
  EventDataSchema,
  EventFieldExtractorPayloadSchema,
  EventFieldSchema2 as EventFieldSchema,
  EventFieldTypeSchema,
  EventMeteringStatusSchema,
  EventNameSchema,
  EventSchema,
  EventsDbCredentialsSecretsSchema,
  EventsPayloadSchema,
  ExportCustomerMessageSchema,
  ExternalCustomerIntegrationSchema,
  ExternalPaymentSchema,
  ExternalProductIntegrationSchema,
  ExtractedPlanSchema,
  FEATURE_FLAG,
  FILTER_OPERATORS,
  FIXED_PRICING_MODELS,
  FIXED_PRODUCT_TYPES,
  FailedInvoiceDeliveriesReportItemSchema,
  FailedInvoiceDeliveriesReportSchema,
  FieldMappingSchema,
  FilterInputSchema,
  FilterOperatorsSchema,
  FilterSchema,
  FinalTierExceededNotificationMetadataSchema,
  FinalTierExceededNotificationSchema,
  FinalTierExceededSystemEventMessageSchema,
  FixedChargesInvoicesAssociatorMessageSchema,
  FixedDeductionPricingConfigurationSchema,
  FixedDeductionPricingInputSchema,
  FixedDeductionPricingSchema,
  FixedDeductionProductVariantSchema,
  FixedLineItemInputSchema,
  FixedLineItemSchema,
  FixedPricingConfigurationSchema,
  FixedPricingInputSchema,
  FixedPricingModelsSchema,
  FixedPricingSchema,
  FixedProductInputSchema,
  FixedProductSchema,
  FixedProductTypeSchema,
  FixedProductVariantInputSchema,
  FixedProductVariantSchema,
  FixedVariantChargeCalculatorMessageSchema,
  FixedVariantChargeSchema,
  FreeTrialPromotionConfigurationInputSchema,
  FreeTrialPromotionConfigurationSchema,
  FreeTrialPromotionModelSchema,
  FullDayPeriodSchema,
  GlobalApiParametersSchema,
  GrantCreditsMessageSchema,
  HUBSPOT_CREATE_TOKEN_ACTIONS,
  HubspotCompanyImportMessageSchema,
  HubspotCompanyPropertiesSchema,
  HubspotCompanySchema,
  HubspotContactPropertiesSchema,
  HubspotContactSchema,
  HubspotContractEntitySchema,
  HubspotCustomerEntitySchema,
  HubspotDealAssociationsSchema,
  HubspotDealImportMessageSchema,
  HubspotDealPropertiesSchema,
  HubspotDealSchema,
  HubspotIntegrationConfigurationSchema,
  HubspotIntegrationSettingsSchema,
  HubspotOwnerSchema,
  HubspotProductPropertiesSchema,
  HubspotProductSchema,
  INTEGRATION_PROVIDERS,
  INVOICES_OVERVIEWS_ADDITIONAL_FILTERS,
  INVOICE_BILLING_STATUSES,
  INVOICE_CALCULATION_STATUSES,
  INVOICE_CREATED_EVENT_PAYLOAD_TYPES,
  INVOICE_CUSTOM_FIELD_PREFIX,
  INVOICE_DUE_DATE_VALUES,
  INVOICE_FILTERABLE_FIELDS,
  INVOICE_PDF_TEMPLATE_KEYS,
  INVOICE_PDF_TYPES,
  INVOICE_REVIEW_STATUSES,
  INVOICE_TYPES,
  ImportSalesforceCustomersMessageSchema,
  ImportStripeCustomerPaymentsMessageSchema,
  ImportStripeCustomersMessageSchema,
  InflationaryUpliftMessageSchema,
  IngestedEventSampleSchema,
  IngestedEventSchema,
  IngestedMatchedEventSchema,
  IngestedMeterSchema,
  IngestionCustomerSchema,
  IntegrationBaseSyncMessageSchema,
  IntegrationExportSchema,
  IntegrationProvidersSchema,
  IntegrationSchema,
  IntegrationSettingsSchema,
  IntegrationVersion,
  IntegrationVersionSchema,
  InvitedUserPayloadSchema,
  InvoiceAmountFieldPathSchema,
  InvoiceAmountFilterSchema,
  InvoiceApprovedNotificationMetadataSchema,
  InvoiceApprovedNotificationSchema,
  InvoiceApprovedSystemEventMessageSchema,
  InvoiceBalanceSchema,
  InvoiceBillingStatusFieldPathSchema,
  InvoiceBillingStatusFilterSchema,
  InvoiceBillingStatusSchema,
  InvoiceBillingStatusUpdatedMessageSchema,
  InvoiceBillingStatusesSchema,
  InvoiceCalculationStatusSchema,
  InvoiceCalculatorControllerMessageSchema,
  InvoiceCalculatorSchema,
  InvoiceChargeCalculationBreakdownSchema,
  InvoiceContractPlanNameFieldPathSchema,
  InvoiceContractPlanNameFilterSchema,
  InvoiceContractStatusFieldPathSchema,
  InvoiceContractStatusFilterSchema,
  InvoiceContractStatusValueSchema,
  InvoiceCreatedEventPayloadSchema,
  InvoiceCreatedEventPayloadTypesSchema,
  InvoiceCreatedFromApiEventPayloadSchema,
  InvoiceCreatedFromPricingEventPayloadSchema,
  InvoiceCurrencyFieldPathSchema,
  InvoiceCurrencyFilterSchema,
  InvoiceCurrencyValueSchema,
  InvoiceCustomFieldFieldPathSchema,
  InvoiceCustomFieldFilterSchema,
  InvoiceCustomerIdFieldPathSchema,
  InvoiceCustomerIdFilterSchema,
  InvoiceDateSchema,
  InvoiceDueDateFieldPathSchema,
  InvoiceDueDateFilterSchema,
  InvoiceEmailTemplateSchema,
  InvoiceExportOrchestratorSchema,
  InvoiceFilterSchema,
  InvoiceFinalizerMessageSchema,
  InvoiceIntegrationEntitySchema,
  InvoiceIssuedAtFieldPathSchema,
  InvoiceIssuedAtFilterSchema,
  InvoiceLastSentFieldPathSchema,
  InvoiceLastSentFilterSchema,
  InvoiceManualReviewFieldPathSchema,
  InvoiceManualReviewFilterSchema,
  InvoiceMarketplaceSyncFieldPathSchema,
  InvoiceMarketplaceSyncFilterSchema,
  InvoiceMarketplaceSyncValueSchema,
  InvoiceMeteredFieldPathSchema,
  InvoiceMeteredFilterSchema,
  InvoiceNameFieldPathSchema,
  InvoiceNameFilterSchema,
  InvoiceNotesFieldPathSchema,
  InvoiceNotesFilterSchema,
  InvoiceOverageFieldPathSchema,
  InvoiceOverageFilterSchema,
  InvoicePaymentProviderInformationSchema,
  InvoicePaymentStatusChangedMetadataSchema,
  InvoicePaymentStatusChangedNotificationSchema,
  InvoicePaymentStatusChangedSystemEventMessageSchema,
  InvoicePdfTemplateKeySchema,
  InvoicePdfTemplateSchema,
  InvoicePdfTypeSchema,
  InvoicePeriodFieldPathSchema,
  InvoicePeriodFilterSchema,
  InvoicePurchaseOrderFieldPathSchema,
  InvoicePurchaseOrderFilterSchema,
  InvoiceReviewStatusFieldPathSchema,
  InvoiceReviewStatusFilterSchema,
  InvoiceReviewStatusSchema,
  InvoiceReviewStatusUpdatedMessageSchema,
  InvoiceReviewStatusesSchema,
  InvoiceSchema,
  InvoiceSendFailedNotificationMetadataSchema,
  InvoiceSendFailedNotificationSchema,
  InvoiceSnapshotCustomerSchema,
  InvoiceSnapshotSchema,
  InvoiceSubsidiaryFieldPathSchema,
  InvoiceSubsidiaryFilterSchema,
  InvoiceSyncIntegrationFieldPathSchema,
  InvoiceSyncIntegrationFilterSchema,
  InvoiceSyncIntegrationValueSchema,
  InvoiceTypeSchema,
  InvoiceYearlyCommitmentFieldPathSchema,
  InvoiceYearlyCommitmentFilterSchema,
  InvoicesCalculatorSchema,
  InvoicesLifeCycleManagerMessageSchema,
  InvoicesOverviewsAdditionalFilterSchema,
  InvoicesOverviewsAdditionalFiltersSchema,
  InvoicingChargeSchema,
  InvoicingChargesCalculatorMessageSchema,
  InvoicingSettingsSchema,
  JournalEntriesReportSchema,
  JournalEntryAccountSchema,
  JournalEntryLineSchema,
  JournalEntrySchema,
  JournalEntryStatusSchema,
  JsonSchema,
  JwtSchema,
  LABEL_ENTITY_TYPES,
  LINE_ITEM_ORDER_KINDS,
  LINE_ITEM_TYPES,
  LINE_ITEM_WITH_NO_PRODUCT_TYPES,
  LabelSchema,
  LabelSummarySchema,
  LineItemCalculatorMessageSchema,
  LineItemInputSchema,
  LineItemOrderEntrySchema,
  LineItemOrderSchema,
  LineItemProductCommitmentInputSchema,
  LineItemProductCommitmentSchema,
  LineItemProductInputSchema,
  LineItemProductSchema,
  LineItemProductVariantInputSchema,
  LineItemProductVariantMeterInputSchema,
  LineItemProductVariantMeterSchema,
  LineItemProductVariantSchema,
  LineItemPromotionInputSchema,
  LineItemPromotionSchema,
  LineItemSchema,
  LineItemTypeSchema,
  LineItemWithNoProductTypeSchema,
  LineItemsCalculatorMessageSchema,
  MARKETPLACE_SYNC_FILTER_STATUSES,
  MASTER_PERMISSIONS,
  MAX_DAYS_TO_APPROVE,
  MAX_DURATION,
  MAX_EVENTS,
  MAX_PAGE_SIZE,
  MAX_TO,
  MIGRATE_AUTO_SCOPE_OPTIONS,
  MINIMUM_MULTI_YEAR_DURATION_MONTHS,
  MIN_EVENTS,
  MONGO_FILTER_OPERATORS,
  MONTHS,
  MONTHS_ENUM,
  MarketplaceSyncFilterStatusSchema,
  MatchCustomerMessageSchema,
  MatchMeterMessageSchema,
  MeasuredPriceBreakdownSchema,
  MeasuredPriceSchema,
  MeasurementPriceSchema,
  MeasurementSchema,
  MeasurementsChargedSystemEventMessageSchema,
  MeasurementsUpsertDispatcherMessageSchema,
  MeterInputSchema,
  MeterProductSchema,
  MeterSchema,
  MeterSqlConfigSchema,
  MeteredEventSchema,
  MeteringSettingsSchema,
  MinimalCustomerReaderSchema,
  MinimalCustomerSchema,
  MonthEndReportNotificationMetadataSchema,
  MonthEndReportNotificationSchema,
  MonthEndReportSystemEventMessageSchema,
  MonthlyClosureReportSchema,
  MonthsSchema,
  MorningAuthDataSchema,
  MorningCustomerEntitySchema,
  MorningMetadataSchema,
  MorningSettingsSchema,
  MrrMovementType,
  NET_SUITE_BILLING_STATUSES,
  NET_SUITE_INTEGRATION_TYPES,
  NOTIFICATION_ALERT_STATUSES,
  NOTIFICATION_ENTITY_TYPES,
  NOTIFICATION_EVENT_TYPES,
  NetSuiteAuthDataSchema,
  NetSuiteBillingStatusSchema,
  NetSuiteCertSecretsSchema,
  NetSuiteClassSchema,
  NetSuiteContractEntitySchema,
  NetSuiteCreditMemoItemSchema,
  NetSuiteCreditMemoSchema,
  NetSuiteCustomerEntitySchema,
  NetSuiteCustomerSchema,
  NetSuiteIntegrationConfigurationSchema,
  NetSuiteIntegrationSettingsSchema,
  NetSuiteIntegrationTypesSchema,
  NetSuiteInvoiceEntitySchema,
  NetSuiteInvoiceItemClassSchema,
  NetSuiteInvoiceItemSchema,
  NetSuiteInvoiceResponseSchema,
  NetSuiteInvoiceSchema,
  NetSuiteProductEntitySchema,
  NetSuiteProductSchema,
  NetSuiteRestAuthDataSchema,
  NetSuiteSalesOrderItemSchema,
  NetSuiteSalesOrderSchema,
  NetSuiteSettingsSchema,
  NetSuiteSoapAuthDataSchema,
  NetSuiteSubsidiarySchema,
  NetSuiteSyncInvoicePayloadSchema,
  NetSuiteSyncInvoiceResponseSchema,
  NetsuiteInvoiceInternalItemSchema,
  NewAccountSchema,
  NewAccountSettingsSchema,
  NewBankDetailsSchema,
  NewBillingCycleSchema,
  NewBillingSettingsSchema,
  NewCalculateInvoiceSchema,
  NewCatalogProductSchema,
  NewCommercialTermsVariantSchema,
  NewCommitmentLineItemSchema,
  NewConsumptionPeriodMonthlyBucketSchema,
  NewConsumptionPeriodSchema,
  NewContractSchema,
  NewContractSchemaWithPlan,
  NewContractSchemaWithPlanBase,
  NewContractSchemaWithoutPlan,
  NewCustomerRelationSchema,
  NewCustomerSchema,
  NewCustomerWithoutContractNotificationMetadataSchema,
  NewCustomerWithoutContractNotificationSchema,
  NewCustomerWithoutContractSystemEventMessageSchema,
  NewEventSchema,
  NewFixedLineItemSchema,
  NewFixedProductSchema,
  NewFixedProductVariantSchema,
  NewFixedVariantChargeSchema,
  NewInvoiceSchema,
  NewInvoicingChargeSchema,
  NewLabelSchema,
  NewLineItemProductCommitmentSchema,
  NewLineItemProductSchema,
  NewLineItemProductVariantMeterSchema,
  NewLineItemProductVariantSchema,
  NewLineItemPromotionSchema,
  NewLineItemSchema,
  NewMeasurementSchema,
  NewMeterSchema,
  NewNonProductFixedLineItemSchema,
  NewNotificationSubscriptionSchema,
  NewOneTimeProductVariantSchema,
  NewPaymentSchema,
  NewPerUnitProductVariantSchema,
  NewPhaseLabelSchema,
  NewPlanSchema,
  NewProductPeriodSchema,
  NewProductSchema,
  NewProductVariantSchema,
  NewPromotionSchema,
  NewRevisionedLineItemSchema,
  NewScheduledInstallmentSchema,
  NewSubscriptionProductVariantSchema,
  NewSubsidiarySchema,
  NewSystemEventSchema,
  NewTieredSubscriptionProductVariantSchema,
  NewTiersProductVariantSchema,
  NewUsageLineItemSchema,
  NewUsageProductSchema,
  NewUsageProductVariantSchema,
  NewUsageVariantChargeSchema,
  NewUserSchema,
  NewVariantChargeSchema,
  NonProductFixedLineItemInputSchema,
  NonProductFixedLineItemSchema,
  NotificationAlertSchema,
  NotificationAlertStatusSchema,
  NotificationChannelSchema,
  NotificationEmitterMessageSchema,
  NotificationEntityTypeSchema,
  NotificationEventTypeSchema,
  NotificationSchema,
  NotificationSubscriptionSchema,
  NumberFilterInputSchema,
  NumberFilterOperatorSchema,
  NumberPricingTemplateSchema,
  OAuth2DataSchema,
  OAuth2IntegrationSchema,
  OAuthIntegrationSecretsSchema,
  OVERAGE_SETTINGS,
  OVERDUE_BUCKET_THRESHOLDS,
  ObjectIdSchema,
  OneTimePricingConfigurationSchema,
  OneTimePricingInputSchema,
  OneTimePricingSchema,
  OneTimeProductVariantInputSchema,
  OneTimeProductVariantSchema,
  OpenAISecretsSchema,
  OriginalInvoiceDataSchema,
  OverageNotificationMetadataSchema,
  OverageNotificationSchema,
  OverageSettingsSchema,
  OverageSystemEventMessageSchema,
  PAYMENT_INTEGRATION_PROVIDERS,
  PAYMENT_PROVIDERS,
  PAYMENT_STATUSES,
  PAYMENT_TERMS,
  PERMISSIONS,
  PERMISSIONS_GROUPS,
  PHASE_TYPES,
  PHONE_REGEX,
  PHONE_VALIDATION_ERROR_MESSAGE,
  PLAN_STATUSES,
  PRICING_MODELS,
  PRICING_TEMPLATE_TYPES,
  PRIMITIVE_TYPES,
  PRODUCT_CONFIG_STATUSES,
  PROMOTION_PRICING_MODELS,
  PROMOTION_TYPES,
  PaddlePaymentEntitySchema,
  PaddleProductEntitySchema,
  PageNumberSchema,
  PageSizeSchema,
  PaginationSchema,
  ParameterizedAggregationMethodSchema,
  ParentAgreementSettingsSchema,
  PartialHubspotIntegrationConfigurationSchema,
  PartialNetSuiteIntegrationConfigurationSchema,
  PartialSalesforceIntegrationConfigurationSchema,
  PartialSlackIntegrationConfigurationSchema,
  PartialStripeIntegrationConfigurationSchema,
  PasswordSchema,
  PaymentCreatedEventMessageSchema,
  PaymentFailedNotificationMetadataSchema,
  PaymentFailedNotificationSchema,
  PaymentFailedSystemEventMessageSchema,
  PaymentInfoSchema,
  PaymentInputSchema,
  PaymentIntegrationEntityMetadataSchema,
  PaymentIntegrationEntitySchema,
  PaymentIntegrationProvidersSchema,
  PaymentProviderIntegrationEntitySchema,
  PaymentProviderSchema,
  PaymentSchema,
  PaymentStatusSchema,
  PaymentTermSchema,
  PerUnitPricingConfigurationSchema,
  PerUnitPricingInputSchema,
  PerUnitPricingSchema,
  PerUnitProductVariantInputSchema,
  PerUnitProductVariantSchema,
  PercentageDeductionPricingConfigurationSchema,
  PercentageDeductionPricingInputSchema,
  PercentageDeductionPricingSchema,
  PercentageDeductionProductVariantSchema,
  PercentagePromotionConfigurationInputSchema,
  PercentagePromotionConfigurationSchema,
  PeriodSchema,
  PermissionSchema,
  PhaseLabelSchema,
  PhaseTypeSchema,
  PlanBillingDataSchema,
  PlanDurationSchema,
  PlanInputFormFixedProductSchema,
  PlanInputFormUsageProductSchema,
  PlanInputSchema,
  PlanSchema,
  PlanStatusSchema,
  PlanStatusesSchema,
  PriceEventMessageSchema,
  PriceSchema,
  PriceTierSchema,
  PriceTiersListSchema,
  PricingInputSchema,
  PricingModelSchema,
  PricingSchema,
  PricingTemplateSchema,
  PricingTemplateTypeSchema,
  PrimitiveTypeSchema,
  ProductCloudProviderSettingsSchema,
  ProductConfigSchema,
  ProductConfigurationSchema,
  ProductConsumptionSchema,
  ProductHubspotEntitySchema,
  ProductInputSchema,
  ProductIntegrationEntitySchema,
  ProductPeriodCalculatorMessageSchema,
  ProductPeriodSchema,
  ProductSchema,
  ProductSettingsSchema,
  ProductUsageReportSchema,
  ProductVariantInputSchema,
  ProductVariantSchema,
  ProductsCalculationLifecycleSystemEventMessageSchema,
  ProductsUsageReportSchema,
  PromotionConfigurationInputSchema,
  PromotionConfigurationSchema,
  PromotionInputSchema,
  PromotionModelInputSchema,
  PromotionModelSchema,
  PromotionSchema,
  PromotionTypeSchema,
  QuickBooksCustomerEntitySchema,
  QuickBooksCustomerSchema,
  QuickBooksProductEntitySchema,
  QuickBooksProductSchema,
  QuickBooksSettingsSchema,
  REPORT_JOB_INVOCATION_TYPES,
  REPORT_JOB_STATUSES,
  REPORT_JOB_TYPES,
  REVENUE_RECOGNITION_TYPE,
  REVISIONED_LINE_ITEM_TYPES,
  ROLES,
  ROLES_PERMISSIONS,
  ReconcileRevenueRecognitionMessageSchema,
  RecurringRevenueContractRecalcMessageSchema,
  RecurringRevenueContractRecalcTriggerReasonSchema,
  RecurringRevenueProductRecalcMessageSchema,
  RecurringRevenueProductRecalcTriggerReasonSchema,
  RecurringRevenueReportSchema,
  RefinedContactSchema,
  RefundPricingConfigurationSchema,
  RefundPricingInputSchema,
  RefundPricingSchema,
  RefundProductVariantSchema,
  ReportDataSchema,
  ReportDatesSchema,
  ReportJobInvocationTypesSchema,
  ReportJobRequestMessageSchema,
  ReportJobStatusesSchema,
  ReportJobTypesSchema,
  ResetPasswordSchema,
  RevenueBreakdownSchema,
  RevenuePerMonthBreakdownSchema,
  RevenuePerMonthSchema,
  RevisionSchema,
  RevisionedLineItemSchema,
  RevisionedLineItemTypeSchema,
  RolesSchema,
  S3AuthDataSchema,
  S3IngestedEventSchema,
  SANDBOX_ENVIRONMENTS,
  SANITY_CHECK_STATUSES,
  SANITY_CHECK_TESTS,
  SEND_GRID_WEBHOOK_EVENTS,
  SORTING_OPTIONS,
  STRIPE_INVOICE_STATUSES,
  SYNC_ENTITIES,
  SYNC_STATUSES,
  SYSTEM_EVENT_MESSAGE_TYPES,
  SYSTEM_EVENT_TYPES,
  SYSTEM_TYPES,
  SaleTaxSchema,
  SalesforceAccountSchema,
  SalesforceAuthDataSchema,
  SalesforceContactSchema,
  SalesforceContractEntitySchema,
  SalesforceCustomerEntitySchema,
  SalesforceIntegrationConfigurationSchema,
  SalesforceIntegrationSettingsSchema,
  SalesforceMeshContractSchema,
  SalesforceMeshContractWithCustomerSchema,
  SandboxEnvironmentSchema,
  SanitizedStringSchema,
  SanityCheckReportSchema,
  SanityCheckStatusSchema,
  SanityCheckTestSchema,
  ScalarValueSchema,
  ScheduledInstallmentConfigurationSchema,
  SendCreditNoteEmailMessageSchema,
  SendEmailMessageSchema,
  SendGridEventSchema,
  SendGridWebhookEventSchema,
  SendInvoiceEmailMessageSchema,
  SendSlackMessageSchema,
  ServiceProductConfigurationSchema,
  ServiceProductSettingsSchema,
  ShareableTokenParamsSchema,
  SlackBlockSchema,
  SlackChannelOptionSchema,
  SlackChannelSchema,
  SlackIntegrationConfigurationSchema,
  SlackIntegrationSettingsSchema,
  SlackInvoiceDataSchema,
  SlackTextBlockSchema,
  SlackUserPayloadSchema,
  SlackUserSchema,
  SortingItemSchema,
  SqlSafeStringSchema,
  StringFilterInputSchema,
  StringFilterOperatorSchema,
  StripeAuthDataSchema,
  StripeCustomerEntitySchema,
  StripeIntegrationConfigurationSchema,
  StripeIntegrationSettingsSchema,
  StripeIntermediateMetadataSchema,
  StripeInvoiceEntitySchema,
  StripeInvoiceStatusSchema,
  StripeMetadataSchema,
  StripePaymentEntitySchema,
  SubscriptionPricingConfigurationSchema,
  SubscriptionPricingInputSchema,
  SubscriptionPricingSchema,
  SubscriptionProductVariantInputSchema,
  SubscriptionProductVariantSchema,
  SubsidiaryInputSchema,
  SubsidiarySchema,
  SyncEntitySchema,
  SyncHubspotContractsMessageSchema,
  SyncHubspotCustomersDispatcherMessageSchema,
  SyncJobAttemptSchema,
  SyncNetSuiteInvoicesStatusesMessageSchema,
  SyncStatusSchema,
  SyncStatusesSchema,
  SystemEventMessageSchema,
  SystemEventMessageTypeSchema,
  SystemEventSchema,
  SystemEventTypesSchema,
  SystemTypesSchema,
  TABLE_NAMES,
  TEXT_TEMPLATE_ENTITY_TYPES,
  TEXT_TEMPLATE_TYPES,
  TIME_UNITS,
  TRIAL_DURATION_TYPES,
  TRIGGER_REPORT_JOB_MESSAGE_ATTRIBUTES,
  TaskFinalizedEventSchema,
  TaxRateSchema,
  TextTemplateEntitySchema,
  TextTemplateEntityTypeSchema,
  TextTemplateSchema,
  TextTemplateTypeSchema,
  TierCrossedNotificationMetadataSchema,
  TierCrossedNotificationSchema,
  TierCrossedSystemEventMessageSchema,
  TierDiscountConfigurationSchema,
  TierUsageDataInputSchema,
  TierUsageDataSchema,
  TieredSubscriptionPricingConfigurationInputSchema,
  TieredSubscriptionPricingConfigurationSchema,
  TieredSubscriptionPricingInputSchema,
  TieredSubscriptionPricingSchema,
  TieredSubscriptionProductVariantInputSchema,
  TieredSubscriptionProductVariantSchema,
  TieredSubscriptionSettingsSchema,
  TiersAdvancePaymentConfigSchema,
  TiersAdvancePaymentSchema,
  TiersPricingConfigurationInputSchema,
  TiersPricingConfigurationSchema,
  TiersPricingInputSchema,
  TiersPricingSchema,
  TiersProductVariantInputSchema,
  TiersProductVariantSchema,
  TiersUsageMapInputSchema,
  TiersUsageMapSchema,
  TimeSlotSchema,
  TimeUnitsSchema,
  TimelineCalculatorMessageSchema,
  TimelineSchema,
  TrialDurationSchema,
  UNCHARGED_USAGE_REASON,
  UNLIMITED_DURATION,
  UPLIFT_DURATION_ERROR_MESSAGE,
  UPLIFT_FLAG_KEYS,
  USAGE_PRICING_MODELS,
  USER_INVITATION_STATUSES,
  UnapprovedInvoicesReportItemSchema,
  UnapprovedInvoicesReportSchema,
  UnchargedEventsNotificationMetadataSchema,
  UnchargedEventsNotificationSchema,
  UnchargedEventsSystemEventMessageSchema,
  UnchargedUsageReportSchema,
  UnlimitedDurationSchema,
  UnmeteredEventsReasonSchema,
  UnmeteredEventsReportItemSchema,
  UnmeteredEventsReportSchema,
  UpcomingInvoicesReportItemSchema,
  UpcomingInvoicesReportSchema,
  UpcomingRenewalNotificationMetadataSchema,
  UpcomingRenewalNotificationSchema,
  UpcomingRenewalSystemEventMessageSchema,
  UpdateCustomerEventsMessageSchema,
  UpdateCustomerMessageSchema,
  UpdateCustomerSchema,
  UpdateEmailMessagesSchema,
  UpdateIntegrationSettingsSchema,
  UpdateInvoiceExchangeRatesMessageSchema,
  UpdateLabelSchema,
  UpdateMeasurementsPayloadSchema,
  UpdateMeasurementsPricesMessageSchema,
  UpdateMeterMessageSchema,
  UpliftConfigurationSchema,
  UpsertMeasurementsPayloadSchema,
  UsageByDateBreakdownSchema,
  UsageLineItemInputSchema,
  UsageLineItemSchema,
  UsagePricingConfigurationSchema,
  UsagePricingInputSchema,
  UsagePricingModelsSchema,
  UsagePricingSchema,
  UsageProductInputSchema,
  UsageProductSchema,
  UsageProductVariantInputSchema,
  UsageProductVariantSchema,
  UsageReportChildCustomerSchema,
  UsageReportContractSchema,
  UsageReportCustomerSchema,
  UsageReportDataItemSchema,
  UsageReportDataSchema,
  UsageReportRowSchema,
  UsageReportV2ReportItemSchema,
  UsageReportV2Schema,
  UsageReportVariantSchema,
  UsageVariantChargeCalculatorMessageSchema,
  UsageVariantChargeSchema,
  UsageVariantChargesCalculatorDispatcherPayloadSchema,
  UserInputBillingIntervalSchema,
  UserInvitationSchema,
  UserInvitationStatusSchema,
  UserSchema,
  UsernameSchema,
  V2IntegrationSettingsSchema,
  V3IntegrationSettingsSchema,
  VersionedIntegrationSettingsSchema,
  VyError,
  WORKFLOW_ACTION_ID,
  WORKFLOW_TEMPLATE_ID,
  WarmUpFlagPayloadSchema,
  WaterfallTotalsBreakdownSchema,
  WebhookChannelSchema,
  WebhookInvokerMessageSchema,
  XeroCustomerEntitySchema,
  XeroProductEntitySchema,
  XeroProductSchema,
  YearlyRevenueSchema,
  contactRefiner,
  created,
  createdEntities,
  deleted,
  fixedRevisionedLineItemSchema,
  getPaymentDueDays,
  hasMeterReset,
  hasUpliftEnabled,
  hubspotCreateTokenActionsSchema,
  invoicesReportItemSchema,
  isFixedPricingModel,
  isMultiYearDuration,
  isPerUnitVariant,
  isUsagePricingModel,
  isWorkflowActionId,
  isWorkflowTemplateId,
  latestMeteredEventUpdatedAtResultSchema,
  maskToken,
  measurementInputSchema,
  passwordConfirmationSchema,
  percentagePromotionLineItemSchema,
  productConfigStatusSchema,
  resultSchema,
  segregated,
  supportsBasePrice,
  supportsProration,
  toPaymentProvider,
  violatesUpliftDurationRule,
  withAdvancePaymentPricingValidation,
  withBasePriceValidation,
  withMeterResetCommitmentRefillValidation,
  withNullAsOptional,
  withOneTimeProrationValidation,
  withUsageProductMeterIdValidation
};
